import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /** The day, does not include a time. */
  Date: any;
  /** DateTime custom scalar type */
  DateTime: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  NonNullableInt: any;
  NonNullablePhoneNumber: any;
  NonNullableText: any;
  NonNullableTimestamptz: any;
  NonNullableUsPostalCode: any;
  /** The exact time of day, does not include the date. May or may not have a timezone offset. */
  Time: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: any;
  UsPostalCode: any;
  /** ZipCode custom scalar type */
  ZipCode: any;
};

export enum ActivationEnum {
  Ems = 'EMS',
  Police = 'POLICE'
}

export type AddEncounterInput = {
  appointmentId: Scalars['Int'];
  channelAttributionId: Scalars['Int'];
  genderRequirement?: Maybe<SexEnum>;
  modules?: Maybe<Array<Maybe<ModuleNameEnum>>>;
  patientId: Scalars['Int'];
  reasonForEncounter: Scalars['NonNullableText'];
  serviceLineId: Scalars['Int'];
  systemLastUpdatedBy: SystemOfOriginEnum;
};

export type AddEncounterPayload = {
  encounter?: Maybe<Encounter>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `addStandingOrder` mutation. */
export type AddStandingOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  vCode?: Maybe<Scalars['String']>;
  vDiagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  vEndedAt?: Maybe<Scalars['Date']>;
  vName?: Maybe<Scalars['String']>;
  vNpi?: Maybe<Scalars['String']>;
  vNumber?: Maybe<Scalars['String']>;
  vOrderType?: Maybe<StandingOrderLookupTypeEnum>;
  vProcedureCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  vStartedAt?: Maybe<Scalars['Date']>;
  vState?: Maybe<Scalars['String']>;
  vUrl?: Maybe<Scalars['String']>;
  vVersion?: Maybe<Scalars['String']>;
};

/** The output of our `addStandingOrder` mutation. */
export type AddStandingOrderPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  integer?: Maybe<Scalars['Int']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A connection to a list of `Addendum` values. */
export type AddendaConnection = {
  /** A list of edges which contains the `Addendum` and cursor to aid in pagination. */
  edges: Array<AddendaEdge>;
  /** A list of `Addendum` objects. */
  nodes: Array<Addendum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Addendum` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Addendum` edge in the connection. */
export type AddendaEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Addendum` at the end of the edge. */
  node: Addendum;
};

/** Methods to use when ordering `Addendum`. */
export enum AddendaOrderBy {
  AddendumIdAsc = 'ADDENDUM_ID_ASC',
  AddendumIdDesc = 'ADDENDUM_ID_DESC',
  EncounterIdAsc = 'ENCOUNTER_ID_ASC',
  EncounterIdDesc = 'ENCOUNTER_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about addendums to an encounter */
export type Addendum = Node & {
  /** Reads and enables pagination through a set of `AddendumAttachment`. */
  addendumAttachments: AddendumAttachmentsConnection;
  /** Reads and enables pagination through a set of `AddendumAttachment`. */
  addendumAttachmentsList: Array<AddendumAttachment>;
  addendumId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `Encounter` that is related to this `Addendum`. */
  encounter?: Maybe<Encounter>;
  encounterId: Scalars['Int'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Scalars['String'];
  user?: Maybe<User>;
};


/** Contains information about addendums to an encounter */
export type AddendumAddendumAttachmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AddendumAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendumAttachmentsOrderBy>>;
};


/** Contains information about addendums to an encounter */
export type AddendumAddendumAttachmentsListArgs = {
  condition?: Maybe<AddendumAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendumAttachmentsOrderBy>>;
};

/** Contains information about attachments to an addendum */
export type AddendumAttachment = Node & {
  /** Reads a single `Addendum` that is related to this `AddendumAttachment`. */
  addendum?: Maybe<Addendum>;
  addendumAttachmentId: Scalars['Int'];
  addendumId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedById?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  type?: Maybe<AddendumAttachmentTypeEnum>;
  url?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `AddendumAttachment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AddendumAttachmentCondition = {
  /** Checks for equality with the object’s `addendumAttachmentId` field. */
  addendumAttachmentId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `addendumId` field. */
  addendumId?: Maybe<Scalars['Int']>;
};

export enum AddendumAttachmentTypeEnum {
  Forms = 'FORMS'
}

/** A connection to a list of `AddendumAttachment` values. */
export type AddendumAttachmentsConnection = {
  /** A list of edges which contains the `AddendumAttachment` and cursor to aid in pagination. */
  edges: Array<AddendumAttachmentsEdge>;
  /** A list of `AddendumAttachment` objects. */
  nodes: Array<AddendumAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AddendumAttachment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AddendumAttachment` edge in the connection. */
export type AddendumAttachmentsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AddendumAttachment` at the end of the edge. */
  node: AddendumAttachment;
};

/** Methods to use when ordering `AddendumAttachment`. */
export enum AddendumAttachmentsOrderBy {
  AddendumAttachmentIdAsc = 'ADDENDUM_ATTACHMENT_ID_ASC',
  AddendumAttachmentIdDesc = 'ADDENDUM_ATTACHMENT_ID_DESC',
  AddendumIdAsc = 'ADDENDUM_ID_ASC',
  AddendumIdDesc = 'ADDENDUM_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/**
 * A condition to be used against `Addendum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AddendumCondition = {
  /** Checks for equality with the object’s `addendumId` field. */
  addendumId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
};

/** A connection to a list of `AllergicCriticality` values. */
export type AllergicCriticalitiesConnection = {
  /** A list of edges which contains the `AllergicCriticality` and cursor to aid in pagination. */
  edges: Array<AllergicCriticalitiesEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection. */
export type AllergicCriticalitiesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
};

/** Methods to use when ordering `AllergicCriticality`. */
export enum AllergicCriticalitiesOrderBy {
  AllergicCriticalityIdAsc = 'ALLERGIC_CRITICALITY_ID_ASC',
  AllergicCriticalityIdDesc = 'ALLERGIC_CRITICALITY_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergic criticality */
export type AllergicCriticality = Node & {
  allergicCriticalityId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionId: AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdList: Array<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityId: AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusId: AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdList: Array<AllergicStatus>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicCriticalityIdAndAllergyId: AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdListArgs = {
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdListArgs = {
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdListArgs = {
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityPatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic criticality */
export type AllergicCriticalityPatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicReactionsByPatientAllergyAllergicCriticalityIdAndAllergicReactionIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicSeveritiesByPatientAllergyAllergicCriticalityIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergicStatusesByPatientAllergyAllergicCriticalityIdAndAllergicStatusIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyConnection = {
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicCriticalityAllergiesByPatientAllergyAllergicCriticalityIdAndAllergyIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicCriticality` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AllergicCriticalityCondition = {
  /** Checks for equality with the object’s `allergicCriticalityId` field. */
  allergicCriticalityId?: Maybe<Scalars['Int']>;
};

/** Contains information about allergic reactions */
export type AllergicReaction = Node & {
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityId: AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  allergicReactionId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityId: AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusId: AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdList: Array<AllergicStatus>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicReactionIdAndAllergyId: AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicReactionIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdListArgs = {
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdListArgs = {
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdListArgs = {
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionPatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic reactions */
export type AllergicReactionPatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicCriticalitiesByPatientAllergyAllergicReactionIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicSeveritiesByPatientAllergyAllergicReactionIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergicStatusesByPatientAllergyAllergicReactionIdAndAllergicStatusIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyConnection = {
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicReactionAllergiesByPatientAllergyAllergicReactionIdAndAllergyIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicReaction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergicReactionCondition = {
  /** Checks for equality with the object’s `allergicReactionId` field. */
  allergicReactionId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `AllergicReaction` values. */
export type AllergicReactionsConnection = {
  /** A list of edges which contains the `AllergicReaction` and cursor to aid in pagination. */
  edges: Array<AllergicReactionsEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection. */
export type AllergicReactionsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
};

/** Methods to use when ordering `AllergicReaction`. */
export enum AllergicReactionsOrderBy {
  AllergicReactionIdAsc = 'ALLERGIC_REACTION_ID_ASC',
  AllergicReactionIdDesc = 'ALLERGIC_REACTION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `AllergicSeverity` values. */
export type AllergicSeveritiesConnection = {
  /** A list of edges which contains the `AllergicSeverity` and cursor to aid in pagination. */
  edges: Array<AllergicSeveritiesEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection. */
export type AllergicSeveritiesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
};

/** Methods to use when ordering `AllergicSeverity`. */
export enum AllergicSeveritiesOrderBy {
  AllergicSeverityIdAsc = 'ALLERGIC_SEVERITY_ID_ASC',
  AllergicSeverityIdDesc = 'ALLERGIC_SEVERITY_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergic severity */
export type AllergicSeverity = Node & {
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityId: AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionId: AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdList: Array<AllergicReaction>;
  allergicSeverityId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusId: AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdList: Array<AllergicStatus>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicSeverityIdAndAllergyId: AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicSeverityIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdListArgs = {
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdListArgs = {
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdListArgs = {
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityPatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic severity */
export type AllergicSeverityPatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicCriticalitiesByPatientAllergyAllergicSeverityIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicReactionsByPatientAllergyAllergicSeverityIdAndAllergicReactionIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergicStatusesByPatientAllergyAllergicSeverityIdAndAllergicStatusIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyConnection = {
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicSeverityAllergiesByPatientAllergyAllergicSeverityIdAndAllergyIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicSeverity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergicSeverityCondition = {
  /** Checks for equality with the object’s `allergicSeverityId` field. */
  allergicSeverityId?: Maybe<Scalars['Int']>;
};

/** Contains information about allergic statuses */
export type AllergicStatus = Node & {
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityId: AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionId: AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdList: Array<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityId: AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  allergicStatusId: Scalars['Int'];
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicStatusIdAndAllergyId: AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesByPatientAllergyAllergicStatusIdAndAllergyIdList: Array<Allergy>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdListArgs = {
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdListArgs = {
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdListArgs = {
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusPatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergic statuses */
export type AllergicStatusPatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicCriticalitiesByPatientAllergyAllergicStatusIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicReactionsByPatientAllergyAllergicStatusIdAndAllergicReactionIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergicSeveritiesByPatientAllergyAllergicStatusIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `Allergy` values, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyConnection = {
  /** A list of edges which contains the `Allergy`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `Allergy` edge in the connection, with data from `PatientAllergy`. */
export type AllergicStatusAllergiesByPatientAllergyAllergicStatusIdAndAllergyIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergicStatus` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergicStatusCondition = {
  /** Checks for equality with the object’s `allergicStatusId` field. */
  allergicStatusId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `AllergicStatus` values. */
export type AllergicStatusesConnection = {
  /** A list of edges which contains the `AllergicStatus` and cursor to aid in pagination. */
  edges: Array<AllergicStatusesEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection. */
export type AllergicStatusesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
};

/** Methods to use when ordering `AllergicStatus`. */
export enum AllergicStatusesOrderBy {
  AllergicStatusIdAsc = 'ALLERGIC_STATUS_ID_ASC',
  AllergicStatusIdDesc = 'ALLERGIC_STATUS_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Allergy` values. */
export type AllergiesConnection = {
  /** A list of edges which contains the `Allergy` and cursor to aid in pagination. */
  edges: Array<AllergiesEdge>;
  /** A list of `Allergy` objects. */
  nodes: Array<Allergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Allergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Allergy` edge in the connection. */
export type AllergiesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Allergy` at the end of the edge. */
  node: Allergy;
};

/** Methods to use when ordering `Allergy`. */
export enum AllergiesOrderBy {
  AllergyIdAsc = 'ALLERGY_ID_ASC',
  AllergyIdDesc = 'ALLERGY_ID_DESC',
  AllergySubstanceIdAsc = 'ALLERGY_SUBSTANCE_ID_ASC',
  AllergySubstanceIdDesc = 'ALLERGY_SUBSTANCE_ID_DESC',
  AllergyTypeIdAsc = 'ALLERGY_TYPE_ID_ASC',
  AllergyTypeIdDesc = 'ALLERGY_TYPE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergies */
export type Allergy = Node & {
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityId: AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdList: Array<AllergicCriticality>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergyIdAndAllergicReactionId: AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdList: Array<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityId: AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdList: Array<AllergicSeverity>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergyIdAndAllergicStatusId: AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdList: Array<AllergicStatus>;
  allergyId: Scalars['Int'];
  /** Reads a single `AllergySubstance` that is related to this `Allergy`. */
  allergySubstance?: Maybe<AllergySubstance>;
  allergySubstanceId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergyType` that is related to this `Allergy`. */
  allergyType?: Maybe<AllergyType>;
  allergyTypeId?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  codeSystemId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** Contains information about allergies */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdListArgs = {
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergies */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdListArgs = {
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** Contains information about allergies */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdListArgs = {
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdListArgs = {
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyPatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** Contains information about allergies */
export type AllergyPatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicCriticality` values, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicCriticality`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdge>;
  /** A list of `AllergicCriticality` objects. */
  nodes: Array<AllergicCriticality>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicCriticality` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicCriticality` at the end of the edge. */
  node: AllergicCriticality;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicCriticality` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicCriticalitiesByPatientAllergyAllergyIdAndAllergicCriticalityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicReaction` values, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicReaction`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdge>;
  /** A list of `AllergicReaction` objects. */
  nodes: Array<AllergicReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicReaction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicReaction` at the end of the edge. */
  node: AllergicReaction;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicReaction` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicReactionsByPatientAllergyAllergyIdAndAllergicReactionIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicSeverity` values, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicSeverity`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdge>;
  /** A list of `AllergicSeverity` objects. */
  nodes: Array<AllergicSeverity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicSeverity` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicSeverity` at the end of the edge. */
  node: AllergicSeverity;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicSeverity` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicSeveritiesByPatientAllergyAllergyIdAndAllergicSeverityIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A connection to a list of `AllergicStatus` values, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyConnection = {
  /** A list of edges which contains the `AllergicStatus`, info from the `PatientAllergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdge>;
  /** A list of `AllergicStatus` objects. */
  nodes: Array<AllergicStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergicStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergicStatus` at the end of the edge. */
  node: AllergicStatus;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies: PatientAllergiesConnection;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergiesList: Array<PatientAllergy>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdgePatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** A `AllergicStatus` edge in the connection, with data from `PatientAllergy`. */
export type AllergyAllergicStatusesByPatientAllergyAllergyIdAndAllergicStatusIdManyToManyEdgePatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};

/** A condition to be used against `Allergy` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AllergyCondition = {
  /** Checks for equality with the object’s `allergyId` field. */
  allergyId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergySubstanceId` field. */
  allergySubstanceId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergyTypeId` field. */
  allergyTypeId?: Maybe<Scalars['Int']>;
};

/** Contains information about allergy substances */
export type AllergySubstance = Node & {
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  allergySubstanceId: Scalars['Int'];
  /** Reads and enables pagination through a set of `AllergyType`. */
  allergyTypesByAllergyAllergySubstanceIdAndAllergyTypeId: AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergyType`. */
  allergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdList: Array<AllergyType>;
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};


/** Contains information about allergy substances */
export type AllergySubstanceAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy substances */
export type AllergySubstanceAllergiesListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy substances */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyTypeCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergyTypesOrderBy>>;
};


/** Contains information about allergy substances */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdListArgs = {
  condition?: Maybe<AllergyTypeCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergyTypesOrderBy>>;
};

/** A connection to a list of `AllergyType` values, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyConnection = {
  /** A list of edges which contains the `AllergyType`, info from the `Allergy`, and the cursor to aid in pagination. */
  edges: Array<AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdge>;
  /** A list of `AllergyType` objects. */
  nodes: Array<AllergyType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergyType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergyType` edge in the connection, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdge = {
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergyType` at the end of the edge. */
  node: AllergyType;
};


/** A `AllergyType` edge in the connection, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdgeAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** A `AllergyType` edge in the connection, with data from `Allergy`. */
export type AllergySubstanceAllergyTypesByAllergyAllergySubstanceIdAndAllergyTypeIdManyToManyEdgeAllergiesListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergySubstance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AllergySubstanceCondition = {
  /** Checks for equality with the object’s `allergySubstanceId` field. */
  allergySubstanceId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `AllergySubstance` values. */
export type AllergySubstancesConnection = {
  /** A list of edges which contains the `AllergySubstance` and cursor to aid in pagination. */
  edges: Array<AllergySubstancesEdge>;
  /** A list of `AllergySubstance` objects. */
  nodes: Array<AllergySubstance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergySubstance` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergySubstance` edge in the connection. */
export type AllergySubstancesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergySubstance` at the end of the edge. */
  node: AllergySubstance;
};

/** Methods to use when ordering `AllergySubstance`. */
export enum AllergySubstancesOrderBy {
  AllergySubstanceIdAsc = 'ALLERGY_SUBSTANCE_ID_ASC',
  AllergySubstanceIdDesc = 'ALLERGY_SUBSTANCE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about allergy types */
export type AllergyType = Node & {
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  /** Reads and enables pagination through a set of `AllergySubstance`. */
  allergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceId: AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AllergySubstance`. */
  allergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdList: Array<AllergySubstance>;
  allergyTypeId: Scalars['Int'];
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};


/** Contains information about allergy types */
export type AllergyTypeAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy types */
export type AllergyTypeAllergiesListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** Contains information about allergy types */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergySubstanceCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergySubstancesOrderBy>>;
};


/** Contains information about allergy types */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdListArgs = {
  condition?: Maybe<AllergySubstanceCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergySubstancesOrderBy>>;
};

/** A connection to a list of `AllergySubstance` values, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyConnection = {
  /** A list of edges which contains the `AllergySubstance`, info from the `Allergy`, and the cursor to aid in pagination. */
  edges: Array<AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdge>;
  /** A list of `AllergySubstance` objects. */
  nodes: Array<AllergySubstance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergySubstance` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergySubstance` edge in the connection, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdge = {
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies: AllergiesConnection;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergiesList: Array<Allergy>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergySubstance` at the end of the edge. */
  node: AllergySubstance;
};


/** A `AllergySubstance` edge in the connection, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdgeAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** A `AllergySubstance` edge in the connection, with data from `Allergy`. */
export type AllergyTypeAllergySubstancesByAllergyAllergyTypeIdAndAllergySubstanceIdManyToManyEdgeAllergiesListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};

/**
 * A condition to be used against `AllergyType` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AllergyTypeCondition = {
  /** Checks for equality with the object’s `allergyTypeId` field. */
  allergyTypeId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `AllergyType` values. */
export type AllergyTypesConnection = {
  /** A list of edges which contains the `AllergyType` and cursor to aid in pagination. */
  edges: Array<AllergyTypesEdge>;
  /** A list of `AllergyType` objects. */
  nodes: Array<AllergyType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AllergyType` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AllergyType` edge in the connection. */
export type AllergyTypesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AllergyType` at the end of the edge. */
  node: AllergyType;
};

/** Methods to use when ordering `AllergyType`. */
export enum AllergyTypesOrderBy {
  AllergyTypeIdAsc = 'ALLERGY_TYPE_ID_ASC',
  AllergyTypeIdDesc = 'ALLERGY_TYPE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ApplicationClient = {
  machine?: Maybe<MachineApplication>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ApplicationClientTypeEnum>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']>;
};

export enum ApplicationClientTypeEnum {
  MachineApplication = 'MACHINE_APPLICATION',
  ReadycoreUser = 'READYCORE_USER'
}

/** Contains information about the appointment */
export type Appointment = Node & {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatches: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesList: Array<AppointmentDispatch>;
  appointmentId: Scalars['Int'];
  availabilityOverride?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  cancelledBy?: Maybe<ApplicationClient>;
  cancelledByClientUuid?: Maybe<Scalars['UUID']>;
  cancelledReason?: Maybe<CancellationReasonEnum>;
  cancelledReasonOther?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** calculates the appointment completed_at timestamp based off the max related appointment_dispatch completed_at timestamps */
  completedAt?: Maybe<Scalars['Datetime']>;
  contactName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  dispatchFailedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  estimatedDuration?: Maybe<Interval>;
  globalId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndPrimaryInsurance: AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndSecondaryInsurance: AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceList: Array<InsuranceRecord>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `Appointment`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  marketOverride?: Maybe<Scalars['Boolean']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  partnership?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterAppointmentIdAndPatientId: AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterAppointmentIdAndPatientIdList: Array<Patient>;
  primaryPhone?: Maybe<Scalars['String']>;
  rescheduledAt?: Maybe<Scalars['Datetime']>;
  rescheduledFrom: Array<Maybe<Scalars['Int']>>;
  rescheduledReason?: Maybe<RescheduleReasonEnum>;
  rescheduledTo?: Maybe<Appointment>;
  /** Reads and enables pagination through a set of `ResponderRole`. */
  responderRolesByAppointmentDispatchAppointmentIdAndResponderId: AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ResponderRole`. */
  responderRolesByAppointmentDispatchAppointmentIdAndResponderIdList: Array<ResponderRole>;
  scheduledFor: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterAppointmentIdAndServiceLineId: AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterAppointmentIdAndServiceLineIdList: Array<ServiceLine>;
  skeduloJobId?: Maybe<Scalars['UUID']>;
  source?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** calculates the appointment status based off the set timestamp fields */
  status?: Maybe<AppointmentStatusEnum>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  systemOfOrigin: SystemOfOriginEnum;
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `Appointment`. */
  userByCreatedBy?: Maybe<User>;
  zip?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
  zoneId: Scalars['Int'];
};


/** Contains information about the appointment */
export type AppointmentAppointmentDispatchesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentAppointmentDispatchesListArgs = {
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdListArgs = {
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ResponderRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ResponderRolesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdListArgs = {
  condition?: Maybe<ResponderRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ResponderRolesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information about the appointment */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdListArgs = {
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};

export type AppointmentAddress = {
  address: Scalars['String'];
  address_lat: Scalars['Float'];
  address_lng: Scalars['Float'];
  marketId: Scalars['Int'];
  zipcode: Scalars['String'];
  zoneId: Scalars['Int'];
};

export type AppointmentAvailability = {
  appointmentSlots: Array<Maybe<AppointmentSlots>>;
  jobDuration?: Maybe<Scalars['Int']>;
  jobTags?: Maybe<Array<Maybe<AppointmentJobTag>>>;
  jobType: Scalars['String'];
  requiredResponders?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Appointment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AppointmentCondition = {
  /** Checks for equality with the object’s `appointmentId` field. */
  appointmentId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `globalId` field. */
  globalId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `rescheduledFrom` field. */
  rescheduledFrom?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `scheduledFor` field. */
  scheduledFor?: Maybe<Scalars['Datetime']>;
  /** Filters to records matching skeduloJobId */
  skeduloJobId?: Maybe<Scalars['UUID']>;
};

/** Contains information mapping 1-to-many dispatched responders to an appointment */
export type AppointmentDispatch = Node & {
  /** Reads a single `Appointment` that is related to this `AppointmentDispatch`. */
  appointment?: Maybe<Appointment>;
  appointmentDispatchId: Scalars['Int'];
  appointmentId: Scalars['Int'];
  atPatientAt?: Maybe<Scalars['Datetime']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  dispatchedAt?: Maybe<Scalars['Datetime']>;
  enRouteAt?: Maybe<Scalars['Datetime']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  onSceneAt?: Maybe<Scalars['Datetime']>;
  removedAt?: Maybe<Scalars['Datetime']>;
  removedBy?: Maybe<Scalars['Int']>;
  removedReason?: Maybe<Scalars['String']>;
  /** Reads a single `ResponderRole` that is related to this `AppointmentDispatch`. */
  responder?: Maybe<ResponderRole>;
  responderId: Scalars['Int'];
  skeduloJobAllocationId?: Maybe<Scalars['UUID']>;
  /** calculates the appointment_dispatch status based off the set timestamp fields */
  status?: Maybe<AppointmentDispatchStatusEnum>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `AppointmentDispatch` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AppointmentDispatchCondition = {
  /** Checks for equality with the object’s `appointmentDispatchId` field. */
  appointmentDispatchId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `appointmentId` field. */
  appointmentId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `responderId` field. */
  responderId?: Maybe<Scalars['Int']>;
  /** Filters on records matching `skedulo_job_allocation_id` */
  skedulo_job_allocation_id?: Maybe<Scalars['String']>;
  /** Filters on records that do not include `status` */
  statusIsNot?: Maybe<Array<Maybe<AppointmentDispatchStatusConditionEnum>>>;
};

/** An input for mutations affecting `AppointmentDispatch` */
export type AppointmentDispatchInput = {
  appointmentDispatchId?: Maybe<Scalars['Int']>;
  appointmentId: Scalars['Int'];
  atPatientAt?: Maybe<Scalars['Datetime']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  dispatchedAt?: Maybe<Scalars['Datetime']>;
  enRouteAt?: Maybe<Scalars['Datetime']>;
  migrationSource?: Maybe<Scalars['String']>;
  onSceneAt?: Maybe<Scalars['Datetime']>;
  removedAt?: Maybe<Scalars['Datetime']>;
  removedBy?: Maybe<Scalars['Int']>;
  removedReason?: Maybe<Scalars['String']>;
  responderId: Scalars['Int'];
  skeduloJobAllocationId?: Maybe<Scalars['UUID']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/** Represents an update to a `AppointmentDispatch`. Fields that are set will be updated. */
export type AppointmentDispatchPatch = {
  appointmentDispatchId?: Maybe<Scalars['Int']>;
  appointmentId?: Maybe<Scalars['Int']>;
  atPatientAt?: Maybe<Scalars['Datetime']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  dispatchedAt?: Maybe<Scalars['Datetime']>;
  enRouteAt?: Maybe<Scalars['Datetime']>;
  migrationSource?: Maybe<Scalars['String']>;
  onSceneAt?: Maybe<Scalars['Datetime']>;
  removedAt?: Maybe<Scalars['Datetime']>;
  removedBy?: Maybe<Scalars['Int']>;
  removedReason?: Maybe<Scalars['String']>;
  responderId?: Maybe<Scalars['Int']>;
  skeduloJobAllocationId?: Maybe<Scalars['UUID']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum AppointmentDispatchStatusConditionEnum {
  AtPatient = 'AT_PATIENT',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  EnRoute = 'EN_ROUTE',
  OnScene = 'ON_SCENE',
  PendingDispatch = 'PENDING_DISPATCH',
  Removed = 'REMOVED'
}

export enum AppointmentDispatchStatusEnum {
  AtPatient = 'AT_PATIENT',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  EnRoute = 'EN_ROUTE',
  OnScene = 'ON_SCENE',
  PendingDispatch = 'PENDING_DISPATCH',
  Removed = 'REMOVED'
}

/** A connection to a list of `AppointmentDispatch` values. */
export type AppointmentDispatchesConnection = {
  /** A list of edges which contains the `AppointmentDispatch` and cursor to aid in pagination. */
  edges: Array<AppointmentDispatchesEdge>;
  /** A list of `AppointmentDispatch` objects. */
  nodes: Array<AppointmentDispatch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AppointmentDispatch` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AppointmentDispatch` edge in the connection. */
export type AppointmentDispatchesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AppointmentDispatch` at the end of the edge. */
  node: AppointmentDispatch;
};

/** Methods to use when ordering `AppointmentDispatch`. */
export enum AppointmentDispatchesOrderBy {
  AppointmentDispatchIdAsc = 'APPOINTMENT_DISPATCH_ID_ASC',
  AppointmentDispatchIdDesc = 'APPOINTMENT_DISPATCH_ID_DESC',
  AppointmentIdAsc = 'APPOINTMENT_ID_ASC',
  AppointmentIdDesc = 'APPOINTMENT_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResponderIdAsc = 'RESPONDER_ID_ASC',
  ResponderIdDesc = 'RESPONDER_ID_DESC'
}

export type AppointmentFilter = {
  markets?: Maybe<Array<Scalars['Int']>>;
  scheduledAfter?: Maybe<Scalars['String']>;
  scheduledBefore?: Maybe<Scalars['String']>;
  serviceLines?: Maybe<Array<Scalars['Int']>>;
  status?: Maybe<Array<AppointmentStatusEnum>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type AppointmentInsuranceRecordsByEncounterAppointmentIdAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

export type AppointmentJobTag = {
  id: Scalars['UUID'];
};

/** Represents an update to a `Appointment`. Fields that are set will be updated. */
export type AppointmentPatch = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  cancelledReason?: Maybe<CancellationReasonEnum>;
  cancelledReasonOther?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  marketId?: Maybe<Scalars['Int']>;
  marketOverride?: Maybe<Scalars['Boolean']>;
  partnership?: Maybe<Scalars['String']>;
  primaryPhone?: Maybe<Scalars['String']>;
  rescheduledReason?: Maybe<RescheduleReasonEnum>;
  scheduledFor?: Maybe<Scalars['Datetime']>;
  skeduloJobId?: Maybe<Scalars['UUID']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyConnection = {
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type AppointmentPatientsByEncounterAppointmentIdAndPatientIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ResponderRole` values, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyConnection = {
  /** A list of edges which contains the `ResponderRole`, info from the `AppointmentDispatch`, and the cursor to aid in pagination. */
  edges: Array<AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdge>;
  /** A list of `ResponderRole` objects. */
  nodes: Array<ResponderRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ResponderRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ResponderRole` edge in the connection, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdge = {
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderId: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderIdList: Array<AppointmentDispatch>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ResponderRole` at the end of the edge. */
  node: ResponderRole;
};


/** A `ResponderRole` edge in the connection, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdgeAppointmentDispatchesByResponderIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** A `ResponderRole` edge in the connection, with data from `AppointmentDispatch`. */
export type AppointmentResponderRolesByAppointmentDispatchAppointmentIdAndResponderIdManyToManyEdgeAppointmentDispatchesByResponderIdListArgs = {
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyConnection = {
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type AppointmentServiceLinesByEncounterAppointmentIdAndServiceLineIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

export type AppointmentSlots = {
  end: Scalars['String'];
  respondersAvailable: Scalars['Int'];
  start: Scalars['String'];
};

export enum AppointmentStatusEnum {
  AtPatient = 'AT_PATIENT',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DispatchFailed = 'DISPATCH_FAILED',
  EnRoute = 'EN_ROUTE',
  OnScene = 'ON_SCENE',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED'
}

export type AppointmentTag = Node & {
  appointmentTag?: Maybe<Scalars['String']>;
  appointmentTagId: Scalars['String'];
  createdAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  skeduloJobTagId?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `AppointmentTag` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AppointmentTagCondition = {
  /** Checks for equality with the object’s `appointmentTagId` field. */
  appointmentTagId?: Maybe<Scalars['String']>;
  /** Filters on records matching `appointmentTagId` */
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An input for mutations affecting `AppointmentTag` */
export type AppointmentTagInput = {
  appointmentTag?: Maybe<Scalars['String']>;
  appointmentTagId: Scalars['String'];
  createdAt?: Maybe<Scalars['Datetime']>;
  skeduloJobTagId?: Maybe<Scalars['String']>;
};

/** Represents an update to a `AppointmentTag`. Fields that are set will be updated. */
export type AppointmentTagPatch = {
  appointmentTag?: Maybe<Scalars['String']>;
  appointmentTagId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  skeduloJobTagId?: Maybe<Scalars['String']>;
};

/** A connection to a list of `AppointmentTag` values. */
export type AppointmentTagsConnection = {
  /** A list of edges which contains the `AppointmentTag` and cursor to aid in pagination. */
  edges: Array<AppointmentTagsEdge>;
  /** A list of `AppointmentTag` objects. */
  nodes: Array<AppointmentTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AppointmentTag` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AppointmentTag` edge in the connection. */
export type AppointmentTagsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `AppointmentTag` at the end of the edge. */
  node: AppointmentTag;
};

/** Methods to use when ordering `AppointmentTag`. */
export enum AppointmentTagsOrderBy {
  AppointmentTagIdAsc = 'APPOINTMENT_TAG_ID_ASC',
  AppointmentTagIdDesc = 'APPOINTMENT_TAG_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Appointment` values. */
export type AppointmentsConnection = {
  /** A list of edges which contains the `Appointment` and cursor to aid in pagination. */
  edges: Array<AppointmentsEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection. */
export type AppointmentsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};

/** Methods to use when ordering `Appointment`. */
export enum AppointmentsOrderBy {
  AppointmentIdAsc = 'APPOINTMENT_ID_ASC',
  AppointmentIdDesc = 'APPOINTMENT_ID_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  GlobalIdAsc = 'GLOBAL_ID_ASC',
  GlobalIdDesc = 'GLOBAL_ID_DESC',
  MarketIdAsc = 'MARKET_ID_ASC',
  MarketIdDesc = 'MARKET_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RescheduledFromAsc = 'RESCHEDULED_FROM_ASC',
  RescheduledFromDesc = 'RESCHEDULED_FROM_DESC',
  ScheduledForAsc = 'SCHEDULED_FOR_ASC',
  ScheduledForDesc = 'SCHEDULED_FOR_DESC'
}

/** Contains Billing Diagnostic information */
export type BillingDiagnostic = Node & {
  billingDiagnosticsId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `EncounterTask` that is related to this `BillingDiagnostic`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `ProcedureCodeReference` that is related to this `BillingDiagnostic`. */
  procedureCodeReference?: Maybe<ProcedureCodeReference>;
  procedureCodeReferenceId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `BillingDiagnostic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BillingDiagnosticCondition = {
  /** Checks for equality with the object’s `billingDiagnosticsId` field. */
  billingDiagnosticsId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `procedureCodeReferenceId` field. */
  procedureCodeReferenceId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `BillingDiagnostic` values. */
export type BillingDiagnosticsConnection = {
  /** A list of edges which contains the `BillingDiagnostic` and cursor to aid in pagination. */
  edges: Array<BillingDiagnosticsEdge>;
  /** A list of `BillingDiagnostic` objects. */
  nodes: Array<BillingDiagnostic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BillingDiagnostic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BillingDiagnostic` edge in the connection. */
export type BillingDiagnosticsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `BillingDiagnostic` at the end of the edge. */
  node: BillingDiagnostic;
};

/** Methods to use when ordering `BillingDiagnostic`. */
export enum BillingDiagnosticsOrderBy {
  BillingDiagnosticsIdAsc = 'BILLING_DIAGNOSTICS_ID_ASC',
  BillingDiagnosticsIdDesc = 'BILLING_DIAGNOSTICS_ID_DESC',
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcedureCodeReferenceIdAsc = 'PROCEDURE_CODE_REFERENCE_ID_ASC',
  ProcedureCodeReferenceIdDesc = 'PROCEDURE_CODE_REFERENCE_ID_DESC'
}

/** All input for the `CancelAppointmentByGlobalId` mutation. */
export type CancelAppointmentByGlobalIdInput = {
  cancelledReason: CancellationReasonEnum;
  cancelledReasonOther?: Maybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  globalId: Scalars['String'];
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
};

/** All input for the `CancelAppointment` mutation. */
export type CancelAppointmentInput = {
  appointmentId: Scalars['Int'];
  cancelledReason: CancellationReasonEnum;
  cancelledReasonOther?: Maybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
};

/** The output of our `CancelAppointment` mutation. */
export type CancelAppointmentPayload = {
  appointment?: Maybe<Appointment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type CancelEncountersInput = {
  cancellationReason: CancellationReasonEnum;
  cancellationReasonOther?: Maybe<Scalars['String']>;
  encounterIds?: Maybe<Array<Scalars['Int']>>;
};

export enum CancellationReasonEnum {
  CallError = 'CALL_ERROR',
  CapacityRelated = 'CAPACITY_RELATED',
  CovidResultSpeed = 'COVID_RESULT_SPEED',
  Financial = 'FINANCIAL',
  NoCallNoShow = 'NO_CALL_NO_SHOW',
  Other = 'OTHER',
  PatientChangedMind = 'PATIENT_CHANGED_MIND',
  PatientConditionImproved = 'PATIENT_CONDITION_IMPROVED',
  PatientWaitTime = 'PATIENT_WAIT_TIME',
  RefusedRescheduling = 'REFUSED_RESCHEDULING',
  ServicesNotAvailable = 'SERVICES_NOT_AVAILABLE',
  SoughtCareElsewhere = 'SOUGHT_CARE_ELSEWHERE',
  TestCall = 'TEST_CALL',
  TextCancellation = 'TEXT_CANCELLATION',
  TimeNoLongerWorks = 'TIME_NO_LONGER_WORKS'
}

/** Contains contains information about the cer role and mapping to user relation. */
export type CerRole = Node & {
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `CerRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/** A condition to be used against `CerRole` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CerRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `CerRole` values. */
export type CerRolesConnection = {
  /** A list of edges which contains the `CerRole` and cursor to aid in pagination. */
  edges: Array<CerRolesEdge>;
  /** A list of `CerRole` objects. */
  nodes: Array<CerRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CerRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CerRole` edge in the connection. */
export type CerRolesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CerRole` at the end of the edge. */
  node: CerRole;
};

/** Methods to use when ordering `CerRole`. */
export enum CerRolesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Contains information about channel attribution */
export type ChannelAttribution = Node & {
  channel: Scalars['String'];
  channelAttributionId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  createdByClientUuid?: Maybe<Scalars['UUID']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  deletedByClientUuid?: Maybe<Scalars['UUID']>;
  globalId: Scalars['UUID'];
  institutionType: ChannelAttributionInstitutionTypeEnum;
  isDeleted: Scalars['Boolean'];
  /** List of Markets for a `ChannelAttribution`. */
  markets?: Maybe<Array<Maybe<Market>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  referralType?: Maybe<ChannelAttributionReferralTypeEnum>;
  tagSystem: ChannelAttributionTagSystemEnum;
  trackingNumber?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `ChannelAttribution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ChannelAttributionCondition = {
  /** Checks for equality with the object’s `channelAttributionId` field. */
  channelAttributionId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `globalId` field. */
  globalId?: Maybe<Scalars['UUID']>;
  /** Filters on records matching `isDeleted` */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Filters on records matching `marketId` */
  marketId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Filters on records matching `tagSystem` */
  tagSystem?: Maybe<ChannelAttributionTagSystemConditionEnum>;
  /** Filters on records matching `trackingNumber` */
  trackingNumber?: Maybe<Scalars['String']>;
};

export enum ChannelAttributionInstitutionTypeEnum {
  CommunityBasedOrganization = 'COMMUNITY_BASED_ORGANIZATION',
  Employer = 'EMPLOYER',
  Ems = 'EMS',
  Government = 'GOVERNMENT',
  HealthPlan = 'HEALTH_PLAN',
  HealthSystem = 'HEALTH_SYSTEM',
  HomeCare = 'HOME_CARE',
  Marketing = 'MARKETING',
  PrimaryCare = 'PRIMARY_CARE',
  PrivateBusiness = 'PRIVATE_BUSINESS',
  SpecialistGroup = 'SPECIALIST_GROUP',
  Training = 'TRAINING',
  Unknown = 'UNKNOWN'
}

export enum ChannelAttributionReferralTypeEnum {
  ClinicalReferral = 'CLINICAL_REFERRAL',
  Dne = 'DNE',
  EmployerReferral = 'EMPLOYER_REFERRAL',
  PatientMarketing = 'PATIENT_MARKETING'
}

export enum ChannelAttributionTagSystemConditionEnum {
  Callrail = 'CALLRAIL',
  Manual = 'MANUAL'
}

export enum ChannelAttributionTagSystemEnum {
  Callrail = 'CALLRAIL',
  Manual = 'MANUAL'
}

/** A connection to a list of `ChannelAttribution` values. */
export type ChannelAttributionsConnection = {
  /** A list of edges which contains the `ChannelAttribution` and cursor to aid in pagination. */
  edges: Array<ChannelAttributionsEdge>;
  /** A list of `ChannelAttribution` objects. */
  nodes: Array<ChannelAttribution>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChannelAttribution` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ChannelAttribution` edge in the connection. */
export type ChannelAttributionsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ChannelAttribution` at the end of the edge. */
  node: ChannelAttribution;
};

/** Methods to use when ordering `ChannelAttribution`. */
export enum ChannelAttributionsOrderBy {
  ChannelAttributionIdAsc = 'CHANNEL_ATTRIBUTION_ID_ASC',
  ChannelAttributionIdDesc = 'CHANNEL_ATTRIBUTION_ID_DESC',
  GlobalIdAsc = 'GLOBAL_ID_ASC',
  GlobalIdDesc = 'GLOBAL_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains data related to Chief Complaint and Histoy of Present Illness */
export type ChiefComplaintAndHpi = Node & {
  chiefComplaint?: Maybe<Scalars['String']>;
  chiefComplaintAndHpiId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `EncounterTask` that is related to this `ChiefComplaintAndHpi`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  historyOfPresentIllness?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ChiefComplaintAndHpi` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ChiefComplaintAndHpiCondition = {
  /** Checks for equality with the object’s `chiefComplaintAndHpiId` field. */
  chiefComplaintAndHpiId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ChiefComplaintAndHpi` values. */
export type ChiefComplaintAndHpisConnection = {
  /** A list of edges which contains the `ChiefComplaintAndHpi` and cursor to aid in pagination. */
  edges: Array<ChiefComplaintAndHpisEdge>;
  /** A list of `ChiefComplaintAndHpi` objects. */
  nodes: Array<ChiefComplaintAndHpi>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChiefComplaintAndHpi` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ChiefComplaintAndHpi` edge in the connection. */
export type ChiefComplaintAndHpisEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ChiefComplaintAndHpi` at the end of the edge. */
  node: ChiefComplaintAndHpi;
};

/** Methods to use when ordering `ChiefComplaintAndHpi`. */
export enum ChiefComplaintAndHpisOrderBy {
  ChiefComplaintAndHpiIdAsc = 'CHIEF_COMPLAINT_AND_HPI_ID_ASC',
  ChiefComplaintAndHpiIdDesc = 'CHIEF_COMPLAINT_AND_HPI_ID_DESC',
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ClaimEncounterInput = {
  encounterId: Scalars['Int'];
};

export type ClaimEncounterPayload = {
  encounter?: Maybe<Encounter>;
};

export type Clinic = Node & {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  dosespotClinicId?: Maybe<Scalars['String']>;
  dosespotClinicKey?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  updatedBy: Scalars['Int'];
  zipcode?: Maybe<Scalars['String']>;
};

/** A condition to be used against `Clinic` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ClinicCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `clinicId` field. */
  clinicId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `Clinic` */
export type ClinicInput = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dosespotClinicId?: Maybe<Scalars['String']>;
  dosespotClinicKey?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy: Scalars['Int'];
  zipcode?: Maybe<Scalars['String']>;
};

/** Represents an update to a `Clinic`. Fields that are set will be updated. */
export type ClinicPatch = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  dosespotClinicId?: Maybe<Scalars['String']>;
  dosespotClinicKey?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** Contains contains information about the clinician role and mapping to user relation. */
export type ClinicianRole = Node & {
  deputyId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  redoxId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `ClinicianRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `ClinicianRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ClinicianRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ClinicianRole` values. */
export type ClinicianRolesConnection = {
  /** A list of edges which contains the `ClinicianRole` and cursor to aid in pagination. */
  edges: Array<ClinicianRolesEdge>;
  /** A list of `ClinicianRole` objects. */
  nodes: Array<ClinicianRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClinicianRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ClinicianRole` edge in the connection. */
export type ClinicianRolesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ClinicianRole` at the end of the edge. */
  node: ClinicianRole;
};

/** Methods to use when ordering `ClinicianRole`. */
export enum ClinicianRolesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `Clinic` values. */
export type ClinicsConnection = {
  /** A list of edges which contains the `Clinic` and cursor to aid in pagination. */
  edges: Array<ClinicsEdge>;
  /** A list of `Clinic` objects. */
  nodes: Array<Clinic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Clinic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Clinic` edge in the connection. */
export type ClinicsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Clinic` at the end of the edge. */
  node: Clinic;
};

/** Methods to use when ordering `Clinic`. */
export enum ClinicsOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  ClinicIdAsc = 'CLINIC_ID_ASC',
  ClinicIdDesc = 'CLINIC_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CodeSystem = Node & {
  codeSystemId: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  oid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `CodeSystem` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CodeSystemCondition = {
  /** Checks for equality with the object’s `codeSystemId` field. */
  codeSystemId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `CodeSystem` */
export type CodeSystemInput = {
  name: Scalars['String'];
  oid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/** Represents an update to a `CodeSystem`. Fields that are set will be updated. */
export type CodeSystemPatch = {
  name?: Maybe<Scalars['String']>;
  oid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/** A connection to a list of `CodeSystem` values. */
export type CodeSystemsConnection = {
  /** A list of edges which contains the `CodeSystem` and cursor to aid in pagination. */
  edges: Array<CodeSystemsEdge>;
  /** A list of `CodeSystem` objects. */
  nodes: Array<CodeSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CodeSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CodeSystem` edge in the connection. */
export type CodeSystemsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CodeSystem` at the end of the edge. */
  node: CodeSystem;
};

/** Methods to use when ordering `CodeSystem`. */
export enum CodeSystemsOrderBy {
  CodeSystemIdAsc = 'CODE_SYSTEM_ID_ASC',
  CodeSystemIdDesc = 'CODE_SYSTEM_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum CommunicationNeedEnum {
  Blind = 'BLIND',
  Brail = 'BRAIL',
  Deaf = 'DEAF',
  LipReader = 'LIP_READER',
  None = 'NONE',
  SignLanguage = 'SIGN_LANGUAGE',
  TranslatorInterpreter = 'TRANSLATOR_INTERPRETER'
}

export type CreateAddendumAttachmentImageInput = {
  isDeleted?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type CreateAddendumAttachmentInput = {
  images?: Maybe<Array<Maybe<CreateAddendumAttachmentImageInput>>>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<AddendumAttachmentTypeEnum>;
};

export type CreateAddendumInput = {
  attachments?: Maybe<Array<Maybe<CreateAddendumAttachmentInput>>>;
  encounterId: Scalars['Int'];
  note: Scalars['String'];
  userId: Scalars['Int'];
};

export type CreateAddendumPayload = {
  addendum?: Maybe<Addendum>;
  clientMutationId?: Maybe<Scalars['String']>;
  encounter?: Maybe<Encounter>;
  query?: Maybe<Query>;
};

/** All input for the create `AppointmentDispatch` mutation. */
export type CreateAppointmentDispatchInput = {
  /** The `AppointmentDispatch` to be created by this mutation. */
  appointmentDispatch: AppointmentDispatchInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The output of our create `AppointmentDispatch` mutation. */
export type CreateAppointmentDispatchPayload = {
  /** Reads a single `Appointment` that is related to this `AppointmentDispatch`. */
  appointment?: Maybe<Appointment>;
  /** The `AppointmentDispatch` that was created by this mutation. */
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** An edge for our `AppointmentDispatch`. May be used by Relay 1. */
  appointmentDispatchEdge?: Maybe<AppointmentDispatchesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ResponderRole` that is related to this `AppointmentDispatch`. */
  responder?: Maybe<ResponderRole>;
};


/** The output of our create `AppointmentDispatch` mutation. */
export type CreateAppointmentDispatchPayloadAppointmentDispatchEdgeArgs = {
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};

/** All input for the `createAppointment` mutation. */
export type CreateAppointmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  input: CreateAppointmentInputRecordInput;
};

/** An input for mutations affecting `CreateAppointmentInputRecord` */
export type CreateAppointmentInputRecordInput = {
  address1: Scalars['NonNullableText'];
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  availabilityOverride?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  contactName: Scalars['NonNullableText'];
  createdBy?: Maybe<Scalars['Int']>;
  encounters?: Maybe<Array<Maybe<CreateEncounterInputRecordInput>>>;
  estimatedDuration?: Maybe<Scalars['String']>;
  marketId: Scalars['NonNullableInt'];
  marketOverride?: Maybe<Scalars['Boolean']>;
  partnership?: Maybe<Scalars['String']>;
  primaryPhone: Scalars['NonNullablePhoneNumber'];
  scheduledFor: Scalars['NonNullableTimestamptz'];
  source?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  systemOfOrigin: NonNullableSystemOfOrigin;
  unit?: Maybe<Scalars['String']>;
  zipCode: Scalars['NonNullableUsPostalCode'];
  zoneId: Scalars['NonNullableInt'];
};

/** The output of our `createAppointment` mutation. */
export type CreateAppointmentPayload = {
  appointment?: Maybe<Appointment>;
  /** An edge for our `Appointment`. May be used by Relay 1. */
  appointmentEdge?: Maybe<AppointmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `Appointment`. */
  market?: Maybe<Market>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Appointment`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our `createAppointment` mutation. */
export type CreateAppointmentPayloadAppointmentEdgeArgs = {
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};

/** All input for the create `AppointmentTag` mutation. */
export type CreateAppointmentTagInput = {
  /** The `AppointmentTag` to be created by this mutation. */
  appointmentTag: AppointmentTagInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The output of our create `AppointmentTag` mutation. */
export type CreateAppointmentTagPayload = {
  /** The `AppointmentTag` that was created by this mutation. */
  appointmentTag?: Maybe<AppointmentTag>;
  /** An edge for our `AppointmentTag`. May be used by Relay 1. */
  appointmentTagEdge?: Maybe<AppointmentTagsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AppointmentTag` mutation. */
export type CreateAppointmentTagPayloadAppointmentTagEdgeArgs = {
  orderBy?: Maybe<Array<AppointmentTagsOrderBy>>;
};

/** All input for the `CreateChannelAttribution` mutation. */
export type CreateChannelAttributionInput = {
  channel: Scalars['String'];
  globalId?: Maybe<Scalars['UUID']>;
  institutionType: ChannelAttributionInstitutionTypeEnum;
  marketIds: Array<Maybe<Scalars['Int']>>;
  referralType?: Maybe<ChannelAttributionReferralTypeEnum>;
  tagSystem: ChannelAttributionTagSystemEnum;
  trackingNumber?: Maybe<Scalars['String']>;
};

/** All input for the create `Clinic` mutation. */
export type CreateClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Clinic` to be created by this mutation. */
  clinic: ClinicInput;
};

/** The output of our create `Clinic` mutation. */
export type CreateClinicPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Clinic` that was created by this mutation. */
  clinic?: Maybe<Clinic>;
  /** An edge for our `Clinic`. May be used by Relay 1. */
  clinicEdge?: Maybe<ClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Clinic` mutation. */
export type CreateClinicPayloadClinicEdgeArgs = {
  orderBy?: Maybe<Array<ClinicsOrderBy>>;
};

export type CreateClinicianEncounterSignatureInput = {
  encounterId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** All input for the create `CodeSystem` mutation. */
export type CreateCodeSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CodeSystem` to be created by this mutation. */
  codeSystem: CodeSystemInput;
};

/** The output of our create `CodeSystem` mutation. */
export type CreateCodeSystemPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CodeSystem` that was created by this mutation. */
  codeSystem?: Maybe<CodeSystem>;
  /** An edge for our `CodeSystem`. May be used by Relay 1. */
  codeSystemEdge?: Maybe<CodeSystemsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CodeSystem` mutation. */
export type CreateCodeSystemPayloadCodeSystemEdgeArgs = {
  orderBy?: Maybe<Array<CodeSystemsOrderBy>>;
};

/** An input for mutations affecting `CreateEncounterInputRecord` */
export type CreateEncounterInputRecordInput = {
  channelAttributionId?: Maybe<Scalars['Int']>;
  genderRequirement?: Maybe<SexEnum>;
  modules?: Maybe<Array<Maybe<ModuleNameEnum>>>;
  noInsuranceReason?: Maybe<NoInsuranceReasonEnum>;
  patientId: Scalars['NonNullableInt'];
  paymentMode?: Maybe<EncounterPaymentModeEnum>;
  primaryInsurance?: Maybe<CreateInsuranceRecordInputRecordInput>;
  primaryInsuranceId?: Maybe<Scalars['Int']>;
  reasonForEncounter: Scalars['NonNullableText'];
  secondaryInsurance?: Maybe<CreateInsuranceRecordInputRecordInput>;
  secondaryInsuranceId?: Maybe<Scalars['Int']>;
  serviceLineId: Scalars['NonNullableInt'];
  stripeId?: Maybe<Scalars['String']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
};

/** All input for the create `EncounterSignature` mutation. */
export type CreateEncounterSignatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EncounterSignature` to be created by this mutation. */
  encounterSignature: EncounterSignatureInput;
};

/** The output of our create `EncounterSignature` mutation. */
export type CreateEncounterSignaturePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Encounter` that is related to this `EncounterSignature`. */
  encounter?: Maybe<Encounter>;
  /** The `EncounterSignature` that was created by this mutation. */
  encounterSignature?: Maybe<EncounterSignature>;
  /** An edge for our `EncounterSignature`. May be used by Relay 1. */
  encounterSignatureEdge?: Maybe<EncounterSignaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EncounterSignature` mutation. */
export type CreateEncounterSignaturePayloadEncounterSignatureEdgeArgs = {
  orderBy?: Maybe<Array<EncounterSignaturesOrderBy>>;
};

/** All input for the create `EncounterTaskAttachment` mutation. */
export type CreateEncounterTaskAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EncounterTaskAttachment` to be created by this mutation. */
  encounterTaskAttachment: EncounterTaskAttachmentInput;
};

/** The output of our create `EncounterTaskAttachment` mutation. */
export type CreateEncounterTaskAttachmentPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EncounterTask` that is related to this `EncounterTaskAttachment`. */
  encounterTask?: Maybe<EncounterTask>;
  /** The `EncounterTaskAttachment` that was created by this mutation. */
  encounterTaskAttachment?: Maybe<EncounterTaskAttachment>;
  /** An edge for our `EncounterTaskAttachment`. May be used by Relay 1. */
  encounterTaskAttachmentEdge?: Maybe<EncounterTaskAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EncounterTaskAttachment` mutation. */
export type CreateEncounterTaskAttachmentPayloadEncounterTaskAttachmentEdgeArgs = {
  orderBy?: Maybe<Array<EncounterTaskAttachmentsOrderBy>>;
};

/** All input for the create `FeatureGate` mutation. */
export type CreateFeatureGateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeatureGate` to be created by this mutation. */
  featureGate: FeatureGateInput;
};

/** The output of our create `FeatureGate` mutation. */
export type CreateFeatureGatePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeatureGate` that was created by this mutation. */
  featureGate?: Maybe<FeatureGate>;
  /** An edge for our `FeatureGate`. May be used by Relay 1. */
  featureGateEdge?: Maybe<FeatureGatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `FeatureGate` mutation. */
export type CreateFeatureGatePayloadFeatureGateEdgeArgs = {
  orderBy?: Maybe<Array<FeatureGatesOrderBy>>;
};

/** All input for the create `InsuranceRecord` mutation. */
export type CreateInsuranceRecordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InsuranceRecord` to be created by this mutation. */
  insuranceRecord: InsuranceRecordInput;
};

/** An input for mutations affecting `CreateInsuranceRecordInputRecord` */
export type CreateInsuranceRecordInputRecordInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  noInsuranceCards?: Maybe<Scalars['Boolean']>;
  packageId?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  policyHolderDob?: Maybe<Scalars['Date']>;
  policyHolderFirstName?: Maybe<Scalars['String']>;
  policyHolderGender?: Maybe<SexEnum>;
  policyHolderLastName?: Maybe<Scalars['String']>;
  relationshipToPolicyHolder?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  zip?: Maybe<Scalars['UsPostalCode']>;
};

/** The output of our create `InsuranceRecord` mutation. */
export type CreateInsuranceRecordPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InsuranceRecord` that was created by this mutation. */
  insuranceRecord?: Maybe<InsuranceRecord>;
  /** An edge for our `InsuranceRecord`. May be used by Relay 1. */
  insuranceRecordEdge?: Maybe<InsuranceRecordsEdge>;
  /** Reads a single `Patient` that is related to this `InsuranceRecord`. */
  patient?: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `InsuranceRecord` mutation. */
export type CreateInsuranceRecordPayloadInsuranceRecordEdgeArgs = {
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};

/** All input for the create `MarketClinic` mutation. */
export type CreateMarketClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MarketClinic` to be created by this mutation. */
  marketClinic: MarketClinicInput;
};

/** The output of our create `MarketClinic` mutation. */
export type CreateMarketClinicPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  /** The `MarketClinic` that was created by this mutation. */
  marketClinic?: Maybe<MarketClinic>;
  /** An edge for our `MarketClinic`. May be used by Relay 1. */
  marketClinicEdge?: Maybe<MarketClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MarketClinic` mutation. */
export type CreateMarketClinicPayloadMarketClinicEdgeArgs = {
  orderBy?: Maybe<Array<MarketClinicsOrderBy>>;
};

/** All input for the create `MedicalDirector` mutation. */
export type CreateMedicalDirectorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MedicalDirector` to be created by this mutation. */
  medicalDirector: MedicalDirectorInput;
};

/** The output of our create `MedicalDirector` mutation. */
export type CreateMedicalDirectorPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MedicalDirector` that was created by this mutation. */
  medicalDirector?: Maybe<MedicalDirector>;
  /** An edge for our `MedicalDirector`. May be used by Relay 1. */
  medicalDirectorEdge?: Maybe<MedicalDirectorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MedicalDirector` mutation. */
export type CreateMedicalDirectorPayloadMedicalDirectorEdgeArgs = {
  orderBy?: Maybe<Array<MedicalDirectorsOrderBy>>;
};

/** All input for the `createPatientForm` mutation. */
export type CreatePatientFormInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  fieldResponse?: Maybe<Scalars['JSON']>;
  fieldResponseJson?: Maybe<Scalars['JSON']>;
  formstackId?: Maybe<Scalars['Int']>;
  patientFormLookupId?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['Datetime']>;
};

/** The output of our `createPatientForm` mutation. */
export type CreatePatientFormPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patientForm?: Maybe<PatientForm>;
  /** An edge for our `PatientForm`. May be used by Relay 1. */
  patientFormEdge?: Maybe<PatientFormsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPatientForm` mutation. */
export type CreatePatientFormPayloadPatientFormEdgeArgs = {
  orderBy?: Maybe<Array<PatientFormsOrderBy>>;
};

/** All input for the `createPatient` mutation. */
export type CreatePatientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patient: PatientInputRecordInput;
};

/** All input for the `createPatientNote` mutation. */
export type CreatePatientNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patientNote: PatientNoteInputRecordInput;
};

/** The output of our `createPatientNote` mutation. */
export type CreatePatientNotePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientNote`. */
  patient?: Maybe<Patient>;
  patientNote?: Maybe<PatientNote>;
  /** An edge for our `PatientNote`. May be used by Relay 1. */
  patientNoteEdge?: Maybe<PatientNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PatientNote`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our `createPatientNote` mutation. */
export type CreatePatientNotePayloadPatientNoteEdgeArgs = {
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};

/** The output of our `createPatient` mutation. */
export type CreatePatientPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** A ReadyCoreStatusCodeEnum indicating the result status of the operation. */
  code?: Maybe<ReadyCoreStatusCodeEnum>;
  /**
   * A status message indicating if the operation was successful, or the reason
   * for failure.
   */
  msg?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge?: Maybe<PatientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createPatient` mutation. */
export type CreatePatientPayloadPatientEdgeArgs = {
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};

/** All input for the create `PhysicalExam` mutation. */
export type CreatePhysicalExamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PhysicalExam` to be created by this mutation. */
  physicalExam: PhysicalExamInput;
};

/** The output of our create `PhysicalExam` mutation. */
export type CreatePhysicalExamPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PhysicalExam` that was created by this mutation. */
  physicalExam?: Maybe<PhysicalExam>;
  /** An edge for our `PhysicalExam`. May be used by Relay 1. */
  physicalExamEdge?: Maybe<PhysicalExamsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PhysicalExam` mutation. */
export type CreatePhysicalExamPayloadPhysicalExamEdgeArgs = {
  orderBy?: Maybe<Array<PhysicalExamsOrderBy>>;
};

export type CreateResponderEncounterSignatureInput = {
  encounterId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CreateSkeduloAppointmentInput = {
  address1: Scalars['String'];
  addressLat: Scalars['Float'];
  addressLng: Scalars['Float'];
  callRailNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contactName: Scalars['String'];
  createdBy?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  duration?: Maybe<Scalars['Int']>;
  forceScheduling: Scalars['Boolean'];
  jobTags?: Maybe<Array<Maybe<JobTagsInput>>>;
  jobType?: Maybe<Scalars['String']>;
  marketId: Scalars['Int'];
  marketOverride: Scalars['Boolean'];
  primaryPhone: Scalars['String'];
  resourceRequired?: Maybe<Scalars['Int']>;
  specialInstructions?: Maybe<Scalars['String']>;
  startTimes?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  systemOfOrigin: SystemOfOriginEnum;
  unit?: Maybe<Scalars['String']>;
  zipCode: Scalars['NonNullableUsPostalCode'];
  zoneId: Scalars['Int'];
};

export type CreateSkeduloInsuranceInput = {
  company: Scalars['String'];
  groupNumber?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  packageId?: Maybe<Scalars['String']>;
  planType?: Maybe<Scalars['String']>;
  policyHolderDob?: Maybe<Scalars['Date']>;
  policyHolderFirstName?: Maybe<Scalars['String']>;
  policyHolderGender?: Maybe<SexEnum>;
  policyHolderLastName?: Maybe<Scalars['String']>;
  relationshipToPolicyHolder?: Maybe<Scalars['String']>;
};

export type CreateSkeduloPatientInput = {
  dob?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  encounters?: Maybe<Array<Maybe<SkeduloEncounterInput>>>;
  firstName?: Maybe<Scalars['String']>;
  highPriorityNoteIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  lastName?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['Int']>;
  paymentMode?: Maybe<Scalars['Int']>;
  preferredPhoneNumber?: Maybe<Scalars['String']>;
  sex?: Maybe<SexEnum>;
};

/** All input for the `CreateStandingOrderInput` mutation. */
export type CreateStandingOrderInput = {
  clinicianId: Scalars['Int'];
  diagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  endedAt: Scalars['Datetime'];
  lookupId: Scalars['Int'];
  lookupType: StandingOrderLookupTypeEnum;
  name: Scalars['String'];
  number: Scalars['String'];
  orderUrl: Scalars['String'];
  procedureCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  startedAt: Scalars['Datetime'];
  state: StateEnum;
  version: Scalars['String'];
};

export enum CredentialsEnum {
  Do = 'DO',
  Lcsw = 'LCSW',
  Md = 'MD',
  Msw = 'MSW',
  Np = 'NP',
  Pa = 'PA',
  Responder = 'RESPONDER'
}

/** All input for the `deleteAppointmentTagByNodeId` mutation. */
export type DeleteAppointmentTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AppointmentTag` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteAppointmentTag` mutation. */
export type DeleteAppointmentTagInput = {
  appointmentTagId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** The output of our delete `AppointmentTag` mutation. */
export type DeleteAppointmentTagPayload = {
  /** The `AppointmentTag` that was deleted by this mutation. */
  appointmentTag?: Maybe<AppointmentTag>;
  /** An edge for our `AppointmentTag`. May be used by Relay 1. */
  appointmentTagEdge?: Maybe<AppointmentTagsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedAppointmentTagNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `AppointmentTag` mutation. */
export type DeleteAppointmentTagPayloadAppointmentTagEdgeArgs = {
  orderBy?: Maybe<Array<AppointmentTagsOrderBy>>;
};

/** All input for the `deleteClinicByNodeId` mutation. */
export type DeleteClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Clinic` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteClinic` mutation. */
export type DeleteClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  clinicId: Scalars['Int'];
};

/** The output of our delete `Clinic` mutation. */
export type DeleteClinicPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Clinic` that was deleted by this mutation. */
  clinic?: Maybe<Clinic>;
  /** An edge for our `Clinic`. May be used by Relay 1. */
  clinicEdge?: Maybe<ClinicsEdge>;
  deletedClinicNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Clinic` mutation. */
export type DeleteClinicPayloadClinicEdgeArgs = {
  orderBy?: Maybe<Array<ClinicsOrderBy>>;
};

/** All input for the `deleteCodeSystemByNodeId` mutation. */
export type DeleteCodeSystemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CodeSystem` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCodeSystem` mutation. */
export type DeleteCodeSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  codeSystemId: Scalars['Int'];
};

/** The output of our delete `CodeSystem` mutation. */
export type DeleteCodeSystemPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CodeSystem` that was deleted by this mutation. */
  codeSystem?: Maybe<CodeSystem>;
  /** An edge for our `CodeSystem`. May be used by Relay 1. */
  codeSystemEdge?: Maybe<CodeSystemsEdge>;
  deletedCodeSystemNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CodeSystem` mutation. */
export type DeleteCodeSystemPayloadCodeSystemEdgeArgs = {
  orderBy?: Maybe<Array<CodeSystemsOrderBy>>;
};

/** All input for the `deleteFeatureGateByNodeId` mutation. */
export type DeleteFeatureGateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeatureGate` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFeatureGate` mutation. */
export type DeleteFeatureGateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  featureId: Scalars['String'];
};

/** The output of our delete `FeatureGate` mutation. */
export type DeleteFeatureGatePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFeatureGateNodeId?: Maybe<Scalars['ID']>;
  /** The `FeatureGate` that was deleted by this mutation. */
  featureGate?: Maybe<FeatureGate>;
  /** An edge for our `FeatureGate`. May be used by Relay 1. */
  featureGateEdge?: Maybe<FeatureGatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `FeatureGate` mutation. */
export type DeleteFeatureGatePayloadFeatureGateEdgeArgs = {
  orderBy?: Maybe<Array<FeatureGatesOrderBy>>;
};

/** All input for the `deleteMarketClinicByNodeId` mutation. */
export type DeleteMarketClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MarketClinic` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMarketClinic` mutation. */
export type DeleteMarketClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  marketId: Scalars['Int'];
};

/** The output of our delete `MarketClinic` mutation. */
export type DeleteMarketClinicPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMarketClinicNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  /** The `MarketClinic` that was deleted by this mutation. */
  marketClinic?: Maybe<MarketClinic>;
  /** An edge for our `MarketClinic`. May be used by Relay 1. */
  marketClinicEdge?: Maybe<MarketClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MarketClinic` mutation. */
export type DeleteMarketClinicPayloadMarketClinicEdgeArgs = {
  orderBy?: Maybe<Array<MarketClinicsOrderBy>>;
};

/** All input for the `deleteMedicalDirectorByNodeId` mutation. */
export type DeleteMedicalDirectorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MedicalDirector` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMedicalDirector` mutation. */
export type DeleteMedicalDirectorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  medicalDirectorId: Scalars['Int'];
};

/** The output of our delete `MedicalDirector` mutation. */
export type DeleteMedicalDirectorPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMedicalDirectorNodeId?: Maybe<Scalars['ID']>;
  /** The `MedicalDirector` that was deleted by this mutation. */
  medicalDirector?: Maybe<MedicalDirector>;
  /** An edge for our `MedicalDirector`. May be used by Relay 1. */
  medicalDirectorEdge?: Maybe<MedicalDirectorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MedicalDirector` mutation. */
export type DeleteMedicalDirectorPayloadMedicalDirectorEdgeArgs = {
  orderBy?: Maybe<Array<MedicalDirectorsOrderBy>>;
};

/** All input for the `deletePhysicalExamByNodeId` mutation. */
export type DeletePhysicalExamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PhysicalExam` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePhysicalExam` mutation. */
export type DeletePhysicalExamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  physicalExamId: Scalars['Int'];
};

/** The output of our delete `PhysicalExam` mutation. */
export type DeletePhysicalExamPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPhysicalExamNodeId?: Maybe<Scalars['ID']>;
  /** The `PhysicalExam` that was deleted by this mutation. */
  physicalExam?: Maybe<PhysicalExam>;
  /** An edge for our `PhysicalExam`. May be used by Relay 1. */
  physicalExamEdge?: Maybe<PhysicalExamsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PhysicalExam` mutation. */
export type DeletePhysicalExamPayloadPhysicalExamEdgeArgs = {
  orderBy?: Maybe<Array<PhysicalExamsOrderBy>>;
};

/** Contains Diagnosis Codes */
export type DiagnosisCodeReference = Node & {
  code: Scalars['String'];
  diagnosisCodeReferenceId: Scalars['Int'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskId: DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdList: Array<EncounterTask>;
  endDate?: Maybe<Scalars['Datetime']>;
  isBillable: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnoses: PatientDiagnosesConnection;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnosesList: Array<PatientDiagnosis>;
  startDate: Scalars['Datetime'];
  system: Scalars['String'];
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdListArgs = {
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferencePatientDiagnosesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientDiagnosisCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientDiagnosesOrderBy>>;
};


/** Contains Diagnosis Codes */
export type DiagnosisCodeReferencePatientDiagnosesListArgs = {
  condition?: Maybe<PatientDiagnosisCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientDiagnosesOrderBy>>;
};

/**
 * A condition to be used against `DiagnosisCodeReference` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DiagnosisCodeReferenceCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `diagnosisCodeReferenceId` field. */
  diagnosisCodeReferenceId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: Maybe<Scalars['Datetime']>;
};

/** A connection to a list of `EncounterTask` values, with data from `PatientDiagnosis`. */
export type DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyConnection = {
  /** A list of edges which contains the `EncounterTask`, info from the `PatientDiagnosis`, and the cursor to aid in pagination. */
  edges: Array<DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `PatientDiagnosis`. */
export type DiagnosisCodeReferenceEncounterTasksByPatientDiagnosisDiagnosisCodeReferenceIdAndEncounterTaskIdManyToManyEdge = {
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  order: Scalars['Int'];
  patientDiagnosisId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `DiagnosisCodeReference` values. */
export type DiagnosisCodeReferencesConnection = {
  /** A list of edges which contains the `DiagnosisCodeReference` and cursor to aid in pagination. */
  edges: Array<DiagnosisCodeReferencesEdge>;
  /** A list of `DiagnosisCodeReference` objects. */
  nodes: Array<DiagnosisCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DiagnosisCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DiagnosisCodeReference` edge in the connection. */
export type DiagnosisCodeReferencesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DiagnosisCodeReference` at the end of the edge. */
  node: DiagnosisCodeReference;
};

/** Methods to use when ordering `DiagnosisCodeReference`. */
export enum DiagnosisCodeReferencesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  DiagnosisCodeReferenceIdAsc = 'DIAGNOSIS_CODE_REFERENCE_ID_ASC',
  DiagnosisCodeReferenceIdDesc = 'DIAGNOSIS_CODE_REFERENCE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

export enum DispositionEnum {
  Completed = 'COMPLETED',
  Discharged = 'DISCHARGED',
  DischargedWithActivation = 'DISCHARGED_WITH_ACTIVATION',
  DischargedWithServiceRefusal = 'DISCHARGED_WITH_SERVICE_REFUSAL',
  PatientDeclinedServices = 'PATIENT_DECLINED_SERVICES',
  Reached = 'REACHED',
  ResponderInitiatedActivation = 'RESPONDER_INITIATED_ACTIVATION',
  UnableToReachIncorrectNumber = 'UNABLE_TO_REACH_INCORRECT_NUMBER',
  UnableToReachLeftVoicemail = 'UNABLE_TO_REACH_LEFT_VOICEMAIL',
  UnableToReachNoVoicemail = 'UNABLE_TO_REACH_NO_VOICEMAIL'
}

export type DoseSpotNotificationsResponse = {
  notificationCount?: Maybe<Scalars['Int']>;
  notificationsUrl?: Maybe<Scalars['String']>;
};

/** A connection to a list of `DosespotDrugAllergy` values. */
export type DosespotDrugAllergiesConnection = {
  /** A list of edges which contains the `DosespotDrugAllergy` and cursor to aid in pagination. */
  edges: Array<DosespotDrugAllergiesEdge>;
  /** A list of `DosespotDrugAllergy` objects. */
  nodes: Array<DosespotDrugAllergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DosespotDrugAllergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DosespotDrugAllergy` edge in the connection. */
export type DosespotDrugAllergiesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DosespotDrugAllergy` at the end of the edge. */
  node: DosespotDrugAllergy;
};

/** Methods to use when ordering `DosespotDrugAllergy`. */
export enum DosespotDrugAllergiesOrderBy {
  DosespotDrugAllergyIdAsc = 'DOSESPOT_DRUG_ALLERGY_ID_ASC',
  DosespotDrugAllergyIdDesc = 'DOSESPOT_DRUG_ALLERGY_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type DosespotDrugAllergy = Node & {
  code?: Maybe<Scalars['String']>;
  codeType?: Maybe<Scalars['String']>;
  dosespotAllergyId?: Maybe<Scalars['String']>;
  dosespotDrugAllergyId: Scalars['Int'];
  encounterId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  onsetDate?: Maybe<Scalars['Datetime']>;
  patientId?: Maybe<Scalars['Int']>;
  reaction?: Maybe<Scalars['String']>;
  reactionType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DosespotDrugAllergy` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DosespotDrugAllergyCondition = {
  /** Checks for equality with the object’s `dosespotDrugAllergyId` field. */
  dosespotDrugAllergyId?: Maybe<Scalars['Int']>;
};

export type DosespotPatientPrescription = Node & {
  dispenseUnit?: Maybe<Scalars['String']>;
  doseForm?: Maybe<Scalars['String']>;
  dosespotEncounterId?: Maybe<Scalars['String']>;
  dosespotPatientPrescriptionId?: Maybe<Scalars['Int']>;
  drugCode?: Maybe<Scalars['String']>;
  drugCodeSystem?: Maybe<Scalars['String']>;
  drugName?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['Datetime']>;
  encounterId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Datetime']>;
  medicationStatus?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFriendlyInstructions?: Maybe<Scalars['String']>;
  patientMedicationId?: Maybe<Scalars['Int']>;
  patientPrescriptionId: Scalars['Int'];
  prescriptionStatus?: Maybe<Scalars['String']>;
  prescriptionType?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  refills?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Datetime']>;
  strength?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DosespotPatientPrescription` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DosespotPatientPrescriptionCondition = {
  /** Checks for equality with the object’s `patientPrescriptionId` field. */
  patientPrescriptionId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `DosespotPatientPrescription` values. */
export type DosespotPatientPrescriptionsConnection = {
  /** A list of edges which contains the `DosespotPatientPrescription` and cursor to aid in pagination. */
  edges: Array<DosespotPatientPrescriptionsEdge>;
  /** A list of `DosespotPatientPrescription` objects. */
  nodes: Array<DosespotPatientPrescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DosespotPatientPrescription` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DosespotPatientPrescription` edge in the connection. */
export type DosespotPatientPrescriptionsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DosespotPatientPrescription` at the end of the edge. */
  node: DosespotPatientPrescription;
};

/** Methods to use when ordering `DosespotPatientPrescription`. */
export enum DosespotPatientPrescriptionsOrderBy {
  Natural = 'NATURAL',
  PatientPrescriptionIdAsc = 'PATIENT_PRESCRIPTION_ID_ASC',
  PatientPrescriptionIdDesc = 'PATIENT_PRESCRIPTION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type DosespotPatientReportedMedication = Node & {
  dispenseUnit?: Maybe<Scalars['String']>;
  doseForm?: Maybe<Scalars['String']>;
  dosespotEncounterId?: Maybe<Scalars['String']>;
  dosespotPatientReportedMedicationId?: Maybe<Scalars['Int']>;
  drugCode?: Maybe<Scalars['String']>;
  drugCodeSystem?: Maybe<Scalars['String']>;
  drugName?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Datetime']>;
  medicationStatus?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFriendlyInstructions?: Maybe<Scalars['String']>;
  patientMedicationId?: Maybe<Scalars['Int']>;
  patientReportedMedicationId: Scalars['Int'];
  quantity?: Maybe<Scalars['String']>;
  refills?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Datetime']>;
  strength?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `DosespotPatientReportedMedication` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DosespotPatientReportedMedicationCondition = {
  /** Checks for equality with the object’s `patientReportedMedicationId` field. */
  patientReportedMedicationId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `DosespotPatientReportedMedication` values. */
export type DosespotPatientReportedMedicationsConnection = {
  /** A list of edges which contains the `DosespotPatientReportedMedication` and cursor to aid in pagination. */
  edges: Array<DosespotPatientReportedMedicationsEdge>;
  /** A list of `DosespotPatientReportedMedication` objects. */
  nodes: Array<DosespotPatientReportedMedication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DosespotPatientReportedMedication` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DosespotPatientReportedMedication` edge in the connection. */
export type DosespotPatientReportedMedicationsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `DosespotPatientReportedMedication` at the end of the edge. */
  node: DosespotPatientReportedMedication;
};

/** Methods to use when ordering `DosespotPatientReportedMedication`. */
export enum DosespotPatientReportedMedicationsOrderBy {
  Natural = 'NATURAL',
  PatientReportedMedicationIdAsc = 'PATIENT_REPORTED_MEDICATION_ID_ASC',
  PatientReportedMedicationIdDesc = 'PATIENT_REPORTED_MEDICATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about drugs and drug manufacturers. */
export type Drug = Node & {
  createdAt: Scalars['Datetime'];
  drugCode: Scalars['String'];
  drugCodeSystem: Scalars['String'];
  drugId: Scalars['Int'];
  drugName: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  manufacturerCode: Scalars['String'];
  manufacturerCodeSystem: Scalars['String'];
  manufacturerName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  routeCode: Scalars['String'];
  routeCodeSystem: Scalars['String'];
  routeName: Scalars['String'];
};

/** A condition to be used against `Drug` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DrugCondition = {
  /** Checks for equality with the object’s `drugCode` field. */
  drugCode?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `drugId` field. */
  drugId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `Drug` values. */
export type DrugsConnection = {
  /** A list of edges which contains the `Drug` and cursor to aid in pagination. */
  edges: Array<DrugsEdge>;
  /** A list of `Drug` objects. */
  nodes: Array<Drug>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Drug` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Drug` edge in the connection. */
export type DrugsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Drug` at the end of the edge. */
  node: Drug;
};

/** Methods to use when ordering `Drug`. */
export enum DrugsOrderBy {
  DrugCodeAsc = 'DRUG_CODE_ASC',
  DrugCodeDesc = 'DRUG_CODE_DESC',
  DrugIdAsc = 'DRUG_ID_ASC',
  DrugIdDesc = 'DRUG_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type EmrAuditLogInput = {
  action: Scalars['String'];
  args?: Maybe<Scalars['String']>;
  patientId: Scalars['Int'];
  query?: Maybe<Scalars['String']>;
};

export type EmrAuditLogPayload = {
  msg?: Maybe<Scalars['String']>;
};

/** Contains information about an encounter */
export type Encounter = Node & {
  activation?: Maybe<ActivationEnum>;
  /** Reads and enables pagination through a set of `Addendum`. */
  addenda: AddendaConnection;
  /** Reads and enables pagination through a set of `Addendum`. */
  addendaList: Array<Addendum>;
  /** Reads a single `Appointment` that is related to this `Encounter`. */
  appointment?: Maybe<Appointment>;
  appointmentId: Scalars['Int'];
  cancellationReason?: Maybe<CancellationReasonEnum>;
  cancellationReasonOther?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  channelAttribution?: Maybe<ChannelAttribution>;
  channelAttributionId: Scalars['Int'];
  claimedAt?: Maybe<Scalars['Datetime']>;
  clinician?: Maybe<User>;
  clinicianId?: Maybe<Scalars['Int']>;
  clinicianIncluded?: Maybe<Scalars['Boolean']>;
  clinicianStatus?: Maybe<EncounterClinicianStatusEnum>;
  createdAt: Scalars['Datetime'];
  disposition?: Maybe<DispositionEnum>;
  encounterId: Scalars['Int'];
  /** Reads and enables pagination through a set of `EncounterSignature`. */
  encounterSignatures: EncounterSignaturesConnection;
  /** Reads and enables pagination through a set of `EncounterSignature`. */
  encounterSignaturesList: Array<EncounterSignature>;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasks: EncounterTasksConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksList: Array<EncounterTask>;
  genderRequirement?: Maybe<SexEnum>;
  globalUuid: Scalars['UUID'];
  inProgressAt?: Maybe<Scalars['Datetime']>;
  inQueueAt?: Maybe<Scalars['Datetime']>;
  migrationSource?: Maybe<Scalars['String']>;
  modules?: Maybe<Array<Maybe<ModuleNameEnum>>>;
  modulesFriendly: Scalars['String'];
  noInsuranceReason?: Maybe<NoInsuranceReasonEnum>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  otherInsurance?: Maybe<Scalars['Int']>;
  parentEncounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `Patient` that is related to this `Encounter`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  paymentMode?: Maybe<EncounterPaymentModeEnum>;
  primaryInsurance?: Maybe<Scalars['Int']>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  primaryInsuranceRecord?: Maybe<InsuranceRecord>;
  reasonForEncounter?: Maybe<Scalars['String']>;
  rescheduledAt?: Maybe<Scalars['Datetime']>;
  rescheduledReason?: Maybe<RescheduleReasonEnum>;
  responderStatus?: Maybe<EncounterResponderStatusEnum>;
  secondaryInsurance?: Maybe<Scalars['Int']>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  secondaryInsuranceRecord?: Maybe<InsuranceRecord>;
  /** Reads a single `ServiceLine` that is related to this `Encounter`. */
  serviceLine?: Maybe<ServiceLine>;
  serviceLineId?: Maybe<Scalars['Int']>;
  stripeCharge?: Maybe<Scalars['JSON']>;
  stripeId?: Maybe<Scalars['String']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  telehealthMeeting?: Maybe<TelehealthMeeting>;
  terminatedAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  visitId?: Maybe<Scalars['String']>;
};


/** Contains information about an encounter */
export type EncounterAddendaArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AddendumCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendaOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterAddendaListArgs = {
  condition?: Maybe<AddendumCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendaOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterEncounterSignaturesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterSignatureCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterSignaturesOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterEncounterSignaturesListArgs = {
  condition?: Maybe<EncounterSignatureCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterSignaturesOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterEncounterTasksArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about an encounter */
export type EncounterEncounterTasksListArgs = {
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};

export enum EncounterAppointmentStatusConditionEnum {
  AtPatient = 'AT_PATIENT',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DispatchFailed = 'DISPATCH_FAILED',
  EnRoute = 'EN_ROUTE',
  OnScene = 'ON_SCENE',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED'
}

export enum EncounterClinicianStatusConditionEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  InQueue = 'IN_QUEUE',
  NotStarted = 'NOT_STARTED',
  NoClinician = 'NO_CLINICIAN',
  Rescheduled = 'RESCHEDULED',
  Terminated = 'TERMINATED'
}

export enum EncounterClinicianStatusEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  InQueue = 'IN_QUEUE',
  NotStarted = 'NOT_STARTED',
  NoClinician = 'NO_CLINICIAN',
  Rescheduled = 'RESCHEDULED',
  Terminated = 'TERMINATED'
}

/**
 * A condition to be used against `Encounter` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EncounterCondition = {
  /** Checks for equality with the object’s `appointmentId` field. */
  appointmentId?: Maybe<Scalars['Int']>;
  /** Filters on records matching `appointmentStatus` */
  appointmentStatus?: Maybe<Array<Maybe<EncounterAppointmentStatusConditionEnum>>>;
  /** Filters to encounter records with matching `clinicianIds` */
  clinicianIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Filters on records matching `responderStatus` */
  clinicianStatus?: Maybe<Array<Maybe<EncounterClinicianStatusConditionEnum>>>;
  /** Filters to records where `completedAt` is after or equal to completed_at */
  completedAtAfter?: Maybe<Scalars['String']>;
  /** Filters to records where `completedAt` is before or equal to completed_at */
  completedAtBefore?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: Maybe<Scalars['Int']>;
  /** Filters to records matching `encounterIds` */
  encounterIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Filters to records matching `marketId` */
  marketId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['Int']>;
  /** Filters on records matching `paymentMode` */
  paymentMode?: Maybe<Array<Maybe<EncounterPaymentModeConditionEnum>>>;
  /** Checks for equality with the object’s `primaryInsurance` field. */
  primaryInsurance?: Maybe<Scalars['Int']>;
  /** Filters to records matching `responderId` */
  responderId?: Maybe<Scalars['Int']>;
  /** Filters on records matching `responderStatus` */
  responderStatus?: Maybe<Array<Maybe<EncounterResponderStatusConditionEnum>>>;
  /** Filters to records where `scheduledFor` is after or equal to scheduled_for */
  scheduledForAfter?: Maybe<Scalars['String']>;
  /** Filters to records where `scheduledFor` is before or equal to scheduled_for */
  scheduledForBefore?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `secondaryInsurance` field. */
  secondaryInsurance?: Maybe<Scalars['Int']>;
  /** Filters on records matching `serviceLineId` */
  serviceLine?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `serviceLineId` field. */
  serviceLineId?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `Encounter`. Fields that are set will be updated. */
export type EncounterPatch = {
  activation?: Maybe<ActivationEnum>;
  cancellationReason?: Maybe<CancellationReasonEnum>;
  cancellationReasonOther?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['Datetime']>;
  channelAttributionId?: Maybe<Scalars['Int']>;
  clinicianId?: Maybe<Scalars['Int']>;
  clinicianIncluded?: Maybe<Scalars['Boolean']>;
  disposition?: Maybe<DispositionEnum>;
  genderRequirement?: Maybe<SexEnum>;
  modules?: Maybe<Array<Maybe<ModuleNameEnum>>>;
  noInsuranceReason?: Maybe<NoInsuranceReasonEnum>;
  paymentMode?: Maybe<EncounterPaymentModeEnum>;
  primaryInsurance?: Maybe<Scalars['Int']>;
  reasonForEncounter?: Maybe<Scalars['String']>;
  rescheduledReason?: Maybe<RescheduleReasonEnum>;
  secondaryInsurance?: Maybe<Scalars['Int']>;
  serviceLineId?: Maybe<Scalars['Int']>;
  stripeCharge?: Maybe<Scalars['JSON']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum EncounterPaymentModeConditionEnum {
  EmployeeBenefit = 'EMPLOYEE_BENEFIT',
  Insurance = 'INSURANCE',
  Invoice = 'INVOICE',
  NoInsurance = 'NO_INSURANCE',
  Partnership = 'PARTNERSHIP',
  Prepaid = 'PREPAID',
  Uninsured = 'UNINSURED'
}

export enum EncounterPaymentModeEnum {
  EmployeeBenefit = 'EMPLOYEE_BENEFIT',
  Insurance = 'INSURANCE',
  Invoice = 'INVOICE',
  NoInsurance = 'NO_INSURANCE',
  Partnership = 'PARTNERSHIP',
  Prepaid = 'PREPAID',
  Uninsured = 'UNINSURED'
}

export enum EncounterResponderStatusConditionEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Rescheduled = 'RESCHEDULED',
  Terminated = 'TERMINATED'
}

export enum EncounterResponderStatusEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Rescheduled = 'RESCHEDULED',
  Terminated = 'TERMINATED'
}

/** Contains information about signatures for an encounter */
export type EncounterSignature = Node & {
  createdAt: Scalars['Datetime'];
  /** Reads a single `Encounter` that is related to this `EncounterSignature`. */
  encounter?: Maybe<Encounter>;
  encounterId: Scalars['Int'];
  encounterSignatureId: Scalars['Int'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operatingAsRole?: Maybe<UserRoleEnum>;
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `EncounterSignature` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EncounterSignatureCondition = {
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterSignatureId` field. */
  encounterSignatureId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `EncounterSignature` */
export type EncounterSignatureInput = {
  createdAt?: Maybe<Scalars['Datetime']>;
  encounterId: Scalars['Int'];
  encounterSignatureId?: Maybe<Scalars['Int']>;
  migrationSource?: Maybe<Scalars['String']>;
  operatingAsRole?: Maybe<UserRoleEnum>;
  userId: Scalars['Int'];
};

/** A connection to a list of `EncounterSignature` values. */
export type EncounterSignaturesConnection = {
  /** A list of edges which contains the `EncounterSignature` and cursor to aid in pagination. */
  edges: Array<EncounterSignaturesEdge>;
  /** A list of `EncounterSignature` objects. */
  nodes: Array<EncounterSignature>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterSignature` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterSignature` edge in the connection. */
export type EncounterSignaturesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterSignature` at the end of the edge. */
  node: EncounterSignature;
};

/** Methods to use when ordering `EncounterSignature`. */
export enum EncounterSignaturesOrderBy {
  EncounterIdAsc = 'ENCOUNTER_ID_ASC',
  EncounterIdDesc = 'ENCOUNTER_ID_DESC',
  EncounterSignatureIdAsc = 'ENCOUNTER_SIGNATURE_ID_ASC',
  EncounterSignatureIdDesc = 'ENCOUNTER_SIGNATURE_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information related to encounter tasks */
export type EncounterTask = Node & {
  assigneeId?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnostics: BillingDiagnosticsConnection;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnosticsList: Array<BillingDiagnostic>;
  /** Reads a single `ChiefComplaintAndHpi` that is related to this `EncounterTask`. */
  chiefComplaintAndHpi?: Maybe<ChiefComplaintAndHpi>;
  /**
   * Reads and enables pagination through a set of `ChiefComplaintAndHpi`.
   * @deprecated Please use chiefComplaintAndHpi instead
   */
  chiefComplaintAndHpis: ChiefComplaintAndHpisConnection;
  clinicianReviewedAt?: Maybe<Scalars['Datetime']>;
  clinicianReviewedBy?: Maybe<Scalars['Int']>;
  corrections?: Maybe<Array<Maybe<EncounterTaskCorrection>>>;
  createdAt: Scalars['Datetime'];
  dataCategory?: Maybe<Scalars['String']>;
  dataType: Scalars['String'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceId: EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyConnection;
  /** Reads and enables pagination through a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdList: Array<DiagnosisCodeReference>;
  /** Reads a single `Encounter` that is related to this `EncounterTask`. */
  encounter?: Maybe<Encounter>;
  encounterId: Scalars['Int'];
  /** Reads and enables pagination through a set of `EncounterTaskAttachment`. */
  encounterTaskAttachments: EncounterTaskAttachmentsConnection;
  /** Reads and enables pagination through a set of `EncounterTaskAttachment`. */
  encounterTaskAttachmentsList: Array<EncounterTaskAttachment>;
  encounterTaskId: Scalars['Int'];
  group: Scalars['String'];
  inProgressAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  medicalDecisionMaking?: Maybe<MedicalDecisionMaking>;
  migrationSource?: Maybe<Scalars['String']>;
  modifiedByResponderIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  modifiedByResponders?: Maybe<Array<Maybe<User>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientAllergyList?: Maybe<Array<Maybe<PatientAllergy>>>;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnoses: PatientDiagnosesConnection;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnosesList: Array<PatientDiagnosis>;
  patientForm?: Maybe<PatientForm>;
  patientFormLookup?: Maybe<PatientFormLookup>;
  patientId: Scalars['Int'];
  patientInstructions?: Maybe<Array<Maybe<PatientInstruction>>>;
  patientProblemList?: Maybe<Array<Maybe<PatientProblem>>>;
  physicalExam?: Maybe<PhysicalExam>;
  pointOfCareTest?: Maybe<PointOfCareTest>;
  pointOfCareTestLookup?: Maybe<PointOfCareTestLookup>;
  /** Reads and enables pagination through a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupId: EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdList: Array<PointOfCareTestLookup>;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
  /** Reads and enables pagination through a set of `ProcedureCodeReference`. */
  procedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceId: EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProcedureCodeReference`. */
  procedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdList: Array<ProcedureCodeReference>;
  progressNote?: Maybe<ProgressNote>;
  responderCompletedAt?: Maybe<Scalars['Datetime']>;
  responderCompletedBy?: Maybe<Scalars['Int']>;
  reviewOfSystems?: Maybe<Array<Maybe<ReviewOfSystemPayload>>>;
  skippedAt?: Maybe<Scalars['Datetime']>;
  skippedBy?: Maybe<Scalars['String']>;
  skippedReason?: Maybe<Scalars['String']>;
  status?: Maybe<EncounterTaskStatusEnum>;
  taskName: Scalars['String'];
  taskRoles: Array<Maybe<UserRoleEnum>>;
  telehealthMeeting?: Maybe<TelehealthMeeting>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  vaccine?: Maybe<Vaccine>;
  vaccineLookups?: Maybe<Array<Maybe<VaccineLookup>>>;
  /** Reads and enables pagination through a set of `Vaccine`. */
  vaccines: VaccinesConnection;
  /** Reads and enables pagination through a set of `Vaccine`. */
  vaccinesList: Array<Vaccine>;
  vitalLookups?: Maybe<Array<Maybe<VitalLookup>>>;
  /** Reads and enables pagination through a set of `VitalLookup`. */
  vitalLookupsByVitalEncounterTaskIdAndVitalLookupId: EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `VitalLookup`. */
  vitalLookupsByVitalEncounterTaskIdAndVitalLookupIdList: Array<VitalLookup>;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskBillingDiagnosticsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<BillingDiagnosticCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskBillingDiagnosticsListArgs = {
  condition?: Maybe<BillingDiagnosticCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskChiefComplaintAndHpisArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ChiefComplaintAndHpiCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ChiefComplaintAndHpisOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<DiagnosisCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdListArgs = {
  condition?: Maybe<DiagnosisCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskEncounterTaskAttachmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskEncounterTaskAttachmentsListArgs = {
  condition?: Maybe<EncounterTaskAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskPatientDiagnosesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientDiagnosisCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientDiagnosesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskPatientDiagnosesListArgs = {
  condition?: Maybe<PatientDiagnosisCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientDiagnosesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PointOfCareTestLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdListArgs = {
  condition?: Maybe<PointOfCareTestLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskPointOfCareTestsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskPointOfCareTestsListArgs = {
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProcedureCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdListArgs = {
  condition?: Maybe<ProcedureCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskVaccinesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VaccineCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VaccinesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskVaccinesListArgs = {
  condition?: Maybe<VaccineCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VaccinesOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VitalLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdListArgs = {
  condition?: Maybe<VitalLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalLookupsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskVitalsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};


/** Contains information related to encounter tasks */
export type EncounterTaskVitalsListArgs = {
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};

/** Contains attachments related to an encounter task */
export type EncounterTaskAttachment = Node & {
  createdAt: Scalars['Datetime'];
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `EncounterTaskAttachment`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskAttachmentId: Scalars['Int'];
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  type: EncounterTaskAttachmentTypeEnum;
  url?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `EncounterTaskAttachment` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskAttachmentCondition = {
  /** Checks for equality with the object’s `encounterTaskAttachmentId` field. */
  encounterTaskAttachmentId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Returns encoutner_task_attachments with matching encounter_task_id that are not deleted */
  encounterTaskIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Filters on records matching "isDeleted". */
  isDeleted?: Maybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `EncounterTaskAttachment` */
export type EncounterTaskAttachmentInput = {
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['Int']>;
  type: EncounterTaskAttachmentTypeEnum;
  url?: Maybe<Scalars['String']>;
};

/** Represents an update to a `EncounterTaskAttachment`. Fields that are set will be updated. */
export type EncounterTaskAttachmentPatch = {
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  patientId?: Maybe<Scalars['Int']>;
  type?: Maybe<EncounterTaskAttachmentTypeEnum>;
  url?: Maybe<Scalars['String']>;
};

export enum EncounterTaskAttachmentTypeEnum {
  Barcode = 'BARCODE',
  Forms = 'FORMS',
  Guardianship = 'GUARDIANSHIP',
  LabResult = 'LAB_RESULT',
  LeaveBehind = 'LEAVE_BEHIND',
  LotNumber = 'LOT_NUMBER',
  PatientIdBack = 'PATIENT_ID_BACK',
  PatientIdFront = 'PATIENT_ID_FRONT',
  PhysicalExam = 'PHYSICAL_EXAM',
  RequisitionForm = 'REQUISITION_FORM',
  ShippingLabel = 'SHIPPING_LABEL',
  SpecimenLabel = 'SPECIMEN_LABEL',
  StandingOrder = 'STANDING_ORDER',
  TestResult = 'TEST_RESULT',
  TransferOfCare = 'TRANSFER_OF_CARE',
  VaccinationLetter = 'VACCINATION_LETTER',
  WorkSchoolNote = 'WORK_SCHOOL_NOTE'
}

/** A connection to a list of `EncounterTaskAttachment` values. */
export type EncounterTaskAttachmentsConnection = {
  /** A list of edges which contains the `EncounterTaskAttachment` and cursor to aid in pagination. */
  edges: Array<EncounterTaskAttachmentsEdge>;
  /** A list of `EncounterTaskAttachment` objects. */
  nodes: Array<EncounterTaskAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTaskAttachment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTaskAttachment` edge in the connection. */
export type EncounterTaskAttachmentsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTaskAttachment` at the end of the edge. */
  node: EncounterTaskAttachment;
};

/** Methods to use when ordering `EncounterTaskAttachment`. */
export enum EncounterTaskAttachmentsOrderBy {
  EncounterTaskAttachmentIdAsc = 'ENCOUNTER_TASK_ATTACHMENT_ID_ASC',
  EncounterTaskAttachmentIdDesc = 'ENCOUNTER_TASK_ATTACHMENT_ID_DESC',
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains comments related to an encounter task */
export type EncounterTaskComment = Node & {
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdById?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskCommentId: Scalars['Int'];
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `EncounterTaskComment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskCommentCondition = {
  /** Checks for equality with the object’s `encounterTaskCommentId` field. */
  encounterTaskCommentId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTaskComment` values. */
export type EncounterTaskCommentsConnection = {
  /** A list of edges which contains the `EncounterTaskComment` and cursor to aid in pagination. */
  edges: Array<EncounterTaskCommentsEdge>;
  /** A list of `EncounterTaskComment` objects. */
  nodes: Array<EncounterTaskComment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTaskComment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTaskComment` edge in the connection. */
export type EncounterTaskCommentsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTaskComment` at the end of the edge. */
  node: EncounterTaskComment;
};

/** Methods to use when ordering `EncounterTaskComment`. */
export enum EncounterTaskCommentsOrderBy {
  EncounterTaskCommentIdAsc = 'ENCOUNTER_TASK_COMMENT_ID_ASC',
  EncounterTaskCommentIdDesc = 'ENCOUNTER_TASK_COMMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/**
 * A condition to be used against `EncounterTask` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskCondition = {
  /** Checks for equality with the object’s `encounterId` field. */
  encounterId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
};

/** Contains correction data for an encounter task */
export type EncounterTaskCorrection = Node & {
  correctionReason: Scalars['String'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  dataType: EncounterTaskDataTypeEnum;
  encounterTaskCorrectionId: Scalars['Int'];
  encounterTaskId: Scalars['Int'];
  jsonValue: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  version: Scalars['Int'];
};

/**
 * A condition to be used against `EncounterTaskCorrection` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EncounterTaskCorrectionCondition = {
  /** Checks for equality with the object’s `encounterTaskCorrectionId` field. */
  encounterTaskCorrectionId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTaskCorrection` values. */
export type EncounterTaskCorrectionsConnection = {
  /** A list of edges which contains the `EncounterTaskCorrection` and cursor to aid in pagination. */
  edges: Array<EncounterTaskCorrectionsEdge>;
  /** A list of `EncounterTaskCorrection` objects. */
  nodes: Array<EncounterTaskCorrection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTaskCorrection` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTaskCorrection` edge in the connection. */
export type EncounterTaskCorrectionsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTaskCorrection` at the end of the edge. */
  node: EncounterTaskCorrection;
};

/** Methods to use when ordering `EncounterTaskCorrection`. */
export enum EncounterTaskCorrectionsOrderBy {
  EncounterTaskCorrectionIdAsc = 'ENCOUNTER_TASK_CORRECTION_ID_ASC',
  EncounterTaskCorrectionIdDesc = 'ENCOUNTER_TASK_CORRECTION_ID_DESC',
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum EncounterTaskDataTypeEnum {
  Attachment = 'ATTACHMENT',
  BillingDiagnostics = 'BILLING_DIAGNOSTICS',
  ChiefComplaintAndHpi = 'CHIEF_COMPLAINT_AND_HPI',
  Disposition = 'DISPOSITION',
  Encounter = 'ENCOUNTER',
  LabTest = 'LAB_TEST',
  MedicalDecisionMaking = 'MEDICAL_DECISION_MAKING',
  Patient = 'PATIENT',
  PatientAllergy = 'PATIENT_ALLERGY',
  PatientForm = 'PATIENT_FORM',
  PatientProblem = 'PATIENT_PROBLEM',
  PhysicalExam = 'PHYSICAL_EXAM',
  PointOfCareTest = 'POINT_OF_CARE_TEST',
  ProgressNote = 'PROGRESS_NOTE',
  Questionnaire = 'QUESTIONNAIRE',
  ReviewingClinician = 'REVIEWING_CLINICIAN',
  Teladoc = 'TELADOC',
  TelehealthMeeting = 'TELEHEALTH_MEETING',
  Vaccine = 'VACCINE',
  Vital = 'VITAL'
}

/** A connection to a list of `DiagnosisCodeReference` values, with data from `PatientDiagnosis`. */
export type EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyConnection = {
  /** A list of edges which contains the `DiagnosisCodeReference`, info from the `PatientDiagnosis`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyEdge>;
  /** A list of `DiagnosisCodeReference` objects. */
  nodes: Array<DiagnosisCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DiagnosisCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DiagnosisCodeReference` edge in the connection, with data from `PatientDiagnosis`. */
export type EncounterTaskDiagnosisCodeReferencesByPatientDiagnosisEncounterTaskIdAndDiagnosisCodeReferenceIdManyToManyEdge = {
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `DiagnosisCodeReference` at the end of the edge. */
  node: DiagnosisCodeReference;
  order: Scalars['Int'];
  patientDiagnosisId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/** Represents an update to a `EncounterTask`. Fields that are set will be updated. */
export type EncounterTaskPatch = {
  clinicianReviewedAt?: Maybe<Scalars['Datetime']>;
  inProgressAt?: Maybe<Scalars['Datetime']>;
  responderCompletedAt?: Maybe<Scalars['Datetime']>;
  skippedAt?: Maybe<Scalars['Datetime']>;
  skippedBy?: Maybe<Scalars['String']>;
  skippedReason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/** A connection to a list of `PointOfCareTestLookup` values, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyConnection = {
  /** A list of edges which contains the `PointOfCareTestLookup`, info from the `PointOfCareTest`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdge>;
  /** A list of `PointOfCareTestLookup` objects. */
  nodes: Array<PointOfCareTestLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointOfCareTestLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointOfCareTestLookup` edge in the connection, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointOfCareTestLookup` at the end of the edge. */
  node: PointOfCareTestLookup;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
};


/** A `PointOfCareTestLookup` edge in the connection, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdgePointOfCareTestsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};


/** A `PointOfCareTestLookup` edge in the connection, with data from `PointOfCareTest`. */
export type EncounterTaskPointOfCareTestLookupsByPointOfCareTestEncounterTaskIdAndPointOfCareTestLookupIdManyToManyEdgePointOfCareTestsListArgs = {
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};

/** A connection to a list of `ProcedureCodeReference` values, with data from `BillingDiagnostic`. */
export type EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyConnection = {
  /** A list of edges which contains the `ProcedureCodeReference`, info from the `BillingDiagnostic`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyEdge>;
  /** A list of `ProcedureCodeReference` objects. */
  nodes: Array<ProcedureCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcedureCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcedureCodeReference` edge in the connection, with data from `BillingDiagnostic`. */
export type EncounterTaskProcedureCodeReferencesByBillingDiagnosticEncounterTaskIdAndProcedureCodeReferenceIdManyToManyEdge = {
  billingDiagnosticsId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `ProcedureCodeReference` at the end of the edge. */
  node: ProcedureCodeReference;
  updatedAt: Scalars['Datetime'];
};

export enum EncounterTaskStatusEnum {
  ClinicianReviewed = 'CLINICIAN_REVIEWED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  ResponderCompleted = 'RESPONDER_COMPLETED',
  Skipped = 'SKIPPED'
}

/** A connection to a list of `VitalLookup` values, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyConnection = {
  /** A list of edges which contains the `VitalLookup`, info from the `Vital`, and the cursor to aid in pagination. */
  edges: Array<EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdge>;
  /** A list of `VitalLookup` objects. */
  nodes: Array<VitalLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VitalLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VitalLookup` edge in the connection, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VitalLookup` at the end of the edge. */
  node: VitalLookup;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** A `VitalLookup` edge in the connection, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdgeVitalsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};


/** A `VitalLookup` edge in the connection, with data from `Vital`. */
export type EncounterTaskVitalLookupsByVitalEncounterTaskIdAndVitalLookupIdManyToManyEdgeVitalsListArgs = {
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};

/** A connection to a list of `EncounterTask` values. */
export type EncounterTasksConnection = {
  /** A list of edges which contains the `EncounterTask` and cursor to aid in pagination. */
  edges: Array<EncounterTasksEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection. */
export type EncounterTasksEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
};

/** Methods to use when ordering `EncounterTask`. */
export enum EncounterTasksOrderBy {
  EncounterIdAsc = 'ENCOUNTER_ID_ASC',
  EncounterIdDesc = 'ENCOUNTER_ID_DESC',
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Encounter` values. */
export type EncountersConnection = {
  /** A list of edges which contains the `Encounter` and cursor to aid in pagination. */
  edges: Array<EncountersEdge>;
  /** A list of `Encounter` objects. */
  nodes: Array<Encounter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Encounter` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Encounter` edge in the connection. */
export type EncountersEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Encounter` at the end of the edge. */
  node: Encounter;
};

/** Methods to use when ordering `Encounter`. */
export enum EncountersOrderBy {
  AppointmentIdAsc = 'APPOINTMENT_ID_ASC',
  AppointmentIdDesc = 'APPOINTMENT_ID_DESC',
  EncounterIdAsc = 'ENCOUNTER_ID_ASC',
  EncounterIdDesc = 'ENCOUNTER_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryInsuranceAsc = 'PRIMARY_INSURANCE_ASC',
  PrimaryInsuranceDesc = 'PRIMARY_INSURANCE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScheduledForAsc = 'SCHEDULED_FOR_ASC',
  ScheduledForDesc = 'SCHEDULED_FOR_DESC',
  SecondaryInsuranceAsc = 'SECONDARY_INSURANCE_ASC',
  SecondaryInsuranceDesc = 'SECONDARY_INSURANCE_DESC',
  ServiceLineIdAsc = 'SERVICE_LINE_ID_ASC',
  ServiceLineIdDesc = 'SERVICE_LINE_ID_DESC'
}

export type FeatureGate = Node & {
  createdAt: Scalars['Datetime'];
  featureId: Scalars['String'];
  isActive: Scalars['Boolean'];
  marketId: Array<Maybe<Scalars['Int']>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  zoneId: Array<Maybe<Scalars['Int']>>;
};

/**
 * A condition to be used against `FeatureGate` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FeatureGateCondition = {
  /** Checks for equality with the object’s `featureId` field. */
  featureId?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `FeatureGate` */
export type FeatureGateInput = {
  createdAt?: Maybe<Scalars['Datetime']>;
  featureId: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  marketId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  zoneId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** Represents an update to a `FeatureGate`. Fields that are set will be updated. */
export type FeatureGatePatch = {
  createdAt?: Maybe<Scalars['Datetime']>;
  featureId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  marketId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  zoneId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type FeatureGateResultOutput = {
  result?: Maybe<Scalars['Boolean']>;
};

/** A connection to a list of `FeatureGate` values. */
export type FeatureGatesConnection = {
  /** A list of edges which contains the `FeatureGate` and cursor to aid in pagination. */
  edges: Array<FeatureGatesEdge>;
  /** A list of `FeatureGate` objects. */
  nodes: Array<FeatureGate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeatureGate` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FeatureGate` edge in the connection. */
export type FeatureGatesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FeatureGate` at the end of the edge. */
  node: FeatureGate;
};

/** Methods to use when ordering `FeatureGate`. */
export enum FeatureGatesOrderBy {
  FeatureIdAsc = 'FEATURE_ID_ASC',
  FeatureIdDesc = 'FEATURE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum GenderIdentityEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  NonDisclose = 'NON_DISCLOSE',
  Other = 'OTHER',
  TransgenderFemale = 'TRANSGENDER_FEMALE',
  TransgenderMale = 'TRANSGENDER_MALE'
}

export enum GenderPronounEnum {
  HeHim = 'HE_HIM',
  SheHer = 'SHE_HER',
  TheyThem = 'THEY_THEM'
}

export type GenerateDoseSpotUrlRequest = {
  encounterId?: Maybe<Scalars['Int']>;
  marketId: Scalars['Int'];
  patientId: Scalars['Int'];
};

/** All input for the `grantItRole` mutation. */
export type GrantItRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `grantItRole` mutation. */
export type GrantItRolePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `grantItRole` mutation. */
export type GrantItRolePayloadUserEdgeArgs = {
  orderBy?: Maybe<Array<UsersOrderBy>>;
};

export type GrantRoleInput = {
  patch: GrantRolePatchRecordInput;
  userId: Scalars['Int'];
};

export type GrantRolePatchRecordInput = {
  credentials?: Maybe<Array<Maybe<CredentialsEnum>>>;
  dob?: Maybe<Scalars['Date']>;
  markets?: Maybe<Array<Maybe<Scalars['Int']>>>;
  npi?: Maybe<Scalars['String']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
  role?: Maybe<UserRoleEnum>;
};

export type GrantRolePayload = {
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export enum IdentifierTypeEnum {
  Dosespot = 'DOSESPOT',
  Npi = 'NPI'
}

/** Contains information an insurance record associated with a patient */
export type InsuranceRecord = Node & {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPrimaryInsuranceAndAppointmentId: InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPrimaryInsuranceAndAppointmentIdList: Array<Appointment>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterSecondaryInsuranceAndAppointmentId: InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterSecondaryInsuranceAndAppointmentIdList: Array<Appointment>;
  attachmentBackUrl?: Maybe<Scalars['JSON']>;
  attachmentFrontUrl?: Maybe<Scalars['JSON']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  groupNumber?: Maybe<Scalars['String']>;
  /** Integer Primary Key for record */
  insuranceRecordId: Scalars['Int'];
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsurance: InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsurance: InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceList: Array<InsuranceRecord>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  memberId?: Maybe<Scalars['String']>;
  noInsuranceCards?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  packageId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `InsuranceRecord`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterPrimaryInsuranceAndPatientId: InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterPrimaryInsuranceAndPatientIdList: Array<Patient>;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterSecondaryInsuranceAndPatientId: InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterSecondaryInsuranceAndPatientIdList: Array<Patient>;
  planType?: Maybe<Scalars['String']>;
  policyHolderDob?: Maybe<Scalars['Date']>;
  policyHolderFirstName?: Maybe<Scalars['String']>;
  policyHolderGender?: Maybe<SexEnum>;
  policyHolderLastName?: Maybe<Scalars['String']>;
  relationshipToPolicyHolder?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPrimaryInsuranceAndServiceLineId: InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPrimaryInsuranceAndServiceLineIdList: Array<ServiceLine>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterSecondaryInsuranceAndServiceLineId: InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterSecondaryInsuranceAndServiceLineIdList: Array<ServiceLine>;
  state?: Maybe<Scalars['String']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  /** Timestamp of when the record was last updated */
  updatedAt?: Maybe<Scalars['Datetime']>;
  zip?: Maybe<Scalars['String']>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordEncountersByPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordEncountersByPrimaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordEncountersBySecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordEncountersBySecondaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdListArgs = {
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdListArgs = {
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdListArgs = {
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information an insurance record associated with a patient */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdListArgs = {
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyConnection = {
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterPrimaryInsuranceAndAppointmentIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyConnection = {
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordAppointmentsByEncounterSecondaryInsuranceAndAppointmentIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/**
 * A condition to be used against `InsuranceRecord` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InsuranceRecordCondition = {
  /** Checks for equality with the object’s `insuranceRecordId` field. */
  insuranceRecordId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `InsuranceRecord` */
export type InsuranceRecordInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  attachmentBackUrl?: Maybe<Scalars['JSON']>;
  attachmentFrontUrl?: Maybe<Scalars['JSON']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  memberId?: Maybe<Scalars['String']>;
  noInsuranceCards?: Maybe<Scalars['Boolean']>;
  packageId?: Maybe<Scalars['String']>;
  patientId: Scalars['Int'];
  planType?: Maybe<Scalars['String']>;
  policyHolderDob?: Maybe<Scalars['Date']>;
  policyHolderFirstName?: Maybe<Scalars['String']>;
  policyHolderGender?: Maybe<SexEnum>;
  policyHolderLastName?: Maybe<Scalars['String']>;
  relationshipToPolicyHolder?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  zip?: Maybe<Scalars['String']>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterPrimaryInsuranceAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordInsuranceRecordsByEncounterSecondaryInsuranceAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** Represents an update to a `InsuranceRecord`. Fields that are set will be updated. */
export type InsuranceRecordPatch = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  attachmentBackUrl?: Maybe<Scalars['JSON']>;
  attachmentFrontUrl?: Maybe<Scalars['JSON']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  groupNumber?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  memberId?: Maybe<Scalars['String']>;
  noInsuranceCards?: Maybe<Scalars['Boolean']>;
  packageId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['Int']>;
  planType?: Maybe<Scalars['String']>;
  policyHolderDob?: Maybe<Scalars['Date']>;
  policyHolderFirstName?: Maybe<Scalars['String']>;
  policyHolderGender?: Maybe<SexEnum>;
  policyHolderLastName?: Maybe<Scalars['String']>;
  relationshipToPolicyHolder?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  /** Timestamp of when the record was last updated */
  updatedAt?: Maybe<Scalars['Datetime']>;
  zip?: Maybe<Scalars['String']>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyConnection = {
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterPrimaryInsuranceAndPatientIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyConnection = {
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordPatientsByEncounterSecondaryInsuranceAndPatientIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyConnection = {
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterPrimaryInsuranceAndServiceLineIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyConnection = {
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type InsuranceRecordServiceLinesByEncounterSecondaryInsuranceAndServiceLineIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values. */
export type InsuranceRecordsConnection = {
  /** A list of edges which contains the `InsuranceRecord` and cursor to aid in pagination. */
  edges: Array<InsuranceRecordsEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection. */
export type InsuranceRecordsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};

/** Methods to use when ordering `InsuranceRecord`. */
export enum InsuranceRecordsOrderBy {
  InsuranceRecordIdAsc = 'INSURANCE_RECORD_ID_ASC',
  InsuranceRecordIdDesc = 'INSURANCE_RECORD_ID_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** Contains contains information about the it role and mapping to user relation. */
export type ItRole = Node & {
  dosespotId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `ItRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/** A condition to be used against `ItRole` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ItRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ItRole` values. */
export type ItRolesConnection = {
  /** A list of edges which contains the `ItRole` and cursor to aid in pagination. */
  edges: Array<ItRolesEdge>;
  /** A list of `ItRole` objects. */
  nodes: Array<ItRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ItRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ItRole` edge in the connection. */
export type ItRolesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ItRole` at the end of the edge. */
  node: ItRole;
};

/** Methods to use when ordering `ItRole`. */
export enum ItRolesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type JobTagsInput = {
  id: Scalars['UUID'];
};

export type JoinTelehealthMeetingInput = {
  encounterTaskId: Scalars['Int'];
};

export type JoinTelehealthMeetingPayload = {
  telehealthMeeting?: Maybe<TelehealthMeeting>;
};

export enum LanguagesEnum {
  Albanian = 'ALBANIAN',
  Amharic = 'AMHARIC',
  Arabic = 'ARABIC',
  Armenian = 'ARMENIAN',
  Bengali = 'BENGALI',
  Chinese = 'CHINESE',
  Croation = 'CROATION',
  Czech = 'CZECH',
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  Finnish = 'FINNISH',
  French = 'FRENCH',
  Frysian = 'FRYSIAN',
  German = 'GERMAN',
  Greek = 'GREEK',
  Gujarati = 'GUJARATI',
  HaitianCreole = 'HAITIAN_CREOLE',
  Hindi = 'HINDI',
  Hmong = 'HMONG',
  Ibo = 'IBO',
  Ilocano = 'ILOCANO',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  Kru = 'KRU',
  Laotian = 'LAOTIAN',
  MonkhmerCambodian = 'MONKHMER_CAMBODIAN',
  Norwegian = 'NORWEGIAN',
  Panjabi = 'PANJABI',
  Persian = 'PERSIAN',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  Punjabi = 'PUNJABI',
  Russian = 'RUSSIAN',
  Samoan = 'SAMOAN',
  Serbian = 'SERBIAN',
  Spanish = 'SPANISH',
  Swedish = 'SWEDISH',
  Tagalog = 'TAGALOG',
  Telegu = 'TELEGU',
  Thai = 'THAI',
  Urdu = 'URDU',
  Vietnamese = 'VIETNAMESE',
  Yiddish = 'YIDDISH',
  Yoruba = 'YORUBA'
}

/** Contains information about the machine_application relation. */
export type MachineApplication = Node & {
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  machineApplicationId: Scalars['Int'];
  machineApplicationUuid: Scalars['UUID'];
  machineName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `MachineApplication` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MachineApplicationCondition = {
  /** Checks for equality with the object’s `machineApplicationId` field. */
  machineApplicationId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `machineApplicationUuid` field. */
  machineApplicationUuid?: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `MachineApplication` values. */
export type MachineApplicationsConnection = {
  /** A list of edges which contains the `MachineApplication` and cursor to aid in pagination. */
  edges: Array<MachineApplicationsEdge>;
  /** A list of `MachineApplication` objects. */
  nodes: Array<MachineApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MachineApplication` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MachineApplication` edge in the connection. */
export type MachineApplicationsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MachineApplication` at the end of the edge. */
  node: MachineApplication;
};

/** Methods to use when ordering `MachineApplication`. */
export enum MachineApplicationsOrderBy {
  MachineApplicationIdAsc = 'MACHINE_APPLICATION_ID_ASC',
  MachineApplicationIdDesc = 'MACHINE_APPLICATION_ID_DESC',
  MachineApplicationUuidAsc = 'MACHINE_APPLICATION_UUID_ASC',
  MachineApplicationUuidDesc = 'MACHINE_APPLICATION_UUID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about a market */
export type Market = Node & {
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsList: Array<Appointment>;
  createdAt: Scalars['Datetime'];
  endTimes: Array<Maybe<Scalars['Time']>>;
  frozenById?: Maybe<Scalars['Int']>;
  frozenByUser?: Maybe<User>;
  frozenReason?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isFrozen: Scalars['Boolean'];
  launchTimestamp?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookups: MarketChannelAttributionLookupsConnection;
  /** Reads and enables pagination through a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookupsList: Array<MarketChannelAttributionLookup>;
  /** Reads and enables pagination through a set of `MarketClinic`. */
  marketClinics: MarketClinicsConnection;
  /** Reads and enables pagination through a set of `MarketClinic`. */
  marketClinicsList: Array<MarketClinic>;
  marketId: Scalars['Int'];
  /** Reads and enables pagination through a set of `MarketPatientFormLookup`. */
  marketPatientFormLookups: MarketPatientFormLookupsConnection;
  /** Reads and enables pagination through a set of `MarketPatientFormLookup`. */
  marketPatientFormLookupsList: Array<MarketPatientFormLookup>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operationalDays?: Maybe<Array<Maybe<Scalars['Int']>>>;
  scheduledFreezeById?: Maybe<Scalars['Int']>;
  scheduledFreezeByUser?: Maybe<User>;
  scheduledFreezeEndTime?: Maybe<Scalars['Datetime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['Datetime']>;
  startTimes: Array<Maybe<Scalars['Time']>>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `User`. */
  usersByAppointmentMarketIdAndCreatedBy: MarketUsersByAppointmentMarketIdAndCreatedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByAppointmentMarketIdAndCreatedByList: Array<User>;
  /** Reads and enables pagination through a set of `Zone`. */
  zones: ZonesConnection;
  /** Reads and enables pagination through a set of `Zone`. */
  zonesList: Array<Zone>;
};


/** Contains information about a market */
export type MarketAppointmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about a market */
export type MarketAppointmentsListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about a market */
export type MarketMarketChannelAttributionLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketChannelAttributionLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketMarketChannelAttributionLookupsListArgs = {
  condition?: Maybe<MarketChannelAttributionLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketMarketClinicsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketClinicCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketClinicsOrderBy>>;
};


/** Contains information about a market */
export type MarketMarketClinicsListArgs = {
  condition?: Maybe<MarketClinicCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketClinicsOrderBy>>;
};


/** Contains information about a market */
export type MarketMarketPatientFormLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketPatientFormLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketMarketPatientFormLookupsListArgs = {
  condition?: Maybe<MarketPatientFormLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** Contains information about a market */
export type MarketUsersByAppointmentMarketIdAndCreatedByArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<UserCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UsersOrderBy>>;
};


/** Contains information about a market */
export type MarketUsersByAppointmentMarketIdAndCreatedByListArgs = {
  condition?: Maybe<UserCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UsersOrderBy>>;
};


/** Contains information about a market */
export type MarketZonesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZoneCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZonesOrderBy>>;
};


/** Contains information about a market */
export type MarketZonesListArgs = {
  condition?: Maybe<ZoneCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZonesOrderBy>>;
};

/** Lookup table mapping markets to channel attribution */
export type MarketChannelAttributionLookup = Node & {
  channelAttributionId: Scalars['Int'];
  /** Reads a single `Market` that is related to this `MarketChannelAttributionLookup`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `MarketChannelAttributionLookup` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MarketChannelAttributionLookupCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `MarketChannelAttributionLookup` values. */
export type MarketChannelAttributionLookupsConnection = {
  /** A list of edges which contains the `MarketChannelAttributionLookup` and cursor to aid in pagination. */
  edges: Array<MarketChannelAttributionLookupsEdge>;
  /** A list of `MarketChannelAttributionLookup` objects. */
  nodes: Array<MarketChannelAttributionLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketChannelAttributionLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketChannelAttributionLookup` edge in the connection. */
export type MarketChannelAttributionLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketChannelAttributionLookup` at the end of the edge. */
  node: MarketChannelAttributionLookup;
};

/** Methods to use when ordering `MarketChannelAttributionLookup`. */
export enum MarketChannelAttributionLookupsOrderBy {
  MarketIdAsc = 'MARKET_ID_ASC',
  MarketIdDesc = 'MARKET_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type MarketClinic = Node & {
  clinicId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  updatedBy: Scalars['Int'];
};

/**
 * A condition to be used against `MarketClinic` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MarketClinicCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `MarketClinic` */
export type MarketClinicInput = {
  clinicId: Scalars['Int'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  marketId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy: Scalars['Int'];
};

/** Represents an update to a `MarketClinic`. Fields that are set will be updated. */
export type MarketClinicPatch = {
  clinicId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  marketId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `MarketClinic` values. */
export type MarketClinicsConnection = {
  /** A list of edges which contains the `MarketClinic` and cursor to aid in pagination. */
  edges: Array<MarketClinicsEdge>;
  /** A list of `MarketClinic` objects. */
  nodes: Array<MarketClinic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketClinic` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketClinic` edge in the connection. */
export type MarketClinicsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketClinic` at the end of the edge. */
  node: MarketClinic;
};

/** Methods to use when ordering `MarketClinic`. */
export enum MarketClinicsOrderBy {
  MarketIdAsc = 'MARKET_ID_ASC',
  MarketIdDesc = 'MARKET_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Market` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MarketCondition = {
  /** Filters to records matching isActive */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Filters to records matching isDeleted */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Filters to records matching isFrozen */
  isFrozen?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
};

/** Contains information about the mapping between the market table and the patient_form_lookup table */
export type MarketPatientFormLookup = Node & {
  /** Reads a single `Market` that is related to this `MarketPatientFormLookup`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFormLookupId: Scalars['Int'];
};

/**
 * A condition to be used against `MarketPatientFormLookup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MarketPatientFormLookupCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `MarketPatientFormLookup` values. */
export type MarketPatientFormLookupsConnection = {
  /** A list of edges which contains the `MarketPatientFormLookup` and cursor to aid in pagination. */
  edges: Array<MarketPatientFormLookupsEdge>;
  /** A list of `MarketPatientFormLookup` objects. */
  nodes: Array<MarketPatientFormLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketPatientFormLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketPatientFormLookup` edge in the connection. */
export type MarketPatientFormLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketPatientFormLookup` at the end of the edge. */
  node: MarketPatientFormLookup;
};

/** Methods to use when ordering `MarketPatientFormLookup`. */
export enum MarketPatientFormLookupsOrderBy {
  MarketIdAsc = 'MARKET_ID_ASC',
  MarketIdDesc = 'MARKET_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about questionnaire markets */
export type MarketQuestionnaireLookup = Node & {
  marketId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  questionnaireLookupId: Scalars['Int'];
};

/**
 * A condition to be used against `MarketQuestionnaireLookup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type MarketQuestionnaireLookupCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `MarketQuestionnaireLookup` values. */
export type MarketQuestionnaireLookupsConnection = {
  /** A list of edges which contains the `MarketQuestionnaireLookup` and cursor to aid in pagination. */
  edges: Array<MarketQuestionnaireLookupsEdge>;
  /** A list of `MarketQuestionnaireLookup` objects. */
  nodes: Array<MarketQuestionnaireLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MarketQuestionnaireLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MarketQuestionnaireLookup` edge in the connection. */
export type MarketQuestionnaireLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MarketQuestionnaireLookup` at the end of the edge. */
  node: MarketQuestionnaireLookup;
};

/** Methods to use when ordering `MarketQuestionnaireLookup`. */
export enum MarketQuestionnaireLookupsOrderBy {
  MarketIdAsc = 'MARKET_ID_ASC',
  MarketIdDesc = 'MARKET_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `User` values, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyConnection = {
  /** A list of edges which contains the `User`, info from the `Appointment`, and the cursor to aid in pagination. */
  edges: Array<MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdge = {
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedBy: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedByList: Array<Appointment>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};


/** A `User` edge in the connection, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdgeAppointmentsByCreatedByArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** A `User` edge in the connection, with data from `Appointment`. */
export type MarketUsersByAppointmentMarketIdAndCreatedByManyToManyEdgeAppointmentsByCreatedByListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};

/** A connection to a list of `Market` values. */
export type MarketsConnection = {
  /** A list of edges which contains the `Market` and cursor to aid in pagination. */
  edges: Array<MarketsEdge>;
  /** A list of `Market` objects. */
  nodes: Array<Market>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Market` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Market` edge in the connection. */
export type MarketsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Market` at the end of the edge. */
  node: Market;
};

/** Methods to use when ordering `Market`. */
export enum MarketsOrderBy {
  MarketIdAsc = 'MARKET_ID_ASC',
  MarketIdDesc = 'MARKET_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains data related to Medical Decision Making */
export type MedicalDecisionMaking = Node & {
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  medicalDecisionMakingId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `MedicalDecisionMaking` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MedicalDecisionMakingCondition = {
  /** Checks for equality with the object’s `medicalDecisionMakingId` field. */
  medicalDecisionMakingId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `MedicalDecisionMaking` values. */
export type MedicalDecisionMakingsConnection = {
  /** A list of edges which contains the `MedicalDecisionMaking` and cursor to aid in pagination. */
  edges: Array<MedicalDecisionMakingsEdge>;
  /** A list of `MedicalDecisionMaking` objects. */
  nodes: Array<MedicalDecisionMaking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MedicalDecisionMaking` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MedicalDecisionMaking` edge in the connection. */
export type MedicalDecisionMakingsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MedicalDecisionMaking` at the end of the edge. */
  node: MedicalDecisionMaking;
};

/** Methods to use when ordering `MedicalDecisionMaking`. */
export enum MedicalDecisionMakingsOrderBy {
  MedicalDecisionMakingIdAsc = 'MEDICAL_DECISION_MAKING_ID_ASC',
  MedicalDecisionMakingIdDesc = 'MEDICAL_DECISION_MAKING_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type MedicalDirector = Node & {
  clinicId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  dosespotAuthId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  medicalDirectorId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  userId?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `MedicalDirector` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MedicalDirectorCondition = {
  /** Checks for equality with the object’s `medicalDirectorId` field. */
  medicalDirectorId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `MedicalDirector` */
export type MedicalDirectorInput = {
  clinicId: Scalars['Int'];
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  dosespotAuthId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  userId?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `MedicalDirector`. Fields that are set will be updated. */
export type MedicalDirectorPatch = {
  clinicId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  dosespotAuthId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `MedicalDirector` values. */
export type MedicalDirectorsConnection = {
  /** A list of edges which contains the `MedicalDirector` and cursor to aid in pagination. */
  edges: Array<MedicalDirectorsEdge>;
  /** A list of `MedicalDirector` objects. */
  nodes: Array<MedicalDirector>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MedicalDirector` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `MedicalDirector` edge in the connection. */
export type MedicalDirectorsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MedicalDirector` at the end of the edge. */
  node: MedicalDirector;
};

/** Methods to use when ordering `MedicalDirector`. */
export enum MedicalDirectorsOrderBy {
  MedicalDirectorIdAsc = 'MEDICAL_DIRECTOR_ID_ASC',
  MedicalDirectorIdDesc = 'MEDICAL_DIRECTOR_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about ReadyCore modules */
export type Module = Node & {
  createdAt: Scalars['Datetime'];
  name: ModuleNameEnum;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  skeduloTag?: Maybe<Scalars['String']>;
};

/** A condition to be used against `Module` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ModuleCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<ModuleNameEnum>;
};

export enum ModuleNameEnum {
  Clinician = 'CLINICIAN',
  ClinicianActivation = 'CLINICIAN_ACTIVATION',
  Default = 'DEFAULT',
  EmsActivation = 'EMS_ACTIVATION',
  FormAbnNoncoverage = 'FORM_ABN_NONCOVERAGE',
  FormAma = 'FORM_AMA',
  FormAuditC = 'FORM_AUDIT_C',
  FormCommunityCare = 'FORM_COMMUNITY_CARE',
  FormDast_10 = 'FORM_DAST_10',
  FormGad_7 = 'FORM_GAD_7',
  FormKatzAdl = 'FORM_KATZ_ADL',
  FormMoriskyRxAdherence = 'FORM_MORISKY_RX_ADHERENCE',
  FormMorseFall = 'FORM_MORSE_FALL',
  FormPain = 'FORM_PAIN',
  FormPhq = 'FORM_PHQ',
  FormPostpartumDepression = 'FORM_POSTPARTUM_DEPRESSION',
  FormRadGeneral = 'FORM_RAD_GENERAL',
  FormReleaseMedical = 'FORM_RELEASE_MEDICAL',
  FormSdoh = 'FORM_SDOH',
  FormTechnology = 'FORM_TECHNOLOGY',
  Note = 'NOTE',
  TestA1C = 'TEST_A1C',
  TestA1COrder = 'TEST_A1C_ORDER',
  TestCovid = 'TEST_COVID',
  TestCovidAntibody = 'TEST_COVID_ANTIBODY',
  TestCovidOrder = 'TEST_COVID_ORDER',
  TestFluAntigen = 'TEST_FLU_ANTIGEN',
  TestFluAntigenOrder = 'TEST_FLU_ANTIGEN_ORDER',
  TestGlucose = 'TEST_GLUCOSE',
  TestGlucoseOrder = 'TEST_GLUCOSE_ORDER',
  TestPregnancy = 'TEST_PREGNANCY',
  TestPregnancyOrder = 'TEST_PREGNANCY_ORDER',
  TestRsv = 'TEST_RSV',
  TestRsvOrder = 'TEST_RSV_ORDER',
  TestStrep = 'TEST_STREP',
  TestStrepOrder = 'TEST_STREP_ORDER',
  VaccineCovid = 'VACCINE_COVID',
  VaccineFlu = 'VACCINE_FLU',
  Vitals = 'VITALS',
  VitalsAdditional = 'VITALS_ADDITIONAL'
}

/** Contains information about the mapping between the module table and the encounter_task table */
export type ModuleTaskMapping = Node & {
  createdAt: Scalars['Datetime'];
  dataCategory?: Maybe<Scalars['String']>;
  dataType: Scalars['String'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  group: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  moduleName: ModuleNameEnum;
  moduleTaskMappingId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  partner: Scalars['String'];
  rank?: Maybe<Scalars['BigFloat']>;
  taskName: Scalars['String'];
  taskRoles: Array<Maybe<UserRoleEnum>>;
};

/**
 * A condition to be used against `ModuleTaskMapping` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ModuleTaskMappingCondition = {
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `moduleTaskMappingId` field. */
  moduleTaskMappingId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ModuleTaskMapping` values. */
export type ModuleTaskMappingsConnection = {
  /** A list of edges which contains the `ModuleTaskMapping` and cursor to aid in pagination. */
  edges: Array<ModuleTaskMappingsEdge>;
  /** A list of `ModuleTaskMapping` objects. */
  nodes: Array<ModuleTaskMapping>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ModuleTaskMapping` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ModuleTaskMapping` edge in the connection. */
export type ModuleTaskMappingsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ModuleTaskMapping` at the end of the edge. */
  node: ModuleTaskMapping;
};

/** Methods to use when ordering `ModuleTaskMapping`. */
export enum ModuleTaskMappingsOrderBy {
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  ModuleTaskMappingIdAsc = 'MODULE_TASK_MAPPING_ID_ASC',
  ModuleTaskMappingIdDesc = 'MODULE_TASK_MAPPING_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `Module` values. */
export type ModulesConnection = {
  /** A list of edges which contains the `Module` and cursor to aid in pagination. */
  edges: Array<ModulesEdge>;
  /** A list of `Module` objects. */
  nodes: Array<Module>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Module` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Module` edge in the connection. */
export type ModulesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Module` at the end of the edge. */
  node: Module;
};

/** Methods to use when ordering `Module`. */
export enum ModulesOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  addEncounter?: Maybe<AddEncounterPayload>;
  addStandingOrder?: Maybe<AddStandingOrderPayload>;
  /** Cancels a single `Appointment` using a unique key and a patch. */
  cancelAppointment?: Maybe<CancelAppointmentPayload>;
  /** Cancels a single `Appointment` using a unique globalId key and a patch. */
  cancelAppointmentByGlobalId?: Maybe<CancelAppointmentPayload>;
  cancelEncounters?: Maybe<Array<Maybe<Encounter>>>;
  claimEncounter?: Maybe<ClaimEncounterPayload>;
  createAddendum?: Maybe<CreateAddendumPayload>;
  /** Takes a create_appointment_input and creates a new appointment with associated encounters and insurance records */
  createAppointment?: Maybe<CreateAppointmentPayload>;
  /** Creates a single `AppointmentDispatch`. */
  createAppointmentDispatch?: Maybe<CreateAppointmentDispatchPayload>;
  /** Creates a single `AppointmentTag`. */
  createAppointmentTag?: Maybe<CreateAppointmentTagPayload>;
  /** Creates a single `ChannelAttribution`. */
  createChannelAttribution?: Maybe<SaveChannelAttributionPayload>;
  /** Creates a single `Clinic`. */
  createClinic?: Maybe<CreateClinicPayload>;
  createClinicianEncounterSignature?: Maybe<UpsertClinicianSignaturePayload>;
  /** Creates a single `CodeSystem`. */
  createCodeSystem?: Maybe<CreateCodeSystemPayload>;
  createEmrAuditLogs?: Maybe<EmrAuditLogPayload>;
  /** Creates a single `EncounterSignature`. */
  createEncounterSignature?: Maybe<CreateEncounterSignaturePayload>;
  /** Creates a single `EncounterTaskAttachment`. */
  createEncounterTaskAttachment?: Maybe<CreateEncounterTaskAttachmentPayload>;
  /** Creates a single `FeatureGate`. */
  createFeatureGate?: Maybe<CreateFeatureGatePayload>;
  /** Creates a single `InsuranceRecord`. */
  createInsuranceRecord?: Maybe<CreateInsuranceRecordPayload>;
  /** Creates a single `MarketClinic`. */
  createMarketClinic?: Maybe<CreateMarketClinicPayload>;
  /** Creates a single `MedicalDirector`. */
  createMedicalDirector?: Maybe<CreateMedicalDirectorPayload>;
  /** Takes a PatientInput and creates a new patient or returns existing if match on global patient id exists. */
  createPatient?: Maybe<CreatePatientPayload>;
  /** Takes encounter_task_id, patient_form_lookup_id, formstack_id, signed_at, field_response and creates a new patient_form record */
  createPatientForm?: Maybe<CreatePatientFormPayload>;
  /** Takes a createPatientNote and creates a new PatientNote. */
  createPatientNote?: Maybe<CreatePatientNotePayload>;
  /** Creates a single `PhysicalExam`. */
  createPhysicalExam?: Maybe<CreatePhysicalExamPayload>;
  createResponderEncounterSignature?: Maybe<UpsertResponderSignaturePayload>;
  createSkeduloAppointment?: Maybe<SkeduloAppointmentCreationPayload>;
  createStandingOrder?: Maybe<SaveStandingOrderPayload>;
  /** Deletes a single `AppointmentTag` using a unique key. */
  deleteAppointmentTag?: Maybe<DeleteAppointmentTagPayload>;
  /** Deletes a single `AppointmentTag` using its globally unique id. */
  deleteAppointmentTagByNodeId?: Maybe<DeleteAppointmentTagPayload>;
  /** Deletes a single `Clinic` using a unique key. */
  deleteClinic?: Maybe<DeleteClinicPayload>;
  /** Deletes a single `Clinic` using its globally unique id. */
  deleteClinicByNodeId?: Maybe<DeleteClinicPayload>;
  /** Deletes a single `CodeSystem` using a unique key. */
  deleteCodeSystem?: Maybe<DeleteCodeSystemPayload>;
  /** Deletes a single `CodeSystem` using its globally unique id. */
  deleteCodeSystemByNodeId?: Maybe<DeleteCodeSystemPayload>;
  /** Deletes a single `FeatureGate` using a unique key. */
  deleteFeatureGate?: Maybe<DeleteFeatureGatePayload>;
  /** Deletes a single `FeatureGate` using its globally unique id. */
  deleteFeatureGateByNodeId?: Maybe<DeleteFeatureGatePayload>;
  /** Deletes a single `MarketClinic` using a unique key. */
  deleteMarketClinic?: Maybe<DeleteMarketClinicPayload>;
  /** Deletes a single `MarketClinic` using its globally unique id. */
  deleteMarketClinicByNodeId?: Maybe<DeleteMarketClinicPayload>;
  /** Deletes a single `MedicalDirector` using a unique key. */
  deleteMedicalDirector?: Maybe<DeleteMedicalDirectorPayload>;
  /** Deletes a single `MedicalDirector` using its globally unique id. */
  deleteMedicalDirectorByNodeId?: Maybe<DeleteMedicalDirectorPayload>;
  /** Deletes a single `PhysicalExam` using a unique key. */
  deletePhysicalExam?: Maybe<DeletePhysicalExamPayload>;
  /** Deletes a single `PhysicalExam` using its globally unique id. */
  deletePhysicalExamByNodeId?: Maybe<DeletePhysicalExamPayload>;
  generateDoseSpotURL?: Maybe<Scalars['String']>;
  /** creates it role for user */
  grantItRole?: Maybe<GrantItRolePayload>;
  grantRole?: Maybe<GrantRolePayload>;
  joinTelehealthMeeting?: Maybe<JoinTelehealthMeetingPayload>;
  rescheduleSkeduloAppointment?: Maybe<RescheduleAppointmentCreationPayload>;
  revertTransitionEncounterTaskToClinicianReviewed?: Maybe<RevertTransitionEncounterTaskToClinicianReviewedPayload>;
  revertTransitionEncounterTaskToResponderCompleted?: Maybe<RevertTransitionEncounterTaskToResponderCompletedPayload>;
  /** deletes it role for user */
  revokeItRole?: Maybe<RevokeItRolePayload>;
  revokeRole?: Maybe<RevokeRolePayload>;
  /**
   * Syncs data from SkeduloJobAllocation input data to a
   * single `AppointmentDispatch` using a unique resourceId
   * and jobAllocationId keys.
   */
  syncSkeduloJobToAppointmentDispatch?: Maybe<SyncSkeduloJobToAppointmentDispatchPayload>;
  unclaimEncounter?: Maybe<UnclaimEncounterPayload>;
  /** Updates a single `Appointment` using a unique key and a patch. */
  updateAppointment?: Maybe<UpdateAppointmentPayload>;
  /** Updates a single `Appointment` using a unique globalId key and a patch. */
  updateAppointmentByGlobalId?: Maybe<UpdateAppointmentPayload>;
  /** Updates a single `AppointmentDispatch` using a unique key and a patch. */
  updateAppointmentDispatch?: Maybe<UpdateAppointmentDispatchPayload>;
  /** Updates a single `AppointmentDispatch` using its globally unique id and a patch. */
  updateAppointmentDispatchByNodeId?: Maybe<UpdateAppointmentDispatchPayload>;
  /** Updates a single `AppointmentTag` using a unique key and a patch. */
  updateAppointmentTag?: Maybe<UpdateAppointmentTagPayload>;
  /** Updates a single `AppointmentTag` using its globally unique id and a patch. */
  updateAppointmentTagByNodeId?: Maybe<UpdateAppointmentTagPayload>;
  /** Updates a single `ChannelAttribution`. */
  updateChannelAttribution?: Maybe<SaveChannelAttributionPayload>;
  /** Updates a single `Clinic` using a unique key and a patch. */
  updateClinic?: Maybe<UpdateClinicPayload>;
  /** Updates a single `Clinic` using its globally unique id and a patch. */
  updateClinicByNodeId?: Maybe<UpdateClinicPayload>;
  /** Updates a single `CodeSystem` using a unique key and a patch. */
  updateCodeSystem?: Maybe<UpdateCodeSystemPayload>;
  /** Updates a single `CodeSystem` using its globally unique id and a patch. */
  updateCodeSystemByNodeId?: Maybe<UpdateCodeSystemPayload>;
  /** Updates a single `Encounter` using a unique key and a patch. */
  updateEncounter?: Maybe<UpdateEncounterPayload>;
  /** Updates a single `Encounter` using its globally unique id and a patch. */
  updateEncounterByNodeId?: Maybe<UpdateEncounterPayload>;
  /** Updates a single `EncounterTask` using a unique key and a patch. */
  updateEncounterTask?: Maybe<UpdateEncounterTaskPayload>;
  /** Updates a single `EncounterTaskAttachment` using a unique key and a patch. */
  updateEncounterTaskAttachment?: Maybe<UpdateEncounterTaskAttachmentPayload>;
  /** Updates a single `EncounterTaskAttachment` using its globally unique id and a patch. */
  updateEncounterTaskAttachmentByNodeId?: Maybe<UpdateEncounterTaskAttachmentPayload>;
  /** Updates a single `EncounterTask` using its globally unique id and a patch. */
  updateEncounterTaskByNodeId?: Maybe<UpdateEncounterTaskPayload>;
  updateEncounterTaskTaskRoles?: Maybe<UpdateEncounterTaskTaskRolesPayload>;
  updateEncounterTaskTaskRolesOnEncounterComplete?: Maybe<UpdateEncounterTaskTaskRolesOnEncounterCompletePayload>;
  /** Updates a single `FeatureGate` using a unique key and a patch. */
  updateFeatureGate?: Maybe<UpdateFeatureGatePayload>;
  /** Updates a single `FeatureGate` using its globally unique id and a patch. */
  updateFeatureGateByNodeId?: Maybe<UpdateFeatureGatePayload>;
  /** Updates a single `InsuranceRecord` using a unique key and a patch. */
  updateInsuranceRecord?: Maybe<UpdateInsuranceRecordPayload>;
  /** Updates a single `InsuranceRecord` using its globally unique id and a patch. */
  updateInsuranceRecordByNodeId?: Maybe<UpdateInsuranceRecordPayload>;
  /** Updates a single `MarketClinic` using a unique key and a patch. */
  updateMarketClinic?: Maybe<UpdateMarketClinicPayload>;
  /** Updates a single `MarketClinic` using its globally unique id and a patch. */
  updateMarketClinicByNodeId?: Maybe<UpdateMarketClinicPayload>;
  /** Updates a single `MedicalDirector` using a unique key and a patch. */
  updateMedicalDirector?: Maybe<UpdateMedicalDirectorPayload>;
  /** Updates a single `MedicalDirector` using its globally unique id and a patch. */
  updateMedicalDirectorByNodeId?: Maybe<UpdateMedicalDirectorPayload>;
  /** Takes a PatientPatch and creates and updates matching patient if exists, returning updated patient. */
  updatePatient?: Maybe<UpdatePatientPayload>;
  /** Updates a single `PatientAttachment` using a unique key and a patch. */
  updatePatientAttachment?: Maybe<UpdatePatientAttachmentPayload>;
  /** Updates a single `PatientAttachment` using its globally unique id and a patch. */
  updatePatientAttachmentByNodeId?: Maybe<UpdatePatientAttachmentPayload>;
  /** Takes a PatientNotePatch and updates patient_note by patient_note_id if exists. */
  updatePatientNote?: Maybe<UpdatePatientNotePayload>;
  /** Updates a single `PhysicalExam` using a unique key and a patch. */
  updatePhysicalExam?: Maybe<UpdatePhysicalExamPayload>;
  /** Updates a single `PhysicalExam` using its globally unique id and a patch. */
  updatePhysicalExamByNodeId?: Maybe<UpdatePhysicalExamPayload>;
  /** Updates `ResponderRole` using an input. */
  updateResponderDeputyId?: Maybe<UpdateResponderDeputyIdPayload>;
  /** Updates `ResponderRole` using an input. */
  updateResponderSkeduloId?: Maybe<UpdateResponderSkeduloIdPayload>;
  updateStandingOrder?: Maybe<SaveStandingOrderPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateVideoConference?: Maybe<UpdateVideoConferencePayload>;
  upsertEncounterTask?: Maybe<UpsertEncounterTaskPayload>;
  upsertMarkets?: Maybe<UpsertMarketsPayload>;
  /** takes an array of user_profiles and will upsert each matching user record with the profile data */
  upsertUsers?: Maybe<UpsertUsersPayload>;
  upsertZipcodes?: Maybe<UpsertZipcodesPayload>;
  upsertZoneZipcodes?: Maybe<UpsertZoneZipcodePayload>;
  upsertZones?: Maybe<UpsertZonesPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddEncounterArgs = {
  input: AddEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddStandingOrderArgs = {
  input: AddStandingOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelAppointmentArgs = {
  input: CancelAppointmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelAppointmentByGlobalIdArgs = {
  input: CancelAppointmentByGlobalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCancelEncountersArgs = {
  input?: Maybe<CancelEncountersInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationClaimEncounterArgs = {
  input: ClaimEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAddendumArgs = {
  input: CreateAddendumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAppointmentArgs = {
  input: CreateAppointmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAppointmentDispatchArgs = {
  input: CreateAppointmentDispatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAppointmentTagArgs = {
  input: CreateAppointmentTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChannelAttributionArgs = {
  input: CreateChannelAttributionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClinicArgs = {
  input: CreateClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClinicianEncounterSignatureArgs = {
  input: CreateClinicianEncounterSignatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCodeSystemArgs = {
  input: CreateCodeSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmrAuditLogsArgs = {
  logs?: Maybe<Array<Maybe<EmrAuditLogInput>>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEncounterSignatureArgs = {
  input: CreateEncounterSignatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEncounterTaskAttachmentArgs = {
  input: CreateEncounterTaskAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeatureGateArgs = {
  input: CreateFeatureGateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInsuranceRecordArgs = {
  input: CreateInsuranceRecordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMarketClinicArgs = {
  input: CreateMarketClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMedicalDirectorArgs = {
  input: CreateMedicalDirectorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePatientArgs = {
  input: CreatePatientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePatientFormArgs = {
  input: CreatePatientFormInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePatientNoteArgs = {
  input: CreatePatientNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePhysicalExamArgs = {
  input: CreatePhysicalExamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateResponderEncounterSignatureArgs = {
  input: CreateResponderEncounterSignatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSkeduloAppointmentArgs = {
  input?: Maybe<SkeduloAppointmentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStandingOrderArgs = {
  input?: Maybe<CreateStandingOrderInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppointmentTagArgs = {
  input: DeleteAppointmentTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppointmentTagByNodeIdArgs = {
  input: DeleteAppointmentTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicArgs = {
  input: DeleteClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicByNodeIdArgs = {
  input: DeleteClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCodeSystemArgs = {
  input: DeleteCodeSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCodeSystemByNodeIdArgs = {
  input: DeleteCodeSystemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureGateArgs = {
  input: DeleteFeatureGateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureGateByNodeIdArgs = {
  input: DeleteFeatureGateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMarketClinicArgs = {
  input: DeleteMarketClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMarketClinicByNodeIdArgs = {
  input: DeleteMarketClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMedicalDirectorArgs = {
  input: DeleteMedicalDirectorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMedicalDirectorByNodeIdArgs = {
  input: DeleteMedicalDirectorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhysicalExamArgs = {
  input: DeletePhysicalExamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePhysicalExamByNodeIdArgs = {
  input: DeletePhysicalExamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateDoseSpotUrlArgs = {
  input: GenerateDoseSpotUrlRequest;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGrantItRoleArgs = {
  input: GrantItRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGrantRoleArgs = {
  input: GrantRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationJoinTelehealthMeetingArgs = {
  input: JoinTelehealthMeetingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRescheduleSkeduloAppointmentArgs = {
  input?: Maybe<RescheduleAppointmentInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevertTransitionEncounterTaskToClinicianReviewedArgs = {
  input: RevertTransitionEncounterTaskToClinicianReviewedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevertTransitionEncounterTaskToResponderCompletedArgs = {
  input: RevertTransitionEncounterTaskToResponderCompletedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeItRoleArgs = {
  input: RevokeItRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeRoleArgs = {
  input: RevokeRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSyncSkeduloJobToAppointmentDispatchArgs = {
  input: SyncSkeduloJobToAppointmentDispatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnclaimEncounterArgs = {
  input: UnclaimEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentArgs = {
  input: UpdateAppointmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentByGlobalIdArgs = {
  input: UpdateAppointmentByGlobalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentDispatchArgs = {
  input: UpdateAppointmentDispatchInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentDispatchByNodeIdArgs = {
  input: UpdateAppointmentDispatchByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentTagArgs = {
  input: UpdateAppointmentTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentTagByNodeIdArgs = {
  input: UpdateAppointmentTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelAttributionArgs = {
  input: UpdateChannelAttributionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicArgs = {
  input: UpdateClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicByNodeIdArgs = {
  input: UpdateClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCodeSystemArgs = {
  input: UpdateCodeSystemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCodeSystemByNodeIdArgs = {
  input: UpdateCodeSystemByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterArgs = {
  input: UpdateEncounterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterByNodeIdArgs = {
  input: UpdateEncounterByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterTaskArgs = {
  input: UpdateEncounterTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterTaskAttachmentArgs = {
  input: UpdateEncounterTaskAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterTaskAttachmentByNodeIdArgs = {
  input: UpdateEncounterTaskAttachmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterTaskByNodeIdArgs = {
  input: UpdateEncounterTaskByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterTaskTaskRolesArgs = {
  input: UpdateEncounterTaskTaskRolesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEncounterTaskTaskRolesOnEncounterCompleteArgs = {
  input: UpdateEncounterTaskTaskRolesOnEncounterCompleteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureGateArgs = {
  input: UpdateFeatureGateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureGateByNodeIdArgs = {
  input: UpdateFeatureGateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInsuranceRecordArgs = {
  input: UpdateInsuranceRecordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInsuranceRecordByNodeIdArgs = {
  input: UpdateInsuranceRecordByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMarketClinicArgs = {
  input: UpdateMarketClinicInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMarketClinicByNodeIdArgs = {
  input: UpdateMarketClinicByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMedicalDirectorArgs = {
  input: UpdateMedicalDirectorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMedicalDirectorByNodeIdArgs = {
  input: UpdateMedicalDirectorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientAttachmentArgs = {
  input: UpdatePatientAttachmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientAttachmentByNodeIdArgs = {
  input: UpdatePatientAttachmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientNoteArgs = {
  input: UpdatePatientNoteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhysicalExamArgs = {
  input: UpdatePhysicalExamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePhysicalExamByNodeIdArgs = {
  input: UpdatePhysicalExamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResponderDeputyIdArgs = {
  input: UpdateResponderDeputyIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResponderSkeduloIdArgs = {
  input: UpdateResponderSkeduloIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStandingOrderArgs = {
  input: UpdateStandingOrderInput;
  standingOrderId: Scalars['Int'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVideoConferenceArgs = {
  input: UpdateVideoConferenceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertEncounterTaskArgs = {
  input: UpsertEncounterTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMarketsArgs = {
  input: UpsertMarketsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUsersArgs = {
  input: UpsertUsersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertZipcodesArgs = {
  input: UpsertZipcodesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertZoneZipcodesArgs = {
  input: UpsertZoneZipcodeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertZonesArgs = {
  input: UpsertZonesInput;
};

export enum NoInsuranceReasonEnum {
  CannotFindInsuranceCards = 'CANNOT_FIND_INSURANCE_CARDS',
  Uninsured = 'UNINSURED'
}

export enum NoSsnReasonEnum {
  DoesNotHaveOne = 'DOES_NOT_HAVE_ONE',
  Refused = 'REFUSED'
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export enum NonNullableSystemOfOrigin {
  ReadyCare = 'READY_CARE',
  ReadyHealth_1 = 'READY_HEALTH_1',
  ReadyHealth_2 = 'READY_HEALTH_2',
  ReadyOps = 'READY_OPS',
  ReadyWebhooks = 'READY_WEBHOOKS',
  ReadyZen = 'READY_ZEN',
  WebBooking = 'WEB_BOOKING'
}

/** Contains contains information about the ops role and mapping to user relation. */
export type OpsRole = Node & {
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  opsAdmin: Scalars['Boolean'];
  skeduloId?: Maybe<Scalars['UUID']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `OpsRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/** A condition to be used against `OpsRole` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type OpsRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `OpsRole` values. */
export type OpsRolesConnection = {
  /** A list of edges which contains the `OpsRole` and cursor to aid in pagination. */
  edges: Array<OpsRolesEdge>;
  /** A list of `OpsRole` objects. */
  nodes: Array<OpsRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpsRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OpsRole` edge in the connection. */
export type OpsRolesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OpsRole` at the end of the edge. */
  node: OpsRole;
};

/** Methods to use when ordering `OpsRole`. */
export enum OpsRolesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Contains contains information about the outreach role and mapping to user relation. */
export type OutreachRole = Node & {
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `OutreachRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `OutreachRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OutreachRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `OutreachRole` values. */
export type OutreachRolesConnection = {
  /** A list of edges which contains the `OutreachRole` and cursor to aid in pagination. */
  edges: Array<OutreachRolesEdge>;
  /** A list of `OutreachRole` objects. */
  nodes: Array<OutreachRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OutreachRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OutreachRole` edge in the connection. */
export type OutreachRolesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `OutreachRole` at the end of the edge. */
  node: OutreachRole;
};

/** Methods to use when ordering `OutreachRole`. */
export enum OutreachRolesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

/** Contains information about the patient relation. */
export type Patient = Node & {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  age?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPatientIdAndAppointmentId: PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterPatientIdAndAppointmentIdList: Array<Appointment>;
  cannotProvideSsn?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>;
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  dob?: Maybe<Scalars['Date']>;
  dosespotId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  genderIdentity?: Maybe<GenderIdentityEnum>;
  genderPronoun?: Maybe<GenderPronounEnum>;
  /** global_human_id is a truncated version of the global_patient_id */
  globalHumanId?: Maybe<Scalars['String']>;
  /** global_patient_id is an algorithmically-generated identifier for the patient that is used throughout our applications at Ready */
  globalPatientId: Scalars['String'];
  hasDifferentGenderIdentity?: Maybe<Scalars['Boolean']>;
  hasPreferredName?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecords: InsuranceRecordsConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndPrimaryInsurance: PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndPrimaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndSecondaryInsurance: PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterPatientIdAndSecondaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsList: Array<InsuranceRecord>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<LanguagesEnum>>>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  /** Meta column describing the data source from which the record migrated from. Default is null. */
  migrationSource?: Maybe<Scalars['String']>;
  noSsnReason?: Maybe<Array<Maybe<NoSsnReasonEnum>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientAttachment`. */
  patientAttachments: PatientAttachmentsConnection;
  /** Reads and enables pagination through a set of `PatientAttachment`. */
  patientAttachmentsList: Array<PatientAttachment>;
  /** Reads and enables pagination through a set of `PatientGuardian`. */
  patientGuardians: PatientGuardiansConnection;
  /** Reads and enables pagination through a set of `PatientGuardian`. */
  patientGuardiansList: Array<PatientGuardian>;
  patientId: Scalars['Int'];
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotes: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesList: Array<PatientNote>;
  preferredName?: Maybe<Scalars['String']>;
  preferredPhoneNumber?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  races?: Maybe<Array<Maybe<RaceEnum>>>;
  respondersSeenBy?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPatientIdAndServiceLineId: PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLinesByEncounterPatientIdAndServiceLineIdList: Array<ServiceLine>;
  sex?: Maybe<SexEnum>;
  skeduloContactId?: Maybe<Scalars['UUID']>;
  specialInstructions?: Maybe<Scalars['String']>;
  ssnSerial?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<PatientSuffixEnum>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  teladocPass?: Maybe<Scalars['String']>;
  teladocUser?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `User`. */
  usersByPatientNotePatientIdAndCreatedBy: PatientUsersByPatientNotePatientIdAndCreatedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByPatientNotePatientIdAndCreatedByList: Array<User>;
  zip?: Maybe<Scalars['String']>;
};


/** Contains information about the patient relation. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientInsuranceRecordsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientInsuranceRecordsListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientPatientAttachmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAttachmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientPatientAttachmentsListArgs = {
  condition?: Maybe<PatientAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAttachmentsOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientPatientGuardiansArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientGuardianCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientGuardiansOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientPatientGuardiansListArgs = {
  condition?: Maybe<PatientGuardianCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientGuardiansOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientPatientNotesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientPatientNotesListArgs = {
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdListArgs = {
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientUsersByPatientNotePatientIdAndCreatedByArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<UserCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UsersOrderBy>>;
};


/** Contains information about the patient relation. */
export type PatientUsersByPatientNotePatientIdAndCreatedByListArgs = {
  condition?: Maybe<UserCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UsersOrderBy>>;
};

/** A connection to a list of `PatientAllergy` values. */
export type PatientAllergiesConnection = {
  /** A list of edges which contains the `PatientAllergy` and cursor to aid in pagination. */
  edges: Array<PatientAllergiesEdge>;
  /** A list of `PatientAllergy` objects. */
  nodes: Array<PatientAllergy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientAllergy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientAllergy` edge in the connection. */
export type PatientAllergiesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientAllergy` at the end of the edge. */
  node: PatientAllergy;
};

/** Methods to use when ordering `PatientAllergy`. */
export enum PatientAllergiesOrderBy {
  AllergicCriticalityIdAsc = 'ALLERGIC_CRITICALITY_ID_ASC',
  AllergicCriticalityIdDesc = 'ALLERGIC_CRITICALITY_ID_DESC',
  AllergicReactionIdAsc = 'ALLERGIC_REACTION_ID_ASC',
  AllergicReactionIdDesc = 'ALLERGIC_REACTION_ID_DESC',
  AllergicSeverityIdAsc = 'ALLERGIC_SEVERITY_ID_ASC',
  AllergicSeverityIdDesc = 'ALLERGIC_SEVERITY_ID_DESC',
  AllergicStatusIdAsc = 'ALLERGIC_STATUS_ID_ASC',
  AllergicStatusIdDesc = 'ALLERGIC_STATUS_ID_DESC',
  AllergyIdAsc = 'ALLERGY_ID_ASC',
  AllergyIdDesc = 'ALLERGY_ID_DESC',
  Natural = 'NATURAL',
  PatientAllergyIdAsc = 'PATIENT_ALLERGY_ID_ASC',
  PatientAllergyIdDesc = 'PATIENT_ALLERGY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about patient allergies */
export type PatientAllergy = Node & {
  /** Reads a single `AllergicCriticality` that is related to this `PatientAllergy`. */
  allergicCriticality?: Maybe<AllergicCriticality>;
  allergicCriticalityId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergicReaction` that is related to this `PatientAllergy`. */
  allergicReaction?: Maybe<AllergicReaction>;
  allergicReactionId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergicSeverity` that is related to this `PatientAllergy`. */
  allergicSeverity?: Maybe<AllergicSeverity>;
  allergicSeverityId?: Maybe<Scalars['Int']>;
  /** Reads a single `AllergicStatus` that is related to this `PatientAllergy`. */
  allergicStatus?: Maybe<AllergicStatus>;
  allergicStatusId?: Maybe<Scalars['Int']>;
  /** Reads a single `Allergy` that is related to this `PatientAllergy`. */
  allergy?: Maybe<Allergy>;
  allergyId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  endedAt?: Maybe<Scalars['Datetime']>;
  finalizedAt?: Maybe<Scalars['Datetime']>;
  finalizedBy?: Maybe<Scalars['Int']>;
  isCurrent: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isFinalized: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  patientAllergyId: Scalars['Int'];
  patientId: Scalars['Int'];
  startedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PatientAllergy` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientAllergyCondition = {
  /** Checks for equality with the object’s `allergicCriticalityId` field. */
  allergicCriticalityId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergicReactionId` field. */
  allergicReactionId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergicSeverityId` field. */
  allergicSeverityId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergicStatusId` field. */
  allergicStatusId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `allergyId` field. */
  allergyId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientAllergyId` field. */
  patientAllergyId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyConnection = {
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type PatientAppointmentsByEncounterPatientIdAndAppointmentIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** Contains information about the patient attachments */
export type PatientAttachment = Node & {
  createdAt: Scalars['Datetime'];
  description?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `PatientAttachment`. */
  patient?: Maybe<Patient>;
  patientAttachmentId: Scalars['Int'];
  patientId: Scalars['Int'];
  type: PatientAttachmentTypeEnum;
  url: Scalars['JSON'];
};

/**
 * A condition to be used against `PatientAttachment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientAttachmentCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientAttachmentId` field. */
  patientAttachmentId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `PatientAttachment`. Fields that are set will be updated. */
export type PatientAttachmentPatch = {
  createdAt?: Maybe<Scalars['Datetime']>;
  description?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  migrationSource?: Maybe<Scalars['String']>;
  patientAttachmentId?: Maybe<Scalars['Int']>;
  patientId?: Maybe<Scalars['Int']>;
  type?: Maybe<PatientAttachmentTypeEnum>;
  url?: Maybe<Scalars['JSON']>;
};

export enum PatientAttachmentTypeEnum {
  Forms = 'FORMS',
  Guardianship = 'GUARDIANSHIP',
  PatientId = 'PATIENT_ID',
  ProfilePicture = 'PROFILE_PICTURE'
}

/** A connection to a list of `PatientAttachment` values. */
export type PatientAttachmentsConnection = {
  /** A list of edges which contains the `PatientAttachment` and cursor to aid in pagination. */
  edges: Array<PatientAttachmentsEdge>;
  /** A list of `PatientAttachment` objects. */
  nodes: Array<PatientAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientAttachment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientAttachment` edge in the connection. */
export type PatientAttachmentsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientAttachment` at the end of the edge. */
  node: PatientAttachment;
};

/** Methods to use when ordering `PatientAttachment`. */
export enum PatientAttachmentsOrderBy {
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PatientAttachmentIdAsc = 'PATIENT_ATTACHMENT_ID_ASC',
  PatientAttachmentIdDesc = 'PATIENT_ATTACHMENT_ID_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Patient` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PatientCondition = {
  /** Filters to records matching `globalHumanId`: checks against globalPatientId */
  globalHumanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `globalPatientId` field. */
  globalPatientId?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['Int']>;
  /** Filters to records matching `patientId` */
  patientIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Filters to records where `updatedAt` is after or equal to updated_at */
  updatedAtAfter?: Maybe<Scalars['String']>;
};

/** A connection to a list of `PatientDiagnosis` values. */
export type PatientDiagnosesConnection = {
  /** A list of edges which contains the `PatientDiagnosis` and cursor to aid in pagination. */
  edges: Array<PatientDiagnosesEdge>;
  /** A list of `PatientDiagnosis` objects. */
  nodes: Array<PatientDiagnosis>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientDiagnosis` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientDiagnosis` edge in the connection. */
export type PatientDiagnosesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientDiagnosis` at the end of the edge. */
  node: PatientDiagnosis;
};

/** Methods to use when ordering `PatientDiagnosis`. */
export enum PatientDiagnosesOrderBy {
  DiagnosisCodeReferenceIdAsc = 'DIAGNOSIS_CODE_REFERENCE_ID_ASC',
  DiagnosisCodeReferenceIdDesc = 'DIAGNOSIS_CODE_REFERENCE_ID_DESC',
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PatientDiagnosisIdAsc = 'PATIENT_DIAGNOSIS_ID_ASC',
  PatientDiagnosisIdDesc = 'PATIENT_DIAGNOSIS_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains Patient Diagnosis information */
export type PatientDiagnosis = Node & {
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `DiagnosisCodeReference` that is related to this `PatientDiagnosis`. */
  diagnosisCodeReference?: Maybe<DiagnosisCodeReference>;
  diagnosisCodeReferenceId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `PatientDiagnosis`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  patientDiagnosisId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PatientDiagnosis` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientDiagnosisCondition = {
  /** Checks for equality with the object’s `diagnosisCodeReferenceId` field. */
  diagnosisCodeReferenceId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientDiagnosisId` field. */
  patientDiagnosisId?: Maybe<Scalars['Int']>;
};

export type PatientEncounterRequest = {
  modules: Array<Scalars['String']>;
  responderGender?: Maybe<Scalars['String']>;
  serviceLineId: Scalars['Int'];
};

/** Contains information linking a patient to a completed form for a given task / encounter */
export type PatientForm = Node & {
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  /** @deprecated Use `field_response_json` for valid JSON. This field remains to preserve existing data. */
  fieldResponse?: Maybe<Scalars['JSON']>;
  fieldResponseJson?: Maybe<Scalars['JSON']>;
  formstackId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFormId: Scalars['Int'];
  patientFormLookupId: Scalars['Int'];
  patientId?: Maybe<Scalars['Int']>;
  signedAt?: Maybe<Scalars['Datetime']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum PatientFormCategoryEnum {
  AbnNoncoverage = 'ABN_NONCOVERAGE',
  Ama = 'AMA',
  AuditC = 'AUDIT_C',
  CcClosure = 'CC_CLOSURE',
  CcGeneral = 'CC_GENERAL',
  CovidContraindications = 'COVID_CONTRAINDICATIONS',
  Dast_10 = 'DAST_10',
  EmsActivation = 'EMS_ACTIVATION',
  ExactSciencesQuestions = 'EXACT_SCIENCES_QUESTIONS',
  FluContraindications = 'FLU_CONTRAINDICATIONS',
  Gad_7 = 'GAD_7',
  HhsCovid = 'HHS_COVID',
  KatzAdl = 'KATZ_ADL',
  MoriskyRxAdherence = 'MORISKY_RX_ADHERENCE',
  MorseFall = 'MORSE_FALL',
  Pain = 'PAIN',
  PatientConsent = 'PATIENT_CONSENT',
  PatientConsentExactSciences = 'PATIENT_CONSENT_EXACT_SCIENCES',
  Phq = 'PHQ',
  PostpartumDepression = 'POSTPARTUM_DEPRESSION',
  PrivacyPractices = 'PRIVACY_PRACTICES',
  RadGeneral = 'RAD_GENERAL',
  ReleaseMedical = 'RELEASE_MEDICAL',
  ReleaseMentalHealth = 'RELEASE_MENTAL_HEALTH',
  ReleasePsychotherapy = 'RELEASE_PSYCHOTHERAPY',
  Sdoh = 'SDOH',
  Technology = 'TECHNOLOGY'
}

/**
 * A condition to be used against `PatientForm` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PatientFormCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `patientFormId` field. */
  patientFormId?: Maybe<Scalars['Int']>;
};

/** Contains information about patient form defintions and the url to form document */
export type PatientFormLookup = Node & {
  createdAt?: Maybe<Scalars['Datetime']>;
  formUrl?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isNonStandard: Scalars['Boolean'];
  language?: Maybe<LanguagesEnum>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientFormCategory: PatientFormCategoryEnum;
  patientFormLookupId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `PatientFormLookup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientFormLookupCondition = {
  /** Checks for equality with the object’s `patientFormLookupId` field. */
  patientFormLookupId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `PatientFormLookup` values. */
export type PatientFormLookupsConnection = {
  /** A list of edges which contains the `PatientFormLookup` and cursor to aid in pagination. */
  edges: Array<PatientFormLookupsEdge>;
  /** A list of `PatientFormLookup` objects. */
  nodes: Array<PatientFormLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientFormLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientFormLookup` edge in the connection. */
export type PatientFormLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientFormLookup` at the end of the edge. */
  node: PatientFormLookup;
};

/** Methods to use when ordering `PatientFormLookup`. */
export enum PatientFormLookupsOrderBy {
  Natural = 'NATURAL',
  PatientFormLookupIdAsc = 'PATIENT_FORM_LOOKUP_ID_ASC',
  PatientFormLookupIdDesc = 'PATIENT_FORM_LOOKUP_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `PatientForm` values. */
export type PatientFormsConnection = {
  /** A list of edges which contains the `PatientForm` and cursor to aid in pagination. */
  edges: Array<PatientFormsEdge>;
  /** A list of `PatientForm` objects. */
  nodes: Array<PatientForm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientForm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientForm` edge in the connection. */
export type PatientFormsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientForm` at the end of the edge. */
  node: PatientForm;
};

/** Methods to use when ordering `PatientForm`. */
export enum PatientFormsOrderBy {
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PatientFormIdAsc = 'PATIENT_FORM_ID_ASC',
  PatientFormIdDesc = 'PATIENT_FORM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about the relationship between the patients and guardians. */
export type PatientGuardian = Node & {
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  guardianId: Scalars['Int'];
  guardianRelationship: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Patient` that is related to this `PatientGuardian`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `PatientGuardian` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientGuardianCondition = {
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `PatientGuardian` values. */
export type PatientGuardiansConnection = {
  /** A list of edges which contains the `PatientGuardian` and cursor to aid in pagination. */
  edges: Array<PatientGuardiansEdge>;
  /** A list of `PatientGuardian` objects. */
  nodes: Array<PatientGuardian>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientGuardian` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientGuardian` edge in the connection. */
export type PatientGuardiansEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientGuardian` at the end of the edge. */
  node: PatientGuardian;
};

/** Methods to use when ordering `PatientGuardian`. */
export enum PatientGuardiansOrderBy {
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `PatientInputRecord` */
export type PatientInputRecordInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  cannotProvideSsn?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>;
  dob: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  genderIdentity?: Maybe<GenderIdentityEnum>;
  genderPronoun?: Maybe<GenderPronounEnum>;
  hasDifferentGenderIdentity?: Maybe<Scalars['Boolean']>;
  hasPreferredName?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<LanguagesEnum>>>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  noSsnReason?: Maybe<Array<Maybe<NoSsnReasonEnum>>>;
  preferredName?: Maybe<Scalars['String']>;
  preferredPhoneNumber?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  races?: Maybe<Array<Maybe<RaceEnum>>>;
  sex?: Maybe<SexEnum>;
  skeduloContactId?: Maybe<Scalars['UUID']>;
  specialInstructions?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<PatientSuffixEnum>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  teladocPass?: Maybe<Scalars['String']>;
  teladocUser?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Contains data related to Patient Instructions */
export type PatientInstruction = Node & {
  careInstructions?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId: Scalars['Int'];
  excusedUntilDate?: Maybe<Scalars['Date']>;
  isDeleted: Scalars['Boolean'];
  levelOfCare?: Maybe<PatientInstructionLevelOfCareEnum>;
  levelOfCareOther?: Maybe<Scalars['String']>;
  medicalRestrictions?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientInstructionId: Scalars['Int'];
  relevantPastMedicalHistory?: Maybe<Scalars['String']>;
  timeframeUnit?: Maybe<PatientInstructionTimeframeEnum>;
  timeframeValue?: Maybe<Scalars['Int']>;
  type: PatientInstructionTypeEnum;
};

/**
 * A condition to be used against `PatientInstruction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientInstructionCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientInstructionId` field. */
  patientInstructionId?: Maybe<Scalars['Int']>;
};

export enum PatientInstructionLevelOfCareEnum {
  BehavioralHealthProvider = 'BEHAVIORAL_HEALTH_PROVIDER',
  Ems = 'EMS',
  Other = 'OTHER',
  PrimaryCare = 'PRIMARY_CARE',
  Ready = 'READY',
  SocialWorker = 'SOCIAL_WORKER',
  SpecialistProvider = 'SPECIALIST_PROVIDER',
  UrgentCare = 'URGENT_CARE'
}

export enum PatientInstructionTimeframeEnum {
  AsSoonAsPossible = 'AS_SOON_AS_POSSIBLE',
  Day = 'DAY',
  Hour = 'HOUR',
  Immediately = 'IMMEDIATELY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum PatientInstructionTypeEnum {
  FollowUp = 'FOLLOW_UP',
  GeneralCareInstructions = 'GENERAL_CARE_INSTRUCTIONS',
  NegativeCovid_19TravelNote = 'NEGATIVE_COVID_19_TRAVEL_NOTE',
  TransferOfCare = 'TRANSFER_OF_CARE',
  WorkOrSchoolNote = 'WORK_OR_SCHOOL_NOTE'
}

/** A connection to a list of `PatientInstruction` values. */
export type PatientInstructionsConnection = {
  /** A list of edges which contains the `PatientInstruction` and cursor to aid in pagination. */
  edges: Array<PatientInstructionsEdge>;
  /** A list of `PatientInstruction` objects. */
  nodes: Array<PatientInstruction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientInstruction` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientInstruction` edge in the connection. */
export type PatientInstructionsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientInstruction` at the end of the edge. */
  node: PatientInstruction;
};

/** Methods to use when ordering `PatientInstruction`. */
export enum PatientInstructionsOrderBy {
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PatientInstructionIdAsc = 'PATIENT_INSTRUCTION_ID_ASC',
  PatientInstructionIdDesc = 'PATIENT_INSTRUCTION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type PatientInsuranceRecordsByEncounterPatientIdAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** Contains information about patient notes */
export type PatientNote = Node & {
  author?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  createdBy?: Maybe<Scalars['Int']>;
  friendlyLabel?: Maybe<Scalars['String']>;
  globalPatientId: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHighPriority?: Maybe<Scalars['Boolean']>;
  label?: Maybe<PatientNoteLabel>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note: Scalars['String'];
  /** Reads a single `Patient` that is related to this `PatientNote`. */
  patient?: Maybe<Patient>;
  patientId: Scalars['Int'];
  patientNoteId: Scalars['Int'];
  systemLastUpdatedBy: SystemOfOriginEnum;
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `PatientNote`. */
  userByCreatedBy?: Maybe<User>;
};

/**
 * A condition to be used against `PatientNote` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PatientNoteCondition = {
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: Maybe<Scalars['Int']>;
  /** Filters to records matching isDeleted */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Filters to records matching isHighPriority */
  isHighPriority?: Maybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `patientNoteId` field. */
  patientNoteId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `PatientNoteInputRecord` */
export type PatientNoteInputRecordInput = {
  isHighPriority?: Maybe<Scalars['Boolean']>;
  label?: Maybe<PatientNoteLabel>;
  note: Scalars['String'];
  patientId: Scalars['Int'];
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
};

export enum PatientNoteLabel {
  Clinical = 'CLINICAL',
  Safety = 'SAFETY'
}

/** An input for mutations affecting `PatientNotePatchRecord` */
export type PatientNotePatchRecordInput = {
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHighPriority?: Maybe<Scalars['Boolean']>;
  label?: Maybe<PatientNoteLabel>;
  note?: Maybe<Scalars['String']>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
};

/** A connection to a list of `PatientNote` values. */
export type PatientNotesConnection = {
  /** A list of edges which contains the `PatientNote` and cursor to aid in pagination. */
  edges: Array<PatientNotesEdge>;
  /** A list of `PatientNote` objects. */
  nodes: Array<PatientNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientNote` edge in the connection. */
export type PatientNotesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientNote` at the end of the edge. */
  node: PatientNote;
};

/** Methods to use when ordering `PatientNote`. */
export enum PatientNotesOrderBy {
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PatientNoteIdAsc = 'PATIENT_NOTE_ID_ASC',
  PatientNoteIdDesc = 'PATIENT_NOTE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `PatientPatchRecord` */
export type PatientPatchRecordInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLat?: Maybe<Scalars['Float']>;
  addressLng?: Maybe<Scalars['Float']>;
  cannotProvideSsn?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>;
  dob?: Maybe<Scalars['Date']>;
  dosespotId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  genderIdentity?: Maybe<GenderIdentityEnum>;
  genderPronoun?: Maybe<GenderPronounEnum>;
  hasDifferentGenderIdentity?: Maybe<Scalars['Boolean']>;
  hasPreferredName?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<LanguagesEnum>>>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  noSsnReason?: Maybe<Array<Maybe<NoSsnReasonEnum>>>;
  preferredName?: Maybe<Scalars['String']>;
  preferredPhoneNumber?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  races?: Maybe<Array<Maybe<RaceEnum>>>;
  sex?: Maybe<SexEnum>;
  skeduloContactId?: Maybe<Scalars['UUID']>;
  specialInstructions?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  suffix?: Maybe<PatientSuffixEnum>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  teladocPass?: Maybe<Scalars['String']>;
  teladocUser?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Contains information about patient problem lists */
export type PatientProblem = Node & {
  addedAt: Scalars['Datetime'];
  createdAt: Scalars['Datetime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  deletedBy?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  endedAt?: Maybe<Scalars['Datetime']>;
  finalizedAt?: Maybe<Scalars['Datetime']>;
  finalizedBy?: Maybe<Scalars['Int']>;
  isCurrent: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isFinalized: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  patientId: Scalars['Int'];
  patientProblemId: Scalars['Int'];
  /** Reads a single `Problem` that is related to this `PatientProblem`. */
  problem?: Maybe<Problem>;
  /** Reads a single `ProblemCategory` that is related to this `PatientProblem`. */
  problemCategory?: Maybe<ProblemCategory>;
  problemCategoryId?: Maybe<Scalars['Int']>;
  problemId?: Maybe<Scalars['Int']>;
  /** Reads a single `ProblemStatus` that is related to this `PatientProblem`. */
  problemStatus?: Maybe<ProblemStatus>;
  problemStatusId?: Maybe<Scalars['Int']>;
  problemText?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `PatientProblem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PatientProblemCondition = {
  /** Checks for equality with the object’s `patientProblemId` field. */
  patientProblemId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `problemCategoryId` field. */
  problemCategoryId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `problemId` field. */
  problemId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `problemStatusId` field. */
  problemStatusId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `PatientProblem` values. */
export type PatientProblemsConnection = {
  /** A list of edges which contains the `PatientProblem` and cursor to aid in pagination. */
  edges: Array<PatientProblemsEdge>;
  /** A list of `PatientProblem` objects. */
  nodes: Array<PatientProblem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PatientProblem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PatientProblem` edge in the connection. */
export type PatientProblemsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PatientProblem` at the end of the edge. */
  node: PatientProblem;
};

/** Methods to use when ordering `PatientProblem`. */
export enum PatientProblemsOrderBy {
  Natural = 'NATURAL',
  PatientProblemIdAsc = 'PATIENT_PROBLEM_ID_ASC',
  PatientProblemIdDesc = 'PATIENT_PROBLEM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProblemCategoryIdAsc = 'PROBLEM_CATEGORY_ID_ASC',
  ProblemCategoryIdDesc = 'PROBLEM_CATEGORY_ID_DESC',
  ProblemIdAsc = 'PROBLEM_ID_ASC',
  ProblemIdDesc = 'PROBLEM_ID_DESC',
  ProblemStatusIdAsc = 'PROBLEM_STATUS_ID_ASC',
  ProblemStatusIdDesc = 'PROBLEM_STATUS_ID_DESC'
}

/** A connection to a list of `ServiceLine` values, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyConnection = {
  /** A list of edges which contains the `ServiceLine`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `ServiceLine` edge in the connection, with data from `Encounter`. */
export type PatientServiceLinesByEncounterPatientIdAndServiceLineIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

export enum PatientSuffixEnum {
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  Jr = 'JR',
  Sr = 'SR'
}

/** A connection to a list of `User` values, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyConnection = {
  /** A list of edges which contains the `User`, info from the `PatientNote`, and the cursor to aid in pagination. */
  edges: Array<PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedBy: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedByList: Array<PatientNote>;
};


/** A `User` edge in the connection, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdgePatientNotesByCreatedByArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** A `User` edge in the connection, with data from `PatientNote`. */
export type PatientUsersByPatientNotePatientIdAndCreatedByManyToManyEdgePatientNotesByCreatedByListArgs = {
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};

/** A connection to a list of `Patient` values. */
export type PatientsConnection = {
  /** A list of edges which contains the `Patient` and cursor to aid in pagination. */
  edges: Array<PatientsEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection. */
export type PatientsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};

/** Methods to use when ordering `Patient`. */
export enum PatientsOrderBy {
  GlobalPatientIdAsc = 'GLOBAL_PATIENT_ID_ASC',
  GlobalPatientIdDesc = 'GLOBAL_PATIENT_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type PhysicalExam = Node & {
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  physicalExamId: Scalars['Int'];
};

/**
 * A condition to be used against `PhysicalExam` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PhysicalExamCondition = {
  /** Checks for equality with the object’s `physicalExamId` field. */
  physicalExamId?: Maybe<Scalars['Int']>;
};

/** An input for mutations affecting `PhysicalExam` */
export type PhysicalExamInput = {
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
};

/** Represents an update to a `PhysicalExam`. Fields that are set will be updated. */
export type PhysicalExamPatch = {
  createdAt?: Maybe<Scalars['Datetime']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
};

/** A connection to a list of `PhysicalExam` values. */
export type PhysicalExamsConnection = {
  /** A list of edges which contains the `PhysicalExam` and cursor to aid in pagination. */
  edges: Array<PhysicalExamsEdge>;
  /** A list of `PhysicalExam` objects. */
  nodes: Array<PhysicalExam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PhysicalExam` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PhysicalExam` edge in the connection. */
export type PhysicalExamsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PhysicalExam` at the end of the edge. */
  node: PhysicalExam;
};

/** Methods to use when ordering `PhysicalExam`. */
export enum PhysicalExamsOrderBy {
  Natural = 'NATURAL',
  PhysicalExamIdAsc = 'PHYSICAL_EXAM_ID_ASC',
  PhysicalExamIdDesc = 'PHYSICAL_EXAM_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about the ReadyCore poct_critical_value_confirmation table */
export type PoctCriticalValueConfirmation = Node & {
  attestedAt: Scalars['Datetime'];
  attestedBy: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  operatingAsRole: UserRoleEnum;
  poctCriticalValueConfirmationId: Scalars['Int'];
  pointOfCareTestId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  user?: Maybe<User>;
};

/**
 * A condition to be used against `PoctCriticalValueConfirmation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PoctCriticalValueConfirmationCondition = {
  /** Checks for equality with the object’s `poctCriticalValueConfirmationId` field. */
  poctCriticalValueConfirmationId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `PoctCriticalValueConfirmation` values. */
export type PoctCriticalValueConfirmationsConnection = {
  /** A list of edges which contains the `PoctCriticalValueConfirmation` and cursor to aid in pagination. */
  edges: Array<PoctCriticalValueConfirmationsEdge>;
  /** A list of `PoctCriticalValueConfirmation` objects. */
  nodes: Array<PoctCriticalValueConfirmation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PoctCriticalValueConfirmation` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PoctCriticalValueConfirmation` edge in the connection. */
export type PoctCriticalValueConfirmationsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PoctCriticalValueConfirmation` at the end of the edge. */
  node: PoctCriticalValueConfirmation;
};

/** Methods to use when ordering `PoctCriticalValueConfirmation`. */
export enum PoctCriticalValueConfirmationsOrderBy {
  Natural = 'NATURAL',
  PoctCriticalValueConfirmationIdAsc = 'POCT_CRITICAL_VALUE_CONFIRMATION_ID_ASC',
  PoctCriticalValueConfirmationIdDesc = 'POCT_CRITICAL_VALUE_CONFIRMATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about a point of care test for a test configuration */
export type PointOfCareTest = Node & {
  clinician?: Maybe<User>;
  clinicianFirstName?: Maybe<Scalars['String']>;
  clinicianId?: Maybe<Scalars['Int']>;
  clinicianLastName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  criticalValueConfirmations?: Maybe<Array<Maybe<PoctCriticalValueConfirmation>>>;
  encounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `PointOfCareTest`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  expirationDate?: Maybe<Scalars['Date']>;
  humidity?: Maybe<Scalars['Int']>;
  internalControlAcceptable?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  lotNumber?: Maybe<Scalars['String']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  pointOfCareTestId: Scalars['Int'];
  /** Reads a single `PointOfCareTestLookup` that is related to this `PointOfCareTest`. */
  pointOfCareTestLookup?: Maybe<PointOfCareTestLookup>;
  pointOfCareTestLookupId: Scalars['Int'];
  result?: Maybe<Scalars['String']>;
  standingOrder?: Maybe<StandingOrder>;
  standingOrderAddedAt?: Maybe<Scalars['Datetime']>;
  standingOrderId?: Maybe<Scalars['Int']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  temperature?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
};

export enum PointOfCareTestCategoryEnum {
  A1C = 'A1C',
  A1CPercent = 'A1C_PERCENT',
  Covid = 'COVID',
  CovidAntibody = 'COVID_ANTIBODY',
  FluAntigen = 'FLU_ANTIGEN',
  Glucose = 'GLUCOSE',
  Pregnancy = 'PREGNANCY',
  Rsv = 'RSV',
  Strep = 'STREP',
  Urinalysis = 'URINALYSIS'
}

/**
 * A condition to be used against `PointOfCareTest` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PointOfCareTestCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `pointOfCareTestId` field. */
  pointOfCareTestId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pointOfCareTestLookupId` field. */
  pointOfCareTestLookupId?: Maybe<Scalars['Int']>;
};

/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookup = Node & {
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskId: PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdList: Array<EncounterTask>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  pointOfCareTestCategory: PointOfCareTestCategoryEnum;
  pointOfCareTestLookupId: Scalars['Int'];
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
  standingOrders?: Maybe<Array<Maybe<StandingOrder>>>;
  system?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdListArgs = {
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookupPointOfCareTestsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};


/** Contains information about a point of care test lookup for a test configuration */
export type PointOfCareTestLookupPointOfCareTestsListArgs = {
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};

/**
 * A condition to be used against `PointOfCareTestLookup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PointOfCareTestLookupCondition = {
  /** Checks for equality with the object’s `pointOfCareTestLookupId` field. */
  pointOfCareTestLookupId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTask` values, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyConnection = {
  /** A list of edges which contains the `EncounterTask`, info from the `PointOfCareTest`, and the cursor to aid in pagination. */
  edges: Array<PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests: PointOfCareTestsConnection;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTestsList: Array<PointOfCareTest>;
};


/** A `EncounterTask` edge in the connection, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdgePointOfCareTestsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};


/** A `EncounterTask` edge in the connection, with data from `PointOfCareTest`. */
export type PointOfCareTestLookupEncounterTasksByPointOfCareTestPointOfCareTestLookupIdAndEncounterTaskIdManyToManyEdgePointOfCareTestsListArgs = {
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};

/** A connection to a list of `PointOfCareTestLookup` values. */
export type PointOfCareTestLookupsConnection = {
  /** A list of edges which contains the `PointOfCareTestLookup` and cursor to aid in pagination. */
  edges: Array<PointOfCareTestLookupsEdge>;
  /** A list of `PointOfCareTestLookup` objects. */
  nodes: Array<PointOfCareTestLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointOfCareTestLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointOfCareTestLookup` edge in the connection. */
export type PointOfCareTestLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointOfCareTestLookup` at the end of the edge. */
  node: PointOfCareTestLookup;
};

/** Methods to use when ordering `PointOfCareTestLookup`. */
export enum PointOfCareTestLookupsOrderBy {
  Natural = 'NATURAL',
  PointOfCareTestLookupIdAsc = 'POINT_OF_CARE_TEST_LOOKUP_ID_ASC',
  PointOfCareTestLookupIdDesc = 'POINT_OF_CARE_TEST_LOOKUP_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `PointOfCareTest` values. */
export type PointOfCareTestsConnection = {
  /** A list of edges which contains the `PointOfCareTest` and cursor to aid in pagination. */
  edges: Array<PointOfCareTestsEdge>;
  /** A list of `PointOfCareTest` objects. */
  nodes: Array<PointOfCareTest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PointOfCareTest` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PointOfCareTest` edge in the connection. */
export type PointOfCareTestsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PointOfCareTest` at the end of the edge. */
  node: PointOfCareTest;
};

/** Methods to use when ordering `PointOfCareTest`. */
export enum PointOfCareTestsOrderBy {
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PointOfCareTestIdAsc = 'POINT_OF_CARE_TEST_ID_ASC',
  PointOfCareTestIdDesc = 'POINT_OF_CARE_TEST_ID_DESC',
  PointOfCareTestLookupIdAsc = 'POINT_OF_CARE_TEST_LOOKUP_ID_ASC',
  PointOfCareTestLookupIdDesc = 'POINT_OF_CARE_TEST_LOOKUP_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about problem lists */
export type Problem = Node & {
  code: Scalars['String'];
  codeSystemId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemIdAndProblemCategoryId: ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemIdAndProblemCategoryIdList: Array<ProblemCategory>;
  problemCategoryId?: Maybe<Scalars['Int']>;
  problemId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemIdAndProblemStatusId: ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemIdAndProblemStatusIdList: Array<ProblemStatus>;
};


/** Contains information about problem lists */
export type ProblemPatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemPatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdListArgs = {
  condition?: Maybe<ProblemCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemStatusesOrderBy>>;
};


/** Contains information about problem lists */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdListArgs = {
  condition?: Maybe<ProblemStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemStatusesOrderBy>>;
};

/** A connection to a list of `ProblemCategory` values. */
export type ProblemCategoriesConnection = {
  /** A list of edges which contains the `ProblemCategory` and cursor to aid in pagination. */
  edges: Array<ProblemCategoriesEdge>;
  /** A list of `ProblemCategory` objects. */
  nodes: Array<ProblemCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemCategory` edge in the connection. */
export type ProblemCategoriesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemCategory` at the end of the edge. */
  node: ProblemCategory;
};

/** Methods to use when ordering `ProblemCategory`. */
export enum ProblemCategoriesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProblemCategoryIdAsc = 'PROBLEM_CATEGORY_ID_ASC',
  ProblemCategoryIdDesc = 'PROBLEM_CATEGORY_ID_DESC'
}

/** Contains information about problem list categories */
export type ProblemCategory = Node & {
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
  problemCategoryId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemCategoryIdAndProblemStatusId: ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdList: Array<ProblemStatus>;
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemCategoryIdAndProblemId: ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemCategoryIdAndProblemIdList: Array<Problem>;
};


/** Contains information about problem list categories */
export type ProblemCategoryPatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryPatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemStatusesOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdListArgs = {
  condition?: Maybe<ProblemStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemStatusesOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemsOrderBy>>;
};


/** Contains information about problem list categories */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdListArgs = {
  condition?: Maybe<ProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemsOrderBy>>;
};

/**
 * A condition to be used against `ProblemCategory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProblemCategoryCondition = {
  /** Checks for equality with the object’s `problemCategoryId` field. */
  problemCategoryId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ProblemStatus` values, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyConnection = {
  /** A list of edges which contains the `ProblemStatus`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdge>;
  /** A list of `ProblemStatus` objects. */
  nodes: Array<ProblemStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemStatus` at the end of the edge. */
  node: ProblemStatus;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdgePatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemStatusesByPatientProblemProblemCategoryIdAndProblemStatusIdManyToManyEdgePatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `Problem` values, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyConnection = {
  /** A list of edges which contains the `Problem`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdge>;
  /** A list of `Problem` objects. */
  nodes: Array<Problem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Problem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Problem` at the end of the edge. */
  node: Problem;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdgePatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemCategoryProblemsByPatientProblemProblemCategoryIdAndProblemIdManyToManyEdgePatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};

/** A condition to be used against `Problem` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProblemCondition = {
  /** Checks for equality with the object’s `problemId` field. */
  problemId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ProblemCategory` values, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyConnection = {
  /** A list of edges which contains the `ProblemCategory`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdge>;
  /** A list of `ProblemCategory` objects. */
  nodes: Array<ProblemCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemCategory` at the end of the edge. */
  node: ProblemCategory;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdgePatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemCategoriesByPatientProblemProblemIdAndProblemCategoryIdManyToManyEdgePatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `ProblemStatus` values, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyConnection = {
  /** A list of edges which contains the `ProblemStatus`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdge>;
  /** A list of `ProblemStatus` objects. */
  nodes: Array<ProblemStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemStatus` at the end of the edge. */
  node: ProblemStatus;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdgePatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemStatus` edge in the connection, with data from `PatientProblem`. */
export type ProblemProblemStatusesByPatientProblemProblemIdAndProblemStatusIdManyToManyEdgePatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};

/** Contains information about problem list statuses */
export type ProblemStatus = Node & {
  code: Scalars['String'];
  codeSystemId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryId: ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdList: Array<ProblemCategory>;
  problemStatusId: Scalars['Int'];
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemStatusIdAndProblemId: ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Problem`. */
  problemsByPatientProblemProblemStatusIdAndProblemIdList: Array<Problem>;
};


/** Contains information about problem list statuses */
export type ProblemStatusPatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusPatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdListArgs = {
  condition?: Maybe<ProblemCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemCategoriesOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemsOrderBy>>;
};


/** Contains information about problem list statuses */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdListArgs = {
  condition?: Maybe<ProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemsOrderBy>>;
};

/**
 * A condition to be used against `ProblemStatus` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProblemStatusCondition = {
  /** Checks for equality with the object’s `problemStatusId` field. */
  problemStatusId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ProblemCategory` values, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyConnection = {
  /** A list of edges which contains the `ProblemCategory`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdge>;
  /** A list of `ProblemCategory` objects. */
  nodes: Array<ProblemCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemCategory` at the end of the edge. */
  node: ProblemCategory;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdgePatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** A `ProblemCategory` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemCategoriesByPatientProblemProblemStatusIdAndProblemCategoryIdManyToManyEdgePatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `Problem` values, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyConnection = {
  /** A list of edges which contains the `Problem`, info from the `PatientProblem`, and the cursor to aid in pagination. */
  edges: Array<ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdge>;
  /** A list of `Problem` objects. */
  nodes: Array<Problem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Problem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Problem` at the end of the edge. */
  node: Problem;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems: PatientProblemsConnection;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblemsList: Array<PatientProblem>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdgePatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** A `Problem` edge in the connection, with data from `PatientProblem`. */
export type ProblemStatusProblemsByPatientProblemProblemStatusIdAndProblemIdManyToManyEdgePatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};

/** A connection to a list of `ProblemStatus` values. */
export type ProblemStatusesConnection = {
  /** A list of edges which contains the `ProblemStatus` and cursor to aid in pagination. */
  edges: Array<ProblemStatusesEdge>;
  /** A list of `ProblemStatus` objects. */
  nodes: Array<ProblemStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProblemStatus` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProblemStatus` edge in the connection. */
export type ProblemStatusesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProblemStatus` at the end of the edge. */
  node: ProblemStatus;
};

/** Methods to use when ordering `ProblemStatus`. */
export enum ProblemStatusesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProblemStatusIdAsc = 'PROBLEM_STATUS_ID_ASC',
  ProblemStatusIdDesc = 'PROBLEM_STATUS_ID_DESC'
}

/** A connection to a list of `Problem` values. */
export type ProblemsConnection = {
  /** A list of edges which contains the `Problem` and cursor to aid in pagination. */
  edges: Array<ProblemsEdge>;
  /** A list of `Problem` objects. */
  nodes: Array<Problem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Problem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Problem` edge in the connection. */
export type ProblemsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Problem` at the end of the edge. */
  node: Problem;
};

/** Methods to use when ordering `Problem`. */
export enum ProblemsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProblemIdAsc = 'PROBLEM_ID_ASC',
  ProblemIdDesc = 'PROBLEM_ID_DESC'
}

/** Contains Procedure Codes */
export type ProcedureCodeReference = Node & {
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnostics: BillingDiagnosticsConnection;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnosticsList: Array<BillingDiagnostic>;
  code: Scalars['String'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskId: ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdList: Array<EncounterTask>;
  endDate?: Maybe<Scalars['Datetime']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  procedureCodeReferenceId: Scalars['Int'];
  startDate: Scalars['Datetime'];
  system: Scalars['String'];
};


/** Contains Procedure Codes */
export type ProcedureCodeReferenceBillingDiagnosticsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<BillingDiagnosticCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains Procedure Codes */
export type ProcedureCodeReferenceBillingDiagnosticsListArgs = {
  condition?: Maybe<BillingDiagnosticCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<BillingDiagnosticsOrderBy>>;
};


/** Contains Procedure Codes */
export type ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains Procedure Codes */
export type ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdListArgs = {
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};

/**
 * A condition to be used against `ProcedureCodeReference` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ProcedureCodeReferenceCondition = {
  /** Checks for equality with the object’s `code` field. */
  code?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `procedureCodeReferenceId` field. */
  procedureCodeReferenceId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: Maybe<Scalars['Datetime']>;
};

/** A connection to a list of `EncounterTask` values, with data from `BillingDiagnostic`. */
export type ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyConnection = {
  /** A list of edges which contains the `EncounterTask`, info from the `BillingDiagnostic`, and the cursor to aid in pagination. */
  edges: Array<ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `BillingDiagnostic`. */
export type ProcedureCodeReferenceEncounterTasksByBillingDiagnosticProcedureCodeReferenceIdAndEncounterTaskIdManyToManyEdge = {
  billingDiagnosticsId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `ProcedureCodeReference` values. */
export type ProcedureCodeReferencesConnection = {
  /** A list of edges which contains the `ProcedureCodeReference` and cursor to aid in pagination. */
  edges: Array<ProcedureCodeReferencesEdge>;
  /** A list of `ProcedureCodeReference` objects. */
  nodes: Array<ProcedureCodeReference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProcedureCodeReference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProcedureCodeReference` edge in the connection. */
export type ProcedureCodeReferencesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProcedureCodeReference` at the end of the edge. */
  node: ProcedureCodeReference;
};

/** Methods to use when ordering `ProcedureCodeReference`. */
export enum ProcedureCodeReferencesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcedureCodeReferenceIdAsc = 'PROCEDURE_CODE_REFERENCE_ID_ASC',
  ProcedureCodeReferenceIdDesc = 'PROCEDURE_CODE_REFERENCE_ID_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

/** Contains information about progress notes for an encounter task */
export type ProgressNote = Node & {
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  encounterTaskId?: Maybe<Scalars['Int']>;
  isDeleted: Scalars['Boolean'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  progressNoteId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ProgressNote` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProgressNoteCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `progressNoteId` field. */
  progressNoteId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ProgressNote` values. */
export type ProgressNotesConnection = {
  /** A list of edges which contains the `ProgressNote` and cursor to aid in pagination. */
  edges: Array<ProgressNotesEdge>;
  /** A list of `ProgressNote` objects. */
  nodes: Array<ProgressNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProgressNote` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProgressNote` edge in the connection. */
export type ProgressNotesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ProgressNote` at the end of the edge. */
  node: ProgressNote;
};

/** Methods to use when ordering `ProgressNote`. */
export enum ProgressNotesOrderBy {
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProgressNoteIdAsc = 'PROGRESS_NOTE_ID_ASC',
  ProgressNoteIdDesc = 'PROGRESS_NOTE_ID_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  /** Reads and enables pagination through a set of `Addendum`. */
  addenda?: Maybe<AddendaConnection>;
  /** Reads a set of `Addendum`. */
  addendaList?: Maybe<Array<Addendum>>;
  addendum?: Maybe<Addendum>;
  addendumAttachment?: Maybe<AddendumAttachment>;
  /** Reads a single `AddendumAttachment` using its globally unique `ID`. */
  addendumAttachmentByNodeId?: Maybe<AddendumAttachment>;
  /** Reads and enables pagination through a set of `AddendumAttachment`. */
  addendumAttachments?: Maybe<AddendumAttachmentsConnection>;
  /** Reads a set of `AddendumAttachment`. */
  addendumAttachmentsList?: Maybe<Array<AddendumAttachment>>;
  /** Reads a single `Addendum` using its globally unique `ID`. */
  addendumByNodeId?: Maybe<Addendum>;
  /** Reads and enables pagination through a set of `AllergicCriticality`. */
  allergicCriticalities?: Maybe<AllergicCriticalitiesConnection>;
  /** Reads a set of `AllergicCriticality`. */
  allergicCriticalitiesList?: Maybe<Array<AllergicCriticality>>;
  allergicCriticality?: Maybe<AllergicCriticality>;
  /** Reads a single `AllergicCriticality` using its globally unique `ID`. */
  allergicCriticalityByNodeId?: Maybe<AllergicCriticality>;
  allergicReaction?: Maybe<AllergicReaction>;
  /** Reads a single `AllergicReaction` using its globally unique `ID`. */
  allergicReactionByNodeId?: Maybe<AllergicReaction>;
  /** Reads and enables pagination through a set of `AllergicReaction`. */
  allergicReactions?: Maybe<AllergicReactionsConnection>;
  /** Reads a set of `AllergicReaction`. */
  allergicReactionsList?: Maybe<Array<AllergicReaction>>;
  /** Reads and enables pagination through a set of `AllergicSeverity`. */
  allergicSeverities?: Maybe<AllergicSeveritiesConnection>;
  /** Reads a set of `AllergicSeverity`. */
  allergicSeveritiesList?: Maybe<Array<AllergicSeverity>>;
  allergicSeverity?: Maybe<AllergicSeverity>;
  /** Reads a single `AllergicSeverity` using its globally unique `ID`. */
  allergicSeverityByNodeId?: Maybe<AllergicSeverity>;
  allergicStatus?: Maybe<AllergicStatus>;
  /** Reads a single `AllergicStatus` using its globally unique `ID`. */
  allergicStatusByNodeId?: Maybe<AllergicStatus>;
  /** Reads and enables pagination through a set of `AllergicStatus`. */
  allergicStatuses?: Maybe<AllergicStatusesConnection>;
  /** Reads a set of `AllergicStatus`. */
  allergicStatusesList?: Maybe<Array<AllergicStatus>>;
  /** Reads and enables pagination through a set of `Allergy`. */
  allergies?: Maybe<AllergiesConnection>;
  /** Reads a set of `Allergy`. */
  allergiesList?: Maybe<Array<Allergy>>;
  allergy?: Maybe<Allergy>;
  /** Reads a single `Allergy` using its globally unique `ID`. */
  allergyByNodeId?: Maybe<Allergy>;
  allergySubstance?: Maybe<AllergySubstance>;
  /** Reads a single `AllergySubstance` using its globally unique `ID`. */
  allergySubstanceByNodeId?: Maybe<AllergySubstance>;
  /** Reads and enables pagination through a set of `AllergySubstance`. */
  allergySubstances?: Maybe<AllergySubstancesConnection>;
  /** Reads a set of `AllergySubstance`. */
  allergySubstancesList?: Maybe<Array<AllergySubstance>>;
  allergyType?: Maybe<AllergyType>;
  /** Reads a single `AllergyType` using its globally unique `ID`. */
  allergyTypeByNodeId?: Maybe<AllergyType>;
  /** Reads and enables pagination through a set of `AllergyType`. */
  allergyTypes?: Maybe<AllergyTypesConnection>;
  /** Reads a set of `AllergyType`. */
  allergyTypesList?: Maybe<Array<AllergyType>>;
  appointment?: Maybe<Appointment>;
  /** Reads a single `Appointment` using its globally unique `ID`. */
  appointmentByNodeId?: Maybe<Appointment>;
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** Reads a single `AppointmentDispatch` using its globally unique `ID`. */
  appointmentDispatchByNodeId?: Maybe<AppointmentDispatch>;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatches?: Maybe<AppointmentDispatchesConnection>;
  /** Reads a set of `AppointmentDispatch`. */
  appointmentDispatchesList?: Maybe<Array<AppointmentDispatch>>;
  appointmentTag?: Maybe<AppointmentTag>;
  /** Reads a single `AppointmentTag` using its globally unique `ID`. */
  appointmentTagByNodeId?: Maybe<AppointmentTag>;
  /** Reads and enables pagination through a set of `AppointmentTag`. */
  appointmentTags?: Maybe<AppointmentTagsConnection>;
  /** Reads a set of `AppointmentTag`. */
  appointmentTagsList?: Maybe<Array<AppointmentTag>>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments?: Maybe<AppointmentsConnection>;
  /** Reads a set of `Appointment`. */
  appointmentsList?: Maybe<Array<Appointment>>;
  billingDiagnostic?: Maybe<BillingDiagnostic>;
  billingDiagnosticByEncounterTaskIdAndProcedureCodeReferenceId?: Maybe<BillingDiagnostic>;
  /** Reads a single `BillingDiagnostic` using its globally unique `ID`. */
  billingDiagnosticByNodeId?: Maybe<BillingDiagnostic>;
  /** Reads and enables pagination through a set of `BillingDiagnostic`. */
  billingDiagnostics?: Maybe<BillingDiagnosticsConnection>;
  /** Reads a set of `BillingDiagnostic`. */
  billingDiagnosticsList?: Maybe<Array<BillingDiagnostic>>;
  cerRole?: Maybe<CerRole>;
  /** Reads a single `CerRole` using its globally unique `ID`. */
  cerRoleByNodeId?: Maybe<CerRole>;
  /** Reads and enables pagination through a set of `CerRole`. */
  cerRoles?: Maybe<CerRolesConnection>;
  /** Reads a set of `CerRole`. */
  cerRolesList?: Maybe<Array<CerRole>>;
  channelAttribution?: Maybe<ChannelAttribution>;
  channelAttributionByGlobalId?: Maybe<ChannelAttribution>;
  /** Reads a single `ChannelAttribution` using its globally unique `ID`. */
  channelAttributionByNodeId?: Maybe<ChannelAttribution>;
  /** Reads and enables pagination through a set of `ChannelAttribution`. */
  channelAttributions?: Maybe<ChannelAttributionsConnection>;
  /** Reads a set of `ChannelAttribution`. */
  channelAttributionsList?: Maybe<Array<ChannelAttribution>>;
  chiefComplaintAndHpi?: Maybe<ChiefComplaintAndHpi>;
  chiefComplaintAndHpiByEncounterTaskId?: Maybe<ChiefComplaintAndHpi>;
  /** Reads a single `ChiefComplaintAndHpi` using its globally unique `ID`. */
  chiefComplaintAndHpiByNodeId?: Maybe<ChiefComplaintAndHpi>;
  /** Reads and enables pagination through a set of `ChiefComplaintAndHpi`. */
  chiefComplaintAndHpis?: Maybe<ChiefComplaintAndHpisConnection>;
  /** Reads a set of `ChiefComplaintAndHpi`. */
  chiefComplaintAndHpisList?: Maybe<Array<ChiefComplaintAndHpi>>;
  clinic?: Maybe<Clinic>;
  /** Reads a single `Clinic` using its globally unique `ID`. */
  clinicByNodeId?: Maybe<Clinic>;
  clinicianRole?: Maybe<ClinicianRole>;
  /** Reads a single `ClinicianRole` using its globally unique `ID`. */
  clinicianRoleByNodeId?: Maybe<ClinicianRole>;
  /** Reads and enables pagination through a set of `ClinicianRole`. */
  clinicianRoles?: Maybe<ClinicianRolesConnection>;
  /** Reads a set of `ClinicianRole`. */
  clinicianRolesList?: Maybe<Array<ClinicianRole>>;
  /** Reads and enables pagination through a set of `Clinic`. */
  clinics?: Maybe<ClinicsConnection>;
  /** Reads a set of `Clinic`. */
  clinicsList?: Maybe<Array<Clinic>>;
  codeSystem?: Maybe<CodeSystem>;
  /** Reads a single `CodeSystem` using its globally unique `ID`. */
  codeSystemByNodeId?: Maybe<CodeSystem>;
  /** Reads and enables pagination through a set of `CodeSystem`. */
  codeSystems?: Maybe<CodeSystemsConnection>;
  /** Reads a set of `CodeSystem`. */
  codeSystemsList?: Maybe<Array<CodeSystem>>;
  createAddOnTask: Encounter;
  diagnosisCodeReference?: Maybe<DiagnosisCodeReference>;
  /** Reads a single `DiagnosisCodeReference` using its globally unique `ID`. */
  diagnosisCodeReferenceByNodeId?: Maybe<DiagnosisCodeReference>;
  /** Reads and enables pagination through a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferences?: Maybe<DiagnosisCodeReferencesConnection>;
  /** Reads a set of `DiagnosisCodeReference`. */
  diagnosisCodeReferencesList?: Maybe<Array<DiagnosisCodeReference>>;
  /** Reads and enables pagination through a set of `DosespotDrugAllergy`. */
  dosespotDrugAllergies?: Maybe<DosespotDrugAllergiesConnection>;
  /** Reads a set of `DosespotDrugAllergy`. */
  dosespotDrugAllergiesList?: Maybe<Array<DosespotDrugAllergy>>;
  dosespotDrugAllergy?: Maybe<DosespotDrugAllergy>;
  /** Reads a single `DosespotDrugAllergy` using its globally unique `ID`. */
  dosespotDrugAllergyByNodeId?: Maybe<DosespotDrugAllergy>;
  dosespotPatientPrescription?: Maybe<DosespotPatientPrescription>;
  /** Reads a single `DosespotPatientPrescription` using its globally unique `ID`. */
  dosespotPatientPrescriptionByNodeId?: Maybe<DosespotPatientPrescription>;
  /** Reads and enables pagination through a set of `DosespotPatientPrescription`. */
  dosespotPatientPrescriptions?: Maybe<DosespotPatientPrescriptionsConnection>;
  /** Reads a set of `DosespotPatientPrescription`. */
  dosespotPatientPrescriptionsList?: Maybe<Array<DosespotPatientPrescription>>;
  dosespotPatientReportedMedication?: Maybe<DosespotPatientReportedMedication>;
  /** Reads a single `DosespotPatientReportedMedication` using its globally unique `ID`. */
  dosespotPatientReportedMedicationByNodeId?: Maybe<DosespotPatientReportedMedication>;
  /** Reads and enables pagination through a set of `DosespotPatientReportedMedication`. */
  dosespotPatientReportedMedications?: Maybe<DosespotPatientReportedMedicationsConnection>;
  /** Reads a set of `DosespotPatientReportedMedication`. */
  dosespotPatientReportedMedicationsList?: Maybe<Array<DosespotPatientReportedMedication>>;
  drug?: Maybe<Drug>;
  /** Reads a single `Drug` using its globally unique `ID`. */
  drugByNodeId?: Maybe<Drug>;
  /** Reads and enables pagination through a set of `Drug`. */
  drugs?: Maybe<DrugsConnection>;
  /** Reads a set of `Drug`. */
  drugsList?: Maybe<Array<Drug>>;
  encounter?: Maybe<Encounter>;
  /** Reads a single `Encounter` using its globally unique `ID`. */
  encounterByNodeId?: Maybe<Encounter>;
  encounterSignature?: Maybe<EncounterSignature>;
  /** Reads a single `EncounterSignature` using its globally unique `ID`. */
  encounterSignatureByNodeId?: Maybe<EncounterSignature>;
  /** Reads and enables pagination through a set of `EncounterSignature`. */
  encounterSignatures?: Maybe<EncounterSignaturesConnection>;
  /** Reads a set of `EncounterSignature`. */
  encounterSignaturesList?: Maybe<Array<EncounterSignature>>;
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskAttachment?: Maybe<EncounterTaskAttachment>;
  /** Reads a single `EncounterTaskAttachment` using its globally unique `ID`. */
  encounterTaskAttachmentByNodeId?: Maybe<EncounterTaskAttachment>;
  /** Reads and enables pagination through a set of `EncounterTaskAttachment`. */
  encounterTaskAttachments?: Maybe<EncounterTaskAttachmentsConnection>;
  /** Reads a set of `EncounterTaskAttachment`. */
  encounterTaskAttachmentsList?: Maybe<Array<EncounterTaskAttachment>>;
  /** Reads a single `EncounterTask` using its globally unique `ID`. */
  encounterTaskByNodeId?: Maybe<EncounterTask>;
  encounterTaskComment?: Maybe<EncounterTaskComment>;
  /** Reads a single `EncounterTaskComment` using its globally unique `ID`. */
  encounterTaskCommentByNodeId?: Maybe<EncounterTaskComment>;
  /** Reads and enables pagination through a set of `EncounterTaskComment`. */
  encounterTaskComments?: Maybe<EncounterTaskCommentsConnection>;
  /** Reads a set of `EncounterTaskComment`. */
  encounterTaskCommentsList?: Maybe<Array<EncounterTaskComment>>;
  encounterTaskCorrection?: Maybe<EncounterTaskCorrection>;
  /** Reads a single `EncounterTaskCorrection` using its globally unique `ID`. */
  encounterTaskCorrectionByNodeId?: Maybe<EncounterTaskCorrection>;
  /** Reads and enables pagination through a set of `EncounterTaskCorrection`. */
  encounterTaskCorrections?: Maybe<EncounterTaskCorrectionsConnection>;
  /** Reads a set of `EncounterTaskCorrection`. */
  encounterTaskCorrectionsList?: Maybe<Array<EncounterTaskCorrection>>;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasks?: Maybe<EncounterTasksConnection>;
  /** Reads a set of `EncounterTask`. */
  encounterTasksList?: Maybe<Array<EncounterTask>>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters?: Maybe<EncountersConnection>;
  /** Reads a set of `Encounter`. */
  encountersList?: Maybe<Array<Encounter>>;
  featureGate?: Maybe<FeatureGate>;
  /** Reads a single `FeatureGate` using its globally unique `ID`. */
  featureGateByNodeId?: Maybe<FeatureGate>;
  /** Reads and enables pagination through a set of `FeatureGate`. */
  featureGates?: Maybe<FeatureGatesConnection>;
  /** Reads a set of `FeatureGate`. */
  featureGatesList?: Maybe<Array<FeatureGate>>;
  getAllergicStatusId?: Maybe<Scalars['Int']>;
  getAllergyTypeId?: Maybe<Scalars['Int']>;
  getAppointmentAvailabilities: AppointmentAvailability;
  getCodeSystemId?: Maybe<Scalars['Int']>;
  /** returns all related appointment history for a given appointment id */
  getCompleteAppointmentHistory?: Maybe<AppointmentsConnection>;
  /** returns all related appointment history for a given appointment id */
  getCompleteAppointmentHistoryList?: Maybe<Array<Appointment>>;
  getCurrentUser?: Maybe<User>;
  getDoseSpotNotificationDetails: DoseSpotNotificationsResponse;
  getFeatureGate?: Maybe<FeatureGateResultOutput>;
  /** Public helper function to get all guardian patient objects for a patient */
  getPatientGuardians?: Maybe<PatientGuardiansConnection>;
  /** Public helper function to get all guardian patient objects for a patient */
  getPatientGuardiansList?: Maybe<Array<PatientGuardian>>;
  getProblemStatusId?: Maybe<Scalars['Int']>;
  /** returns all previous rescheduled appointment history for a given appointment id */
  getRescheduledFromAppointmentHistory?: Maybe<AppointmentsConnection>;
  /** returns all previous rescheduled appointment history for a given appointment id */
  getRescheduledFromAppointmentHistoryList?: Maybe<Array<Appointment>>;
  getUser?: Maybe<User>;
  insuranceRecord?: Maybe<InsuranceRecord>;
  /** Reads a single `InsuranceRecord` using its globally unique `ID`. */
  insuranceRecordByNodeId?: Maybe<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecords?: Maybe<InsuranceRecordsConnection>;
  /** Reads a set of `InsuranceRecord`. */
  insuranceRecordsList?: Maybe<Array<InsuranceRecord>>;
  itRole?: Maybe<ItRole>;
  /** Reads a single `ItRole` using its globally unique `ID`. */
  itRoleByNodeId?: Maybe<ItRole>;
  /** Reads and enables pagination through a set of `ItRole`. */
  itRoles?: Maybe<ItRolesConnection>;
  /** Reads a set of `ItRole`. */
  itRolesList?: Maybe<Array<ItRole>>;
  /** Public helper function to paginate through a list of clinicians */
  listClinicians?: Maybe<UsersConnection>;
  /** Public helper function to paginate through a list of clinicians */
  listCliniciansList?: Maybe<Array<User>>;
  /** Public helper function to paginate through a list of responders */
  listResponders?: Maybe<UsersConnection>;
  /** Public helper function to paginate through a list of responders */
  listRespondersList?: Maybe<Array<User>>;
  /** Reads a single `MachineApplication` using its globally unique `ID`. */
  machineApplicationByNodeId?: Maybe<MachineApplication>;
  /** Reads and enables pagination through a set of `MachineApplication`. */
  machineApplications?: Maybe<MachineApplicationsConnection>;
  /** Reads a set of `MachineApplication`. */
  machineApplicationsList?: Maybe<Array<MachineApplication>>;
  market?: Maybe<Market>;
  marketByName?: Maybe<Market>;
  /** Reads a single `Market` using its globally unique `ID`. */
  marketByNodeId?: Maybe<Market>;
  marketChannelAttributionLookup?: Maybe<MarketChannelAttributionLookup>;
  /** Reads a single `MarketChannelAttributionLookup` using its globally unique `ID`. */
  marketChannelAttributionLookupByNodeId?: Maybe<MarketChannelAttributionLookup>;
  /** Reads and enables pagination through a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookups?: Maybe<MarketChannelAttributionLookupsConnection>;
  /** Reads a set of `MarketChannelAttributionLookup`. */
  marketChannelAttributionLookupsList?: Maybe<Array<MarketChannelAttributionLookup>>;
  marketClinic?: Maybe<MarketClinic>;
  /** Reads a single `MarketClinic` using its globally unique `ID`. */
  marketClinicByNodeId?: Maybe<MarketClinic>;
  /** Reads and enables pagination through a set of `MarketClinic`. */
  marketClinics?: Maybe<MarketClinicsConnection>;
  /** Reads a set of `MarketClinic`. */
  marketClinicsList?: Maybe<Array<MarketClinic>>;
  marketPatientFormLookup?: Maybe<MarketPatientFormLookup>;
  /** Reads a single `MarketPatientFormLookup` using its globally unique `ID`. */
  marketPatientFormLookupByNodeId?: Maybe<MarketPatientFormLookup>;
  /** Reads and enables pagination through a set of `MarketPatientFormLookup`. */
  marketPatientFormLookups?: Maybe<MarketPatientFormLookupsConnection>;
  /** Reads a set of `MarketPatientFormLookup`. */
  marketPatientFormLookupsList?: Maybe<Array<MarketPatientFormLookup>>;
  marketQuestionnaireLookup?: Maybe<MarketQuestionnaireLookup>;
  /** Reads a single `MarketQuestionnaireLookup` using its globally unique `ID`. */
  marketQuestionnaireLookupByNodeId?: Maybe<MarketQuestionnaireLookup>;
  /** Reads and enables pagination through a set of `MarketQuestionnaireLookup`. */
  marketQuestionnaireLookups?: Maybe<MarketQuestionnaireLookupsConnection>;
  /** Reads a set of `MarketQuestionnaireLookup`. */
  marketQuestionnaireLookupsList?: Maybe<Array<MarketQuestionnaireLookup>>;
  /** Reads and enables pagination through a set of `Market`. */
  markets?: Maybe<MarketsConnection>;
  /** Reads a set of `Market`. */
  marketsList?: Maybe<Array<Market>>;
  medicalDecisionMaking?: Maybe<MedicalDecisionMaking>;
  /** Reads a single `MedicalDecisionMaking` using its globally unique `ID`. */
  medicalDecisionMakingByNodeId?: Maybe<MedicalDecisionMaking>;
  /** Reads and enables pagination through a set of `MedicalDecisionMaking`. */
  medicalDecisionMakings?: Maybe<MedicalDecisionMakingsConnection>;
  /** Reads a set of `MedicalDecisionMaking`. */
  medicalDecisionMakingsList?: Maybe<Array<MedicalDecisionMaking>>;
  medicalDirector?: Maybe<MedicalDirector>;
  /** Reads a single `MedicalDirector` using its globally unique `ID`. */
  medicalDirectorByNodeId?: Maybe<MedicalDirector>;
  /** Reads and enables pagination through a set of `MedicalDirector`. */
  medicalDirectors?: Maybe<MedicalDirectorsConnection>;
  /** Reads a set of `MedicalDirector`. */
  medicalDirectorsList?: Maybe<Array<MedicalDirector>>;
  module?: Maybe<Module>;
  /** Reads a single `Module` using its globally unique `ID`. */
  moduleByNodeId?: Maybe<Module>;
  moduleTaskMapping?: Maybe<ModuleTaskMapping>;
  /** Reads a single `ModuleTaskMapping` using its globally unique `ID`. */
  moduleTaskMappingByNodeId?: Maybe<ModuleTaskMapping>;
  /** Reads and enables pagination through a set of `ModuleTaskMapping`. */
  moduleTaskMappings?: Maybe<ModuleTaskMappingsConnection>;
  /** Reads a set of `ModuleTaskMapping`. */
  moduleTaskMappingsList?: Maybe<Array<ModuleTaskMapping>>;
  /** Reads and enables pagination through a set of `Module`. */
  modules?: Maybe<ModulesConnection>;
  /** Reads a set of `Module`. */
  modulesList?: Maybe<Array<Module>>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  opsRole?: Maybe<OpsRole>;
  /** Reads a single `OpsRole` using its globally unique `ID`. */
  opsRoleByNodeId?: Maybe<OpsRole>;
  /** Reads and enables pagination through a set of `OpsRole`. */
  opsRoles?: Maybe<OpsRolesConnection>;
  /** Reads a set of `OpsRole`. */
  opsRolesList?: Maybe<Array<OpsRole>>;
  outreachRole?: Maybe<OutreachRole>;
  /** Reads a single `OutreachRole` using its globally unique `ID`. */
  outreachRoleByNodeId?: Maybe<OutreachRole>;
  /** Reads and enables pagination through a set of `OutreachRole`. */
  outreachRoles?: Maybe<OutreachRolesConnection>;
  /** Reads a set of `OutreachRole`. */
  outreachRolesList?: Maybe<Array<OutreachRole>>;
  patient?: Maybe<Patient>;
  /** Reads and enables pagination through a set of `PatientAllergy`. */
  patientAllergies?: Maybe<PatientAllergiesConnection>;
  /** Reads a set of `PatientAllergy`. */
  patientAllergiesList?: Maybe<Array<PatientAllergy>>;
  patientAllergy?: Maybe<PatientAllergy>;
  /** Reads a single `PatientAllergy` using its globally unique `ID`. */
  patientAllergyByNodeId?: Maybe<PatientAllergy>;
  patientAttachment?: Maybe<PatientAttachment>;
  /** Reads a single `PatientAttachment` using its globally unique `ID`. */
  patientAttachmentByNodeId?: Maybe<PatientAttachment>;
  /** Reads and enables pagination through a set of `PatientAttachment`. */
  patientAttachments?: Maybe<PatientAttachmentsConnection>;
  /** Reads a set of `PatientAttachment`. */
  patientAttachmentsList?: Maybe<Array<PatientAttachment>>;
  patientByGlobalPatientId?: Maybe<Patient>;
  /** Reads a single `Patient` using its globally unique `ID`. */
  patientByNodeId?: Maybe<Patient>;
  /** Reads and enables pagination through a set of `PatientDiagnosis`. */
  patientDiagnoses?: Maybe<PatientDiagnosesConnection>;
  /** Reads a set of `PatientDiagnosis`. */
  patientDiagnosesList?: Maybe<Array<PatientDiagnosis>>;
  patientDiagnosis?: Maybe<PatientDiagnosis>;
  patientDiagnosisByEncounterTaskIdAndDiagnosisCodeReferenceId?: Maybe<PatientDiagnosis>;
  /** Reads a single `PatientDiagnosis` using its globally unique `ID`. */
  patientDiagnosisByNodeId?: Maybe<PatientDiagnosis>;
  patientForm?: Maybe<PatientForm>;
  /** Reads a single `PatientForm` using its globally unique `ID`. */
  patientFormByNodeId?: Maybe<PatientForm>;
  patientFormLookup?: Maybe<PatientFormLookup>;
  /** Reads a single `PatientFormLookup` using its globally unique `ID`. */
  patientFormLookupByNodeId?: Maybe<PatientFormLookup>;
  /** Reads and enables pagination through a set of `PatientFormLookup`. */
  patientFormLookups?: Maybe<PatientFormLookupsConnection>;
  /** Reads a set of `PatientFormLookup`. */
  patientFormLookupsList?: Maybe<Array<PatientFormLookup>>;
  /** Reads and enables pagination through a set of `PatientForm`. */
  patientForms?: Maybe<PatientFormsConnection>;
  /** Reads a set of `PatientForm`. */
  patientFormsList?: Maybe<Array<PatientForm>>;
  patientGuardian?: Maybe<PatientGuardian>;
  /** Reads a single `PatientGuardian` using its globally unique `ID`. */
  patientGuardianByNodeId?: Maybe<PatientGuardian>;
  /** Reads and enables pagination through a set of `PatientGuardian`. */
  patientGuardians?: Maybe<PatientGuardiansConnection>;
  /** Reads a set of `PatientGuardian`. */
  patientGuardiansList?: Maybe<Array<PatientGuardian>>;
  patientInstruction?: Maybe<PatientInstruction>;
  /** Reads a single `PatientInstruction` using its globally unique `ID`. */
  patientInstructionByNodeId?: Maybe<PatientInstruction>;
  /** Reads and enables pagination through a set of `PatientInstruction`. */
  patientInstructions?: Maybe<PatientInstructionsConnection>;
  /** Reads a set of `PatientInstruction`. */
  patientInstructionsList?: Maybe<Array<PatientInstruction>>;
  patientNote?: Maybe<PatientNote>;
  /** Reads a single `PatientNote` using its globally unique `ID`. */
  patientNoteByNodeId?: Maybe<PatientNote>;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotes?: Maybe<PatientNotesConnection>;
  /** Reads a set of `PatientNote`. */
  patientNotesList?: Maybe<Array<PatientNote>>;
  patientProblem?: Maybe<PatientProblem>;
  /** Reads a single `PatientProblem` using its globally unique `ID`. */
  patientProblemByNodeId?: Maybe<PatientProblem>;
  /** Reads and enables pagination through a set of `PatientProblem`. */
  patientProblems?: Maybe<PatientProblemsConnection>;
  /** Reads a set of `PatientProblem`. */
  patientProblemsList?: Maybe<Array<PatientProblem>>;
  /** Reads and enables pagination through a set of `Patient`. */
  patients?: Maybe<PatientsConnection>;
  /** Reads a set of `Patient`. */
  patientsList?: Maybe<Array<Patient>>;
  physicalExam?: Maybe<PhysicalExam>;
  /** Reads a single `PhysicalExam` using its globally unique `ID`. */
  physicalExamByNodeId?: Maybe<PhysicalExam>;
  /** Reads and enables pagination through a set of `PhysicalExam`. */
  physicalExams?: Maybe<PhysicalExamsConnection>;
  /** Reads a set of `PhysicalExam`. */
  physicalExamsList?: Maybe<Array<PhysicalExam>>;
  poctCriticalValueConfirmation?: Maybe<PoctCriticalValueConfirmation>;
  /** Reads a single `PoctCriticalValueConfirmation` using its globally unique `ID`. */
  poctCriticalValueConfirmationByNodeId?: Maybe<PoctCriticalValueConfirmation>;
  /** Reads and enables pagination through a set of `PoctCriticalValueConfirmation`. */
  poctCriticalValueConfirmations?: Maybe<PoctCriticalValueConfirmationsConnection>;
  /** Reads a set of `PoctCriticalValueConfirmation`. */
  poctCriticalValueConfirmationsList?: Maybe<Array<PoctCriticalValueConfirmation>>;
  pointOfCareTest?: Maybe<PointOfCareTest>;
  /** Reads a single `PointOfCareTest` using its globally unique `ID`. */
  pointOfCareTestByNodeId?: Maybe<PointOfCareTest>;
  pointOfCareTestLookup?: Maybe<PointOfCareTestLookup>;
  /** Reads a single `PointOfCareTestLookup` using its globally unique `ID`. */
  pointOfCareTestLookupByNodeId?: Maybe<PointOfCareTestLookup>;
  /** Reads and enables pagination through a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookups?: Maybe<PointOfCareTestLookupsConnection>;
  /** Reads a set of `PointOfCareTestLookup`. */
  pointOfCareTestLookupsList?: Maybe<Array<PointOfCareTestLookup>>;
  /** Reads and enables pagination through a set of `PointOfCareTest`. */
  pointOfCareTests?: Maybe<PointOfCareTestsConnection>;
  /** Reads a set of `PointOfCareTest`. */
  pointOfCareTestsList?: Maybe<Array<PointOfCareTest>>;
  problem?: Maybe<Problem>;
  /** Reads a single `Problem` using its globally unique `ID`. */
  problemByNodeId?: Maybe<Problem>;
  /** Reads and enables pagination through a set of `ProblemCategory`. */
  problemCategories?: Maybe<ProblemCategoriesConnection>;
  /** Reads a set of `ProblemCategory`. */
  problemCategoriesList?: Maybe<Array<ProblemCategory>>;
  problemCategory?: Maybe<ProblemCategory>;
  /** Reads a single `ProblemCategory` using its globally unique `ID`. */
  problemCategoryByNodeId?: Maybe<ProblemCategory>;
  problemStatus?: Maybe<ProblemStatus>;
  /** Reads a single `ProblemStatus` using its globally unique `ID`. */
  problemStatusByNodeId?: Maybe<ProblemStatus>;
  /** Reads and enables pagination through a set of `ProblemStatus`. */
  problemStatuses?: Maybe<ProblemStatusesConnection>;
  /** Reads a set of `ProblemStatus`. */
  problemStatusesList?: Maybe<Array<ProblemStatus>>;
  /** Reads and enables pagination through a set of `Problem`. */
  problems?: Maybe<ProblemsConnection>;
  /** Reads a set of `Problem`. */
  problemsList?: Maybe<Array<Problem>>;
  procedureCodeReference?: Maybe<ProcedureCodeReference>;
  /** Reads a single `ProcedureCodeReference` using its globally unique `ID`. */
  procedureCodeReferenceByNodeId?: Maybe<ProcedureCodeReference>;
  /** Reads and enables pagination through a set of `ProcedureCodeReference`. */
  procedureCodeReferences?: Maybe<ProcedureCodeReferencesConnection>;
  /** Reads a set of `ProcedureCodeReference`. */
  procedureCodeReferencesList?: Maybe<Array<ProcedureCodeReference>>;
  progressNote?: Maybe<ProgressNote>;
  /** Reads a single `ProgressNote` using its globally unique `ID`. */
  progressNoteByNodeId?: Maybe<ProgressNote>;
  /** Reads and enables pagination through a set of `ProgressNote`. */
  progressNotes?: Maybe<ProgressNotesConnection>;
  /** Reads a set of `ProgressNote`. */
  progressNotesList?: Maybe<Array<ProgressNote>>;
  questionnaire?: Maybe<Questionnaire>;
  /** Reads a single `Questionnaire` using its globally unique `ID`. */
  questionnaireByNodeId?: Maybe<Questionnaire>;
  /** Reads and enables pagination through a set of `QuestionnaireCategory`. */
  questionnaireCategories?: Maybe<QuestionnaireCategoriesConnection>;
  /** Reads a set of `QuestionnaireCategory`. */
  questionnaireCategoriesList?: Maybe<Array<QuestionnaireCategory>>;
  questionnaireCategory?: Maybe<QuestionnaireCategory>;
  /** Reads a single `QuestionnaireCategory` using its globally unique `ID`. */
  questionnaireCategoryByNodeId?: Maybe<QuestionnaireCategory>;
  questionnaireLookup?: Maybe<QuestionnaireLookup>;
  /** Reads a single `QuestionnaireLookup` using its globally unique `ID`. */
  questionnaireLookupByNodeId?: Maybe<QuestionnaireLookup>;
  /** Reads and enables pagination through a set of `QuestionnaireLookup`. */
  questionnaireLookups?: Maybe<QuestionnaireLookupsConnection>;
  /** Reads a set of `QuestionnaireLookup`. */
  questionnaireLookupsList?: Maybe<Array<QuestionnaireLookup>>;
  /** Reads and enables pagination through a set of `Questionnaire`. */
  questionnaires?: Maybe<QuestionnairesConnection>;
  /** Reads a set of `Questionnaire`. */
  questionnairesList?: Maybe<Array<Questionnaire>>;
  responderRole?: Maybe<ResponderRole>;
  /** Reads a single `ResponderRole` using its globally unique `ID`. */
  responderRoleByNodeId?: Maybe<ResponderRole>;
  /** Reads and enables pagination through a set of `ResponderRole`. */
  responderRoles?: Maybe<ResponderRolesConnection>;
  /** Reads a set of `ResponderRole`. */
  responderRolesList?: Maybe<Array<ResponderRole>>;
  reviewOfSystem?: Maybe<ReviewOfSystem>;
  reviewOfSystemByEncounterTaskIdAndTemplate?: Maybe<ReviewOfSystem>;
  /** Reads a single `ReviewOfSystem` using its globally unique `ID`. */
  reviewOfSystemByNodeId?: Maybe<ReviewOfSystem>;
  reviewOfSystemSystem?: Maybe<ReviewOfSystemSystem>;
  /** Reads a single `ReviewOfSystemSystem` using its globally unique `ID`. */
  reviewOfSystemSystemByNodeId?: Maybe<ReviewOfSystemSystem>;
  reviewOfSystemSystemByReviewOfSystemIdAndSystem?: Maybe<ReviewOfSystemSystem>;
  /** Reads and enables pagination through a set of `ReviewOfSystemSystem`. */
  reviewOfSystemSystems?: Maybe<ReviewOfSystemSystemsConnection>;
  /** Reads a set of `ReviewOfSystemSystem`. */
  reviewOfSystemSystemsList?: Maybe<Array<ReviewOfSystemSystem>>;
  /** Reads and enables pagination through a set of `ReviewOfSystem`. */
  reviewOfSystems?: Maybe<ReviewOfSystemsConnection>;
  /** Reads a set of `ReviewOfSystem`. */
  reviewOfSystemsList?: Maybe<Array<ReviewOfSystem>>;
  searchAllergyCodes?: Maybe<Array<Allergy>>;
  searchAppointments?: Maybe<Array<Appointment>>;
  /** Reads and enables pagination through a set of `Appointment`. */
  searchAppointmentsQuery?: Maybe<AppointmentsConnection>;
  /** Reads and enables pagination through a set of `Appointment`. */
  searchAppointmentsQueryList?: Maybe<Array<Appointment>>;
  searchCPTCodes?: Maybe<Array<ProcedureCodeReference>>;
  searchClinicians?: Maybe<Array<User>>;
  searchICDCodes?: Maybe<Array<DiagnosisCodeReference>>;
  searchPatients?: Maybe<Array<Patient>>;
  searchReactionCodes?: Maybe<Array<AllergicReaction>>;
  searchResponders?: Maybe<Array<User>>;
  serviceLine?: Maybe<ServiceLine>;
  /** Reads a single `ServiceLine` using its globally unique `ID`. */
  serviceLineByNodeId?: Maybe<ServiceLine>;
  /** Reads and enables pagination through a set of `ServiceLine`. */
  serviceLines?: Maybe<ServiceLinesConnection>;
  /** Reads a set of `ServiceLine`. */
  serviceLinesList?: Maybe<Array<ServiceLine>>;
  standingOrder?: Maybe<StandingOrder>;
  /** Reads a single `StandingOrder` using its globally unique `ID`. */
  standingOrderByNodeId?: Maybe<StandingOrder>;
  standingOrderByNumberAndStateAndVersion?: Maybe<StandingOrder>;
  /** Reads and enables pagination through a set of `StandingOrder`. */
  standingOrders?: Maybe<StandingOrdersConnection>;
  /** Reads a set of `StandingOrder`. */
  standingOrdersList?: Maybe<Array<StandingOrder>>;
  startEncounter: Encounter;
  supervisorRole?: Maybe<SupervisorRole>;
  /** Reads a single `SupervisorRole` using its globally unique `ID`. */
  supervisorRoleByNodeId?: Maybe<SupervisorRole>;
  /** Reads and enables pagination through a set of `SupervisorRole`. */
  supervisorRoles?: Maybe<SupervisorRolesConnection>;
  /** Reads a set of `SupervisorRole`. */
  supervisorRolesList?: Maybe<Array<SupervisorRole>>;
  telehealthMeeting?: Maybe<TelehealthMeeting>;
  /** Reads a single `TelehealthMeeting` using its globally unique `ID`. */
  telehealthMeetingByNodeId?: Maybe<TelehealthMeeting>;
  /** Reads and enables pagination through a set of `TelehealthMeeting`. */
  telehealthMeetings?: Maybe<TelehealthMeetingsConnection>;
  /** Reads a set of `TelehealthMeeting`. */
  telehealthMeetingsList?: Maybe<Array<TelehealthMeeting>>;
  user?: Maybe<User>;
  userByEmployeeId?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  /** Reads and enables pagination through a set of `UserMarket`. */
  userMarkets?: Maybe<UserMarketsConnection>;
  /** Reads a set of `UserMarket`. */
  userMarketsList?: Maybe<Array<UserMarket>>;
  userPatient?: Maybe<UserPatient>;
  /** Reads a single `UserPatient` using its globally unique `ID`. */
  userPatientByNodeId?: Maybe<UserPatient>;
  /** Reads and enables pagination through a set of `UserPatient`. */
  userPatients?: Maybe<UserPatientsConnection>;
  /** Reads a set of `UserPatient`. */
  userPatientsList?: Maybe<Array<UserPatient>>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  /** Reads a set of `User`. */
  usersList?: Maybe<Array<User>>;
  /** Reads and enables pagination through a set of `VRedoxPatientExport`. */
  vRedoxPatientExports?: Maybe<VRedoxPatientExportsConnection>;
  /** Reads a set of `VRedoxPatientExport`. */
  vRedoxPatientExportsList?: Maybe<Array<VRedoxPatientExport>>;
  vaccine?: Maybe<Vaccine>;
  /** Reads a single `Vaccine` using its globally unique `ID`. */
  vaccineByNodeId?: Maybe<Vaccine>;
  vaccineLookup?: Maybe<VaccineLookup>;
  /** Reads a single `VaccineLookup` using its globally unique `ID`. */
  vaccineLookupByNodeId?: Maybe<VaccineLookup>;
  /** Reads and enables pagination through a set of `VaccineLookup`. */
  vaccineLookups?: Maybe<VaccineLookupsConnection>;
  /** Reads a set of `VaccineLookup`. */
  vaccineLookupsList?: Maybe<Array<VaccineLookup>>;
  /** Reads and enables pagination through a set of `Vaccine`. */
  vaccines?: Maybe<VaccinesConnection>;
  /** Reads a set of `Vaccine`. */
  vaccinesList?: Maybe<Array<Vaccine>>;
  videoConference?: Maybe<VideoConference>;
  /** Reads a single `VideoConference` using its globally unique `ID`. */
  videoConferenceByNodeId?: Maybe<VideoConference>;
  /** Reads and enables pagination through a set of `VideoConference`. */
  videoConferences?: Maybe<VideoConferencesConnection>;
  /** Reads a set of `VideoConference`. */
  videoConferencesList?: Maybe<Array<VideoConference>>;
  vital?: Maybe<Vital>;
  /** Reads a single `Vital` using its globally unique `ID`. */
  vitalByNodeId?: Maybe<Vital>;
  vitalLookup?: Maybe<VitalLookup>;
  /** Reads a single `VitalLookup` using its globally unique `ID`. */
  vitalLookupByNodeId?: Maybe<VitalLookup>;
  /** Reads and enables pagination through a set of `VitalLookup`. */
  vitalLookups?: Maybe<VitalLookupsConnection>;
  /** Reads a set of `VitalLookup`. */
  vitalLookupsList?: Maybe<Array<VitalLookup>>;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals?: Maybe<VitalsConnection>;
  /** Reads a set of `Vital`. */
  vitalsList?: Maybe<Array<Vital>>;
  zipcode?: Maybe<Zipcode>;
  /** Reads a single `Zipcode` using its globally unique `ID`. */
  zipcodeByNodeId?: Maybe<Zipcode>;
  /** Reads and enables pagination through a set of `Zipcode`. */
  zipcodes?: Maybe<ZipcodesConnection>;
  /** Reads a set of `Zipcode`. */
  zipcodesList?: Maybe<Array<Zipcode>>;
  zone?: Maybe<Zone>;
  /** Reads a single `Zone` using its globally unique `ID`. */
  zoneByNodeId?: Maybe<Zone>;
  zoneZipcode?: Maybe<ZoneZipcode>;
  /** Reads a single `ZoneZipcode` using its globally unique `ID`. */
  zoneZipcodeByNodeId?: Maybe<ZoneZipcode>;
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodes?: Maybe<ZoneZipcodesConnection>;
  /** Reads a set of `ZoneZipcode`. */
  zoneZipcodesList?: Maybe<Array<ZoneZipcode>>;
  /** Reads and enables pagination through a set of `Zone`. */
  zones?: Maybe<ZonesConnection>;
  /** Reads a set of `Zone`. */
  zonesList?: Maybe<Array<Zone>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendaArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AddendumCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendaOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendaListArgs = {
  condition?: Maybe<AddendumCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendaOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendumArgs = {
  addendumId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendumAttachmentArgs = {
  addendumAttachmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendumAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendumAttachmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AddendumAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendumAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendumAttachmentsListArgs = {
  condition?: Maybe<AddendumAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AddendumAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAddendumByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicCriticalitiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicCriticalitiesListArgs = {
  condition?: Maybe<AllergicCriticalityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicCriticalitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicCriticalityArgs = {
  allergicCriticalityId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicCriticalityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicReactionArgs = {
  allergicReactionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicReactionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicReactionsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicReactionsListArgs = {
  condition?: Maybe<AllergicReactionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicReactionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicSeveritiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicSeveritiesListArgs = {
  condition?: Maybe<AllergicSeverityCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicSeveritiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicSeverityArgs = {
  allergicSeverityId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicSeverityByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicStatusArgs = {
  allergicStatusId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicStatusByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicStatusesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergicStatusesListArgs = {
  condition?: Maybe<AllergicStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergicStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergiesListArgs = {
  condition?: Maybe<AllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergyArgs = {
  allergyId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergySubstanceArgs = {
  allergySubstanceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergySubstanceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergySubstancesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergySubstanceCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergySubstancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergySubstancesListArgs = {
  condition?: Maybe<AllergySubstanceCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergySubstancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergyTypeArgs = {
  allergyTypeId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergyTypeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergyTypesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AllergyTypeCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergyTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllergyTypesListArgs = {
  condition?: Maybe<AllergyTypeCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AllergyTypesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentArgs = {
  appointmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentDispatchArgs = {
  appointmentDispatchId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentDispatchByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentDispatchesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentDispatchesListArgs = {
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentTagArgs = {
  appointmentTagId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentTagByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentTagsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentTagCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentTagsListArgs = {
  condition?: Maybe<AppointmentTagCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentTagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAppointmentsListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingDiagnosticArgs = {
  billingDiagnosticsId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingDiagnosticByEncounterTaskIdAndProcedureCodeReferenceIdArgs = {
  encounterTaskId: Scalars['Int'];
  procedureCodeReferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingDiagnosticByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingDiagnosticsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<BillingDiagnosticCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<BillingDiagnosticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingDiagnosticsListArgs = {
  condition?: Maybe<BillingDiagnosticCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<BillingDiagnosticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCerRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCerRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCerRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<CerRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CerRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCerRolesListArgs = {
  condition?: Maybe<CerRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CerRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelAttributionArgs = {
  channelAttributionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelAttributionByGlobalIdArgs = {
  globalId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelAttributionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelAttributionsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ChannelAttributionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ChannelAttributionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelAttributionsListArgs = {
  condition?: Maybe<ChannelAttributionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ChannelAttributionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChiefComplaintAndHpiArgs = {
  chiefComplaintAndHpiId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChiefComplaintAndHpiByEncounterTaskIdArgs = {
  encounterTaskId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChiefComplaintAndHpiByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChiefComplaintAndHpisArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ChiefComplaintAndHpiCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ChiefComplaintAndHpisOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryChiefComplaintAndHpisListArgs = {
  condition?: Maybe<ChiefComplaintAndHpiCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ChiefComplaintAndHpisOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicArgs = {
  clinicId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicianRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicianRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicianRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ClinicianRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ClinicianRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicianRolesListArgs = {
  condition?: Maybe<ClinicianRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ClinicianRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ClinicCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClinicsListArgs = {
  condition?: Maybe<ClinicCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCodeSystemArgs = {
  codeSystemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCodeSystemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCodeSystemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<CodeSystemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CodeSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCodeSystemsListArgs = {
  condition?: Maybe<CodeSystemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CodeSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCreateAddOnTaskArgs = {
  encounterId: Scalars['Int'];
  moduleName: ModuleNameEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryDiagnosisCodeReferenceArgs = {
  diagnosisCodeReferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDiagnosisCodeReferenceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDiagnosisCodeReferencesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<DiagnosisCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDiagnosisCodeReferencesListArgs = {
  condition?: Maybe<DiagnosisCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DiagnosisCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotDrugAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<DosespotDrugAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DosespotDrugAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotDrugAllergiesListArgs = {
  condition?: Maybe<DosespotDrugAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DosespotDrugAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotDrugAllergyArgs = {
  dosespotDrugAllergyId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotDrugAllergyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientPrescriptionArgs = {
  patientPrescriptionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientPrescriptionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientPrescriptionsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<DosespotPatientPrescriptionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DosespotPatientPrescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientPrescriptionsListArgs = {
  condition?: Maybe<DosespotPatientPrescriptionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DosespotPatientPrescriptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientReportedMedicationArgs = {
  patientReportedMedicationId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientReportedMedicationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientReportedMedicationsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<DosespotPatientReportedMedicationCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DosespotPatientReportedMedicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDosespotPatientReportedMedicationsListArgs = {
  condition?: Maybe<DosespotPatientReportedMedicationCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DosespotPatientReportedMedicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDrugArgs = {
  drugId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDrugByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDrugsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<DrugCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DrugsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDrugsListArgs = {
  condition?: Maybe<DrugCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<DrugsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterArgs = {
  encounterId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterSignatureArgs = {
  encounterSignatureId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterSignatureByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterSignaturesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterSignatureCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterSignaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterSignaturesListArgs = {
  condition?: Maybe<EncounterSignatureCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterSignaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskArgs = {
  encounterTaskId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskAttachmentArgs = {
  encounterTaskAttachmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskAttachmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskAttachmentsListArgs = {
  condition?: Maybe<EncounterTaskAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCommentArgs = {
  encounterTaskCommentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCommentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCommentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCommentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCommentsListArgs = {
  condition?: Maybe<EncounterTaskCommentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskCommentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCorrectionArgs = {
  encounterTaskCorrectionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCorrectionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCorrectionsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCorrectionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskCorrectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTaskCorrectionsListArgs = {
  condition?: Maybe<EncounterTaskCorrectionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTaskCorrectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTasksArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncounterTasksListArgs = {
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureGateArgs = {
  featureId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureGateByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureGatesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<FeatureGateCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<FeatureGatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureGatesListArgs = {
  condition?: Maybe<FeatureGateCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<FeatureGatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAllergicStatusIdArgs = {
  searchName: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAllergyTypeIdArgs = {
  searchName: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetAppointmentAvailabilitiesArgs = {
  appointment: AppointmentAddress;
  end: Scalars['String'];
  patients: Array<Maybe<PatientEncounterRequest>>;
  start: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCodeSystemIdArgs = {
  searchName: Scalars['String'];
  searchVersion: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCompleteAppointmentHistoryArgs = {
  after?: Maybe<Scalars['Cursor']>;
  appointmentId?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetCompleteAppointmentHistoryListArgs = {
  appointmentId?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetFeatureGateArgs = {
  featureId: Scalars['String'];
  marketId?: Maybe<Scalars['Int']>;
  zoneId?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPatientGuardiansArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  patientId?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPatientGuardiansListArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  patientId?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetProblemStatusIdArgs = {
  searchName: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRescheduledFromAppointmentHistoryArgs = {
  after?: Maybe<Scalars['Cursor']>;
  appointmentId?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRescheduledFromAppointmentHistoryListArgs = {
  appointmentId?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUserArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInsuranceRecordArgs = {
  insuranceRecordId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInsuranceRecordByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInsuranceRecordsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInsuranceRecordsListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryItRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryItRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ItRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ItRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryItRolesListArgs = {
  condition?: Maybe<ItRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ItRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryListCliniciansArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryListCliniciansListArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryListRespondersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryListRespondersListArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMachineApplicationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMachineApplicationsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MachineApplicationCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MachineApplicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMachineApplicationsListArgs = {
  condition?: Maybe<MachineApplicationCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MachineApplicationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketArgs = {
  marketId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketChannelAttributionLookupArgs = {
  channelAttributionId: Scalars['Int'];
  marketId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketChannelAttributionLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketChannelAttributionLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketChannelAttributionLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketChannelAttributionLookupsListArgs = {
  condition?: Maybe<MarketChannelAttributionLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketChannelAttributionLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketClinicArgs = {
  clinicId: Scalars['Int'];
  marketId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketClinicByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketClinicsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketClinicCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketClinicsListArgs = {
  condition?: Maybe<MarketClinicCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketClinicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketPatientFormLookupArgs = {
  marketId: Scalars['Int'];
  patientFormLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketPatientFormLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketPatientFormLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketPatientFormLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketPatientFormLookupsListArgs = {
  condition?: Maybe<MarketPatientFormLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketPatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketQuestionnaireLookupArgs = {
  marketId: Scalars['Int'];
  questionnaireLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketQuestionnaireLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketQuestionnaireLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketQuestionnaireLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketQuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketQuestionnaireLookupsListArgs = {
  condition?: Maybe<MarketQuestionnaireLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketQuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketsListArgs = {
  condition?: Maybe<MarketCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDecisionMakingArgs = {
  medicalDecisionMakingId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDecisionMakingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDecisionMakingsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MedicalDecisionMakingCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MedicalDecisionMakingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDecisionMakingsListArgs = {
  condition?: Maybe<MedicalDecisionMakingCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MedicalDecisionMakingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDirectorArgs = {
  medicalDirectorId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDirectorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDirectorsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MedicalDirectorCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MedicalDirectorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMedicalDirectorsListArgs = {
  condition?: Maybe<MedicalDirectorCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MedicalDirectorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryModuleArgs = {
  name: ModuleNameEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryModuleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryModuleTaskMappingArgs = {
  moduleTaskMappingId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryModuleTaskMappingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryModuleTaskMappingsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ModuleTaskMappingCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ModuleTaskMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryModuleTaskMappingsListArgs = {
  condition?: Maybe<ModuleTaskMappingCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ModuleTaskMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryModulesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ModuleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ModulesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryModulesListArgs = {
  condition?: Maybe<ModuleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ModulesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpsRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpsRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpsRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<OpsRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<OpsRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOpsRolesListArgs = {
  condition?: Maybe<OpsRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<OpsRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOutreachRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOutreachRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOutreachRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<OutreachRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<OutreachRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOutreachRolesListArgs = {
  condition?: Maybe<OutreachRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<OutreachRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientArgs = {
  patientId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAllergiesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAllergiesListArgs = {
  condition?: Maybe<PatientAllergyCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAllergiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAllergyArgs = {
  patientAllergyId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAllergyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAttachmentArgs = {
  patientAttachmentId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAttachmentByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAttachmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientAttachmentsListArgs = {
  condition?: Maybe<PatientAttachmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientAttachmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientByGlobalPatientIdArgs = {
  globalPatientId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientDiagnosesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientDiagnosisCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientDiagnosesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientDiagnosesListArgs = {
  condition?: Maybe<PatientDiagnosisCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientDiagnosesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientDiagnosisArgs = {
  patientDiagnosisId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientDiagnosisByEncounterTaskIdAndDiagnosisCodeReferenceIdArgs = {
  diagnosisCodeReferenceId: Scalars['Int'];
  encounterTaskId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientDiagnosisByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormArgs = {
  patientFormId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormLookupArgs = {
  patientFormLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientFormLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormLookupsListArgs = {
  condition?: Maybe<PatientFormLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientFormLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientFormCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientFormsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientFormsListArgs = {
  condition?: Maybe<PatientFormCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientFormsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientGuardianArgs = {
  guardianId: Scalars['Int'];
  patientId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientGuardianByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientGuardiansArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientGuardianCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientGuardiansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientGuardiansListArgs = {
  condition?: Maybe<PatientGuardianCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientGuardiansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientInstructionArgs = {
  patientInstructionId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientInstructionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientInstructionsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientInstructionCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientInstructionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientInstructionsListArgs = {
  condition?: Maybe<PatientInstructionCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientInstructionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientNoteArgs = {
  patientNoteId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientNoteByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientNotesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientNotesListArgs = {
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientProblemArgs = {
  patientProblemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientProblemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientProblemsListArgs = {
  condition?: Maybe<PatientProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPatientsListArgs = {
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPhysicalExamArgs = {
  physicalExamId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhysicalExamByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhysicalExamsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PhysicalExamCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PhysicalExamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPhysicalExamsListArgs = {
  condition?: Maybe<PhysicalExamCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PhysicalExamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPoctCriticalValueConfirmationArgs = {
  poctCriticalValueConfirmationId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoctCriticalValueConfirmationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoctCriticalValueConfirmationsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PoctCriticalValueConfirmationCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PoctCriticalValueConfirmationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPoctCriticalValueConfirmationsListArgs = {
  condition?: Maybe<PoctCriticalValueConfirmationCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PoctCriticalValueConfirmationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestArgs = {
  pointOfCareTestId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestLookupArgs = {
  pointOfCareTestLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PointOfCareTestLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestLookupsListArgs = {
  condition?: Maybe<PointOfCareTestLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPointOfCareTestsListArgs = {
  condition?: Maybe<PointOfCareTestCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PointOfCareTestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemArgs = {
  problemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemCategoriesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemCategoriesListArgs = {
  condition?: Maybe<ProblemCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemCategoryArgs = {
  problemCategoryId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemCategoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemStatusArgs = {
  problemStatusId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemStatusByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemStatusesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemStatusesListArgs = {
  condition?: Maybe<ProblemStatusCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProblemsListArgs = {
  condition?: Maybe<ProblemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProblemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureCodeReferenceArgs = {
  procedureCodeReferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureCodeReferenceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureCodeReferencesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProcedureCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProcedureCodeReferencesListArgs = {
  condition?: Maybe<ProcedureCodeReferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProcedureCodeReferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProgressNoteArgs = {
  progressNoteId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProgressNoteByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProgressNotesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ProgressNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProgressNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProgressNotesListArgs = {
  condition?: Maybe<ProgressNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ProgressNotesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireArgs = {
  questionnaireId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireCategoriesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<QuestionnaireCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<QuestionnaireCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireCategoriesListArgs = {
  condition?: Maybe<QuestionnaireCategoryCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<QuestionnaireCategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireCategoryArgs = {
  category: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireCategoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireLookupArgs = {
  questionnaireLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<QuestionnaireLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<QuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnaireLookupsListArgs = {
  condition?: Maybe<QuestionnaireLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<QuestionnaireLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnairesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<QuestionnaireCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<QuestionnairesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionnairesListArgs = {
  condition?: Maybe<QuestionnaireCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<QuestionnairesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryResponderRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResponderRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResponderRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ResponderRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ResponderRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryResponderRolesListArgs = {
  condition?: Maybe<ResponderRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ResponderRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemArgs = {
  reviewOfSystemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemByEncounterTaskIdAndTemplateArgs = {
  encounterTaskId: Scalars['Int'];
  template: ReviewOfSystemTemplateEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemSystemArgs = {
  reviewOfSystemSystemId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemSystemByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemSystemByReviewOfSystemIdAndSystemArgs = {
  reviewOfSystemId: Scalars['Int'];
  system: ReviewOfSystemSystemEnum;
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemSystemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ReviewOfSystemSystemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ReviewOfSystemSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemSystemsListArgs = {
  condition?: Maybe<ReviewOfSystemSystemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ReviewOfSystemSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ReviewOfSystemCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ReviewOfSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReviewOfSystemsListArgs = {
  condition?: Maybe<ReviewOfSystemCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ReviewOfSystemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchAllergyCodesArgs = {
  allergyTypeGroup: SearchAllergyCodesTypeGroup;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<SearchAllergyCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchAppointmentsArgs = {
  condition?: Maybe<AppointmentFilter>;
  limit?: Maybe<Scalars['Int']>;
  nameQuery?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<SearchAppointmentsOrderByEnum>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchAppointmentsQueryArgs = {
  _limit?: Maybe<Scalars['Int']>;
  _offset?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  nameQuery?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchAppointmentsQueryListArgs = {
  _limit?: Maybe<Scalars['Int']>;
  _offset?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  nameQuery?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchCptCodesArgs = {
  activeDate: Scalars['Date'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<SearchCptCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchCliniciansArgs = {
  limit?: Maybe<Scalars['Int']>;
  nameQuery: Scalars['String'];
  orderBy?: Maybe<SearchCliniciansOrderBy>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchIcdCodesArgs = {
  activeDate: Scalars['Date'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<SearchIcdCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchPatientsArgs = {
  limit?: Maybe<Scalars['Int']>;
  nameQuery: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<SearchPatientsOrderBy>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchReactionCodesArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<SearchReactionCodesOrderBy>;
  searchTerms: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchRespondersArgs = {
  limit?: Maybe<Scalars['Int']>;
  nameQuery: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<SearchRespondersOrderBy>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceLineArgs = {
  serviceLineId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceLineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceLinesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceLinesListArgs = {
  condition?: Maybe<ServiceLineCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ServiceLinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStandingOrderArgs = {
  standingOrderId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStandingOrderByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStandingOrderByNumberAndStateAndVersionArgs = {
  number: Scalars['String'];
  state: StateEnum;
  version: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStandingOrdersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<StandingOrderCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<StandingOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStandingOrdersListArgs = {
  condition?: Maybe<StandingOrderCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<StandingOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStartEncounterArgs = {
  encounterId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupervisorRoleArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupervisorRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupervisorRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<SupervisorRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SupervisorRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySupervisorRolesListArgs = {
  condition?: Maybe<SupervisorRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SupervisorRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTelehealthMeetingArgs = {
  telehealthMeetingId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTelehealthMeetingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTelehealthMeetingsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<TelehealthMeetingCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<TelehealthMeetingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTelehealthMeetingsListArgs = {
  condition?: Maybe<TelehealthMeetingCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<TelehealthMeetingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByEmployeeIdArgs = {
  employeeId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserMarketsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UserMarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserMarketsListArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UserMarketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPatientArgs = {
  patientId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPatientByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPatientsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<UserPatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UserPatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserPatientsListArgs = {
  condition?: Maybe<UserPatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UserPatientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<UserCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersListArgs = {
  condition?: Maybe<UserCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVRedoxPatientExportsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VRedoxPatientExportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVRedoxPatientExportsListArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VRedoxPatientExportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccineArgs = {
  vaccineId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccineByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccineLookupArgs = {
  vaccineLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccineLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccineLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VaccineLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VaccineLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccineLookupsListArgs = {
  condition?: Maybe<VaccineLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VaccineLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccinesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VaccineCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VaccinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVaccinesListArgs = {
  condition?: Maybe<VaccineCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VaccinesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVideoConferenceArgs = {
  videoConferenceId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVideoConferenceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVideoConferencesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VideoConferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VideoConferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVideoConferencesListArgs = {
  condition?: Maybe<VideoConferenceCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VideoConferencesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalArgs = {
  vitalId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalLookupArgs = {
  vitalLookupId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalLookupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalLookupsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VitalLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalLookupsListArgs = {
  condition?: Maybe<VitalLookupCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalLookupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryVitalsListArgs = {
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZipcodeArgs = {
  zipCode: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZipcodeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZipcodesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZipcodesListArgs = {
  condition?: Maybe<ZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneArgs = {
  zoneId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneZipcodeArgs = {
  zipCode: Scalars['UsPostalCode'];
  zoneId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneZipcodeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneZipcodesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZoneZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZoneZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneZipcodesListArgs = {
  condition?: Maybe<ZoneZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZoneZipcodesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZonesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZoneCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZonesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryZonesListArgs = {
  condition?: Maybe<ZoneCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZonesOrderBy>>;
};

/** Contains information about questionnaire responses */
export type Questionnaire = Node & {
  createdAt: Scalars['Datetime'];
  encounterId?: Maybe<Scalars['Int']>;
  encounterTaskId: Scalars['Int'];
  migrationSource: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  questionnaireId: Scalars['Int'];
  questionnaireLookupId: Scalars['Int'];
  response: Scalars['JSON'];
};

/** A connection to a list of `QuestionnaireCategory` values. */
export type QuestionnaireCategoriesConnection = {
  /** A list of edges which contains the `QuestionnaireCategory` and cursor to aid in pagination. */
  edges: Array<QuestionnaireCategoriesEdge>;
  /** A list of `QuestionnaireCategory` objects. */
  nodes: Array<QuestionnaireCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `QuestionnaireCategory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `QuestionnaireCategory` edge in the connection. */
export type QuestionnaireCategoriesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `QuestionnaireCategory` at the end of the edge. */
  node: QuestionnaireCategory;
};

/** Methods to use when ordering `QuestionnaireCategory`. */
export enum QuestionnaireCategoriesOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Contains information about questionnaire categories */
export type QuestionnaireCategory = Node & {
  category: Scalars['String'];
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/**
 * A condition to be used against `QuestionnaireCategory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type QuestionnaireCategoryCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `Questionnaire` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type QuestionnaireCondition = {
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `questionnaireId` field. */
  questionnaireId?: Maybe<Scalars['Int']>;
};

/** Contains information about questionnaire lookups */
export type QuestionnaireLookup = Node & {
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  question: Scalars['String'];
  questionCategory: Scalars['String'];
  questionType: QuestionnaireTypeEnum;
  questionnaireLookupId: Scalars['Int'];
};

/**
 * A condition to be used against `QuestionnaireLookup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type QuestionnaireLookupCondition = {
  /** Checks for equality with the object’s `questionnaireLookupId` field. */
  questionnaireLookupId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `QuestionnaireLookup` values. */
export type QuestionnaireLookupsConnection = {
  /** A list of edges which contains the `QuestionnaireLookup` and cursor to aid in pagination. */
  edges: Array<QuestionnaireLookupsEdge>;
  /** A list of `QuestionnaireLookup` objects. */
  nodes: Array<QuestionnaireLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `QuestionnaireLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `QuestionnaireLookup` edge in the connection. */
export type QuestionnaireLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `QuestionnaireLookup` at the end of the edge. */
  node: QuestionnaireLookup;
};

/** Methods to use when ordering `QuestionnaireLookup`. */
export enum QuestionnaireLookupsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuestionnaireLookupIdAsc = 'QUESTIONNAIRE_LOOKUP_ID_ASC',
  QuestionnaireLookupIdDesc = 'QUESTIONNAIRE_LOOKUP_ID_DESC'
}

export enum QuestionnaireTypeEnum {
  HhsCovidCongregateCareResidence = 'HHS_COVID_CONGREGATE_CARE_RESIDENCE',
  HhsCovidDateOfOnset = 'HHS_COVID_DATE_OF_ONSET',
  HhsCovidEmployerAddress = 'HHS_COVID_EMPLOYER_ADDRESS',
  HhsCovidEmployerName = 'HHS_COVID_EMPLOYER_NAME',
  HhsCovidEmployerPhoneNumber = 'HHS_COVID_EMPLOYER_PHONE_NUMBER',
  HhsCovidHasTestedBefore = 'HHS_COVID_HAS_TESTED_BEFORE',
  HhsCovidInASchool = 'HHS_COVID_IN_A_SCHOOL',
  HhsCovidIsAddressDifferent = 'HHS_COVID_IS_ADDRESS_DIFFERENT',
  HhsCovidIsEmployed = 'HHS_COVID_IS_EMPLOYED',
  HhsCovidIsEmployedHealthcare = 'HHS_COVID_IS_EMPLOYED_HEALTHCARE',
  HhsCovidIsPregnant = 'HHS_COVID_IS_PREGNANT',
  HhsCovidIsSymptomatic = 'HHS_COVID_IS_SYMPTOMATIC',
  HhsCovidLocalAddress = 'HHS_COVID_LOCAL_ADDRESS',
  HhsCovidOccupation = 'HHS_COVID_OCCUPATION',
  HhsCovidPositiveTestDate = 'HHS_COVID_POSITIVE_TEST_DATE',
  HhsCovidPreviouslyPositive = 'HHS_COVID_PREVIOUSLY_POSITIVE',
  HhsCovidSchoolAddress = 'HHS_COVID_SCHOOL_ADDRESS',
  HhsCovidSchoolName = 'HHS_COVID_SCHOOL_NAME'
}

/** A connection to a list of `Questionnaire` values. */
export type QuestionnairesConnection = {
  /** A list of edges which contains the `Questionnaire` and cursor to aid in pagination. */
  edges: Array<QuestionnairesEdge>;
  /** A list of `Questionnaire` objects. */
  nodes: Array<Questionnaire>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Questionnaire` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Questionnaire` edge in the connection. */
export type QuestionnairesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Questionnaire` at the end of the edge. */
  node: Questionnaire;
};

/** Methods to use when ordering `Questionnaire`. */
export enum QuestionnairesOrderBy {
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuestionnaireIdAsc = 'QUESTIONNAIRE_ID_ASC',
  QuestionnaireIdDesc = 'QUESTIONNAIRE_ID_DESC'
}

export enum RaceEnum {
  African = 'AFRICAN',
  AfricanAmerican = 'AFRICAN_AMERICAN',
  AmericanIndian = 'AMERICAN_INDIAN',
  Asian = 'ASIAN',
  Caucasian = 'CAUCASIAN',
  Declined = 'DECLINED',
  Hispanic = 'HISPANIC',
  Latino = 'LATINO',
  NativeAlaskan = 'NATIVE_ALASKAN',
  NativeHawaiian = 'NATIVE_HAWAIIAN',
  Other = 'OTHER',
  PacificIslander = 'PACIFIC_ISLANDER',
  Unknown = 'UNKNOWN'
}

export enum ReadyCoreStatusCodeEnum {
  BadRequest = 'BAD_REQUEST',
  DuplicateResourceFound = 'DUPLICATE_RESOURCE_FOUND',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  OperationSuccessful = 'OPERATION_SUCCESSFUL',
  ResourceNotImplemented = 'RESOURCE_NOT_IMPLEMENTED'
}

export type RescheduleAppointmentCreationPayload = {
  appointmentId?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
};

export type RescheduleAppointmentInput = {
  appointment?: Maybe<CreateSkeduloAppointmentInput>;
  appointmentId?: Maybe<Scalars['Int']>;
  patients?: Maybe<Array<Maybe<CreateSkeduloPatientInput>>>;
  rescheduleReason?: Maybe<RescheduleReasonEnum>;
};

export enum RescheduleReasonEnum {
  EngagingResponders = 'ENGAGING_RESPONDERS',
  InputError = 'INPUT_ERROR',
  LackOfResourcesClinician = 'LACK_OF_RESOURCES_CLINICIAN',
  LackOfResourcesReadyInitiated = 'LACK_OF_RESOURCES_READY_INITIATED',
  LackOfResourcesResponder = 'LACK_OF_RESOURCES_RESPONDER',
  PatientWaitTimePatientInitiated = 'PATIENT_WAIT_TIME_PATIENT_INITIATED',
  TimeNoLongerWorksPatientInitiated = 'TIME_NO_LONGER_WORKS_PATIENT_INITIATED'
}

/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRole = Node & {
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderId: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesByResponderIdList: Array<AppointmentDispatch>;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByAppointmentDispatchResponderIdAndAppointmentId: ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByAppointmentDispatchResponderIdAndAppointmentIdList: Array<Appointment>;
  deputyId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  registeredDob?: Maybe<Scalars['Date']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
  skeduloId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `ResponderRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleAppointmentDispatchesByResponderIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleAppointmentDispatchesByResponderIdListArgs = {
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains contains information about the responder role and mapping to user relation. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyConnection = {
  /** A list of edges which contains the `Appointment`, info from the `AppointmentDispatch`, and the cursor to aid in pagination. */
  edges: Array<ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdge = {
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatches: AppointmentDispatchesConnection;
  /** Reads and enables pagination through a set of `AppointmentDispatch`. */
  appointmentDispatchesList: Array<AppointmentDispatch>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdgeAppointmentDispatchesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `AppointmentDispatch`. */
export type ResponderRoleAppointmentsByAppointmentDispatchResponderIdAndAppointmentIdManyToManyEdgeAppointmentDispatchesListArgs = {
  condition?: Maybe<AppointmentDispatchCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};

/**
 * A condition to be used against `ResponderRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ResponderRoleCondition = {
  /** Checks for equality with the object’s `skeduloId` field. */
  skeduloId?: Maybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ResponderRole` values. */
export type ResponderRolesConnection = {
  /** A list of edges which contains the `ResponderRole` and cursor to aid in pagination. */
  edges: Array<ResponderRolesEdge>;
  /** A list of `ResponderRole` objects. */
  nodes: Array<ResponderRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ResponderRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ResponderRole` edge in the connection. */
export type ResponderRolesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ResponderRole` at the end of the edge. */
  node: ResponderRole;
};

/** Methods to use when ordering `ResponderRole`. */
export enum ResponderRolesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SkeduloIdAsc = 'SKEDULO_ID_ASC',
  SkeduloIdDesc = 'SKEDULO_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** All input for the `revertTransitionEncounterTaskToClinicianReviewed` mutation. */
export type RevertTransitionEncounterTaskToClinicianReviewedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  vTaskId: Scalars['Int'];
};

/** The output of our `revertTransitionEncounterTaskToClinicianReviewed` mutation. */
export type RevertTransitionEncounterTaskToClinicianReviewedPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterTaskStatusEnum?: Maybe<EncounterTaskStatusEnum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `revertTransitionEncounterTaskToResponderCompleted` mutation. */
export type RevertTransitionEncounterTaskToResponderCompletedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  vTaskId: Scalars['Int'];
};

/** The output of our `revertTransitionEncounterTaskToResponderCompleted` mutation. */
export type RevertTransitionEncounterTaskToResponderCompletedPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterTaskStatusEnum?: Maybe<EncounterTaskStatusEnum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ReviewOfSystem = Node & {
  createdAt: Scalars['Datetime'];
  encounterTaskId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  reviewOfSystemId: Scalars['Int'];
  template: ReviewOfSystemTemplateEnum;
};

/**
 * A condition to be used against `ReviewOfSystem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReviewOfSystemCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `reviewOfSystemId` field. */
  reviewOfSystemId?: Maybe<Scalars['Int']>;
};

export type ReviewOfSystemEvaluationPayload = {
  key: Scalars['String'];
  value: Scalars['Boolean'];
};

export type ReviewOfSystemPayload = {
  systems?: Maybe<Array<Maybe<ReviewOfSystemSystemPayload>>>;
  template?: Maybe<ReviewOfSystemTemplateEnum>;
};

export type ReviewOfSystemSystem = Node & {
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  reviewOfSystemId: Scalars['Int'];
  reviewOfSystemSystemId: Scalars['Int'];
  system: ReviewOfSystemSystemEnum;
};

/**
 * A condition to be used against `ReviewOfSystemSystem` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ReviewOfSystemSystemCondition = {
  /** Checks for equality with the object’s `reviewOfSystemId` field. */
  reviewOfSystemId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `reviewOfSystemSystemId` field. */
  reviewOfSystemSystemId?: Maybe<Scalars['Int']>;
};

export enum ReviewOfSystemSystemEnum {
  Cardiovascular = 'CARDIOVASCULAR',
  Constitutional = 'CONSTITUTIONAL',
  Covid_19Screening = 'COVID_19_SCREENING',
  Endocrine = 'ENDOCRINE',
  Ent = 'ENT',
  Eyes = 'EYES',
  Gastrointestinal = 'GASTROINTESTINAL',
  Genitourinary = 'GENITOURINARY',
  HemeLymph = 'HEME_LYMPH',
  Musculoskeletal = 'MUSCULOSKELETAL',
  Neurological = 'NEUROLOGICAL',
  ObGyn = 'OB_GYN',
  Psych = 'PSYCH',
  Respiratory = 'RESPIRATORY',
  Skin = 'SKIN'
}

export type ReviewOfSystemSystemPayload = {
  evaluations: Array<Maybe<ReviewOfSystemEvaluationPayload>>;
  note?: Maybe<Scalars['String']>;
  system: ReviewOfSystemSystemEnum;
};

/** A connection to a list of `ReviewOfSystemSystem` values. */
export type ReviewOfSystemSystemsConnection = {
  /** A list of edges which contains the `ReviewOfSystemSystem` and cursor to aid in pagination. */
  edges: Array<ReviewOfSystemSystemsEdge>;
  /** A list of `ReviewOfSystemSystem` objects. */
  nodes: Array<ReviewOfSystemSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReviewOfSystemSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReviewOfSystemSystem` edge in the connection. */
export type ReviewOfSystemSystemsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReviewOfSystemSystem` at the end of the edge. */
  node: ReviewOfSystemSystem;
};

/** Methods to use when ordering `ReviewOfSystemSystem`. */
export enum ReviewOfSystemSystemsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReviewOfSystemIdAsc = 'REVIEW_OF_SYSTEM_ID_ASC',
  ReviewOfSystemIdDesc = 'REVIEW_OF_SYSTEM_ID_DESC',
  ReviewOfSystemSystemIdAsc = 'REVIEW_OF_SYSTEM_SYSTEM_ID_ASC',
  ReviewOfSystemSystemIdDesc = 'REVIEW_OF_SYSTEM_SYSTEM_ID_DESC'
}

export enum ReviewOfSystemTemplateEnum {
  All = 'ALL',
  Constitutional = 'CONSTITUTIONAL',
  Covid_19 = 'COVID_19',
  Gastrointestinal = 'GASTROINTESTINAL',
  GeneralAdult = 'GENERAL_ADULT'
}

/** A connection to a list of `ReviewOfSystem` values. */
export type ReviewOfSystemsConnection = {
  /** A list of edges which contains the `ReviewOfSystem` and cursor to aid in pagination. */
  edges: Array<ReviewOfSystemsEdge>;
  /** A list of `ReviewOfSystem` objects. */
  nodes: Array<ReviewOfSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReviewOfSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ReviewOfSystem` edge in the connection. */
export type ReviewOfSystemsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ReviewOfSystem` at the end of the edge. */
  node: ReviewOfSystem;
};

/** Methods to use when ordering `ReviewOfSystem`. */
export enum ReviewOfSystemsOrderBy {
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReviewOfSystemIdAsc = 'REVIEW_OF_SYSTEM_ID_ASC',
  ReviewOfSystemIdDesc = 'REVIEW_OF_SYSTEM_ID_DESC'
}

/** All input for the `revokeItRole` mutation. */
export type RevokeItRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our `revokeItRole` mutation. */
export type RevokeItRolePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `revokeItRole` mutation. */
export type RevokeItRolePayloadUserEdgeArgs = {
  orderBy?: Maybe<Array<UsersOrderBy>>;
};

export type RevokeRoleInput = {
  patch: RevokeRolePatchRecordInput;
  userId: Scalars['Int'];
};

export type RevokeRolePatchRecordInput = {
  role?: Maybe<UserRoleEnum>;
};

export type RevokeRolePayload = {
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type SaveChannelAttributionPayload = {
  channelAttribution?: Maybe<ChannelAttribution>;
};

export type SaveMarketInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  endTimes?: Maybe<Array<Maybe<Scalars['Time']>>>;
  frozenReason?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isFrozen?: Maybe<Scalars['Boolean']>;
  launchTimestamp?: Maybe<Scalars['Datetime']>;
  marketId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  operationalDays?: Maybe<Array<Maybe<Scalars['Int']>>>;
  scheduledFreezeEndTime?: Maybe<Scalars['Datetime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['Datetime']>;
  startTimes?: Maybe<Array<Maybe<Scalars['Time']>>>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** The output of our `SaveStandingOrder` mutation. */
export type SaveStandingOrderPayload = {
  standingOrder?: Maybe<StandingOrder>;
};

export type SaveZipcodeInput = {
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  scheduledFreezeEndTime?: Maybe<Scalars['DateTime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zipcode: Scalars['String'];
};

export type SaveZoneInput = {
  appointmentDurationAdjustment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  frozenReason?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isFrozen?: Maybe<Scalars['Boolean']>;
  launchTimestamp?: Maybe<Scalars['Date']>;
  marketId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  scheduledFreezeEndTime?: Maybe<Scalars['DateTime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['DateTime']>;
  skeduloRegionAreaId?: Maybe<Scalars['String']>;
  skeduloRegionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zoneId?: Maybe<Scalars['Int']>;
};

export enum SearchAllergyCodesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum SearchAllergyCodesTypeGroup {
  DrugAllergy = 'DRUG_ALLERGY',
  NonDrugAllergy = 'NON_DRUG_ALLERGY'
}

export enum SearchAppointmentsOrderByEnum {
  ScheduledForAsc = 'SCHEDULED_FOR_ASC',
  ScheduledForDesc = 'SCHEDULED_FOR_DESC'
}

export enum SearchCliniciansOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum SearchCptCodesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum SearchIcdCodesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum SearchPatientsOrderBy {
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GlobalPatientIdAsc = 'GLOBAL_PATIENT_ID_ASC',
  GlobalPatientIdDesc = 'GLOBAL_PATIENT_ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PreferredNameAsc = 'PREFERRED_NAME_ASC',
  PreferredNameDesc = 'PREFERRED_NAME_DESC'
}

export enum SearchReactionCodesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum SearchRespondersOrderBy {
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Contains information about the ReadyCore service lines */
export type ServiceLine = Node & {
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterServiceLineIdAndAppointmentId: ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByEncounterServiceLineIdAndAppointmentIdList: Array<Appointment>;
  averageDuration?: Maybe<Interval>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  friendlyName: Scalars['String'];
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndPrimaryInsurance: ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceList: Array<InsuranceRecord>;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndSecondaryInsurance: ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyConnection;
  /** Reads and enables pagination through a set of `InsuranceRecord`. */
  insuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceList: Array<InsuranceRecord>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterServiceLineIdAndPatientId: ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByEncounterServiceLineIdAndPatientIdList: Array<Patient>;
  priority: Scalars['Int'];
  segment?: Maybe<Scalars['String']>;
  serviceLineId: Scalars['Int'];
  subType: Scalars['String'];
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceListArgs = {
  condition?: Maybe<InsuranceRecordCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information about the ReadyCore service lines */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdListArgs = {
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};

/** A connection to a list of `Appointment` values, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyConnection = {
  /** A list of edges which contains the `Appointment`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdge>;
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Appointment` at the end of the edge. */
  node: Appointment;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Appointment` edge in the connection, with data from `Encounter`. */
export type ServiceLineAppointmentsByEncounterServiceLineIdAndAppointmentIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/**
 * A condition to be used against `ServiceLine` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ServiceLineCondition = {
  /** Filters on records matching `serviceLineId` */
  ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Checks for equality with the object’s `serviceLineId` field. */
  serviceLineId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersByPrimaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndPrimaryInsuranceManyToManyEdgeEncountersByPrimaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `InsuranceRecord` values, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyConnection = {
  /** A list of edges which contains the `InsuranceRecord`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdge>;
  /** A list of `InsuranceRecord` objects. */
  nodes: Array<InsuranceRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsuranceRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsurance: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersBySecondaryInsuranceList: Array<Encounter>;
  /** The `InsuranceRecord` at the end of the edge. */
  node: InsuranceRecord;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `InsuranceRecord` edge in the connection, with data from `Encounter`. */
export type ServiceLineInsuranceRecordsByEncounterServiceLineIdAndSecondaryInsuranceManyToManyEdgeEncountersBySecondaryInsuranceListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `Patient` values, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyConnection = {
  /** A list of edges which contains the `Patient`, info from the `Encounter`, and the cursor to aid in pagination. */
  edges: Array<ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Encounter`. */
  encounters: EncountersConnection;
  /** Reads and enables pagination through a set of `Encounter`. */
  encountersList: Array<Encounter>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdgeEncountersArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `Encounter`. */
export type ServiceLinePatientsByEncounterServiceLineIdAndPatientIdManyToManyEdgeEncountersListArgs = {
  condition?: Maybe<EncounterCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** A connection to a list of `ServiceLine` values. */
export type ServiceLinesConnection = {
  /** A list of edges which contains the `ServiceLine` and cursor to aid in pagination. */
  edges: Array<ServiceLinesEdge>;
  /** A list of `ServiceLine` objects. */
  nodes: Array<ServiceLine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceLine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ServiceLine` edge in the connection. */
export type ServiceLinesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ServiceLine` at the end of the edge. */
  node: ServiceLine;
};

/** Methods to use when ordering `ServiceLine`. */
export enum ServiceLinesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceLineIdAsc = 'SERVICE_LINE_ID_ASC',
  ServiceLineIdDesc = 'SERVICE_LINE_ID_DESC'
}

export enum SexEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type SkeduloAppointmentCreationPayload = {
  appointmentId?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
};

export type SkeduloAppointmentInput = {
  appointment?: Maybe<CreateSkeduloAppointmentInput>;
  patients?: Maybe<Array<Maybe<CreateSkeduloPatientInput>>>;
};

export type SkeduloEncounterInput = {
  channelAttributionId?: Maybe<Scalars['Int']>;
  genderRequirement?: Maybe<SexEnum>;
  modules?: Maybe<Array<Maybe<ModuleNameEnum>>>;
  paymentMode?: Maybe<EncounterPaymentModeEnum>;
  primaryInsurance?: Maybe<CreateSkeduloInsuranceInput>;
  primaryInsuranceId?: Maybe<Scalars['Int']>;
  reasonForEncounter?: Maybe<Scalars['String']>;
  secondaryInsurance?: Maybe<CreateSkeduloInsuranceInput>;
  secondaryInsuranceId?: Maybe<Scalars['Int']>;
  serviceLineId?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['String']>;
};

/** Contains information about standing orders for a test configuration */
export type StandingOrder = Node & {
  clinician?: Maybe<User>;
  clinicianId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  diagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  endedAt?: Maybe<Scalars['Datetime']>;
  isDeleted: Scalars['Boolean'];
  lookupId?: Maybe<Scalars['Int']>;
  lookupType?: Maybe<StandingOrderLookupTypeEnum>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  number: Scalars['String'];
  orderUrl: Scalars['String'];
  procedureCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  standingOrderId: Scalars['Int'];
  startedAt?: Maybe<Scalars['Datetime']>;
  state: StateEnum;
  updatedAt: Scalars['Datetime'];
  version: Scalars['String'];
};

/**
 * A condition to be used against `StandingOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StandingOrderCondition = {
  /** Filters on records matching `lookupType` */
  lookupType?: Maybe<StandingOrderLookupTypeConditionEnum>;
  /** Checks for equality with the object’s `number` field. */
  number?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `standingOrderId` field. */
  standingOrderId?: Maybe<Scalars['Int']>;
};

/** All input for `CreateStandingOrderLookup`. */
export type StandingOrderLookupInput = {
  lookupId: Scalars['Int'];
  lookupType: StandingOrderLookupTypeEnum;
};

export enum StandingOrderLookupTypeConditionEnum {
  PointOfCareTest = 'POINT_OF_CARE_TEST',
  Vaccine = 'VACCINE'
}

export enum StandingOrderLookupTypeEnum {
  PointOfCareTest = 'POINT_OF_CARE_TEST',
  Vaccine = 'VACCINE'
}

/** A connection to a list of `StandingOrder` values. */
export type StandingOrdersConnection = {
  /** A list of edges which contains the `StandingOrder` and cursor to aid in pagination. */
  edges: Array<StandingOrdersEdge>;
  /** A list of `StandingOrder` objects. */
  nodes: Array<StandingOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StandingOrder` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StandingOrder` edge in the connection. */
export type StandingOrdersEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `StandingOrder` at the end of the edge. */
  node: StandingOrder;
};

/** Methods to use when ordering `StandingOrder`. */
export enum StandingOrdersOrderBy {
  Natural = 'NATURAL',
  NumberAsc = 'NUMBER_ASC',
  NumberDesc = 'NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StandingOrderIdAsc = 'STANDING_ORDER_ID_ASC',
  StandingOrderIdDesc = 'STANDING_ORDER_ID_DESC'
}

export enum StateEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** Contains contains information about the suipervisor role and mapping to user relation. */
export type SupervisorRole = Node & {
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  registeredDob?: Maybe<Scalars['Date']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  updatedBy?: Maybe<Scalars['Int']>;
  /** Reads a single `User` that is related to this `SupervisorRole`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `SupervisorRole` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SupervisorRoleCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `SupervisorRole` values. */
export type SupervisorRolesConnection = {
  /** A list of edges which contains the `SupervisorRole` and cursor to aid in pagination. */
  edges: Array<SupervisorRolesEdge>;
  /** A list of `SupervisorRole` objects. */
  nodes: Array<SupervisorRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SupervisorRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SupervisorRole` edge in the connection. */
export type SupervisorRolesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `SupervisorRole` at the end of the edge. */
  node: SupervisorRole;
};

/** Methods to use when ordering `SupervisorRole`. */
export enum SupervisorRolesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** All input for the `syncSkeduloJobToAppointmentDispatch` mutation. */
export type SyncSkeduloJobToAppointmentDispatchInput = {
  /** The AppointmentDispatch atPatientAt Timestamp */
  atPatientAt?: Maybe<Scalars['DateTime']>;
  /** The AppointmentDispatch cancelledAt Timestamp */
  cancelledAt?: Maybe<Scalars['DateTime']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The AppointmentDispatch completedAt Timestamp */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** The AppointmentDispatch dispatchedAt Timestamp */
  dispatchedAt?: Maybe<Scalars['DateTime']>;
  /** The AppointmentDispatch enRouteAt Timestamp */
  enRouteAt?: Maybe<Scalars['DateTime']>;
  /** Unique ID that corresponds to the AppointmentDispatch skeduloJobAllocationId */
  jobAllocationId: Scalars['String'];
  /** Unique ID that corresponds to the Appointment skeduloJobId */
  jobId: Scalars['String'];
  /** The AppointmentDispatch onSceneAt Timestamp */
  onSceneAt?: Maybe<Scalars['DateTime']>;
  /** The AppointmentDispatch removedAt Timestamp */
  removedAt?: Maybe<Scalars['DateTime']>;
  /** Unique ID that corresponds to the Responder skeduloId */
  resourceId: Scalars['String'];
};

/** The output of our `syncSkeduloJobToAppointmentDispatch` mutation. */
export type SyncSkeduloJobToAppointmentDispatchPayload = {
  /** The `AppointmentDispatch` that was updated by this mutation. */
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** String message containing information about errors or success. */
  message?: Maybe<Scalars['String']>;
  /** Flag indicating whether the sync was successful or not. */
  success?: Maybe<Scalars['Boolean']>;
};

export enum SystemOfOriginEnum {
  ReadyCare = 'READY_CARE',
  ReadyHealth_1 = 'READY_HEALTH_1',
  ReadyHealth_2 = 'READY_HEALTH_2',
  ReadyOps = 'READY_OPS',
  ReadyWebhooks = 'READY_WEBHOOKS',
  ReadyZen = 'READY_ZEN',
  WebBooking = 'WEB_BOOKING'
}

/** Contains data related to Telehealth Meeting */
export type TelehealthMeeting = Node & {
  alternateConnectionMethod?: Maybe<TelehealthMeetingAlternateConnectionMethodEnum>;
  alternateConnectionReason?: Maybe<Scalars['String']>;
  clinician?: Maybe<User>;
  clinicianClaimedAt?: Maybe<Scalars['Datetime']>;
  clinicianId?: Maybe<Scalars['Int']>;
  clinicianRemovedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  encounterTaskId: Scalars['Int'];
  inQueueAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  telehealthMeetingChildId?: Maybe<Scalars['Int']>;
  telehealthMeetingId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  videoConference?: Maybe<VideoConference>;
  videoConferenceId?: Maybe<Scalars['Int']>;
};

export enum TelehealthMeetingAlternateConnectionMethodEnum {
  FamilyMemberTeleconference = 'FAMILY_MEMBER_TELECONFERENCE',
  GoogleMeet = 'GOOGLE_MEET',
  NonReadyhealthZoom = 'NON_READYHEALTH_ZOOM',
  Other = 'OTHER'
}

/**
 * A condition to be used against `TelehealthMeeting` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TelehealthMeetingCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `telehealthMeetingChildId` field. */
  telehealthMeetingChildId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `telehealthMeetingId` field. */
  telehealthMeetingId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `TelehealthMeeting` values. */
export type TelehealthMeetingsConnection = {
  /** A list of edges which contains the `TelehealthMeeting` and cursor to aid in pagination. */
  edges: Array<TelehealthMeetingsEdge>;
  /** A list of `TelehealthMeeting` objects. */
  nodes: Array<TelehealthMeeting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TelehealthMeeting` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TelehealthMeeting` edge in the connection. */
export type TelehealthMeetingsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `TelehealthMeeting` at the end of the edge. */
  node: TelehealthMeeting;
};

/** Methods to use when ordering `TelehealthMeeting`. */
export enum TelehealthMeetingsOrderBy {
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TelehealthMeetingChildIdAsc = 'TELEHEALTH_MEETING_CHILD_ID_ASC',
  TelehealthMeetingChildIdDesc = 'TELEHEALTH_MEETING_CHILD_ID_DESC',
  TelehealthMeetingIdAsc = 'TELEHEALTH_MEETING_ID_ASC',
  TelehealthMeetingIdDesc = 'TELEHEALTH_MEETING_ID_DESC'
}

export type UnclaimEncounterInput = {
  encounterId: Scalars['Int'];
};

export type UnclaimEncounterPayload = {
  encounter?: Maybe<Encounter>;
};

/** All input for the `UpdateAppointmentByGlobalId` mutation. */
export type UpdateAppointmentByGlobalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  globalId: Scalars['String'];
  patch: AppointmentPatch;
};

/** All input for the `updateAppointmentDispatchByNodeId` mutation. */
export type UpdateAppointmentDispatchByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AppointmentDispatch` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AppointmentDispatch` being updated. */
  patch: AppointmentDispatchPatch;
};

/** All input for the `updateAppointmentDispatch` mutation. */
export type UpdateAppointmentDispatchInput = {
  appointmentDispatchId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `AppointmentDispatch` being updated. */
  patch: AppointmentDispatchPatch;
};

/** The output of our update `AppointmentDispatch` mutation. */
export type UpdateAppointmentDispatchPayload = {
  /** Reads a single `Appointment` that is related to this `AppointmentDispatch`. */
  appointment?: Maybe<Appointment>;
  /** The `AppointmentDispatch` that was updated by this mutation. */
  appointmentDispatch?: Maybe<AppointmentDispatch>;
  /** An edge for our `AppointmentDispatch`. May be used by Relay 1. */
  appointmentDispatchEdge?: Maybe<AppointmentDispatchesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ResponderRole` that is related to this `AppointmentDispatch`. */
  responder?: Maybe<ResponderRole>;
};


/** The output of our update `AppointmentDispatch` mutation. */
export type UpdateAppointmentDispatchPayloadAppointmentDispatchEdgeArgs = {
  orderBy?: Maybe<Array<AppointmentDispatchesOrderBy>>;
};

/** All input for the `updateAppointment` mutation. */
export type UpdateAppointmentInput = {
  appointmentId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Appointment` being updated. */
  patch: AppointmentPatch;
};

/** The output of our update `Appointment` mutation. */
export type UpdateAppointmentPayload = {
  /** The `Appointment` that was updated by this mutation. */
  appointment?: Maybe<Appointment>;
  /** An edge for our `Appointment`. May be used by Relay 1. */
  appointmentEdge?: Maybe<AppointmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `Appointment`. */
  market?: Maybe<Market>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Appointment`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our update `Appointment` mutation. */
export type UpdateAppointmentPayloadAppointmentEdgeArgs = {
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};

/** All input for the `updateAppointmentTagByNodeId` mutation. */
export type UpdateAppointmentTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AppointmentTag` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AppointmentTag` being updated. */
  patch: AppointmentTagPatch;
};

/** All input for the `updateAppointmentTag` mutation. */
export type UpdateAppointmentTagInput = {
  appointmentTagId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `AppointmentTag` being updated. */
  patch: AppointmentTagPatch;
};

/** The output of our update `AppointmentTag` mutation. */
export type UpdateAppointmentTagPayload = {
  /** The `AppointmentTag` that was updated by this mutation. */
  appointmentTag?: Maybe<AppointmentTag>;
  /** An edge for our `AppointmentTag`. May be used by Relay 1. */
  appointmentTagEdge?: Maybe<AppointmentTagsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AppointmentTag` mutation. */
export type UpdateAppointmentTagPayloadAppointmentTagEdgeArgs = {
  orderBy?: Maybe<Array<AppointmentTagsOrderBy>>;
};

/** All input for the `UpdateChannelAttribution` mutation. */
export type UpdateChannelAttributionInput = {
  channel?: Maybe<Scalars['String']>;
  channelAttributionId: Scalars['Int'];
  institutionType?: Maybe<ChannelAttributionInstitutionTypeEnum>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  marketIds: Array<Maybe<Scalars['Int']>>;
  referralType?: Maybe<ChannelAttributionReferralTypeEnum>;
  tagSystem?: Maybe<ChannelAttributionTagSystemEnum>;
  trackingNumber?: Maybe<Scalars['String']>;
};

/** All input for the `updateClinicByNodeId` mutation. */
export type UpdateClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Clinic` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Clinic` being updated. */
  patch: ClinicPatch;
};

/** All input for the `updateClinic` mutation. */
export type UpdateClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  /** An object where the defined keys will be set on the `Clinic` being updated. */
  patch: ClinicPatch;
};

/** The output of our update `Clinic` mutation. */
export type UpdateClinicPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Clinic` that was updated by this mutation. */
  clinic?: Maybe<Clinic>;
  /** An edge for our `Clinic`. May be used by Relay 1. */
  clinicEdge?: Maybe<ClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Clinic` mutation. */
export type UpdateClinicPayloadClinicEdgeArgs = {
  orderBy?: Maybe<Array<ClinicsOrderBy>>;
};

/** All input for the `updateCodeSystemByNodeId` mutation. */
export type UpdateCodeSystemByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CodeSystem` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CodeSystem` being updated. */
  patch: CodeSystemPatch;
};

/** All input for the `updateCodeSystem` mutation. */
export type UpdateCodeSystemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  codeSystemId: Scalars['Int'];
  /** An object where the defined keys will be set on the `CodeSystem` being updated. */
  patch: CodeSystemPatch;
};

/** The output of our update `CodeSystem` mutation. */
export type UpdateCodeSystemPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CodeSystem` that was updated by this mutation. */
  codeSystem?: Maybe<CodeSystem>;
  /** An edge for our `CodeSystem`. May be used by Relay 1. */
  codeSystemEdge?: Maybe<CodeSystemsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CodeSystem` mutation. */
export type UpdateCodeSystemPayloadCodeSystemEdgeArgs = {
  orderBy?: Maybe<Array<CodeSystemsOrderBy>>;
};

/** All input for the `updateEncounterByNodeId` mutation. */
export type UpdateEncounterByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Encounter` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Encounter` being updated. */
  patch: EncounterPatch;
};

/** All input for the `updateEncounter` mutation. */
export type UpdateEncounterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterId: Scalars['Int'];
  /** An object where the defined keys will be set on the `Encounter` being updated. */
  patch: EncounterPatch;
};

/** The output of our update `Encounter` mutation. */
export type UpdateEncounterPayload = {
  /** Reads a single `Appointment` that is related to this `Encounter`. */
  appointment?: Maybe<Appointment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Encounter` that was updated by this mutation. */
  encounter?: Maybe<Encounter>;
  /** An edge for our `Encounter`. May be used by Relay 1. */
  encounterEdge?: Maybe<EncountersEdge>;
  /** Reads a single `Patient` that is related to this `Encounter`. */
  patient?: Maybe<Patient>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  primaryInsuranceRecord?: Maybe<InsuranceRecord>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `InsuranceRecord` that is related to this `Encounter`. */
  secondaryInsuranceRecord?: Maybe<InsuranceRecord>;
  /** Reads a single `ServiceLine` that is related to this `Encounter`. */
  serviceLine?: Maybe<ServiceLine>;
};


/** The output of our update `Encounter` mutation. */
export type UpdateEncounterPayloadEncounterEdgeArgs = {
  orderBy?: Maybe<Array<EncountersOrderBy>>;
};

/** All input for the `updateEncounterTaskAttachmentByNodeId` mutation. */
export type UpdateEncounterTaskAttachmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EncounterTaskAttachment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `EncounterTaskAttachment` being updated. */
  patch: EncounterTaskAttachmentPatch;
};

/** All input for the `updateEncounterTaskAttachment` mutation. */
export type UpdateEncounterTaskAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterTaskAttachmentId: Scalars['Int'];
  /** An object where the defined keys will be set on the `EncounterTaskAttachment` being updated. */
  patch: EncounterTaskAttachmentPatch;
};

/** The output of our update `EncounterTaskAttachment` mutation. */
export type UpdateEncounterTaskAttachmentPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `EncounterTask` that is related to this `EncounterTaskAttachment`. */
  encounterTask?: Maybe<EncounterTask>;
  /** The `EncounterTaskAttachment` that was updated by this mutation. */
  encounterTaskAttachment?: Maybe<EncounterTaskAttachment>;
  /** An edge for our `EncounterTaskAttachment`. May be used by Relay 1. */
  encounterTaskAttachmentEdge?: Maybe<EncounterTaskAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EncounterTaskAttachment` mutation. */
export type UpdateEncounterTaskAttachmentPayloadEncounterTaskAttachmentEdgeArgs = {
  orderBy?: Maybe<Array<EncounterTaskAttachmentsOrderBy>>;
};

/** All input for the `updateEncounterTaskByNodeId` mutation. */
export type UpdateEncounterTaskByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EncounterTask` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `EncounterTask` being updated. */
  patch: EncounterTaskPatch;
};

/** All input for the `updateEncounterTask` mutation. */
export type UpdateEncounterTaskInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  encounterTaskId: Scalars['Int'];
  /** An object where the defined keys will be set on the `EncounterTask` being updated. */
  patch: EncounterTaskPatch;
};

/** The output of our update `EncounterTask` mutation. */
export type UpdateEncounterTaskPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Encounter` that is related to this `EncounterTask`. */
  encounter?: Maybe<Encounter>;
  /** The `EncounterTask` that was updated by this mutation. */
  encounterTask?: Maybe<EncounterTask>;
  /** An edge for our `EncounterTask`. May be used by Relay 1. */
  encounterTaskEdge?: Maybe<EncounterTasksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EncounterTask` mutation. */
export type UpdateEncounterTaskPayloadEncounterTaskEdgeArgs = {
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};

/** All input for the `updateEncounterTaskTaskRoles` mutation. */
export type UpdateEncounterTaskTaskRolesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  vEncounterId: Scalars['Int'];
};

/** All input for the `updateEncounterTaskTaskRolesOnEncounterComplete` mutation. */
export type UpdateEncounterTaskTaskRolesOnEncounterCompleteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  vEncounterId: Scalars['Int'];
};

/** The output of our `updateEncounterTaskTaskRolesOnEncounterComplete` mutation. */
export type UpdateEncounterTaskTaskRolesOnEncounterCompletePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** The output of our `updateEncounterTaskTaskRoles` mutation. */
export type UpdateEncounterTaskTaskRolesPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateFeatureGateByNodeId` mutation. */
export type UpdateFeatureGateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeatureGate` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FeatureGate` being updated. */
  patch: FeatureGatePatch;
};

/** All input for the `updateFeatureGate` mutation. */
export type UpdateFeatureGateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  featureId: Scalars['String'];
  /** An object where the defined keys will be set on the `FeatureGate` being updated. */
  patch: FeatureGatePatch;
};

/** The output of our update `FeatureGate` mutation. */
export type UpdateFeatureGatePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FeatureGate` that was updated by this mutation. */
  featureGate?: Maybe<FeatureGate>;
  /** An edge for our `FeatureGate`. May be used by Relay 1. */
  featureGateEdge?: Maybe<FeatureGatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `FeatureGate` mutation. */
export type UpdateFeatureGatePayloadFeatureGateEdgeArgs = {
  orderBy?: Maybe<Array<FeatureGatesOrderBy>>;
};

/** All input for the `updateInsuranceRecordByNodeId` mutation. */
export type UpdateInsuranceRecordByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `InsuranceRecord` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `InsuranceRecord` being updated. */
  patch: InsuranceRecordPatch;
};

/** All input for the `updateInsuranceRecord` mutation. */
export type UpdateInsuranceRecordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Integer Primary Key for record */
  insuranceRecordId: Scalars['Int'];
  /** An object where the defined keys will be set on the `InsuranceRecord` being updated. */
  patch: InsuranceRecordPatch;
};

/** The output of our update `InsuranceRecord` mutation. */
export type UpdateInsuranceRecordPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `InsuranceRecord` that was updated by this mutation. */
  insuranceRecord?: Maybe<InsuranceRecord>;
  /** An edge for our `InsuranceRecord`. May be used by Relay 1. */
  insuranceRecordEdge?: Maybe<InsuranceRecordsEdge>;
  /** Reads a single `Patient` that is related to this `InsuranceRecord`. */
  patient?: Maybe<Patient>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `InsuranceRecord` mutation. */
export type UpdateInsuranceRecordPayloadInsuranceRecordEdgeArgs = {
  orderBy?: Maybe<Array<InsuranceRecordsOrderBy>>;
};

/** All input for the `updateMarketClinicByNodeId` mutation. */
export type UpdateMarketClinicByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MarketClinic` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MarketClinic` being updated. */
  patch: MarketClinicPatch;
};

/** All input for the `updateMarketClinic` mutation. */
export type UpdateMarketClinicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  clinicId: Scalars['Int'];
  marketId: Scalars['Int'];
  /** An object where the defined keys will be set on the `MarketClinic` being updated. */
  patch: MarketClinicPatch;
};

/** The output of our update `MarketClinic` mutation. */
export type UpdateMarketClinicPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Market` that is related to this `MarketClinic`. */
  market?: Maybe<Market>;
  /** The `MarketClinic` that was updated by this mutation. */
  marketClinic?: Maybe<MarketClinic>;
  /** An edge for our `MarketClinic`. May be used by Relay 1. */
  marketClinicEdge?: Maybe<MarketClinicsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MarketClinic` mutation. */
export type UpdateMarketClinicPayloadMarketClinicEdgeArgs = {
  orderBy?: Maybe<Array<MarketClinicsOrderBy>>;
};

/** All input for the `updateMedicalDirectorByNodeId` mutation. */
export type UpdateMedicalDirectorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MedicalDirector` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MedicalDirector` being updated. */
  patch: MedicalDirectorPatch;
};

/** All input for the `updateMedicalDirector` mutation. */
export type UpdateMedicalDirectorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  medicalDirectorId: Scalars['Int'];
  /** An object where the defined keys will be set on the `MedicalDirector` being updated. */
  patch: MedicalDirectorPatch;
};

/** The output of our update `MedicalDirector` mutation. */
export type UpdateMedicalDirectorPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `MedicalDirector` that was updated by this mutation. */
  medicalDirector?: Maybe<MedicalDirector>;
  /** An edge for our `MedicalDirector`. May be used by Relay 1. */
  medicalDirectorEdge?: Maybe<MedicalDirectorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MedicalDirector` mutation. */
export type UpdateMedicalDirectorPayloadMedicalDirectorEdgeArgs = {
  orderBy?: Maybe<Array<MedicalDirectorsOrderBy>>;
};

/** All input for the `updatePatientAttachmentByNodeId` mutation. */
export type UpdatePatientAttachmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PatientAttachment` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PatientAttachment` being updated. */
  patch: PatientAttachmentPatch;
};

/** All input for the `updatePatientAttachment` mutation. */
export type UpdatePatientAttachmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PatientAttachment` being updated. */
  patch: PatientAttachmentPatch;
  patientAttachmentId: Scalars['Int'];
};

/** The output of our update `PatientAttachment` mutation. */
export type UpdatePatientAttachmentPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientAttachment`. */
  patient?: Maybe<Patient>;
  /** The `PatientAttachment` that was updated by this mutation. */
  patientAttachment?: Maybe<PatientAttachment>;
  /** An edge for our `PatientAttachment`. May be used by Relay 1. */
  patientAttachmentEdge?: Maybe<PatientAttachmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PatientAttachment` mutation. */
export type UpdatePatientAttachmentPayloadPatientAttachmentEdgeArgs = {
  orderBy?: Maybe<Array<PatientAttachmentsOrderBy>>;
};

/** All input for the `updatePatient` mutation. */
export type UpdatePatientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patch: PatientPatchRecordInput;
  patientId: Scalars['Int'];
};

/** All input for the `updatePatientNote` mutation. */
export type UpdatePatientNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patch: PatientNotePatchRecordInput;
  patientNoteId: Scalars['Int'];
};

/** The output of our `updatePatientNote` mutation. */
export type UpdatePatientNotePayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Patient` that is related to this `PatientNote`. */
  patient?: Maybe<Patient>;
  patientNote?: Maybe<PatientNote>;
  /** An edge for our `PatientNote`. May be used by Relay 1. */
  patientNoteEdge?: Maybe<PatientNotesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PatientNote`. */
  userByCreatedBy?: Maybe<User>;
};


/** The output of our `updatePatientNote` mutation. */
export type UpdatePatientNotePayloadPatientNoteEdgeArgs = {
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};

/** The output of our `updatePatient` mutation. */
export type UpdatePatientPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge?: Maybe<PatientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updatePatient` mutation. */
export type UpdatePatientPayloadPatientEdgeArgs = {
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};

/** All input for the `updatePhysicalExamByNodeId` mutation. */
export type UpdatePhysicalExamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PhysicalExam` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PhysicalExam` being updated. */
  patch: PhysicalExamPatch;
};

/** All input for the `updatePhysicalExam` mutation. */
export type UpdatePhysicalExamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PhysicalExam` being updated. */
  patch: PhysicalExamPatch;
  physicalExamId: Scalars['Int'];
};

/** The output of our update `PhysicalExam` mutation. */
export type UpdatePhysicalExamPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PhysicalExam` that was updated by this mutation. */
  physicalExam?: Maybe<PhysicalExam>;
  /** An edge for our `PhysicalExam`. May be used by Relay 1. */
  physicalExamEdge?: Maybe<PhysicalExamsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PhysicalExam` mutation. */
export type UpdatePhysicalExamPayloadPhysicalExamEdgeArgs = {
  orderBy?: Maybe<Array<PhysicalExamsOrderBy>>;
};

/** All input for the `updateResponderDeputyId` mutation. */
export type UpdateResponderDeputyIdInput = {
  clientMutationId?: Maybe<Scalars['String']>;
  deputyId: Scalars['String'];
  userId: Scalars['Int'];
};

/** The output of our `UpdateResponderDeputyId` mutation. */
export type UpdateResponderDeputyIdPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

/** All input for the `updateResponderSkeduloId` mutation. */
export type UpdateResponderSkeduloIdInput = {
  clientMutationId?: Maybe<Scalars['String']>;
  skeduloId: Scalars['String'];
  userId: Scalars['Int'];
};

/** The output of our `UpdateResponderSkeduloId` mutation. */
export type UpdateResponderSkeduloIdPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

/** All input for the `UpdateStandingOrderInput` mutation. */
export type UpdateStandingOrderInput = {
  clinicianId?: Maybe<Scalars['Int']>;
  diagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  endedAt?: Maybe<Scalars['Datetime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lookup?: Maybe<StandingOrderLookupInput>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  orderUrl?: Maybe<Scalars['String']>;
  procedureCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  startedAt?: Maybe<Scalars['Datetime']>;
  state?: Maybe<StateEnum>;
  version?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  patch: UserPatchRecordInput;
  userId: Scalars['Int'];
};

export type UpdateUserPayload = {
  query?: Maybe<Query>;
  user?: Maybe<User>;
};

export type UpdateVideoConferenceInput = {
  meetingEndTime?: Maybe<Scalars['Date']>;
  meetingId: Scalars['BigInt'];
  meetingStartTime?: Maybe<Scalars['Date']>;
};

export type UpdateVideoConferencePayload = {
  query?: Maybe<Query>;
  videoConference?: Maybe<VideoConference>;
};

export type UpsertClinicianSignaturePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  encounter?: Maybe<Encounter>;
  encounterSignature?: Maybe<EncounterSignature>;
  query?: Maybe<Query>;
};

export type UpsertEncounterTaskAttachmentImageInput = {
  encounterTaskAttachmentId?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type UpsertEncounterTaskAttachmentInput = {
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<UpsertEncounterTaskAttachmentImageInput>>>;
  isRequired?: Maybe<Scalars['Boolean']>;
  type?: Maybe<EncounterTaskAttachmentTypeEnum>;
};

export type UpsertEncounterTaskBillingDiagnosticsInput = {
  procedureCodeReferenceIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type UpsertEncounterTaskChiefComplaintAndHpiInput = {
  chiefComplaint?: Maybe<Scalars['String']>;
  historyOfPresentIllness?: Maybe<Scalars['String']>;
  reviewOfSystems?: Maybe<Array<Maybe<UpsertReviewOfSystemInput>>>;
};

export type UpsertEncounterTaskDispositionInput = {
  activation?: Maybe<ActivationEnum>;
  clinicianIncluded?: Maybe<Scalars['Boolean']>;
  disposition?: Maybe<DispositionEnum>;
  patientInstructions?: Maybe<Array<Maybe<UpsertPatientInstructionInput>>>;
};

export type UpsertEncounterTaskInput = {
  attachments?: Maybe<Array<Maybe<UpsertEncounterTaskAttachmentInput>>>;
  billingDiagnostics?: Maybe<UpsertEncounterTaskBillingDiagnosticsInput>;
  chiefComplaintAndHpi?: Maybe<UpsertEncounterTaskChiefComplaintAndHpiInput>;
  clinicianReviewedAt?: Maybe<Scalars['DateTime']>;
  correctionReason?: Maybe<Scalars['String']>;
  disposition?: Maybe<UpsertEncounterTaskDispositionInput>;
  encounterTaskId: Scalars['Int'];
  inProgressAt?: Maybe<Scalars['DateTime']>;
  medicalDecisionMaking?: Maybe<UpsertEncounterTaskMedicalDecisionMakingInput>;
  patientAllergy?: Maybe<Array<Maybe<UpsertEncounterTaskPatientAllergyInput>>>;
  patientProblem?: Maybe<Array<Maybe<UpsertEncounterTaskPatientProblemInput>>>;
  paymentMode?: Maybe<UpsertEncounterTaskPaymentModeInput>;
  physicalExam?: Maybe<UpsertEncounterTaskPhysicalExamInput>;
  pointOfCareTest?: Maybe<UpsertEncounterTaskPointOfCareTestInput>;
  progressNote?: Maybe<UpsertEncounterTaskProgressNoteInput>;
  responderCompletedAt?: Maybe<Scalars['DateTime']>;
  skippedReason?: Maybe<Scalars['String']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  telehealthMeeting?: Maybe<UpsertEncounterTaskTelehealthMeetingInput>;
  vaccine?: Maybe<UpsertEncounterTaskVaccineInput>;
  vital?: Maybe<Array<Maybe<UpsertEncounterTaskVital>>>;
};

export type UpsertEncounterTaskMedicalDecisionMakingInput = {
  diagnosisCodeReferenceIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  note?: Maybe<Scalars['String']>;
};

export type UpsertEncounterTaskPatientAllergyInput = {
  allergicCriticalityId?: Maybe<Scalars['Int']>;
  allergicReactionId?: Maybe<Scalars['Int']>;
  allergicSeverityId?: Maybe<Scalars['Int']>;
  allergicStatusId?: Maybe<Scalars['Int']>;
  allergyId?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['Datetime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  patientAllergyId?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['Datetime']>;
};

export type UpsertEncounterTaskPatientProblemInput = {
  endedAt?: Maybe<Scalars['Datetime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  patientProblemId?: Maybe<Scalars['Int']>;
  problemStatusId?: Maybe<Scalars['Int']>;
  problemText?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Datetime']>;
};

export type UpsertEncounterTaskPayload = {
  encounterTask?: Maybe<EncounterTask>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type UpsertEncounterTaskPaymentModeInput = {
  paymentMode: EncounterPaymentModeEnum;
};

export type UpsertEncounterTaskPhysicalExamInput = {
  encounterTaskId: Scalars['Int'];
  note: Scalars['String'];
  physicalExamId?: Maybe<Scalars['Int']>;
};

export type UpsertEncounterTaskPointOfCareTestInput = {
  attestedAt?: Maybe<Scalars['DateTime']>;
  attestedByRole?: Maybe<UserRoleEnum>;
  clinicianFirstName?: Maybe<Scalars['String']>;
  clinicianLastName?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['Date']>;
  humidity?: Maybe<Scalars['Int']>;
  internalControlAcceptable?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lotNumber?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  standingOrderAddedAt?: Maybe<Scalars['Date']>;
  standingOrderId?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
};

export type UpsertEncounterTaskProgressNoteInput = {
  encounterTaskId: Scalars['Int'];
  note: Scalars['String'];
  progressNoteId?: Maybe<Scalars['Int']>;
};

export type UpsertEncounterTaskTelehealthMeetingInput = {
  alternateConnectionMethod?: Maybe<TelehealthMeetingAlternateConnectionMethodEnum>;
  alternateConnectionReason?: Maybe<Scalars['String']>;
};

export type UpsertEncounterTaskVaccineInput = {
  adverseReactions?: Maybe<Array<Maybe<VaccineAdverseReactionEnum>>>;
  contraindication?: Maybe<Scalars['Boolean']>;
  doseNumber?: Maybe<Scalars['Int']>;
  hadAdverseReaction?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  location?: Maybe<VaccineLocationEnum>;
  lotExpiration?: Maybe<Scalars['DateTime']>;
  lotNumber?: Maybe<Scalars['String']>;
  otherAdverseReactions?: Maybe<Scalars['String']>;
  standingOrderAddedAt?: Maybe<Scalars['Date']>;
  standingOrderId?: Maybe<Scalars['Int']>;
  totalDoses?: Maybe<Scalars['Int']>;
  vaccineLookupId?: Maybe<Scalars['Int']>;
  visEdition?: Maybe<Scalars['DateTime']>;
  visReceived?: Maybe<Scalars['Boolean']>;
};

export type UpsertEncounterTaskVital = {
  result: Scalars['String'];
  vitalLookupType: VitalLookupTypeEnum;
};

export type UpsertMarketsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  markets: Array<Maybe<SaveMarketInput>>;
};

export type UpsertMarketsPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<Maybe<Market>>>;
  query?: Maybe<Query>;
};

export type UpsertPatientInstructionInput = {
  careInstructions?: Maybe<Scalars['String']>;
  excusedUntilDate?: Maybe<Scalars['Datetime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  levelOfCare?: Maybe<PatientInstructionLevelOfCareEnum>;
  levelOfCareOther?: Maybe<Scalars['String']>;
  medicalRestrictions?: Maybe<Scalars['String']>;
  patientInstructionId?: Maybe<Scalars['Int']>;
  relevantPastMedicalHistory?: Maybe<Scalars['String']>;
  timeframeUnit?: Maybe<PatientInstructionTimeframeEnum>;
  timeframeValue?: Maybe<Scalars['Int']>;
  type?: Maybe<PatientInstructionTypeEnum>;
};

export type UpsertResponderSignaturePayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  encounter?: Maybe<Encounter>;
  encounterSignature?: Maybe<EncounterSignature>;
  query?: Maybe<Query>;
};

export type UpsertReviewOfSystemEvaluationInput = {
  key: Scalars['String'];
  value: Scalars['Boolean'];
};

export type UpsertReviewOfSystemInput = {
  systems: Array<Maybe<UpsertReviewOfSystemSystemInput>>;
  template: ReviewOfSystemTemplateEnum;
};

export type UpsertReviewOfSystemSystemInput = {
  evaluations: Array<Maybe<UpsertReviewOfSystemEvaluationInput>>;
  note?: Maybe<Scalars['String']>;
  system: ReviewOfSystemSystemEnum;
};

/** All input for the `upsertUsers` mutation. */
export type UpsertUsersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  userProfiles: Array<Maybe<UserProfileInput>>;
};

/** The output of our `upsertUsers` mutation. */
export type UpsertUsersPayload = {
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type UpsertZipcodesInput = {
  clientMutationId?: Maybe<Scalars['String']>;
  zipcodes: Array<Maybe<SaveZipcodeInput>>;
};

export type UpsertZipcodesPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  zipcodes?: Maybe<Array<Maybe<Zipcode>>>;
};

export type UpsertZoneZipcodeInput = {
  zipCodes: Array<Maybe<Scalars['ZipCode']>>;
  zoneId: Scalars['Int'];
};

export type UpsertZoneZipcodePayload = {
  code?: Maybe<Scalars['String']>;
  zoneZipcodes?: Maybe<Array<Maybe<ZoneZipcode>>>;
};

export type UpsertZonesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  zones: Array<Maybe<SaveZoneInput>>;
};

export type UpsertZonesPayload = {
  clientMutationId?: Maybe<Scalars['String']>;
  query?: Maybe<Query>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};

/** Contains information about the user relation. */
export type User = Node & {
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedBy: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsByCreatedByList: Array<Appointment>;
  /** Reads a single `CerRole` that is related to this `User`. */
  cerRole?: Maybe<CerRole>;
  /**
   * Reads and enables pagination through a set of `CerRole`.
   * @deprecated Please use cerRole instead
   */
  cerRoles: CerRolesConnection;
  /** Reads a single `ClinicianRole` that is related to this `User`. */
  clinicianRole?: Maybe<ClinicianRole>;
  /**
   * Reads and enables pagination through a set of `ClinicianRole`.
   * @deprecated Please use clinicianRole instead
   */
  clinicianRoles: ClinicianRolesConnection;
  createdAt?: Maybe<Scalars['Datetime']>;
  credentials?: Maybe<Array<Maybe<CredentialsEnum>>>;
  deletedAt?: Maybe<Scalars['Datetime']>;
  dob?: Maybe<Scalars['Date']>;
  /** Only one email address can be active at a time, but email addresses can be re-used within the organization. */
  email?: Maybe<Scalars['String']>;
  /** Unique Employee ID that maps to the user Google ID. */
  employeeId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  friendlyRoles?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  isCer?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user is clinician. */
  isClinician?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user is it. */
  isIt?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user has ops role. */
  isOps?: Maybe<Scalars['Boolean']>;
  isOutreach?: Maybe<Scalars['Boolean']>;
  /** Computed column on the user relation to indicate if user is responder. */
  isResponder?: Maybe<Scalars['Boolean']>;
  isSupervisor?: Maybe<Scalars['Boolean']>;
  /** Reads a single `ItRole` that is related to this `User`. */
  itRole?: Maybe<ItRole>;
  /**
   * Reads and enables pagination through a set of `ItRole`.
   * @deprecated Please use itRole instead
   */
  itRoles: ItRolesConnection;
  languages?: Maybe<Array<Maybe<LanguagesEnum>>>;
  lastLoginAt?: Maybe<Scalars['Datetime']>;
  lastName?: Maybe<Scalars['String']>;
  loginsCount?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Market`. */
  marketsByAppointmentCreatedByAndMarketId: UserMarketsByAppointmentCreatedByAndMarketIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Market`. */
  marketsByAppointmentCreatedByAndMarketIdList: Array<Market>;
  /** Meta column describing the data source from which the record migrated from. Default is null. */
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  npi?: Maybe<Scalars['String']>;
  /** Reads a single `OpsRole` that is related to this `User`. */
  opsRole?: Maybe<OpsRole>;
  /**
   * Reads and enables pagination through a set of `OpsRole`.
   * @deprecated Please use opsRole instead
   */
  opsRoles: OpsRolesConnection;
  /** Reads a single `OutreachRole` that is related to this `User`. */
  outreachRole?: Maybe<OutreachRole>;
  /**
   * Reads and enables pagination through a set of `OutreachRole`.
   * @deprecated Please use outreachRole instead
   */
  outreachRoles: OutreachRolesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedBy: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesByCreatedByList: Array<PatientNote>;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByPatientNoteCreatedByAndPatientId: UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Patient`. */
  patientsByPatientNoteCreatedByAndPatientIdList: Array<Patient>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
  /** Reads a single `ResponderRole` that is related to this `User`. */
  responderRole?: Maybe<ResponderRole>;
  /**
   * Reads and enables pagination through a set of `ResponderRole`.
   * @deprecated Please use responderRole instead
   */
  responderRoles: ResponderRolesConnection;
  roles: Array<UserRole>;
  /** Reads a single `SupervisorRole` that is related to this `User`. */
  supervisorRole?: Maybe<SupervisorRole>;
  /**
   * Reads and enables pagination through a set of `SupervisorRole`.
   * @deprecated Please use supervisorRole instead
   */
  supervisorRoles: SupervisorRolesConnection;
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Id is the primary key, auto-incrementing integer. */
  userId: Scalars['Int'];
  userIdentifiersList?: Maybe<Array<Maybe<UserIdentifier>>>;
  userMarketsList?: Maybe<Array<Maybe<Market>>>;
  /** Reads and enables pagination through a set of `UserPatient`. */
  userPatients: UserPatientsConnection;
  /** Reads and enables pagination through a set of `UserPatient`. */
  userPatientsList: Array<UserPatient>;
  userUuid: Scalars['UUID'];
};


/** Contains information about the user relation. */
export type UserAppointmentsByCreatedByArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserAppointmentsByCreatedByListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserCerRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<CerRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<CerRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserClinicianRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ClinicianRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ClinicianRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserItRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ItRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ItRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserMarketsByAppointmentCreatedByAndMarketIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<MarketCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserMarketsByAppointmentCreatedByAndMarketIdListArgs = {
  condition?: Maybe<MarketCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<MarketsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserOpsRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<OpsRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<OpsRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserOutreachRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<OutreachRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<OutreachRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserPatientNotesByCreatedByArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserPatientNotesByCreatedByListArgs = {
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdListArgs = {
  condition?: Maybe<PatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserResponderRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ResponderRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ResponderRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserSupervisorRolesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<SupervisorRoleCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<SupervisorRolesOrderBy>>;
};


/** Contains information about the user relation. */
export type UserUserPatientsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<UserPatientCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UserPatientsOrderBy>>;
};


/** Contains information about the user relation. */
export type UserUserPatientsListArgs = {
  condition?: Maybe<UserPatientCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<UserPatientsOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `employeeId` field. */
  employeeId?: Maybe<Scalars['String']>;
  /** Filters to records matching isDeleted */
  isDeleted?: Maybe<Array<Scalars['Boolean']>>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userUuid` field. */
  userUuid?: Maybe<Scalars['UUID']>;
};

/** Contains information about the mapping between ReadyCore user table and identifiers */
export type UserIdentifier = {
  endedAt?: Maybe<Scalars['Datetime']>;
  identifier: Scalars['String'];
  identifierType: IdentifierTypeEnum;
  isDeleted: Scalars['Boolean'];
  startedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserIdentifier`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
  userIdentifierId: Scalars['Int'];
};

/** Contains information about the mapping between ReadyCore user table and markets */
export type UserMarket = {
  isDeleted: Scalars['Boolean'];
  marketId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  updatedBy?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
  userMarketId: Scalars['Int'];
};

/** A connection to a list of `Market` values, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyConnection = {
  /** A list of edges which contains the `Market`, info from the `Appointment`, and the cursor to aid in pagination. */
  edges: Array<UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdge>;
  /** A list of `Market` objects. */
  nodes: Array<Market>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Market` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Market` edge in the connection, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdge = {
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection;
  /** Reads and enables pagination through a set of `Appointment`. */
  appointmentsList: Array<Appointment>;
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Market` at the end of the edge. */
  node: Market;
};


/** A `Market` edge in the connection, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdgeAppointmentsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};


/** A `Market` edge in the connection, with data from `Appointment`. */
export type UserMarketsByAppointmentCreatedByAndMarketIdManyToManyEdgeAppointmentsListArgs = {
  condition?: Maybe<AppointmentCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy>>;
};

/** A connection to a list of `UserMarket` values. */
export type UserMarketsConnection = {
  /** A list of edges which contains the `UserMarket` and cursor to aid in pagination. */
  edges: Array<UserMarketsEdge>;
  /** A list of `UserMarket` objects. */
  nodes: Array<UserMarket>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserMarket` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserMarket` edge in the connection. */
export type UserMarketsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserMarket` at the end of the edge. */
  node: UserMarket;
};

/** Methods to use when ordering `UserMarket`. */
export enum UserMarketsOrderBy {
  Natural = 'NATURAL'
}

export type UserPatchRecordInput = {
  credentials?: Maybe<Array<Maybe<CredentialsEnum>>>;
  dob?: Maybe<Scalars['Date']>;
  markets?: Maybe<Array<Maybe<Scalars['Int']>>>;
  npi?: Maybe<Scalars['String']>;
  registeredFirstName?: Maybe<Scalars['String']>;
  registeredLastName?: Maybe<Scalars['String']>;
};

/** Contains information about the mapping between ReadyCore user table and patient table */
export type UserPatient = Node & {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId: Scalars['Int'];
  /** Reads a single `User` that is related to this `UserPatient`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UserPatient` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserPatientCondition = {
  /** Checks for equality with the object’s `userId` field. */
  userId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `Patient` values, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyConnection = {
  /** A list of edges which contains the `Patient`, info from the `PatientNote`, and the cursor to aid in pagination. */
  edges: Array<UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdge>;
  /** A list of `Patient` objects. */
  nodes: Array<Patient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Patient` edge in the connection, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Patient` at the end of the edge. */
  node: Patient;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotes: PatientNotesConnection;
  /** Reads and enables pagination through a set of `PatientNote`. */
  patientNotesList: Array<PatientNote>;
};


/** A `Patient` edge in the connection, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdgePatientNotesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};


/** A `Patient` edge in the connection, with data from `PatientNote`. */
export type UserPatientsByPatientNoteCreatedByAndPatientIdManyToManyEdgePatientNotesListArgs = {
  condition?: Maybe<PatientNoteCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<PatientNotesOrderBy>>;
};

/** A connection to a list of `UserPatient` values. */
export type UserPatientsConnection = {
  /** A list of edges which contains the `UserPatient` and cursor to aid in pagination. */
  edges: Array<UserPatientsEdge>;
  /** A list of `UserPatient` objects. */
  nodes: Array<UserPatient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserPatient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserPatient` edge in the connection. */
export type UserPatientsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserPatient` at the end of the edge. */
  node: UserPatient;
};

/** Methods to use when ordering `UserPatient`. */
export enum UserPatientsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** An input for mutations affecting `UserProfile` */
export type UserProfileInput = {
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['Datetime']>;
  lastName?: Maybe<Scalars['String']>;
  loginsCount?: Maybe<Scalars['Int']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
};

export enum UserRole {
  Clinician = 'CLINICIAN',
  It = 'IT',
  Responder = 'RESPONDER',
  Supervisor = 'SUPERVISOR',
  Unassigned = 'UNASSIGNED'
}

export enum UserRoleEnum {
  Clinician = 'CLINICIAN',
  Responder = 'RESPONDER',
  Supervisor = 'SUPERVISOR'
}

/** A connection to a list of `User` values. */
export type UsersConnection = {
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EmployeeIdAsc = 'EMPLOYEE_ID_ASC',
  EmployeeIdDesc = 'EMPLOYEE_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  UserUuidAsc = 'USER_UUID_ASC',
  UserUuidDesc = 'USER_UUID_DESC'
}

export type VRedoxPatientExport = {
  addendum?: Maybe<Scalars['String']>;
  appointmentId?: Maybe<Scalars['Int']>;
  cptCode1?: Maybe<Scalars['String']>;
  cptCode2?: Maybe<Scalars['String']>;
  cptCode3?: Maybe<Scalars['String']>;
  cptCode4?: Maybe<Scalars['String']>;
  cptCode5?: Maybe<Scalars['String']>;
  disposition?: Maybe<DispositionEnum>;
  doctorname?: Maybe<Scalars['String']>;
  doctornpinumber?: Maybe<Scalars['String']>;
  dosagefrequencydescription?: Maybe<Scalars['String']>;
  druginfo?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['Int']>;
  hpi?: Maybe<Scalars['String']>;
  icd10RegexMatches?: Maybe<Scalars['String']>;
  instructionFreetext?: Maybe<Scalars['String']>;
  mdm?: Maybe<Scalars['String']>;
  medhistorydosage?: Maybe<Scalars['String']>;
  medhistorydrug?: Maybe<Scalars['String']>;
  medhistoryfreq?: Maybe<Scalars['String']>;
  medhistoryndc?: Maybe<Scalars['String']>;
  medicalConditions?: Maybe<Scalars['String']>;
  ndcid?: Maybe<Scalars['String']>;
  patientfriendlysig?: Maybe<Scalars['String']>;
  prescriptiondate?: Maybe<Scalars['String']>;
  referraltext?: Maybe<Scalars['String']>;
  rosCardiovascularAnswer?: Maybe<Scalars['String']>;
  rosConstitutionalAnswer?: Maybe<Scalars['String']>;
  rosCovidAnswer?: Maybe<Scalars['String']>;
  rosEndocrineAnswer?: Maybe<Scalars['String']>;
  rosEntAnswer?: Maybe<Scalars['String']>;
  rosGastroAnswer?: Maybe<Scalars['String']>;
  rosGenitourinaryAnswer?: Maybe<Scalars['String']>;
  rosHemelymphAnswer?: Maybe<Scalars['String']>;
  rosMusculoskeletalAnswer?: Maybe<Scalars['String']>;
  rosNeurologicalAnswer?: Maybe<Scalars['String']>;
  rosObgynAnswer?: Maybe<Scalars['String']>;
  rosPsychAnswer?: Maybe<Scalars['String']>;
  rosRespiratoryAnswer?: Maybe<Scalars['String']>;
  rosSkinAnswer?: Maybe<Scalars['String']>;
  route?: Maybe<Scalars['String']>;
  socialHistoryAnswer?: Maybe<Scalars['String']>;
  socialHistoryQuestion?: Maybe<Scalars['String']>;
  visitDiagnosis?: Maybe<Scalars['String']>;
  visitDiagnosisDescription?: Maybe<Scalars['String']>;
};

/** A connection to a list of `VRedoxPatientExport` values. */
export type VRedoxPatientExportsConnection = {
  /** A list of edges which contains the `VRedoxPatientExport` and cursor to aid in pagination. */
  edges: Array<VRedoxPatientExportsEdge>;
  /** A list of `VRedoxPatientExport` objects. */
  nodes: Array<VRedoxPatientExport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VRedoxPatientExport` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VRedoxPatientExport` edge in the connection. */
export type VRedoxPatientExportsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VRedoxPatientExport` at the end of the edge. */
  node: VRedoxPatientExport;
};

/** Methods to use when ordering `VRedoxPatientExport`. */
export enum VRedoxPatientExportsOrderBy {
  Natural = 'NATURAL'
}

/** Contains information about administered vaccines. */
export type Vaccine = Node & {
  adverseReactions?: Maybe<Array<Maybe<VaccineAdverseReactionEnum>>>;
  contraindication?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Datetime'];
  doseNumber?: Maybe<Scalars['Int']>;
  encounterId: Scalars['Int'];
  /** Reads a single `EncounterTask` that is related to this `Vaccine`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  hadAdverseReaction?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  location?: Maybe<VaccineLocationEnum>;
  lotExpiration?: Maybe<Scalars['Date']>;
  lotNumber?: Maybe<Scalars['String']>;
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  orderedBy?: Maybe<Scalars['Int']>;
  otherAdverseReactions?: Maybe<Scalars['String']>;
  patientId: Scalars['Int'];
  standingOrder?: Maybe<StandingOrder>;
  standingOrderAddedAt?: Maybe<Scalars['Datetime']>;
  standingOrderId?: Maybe<Scalars['Int']>;
  systemLastUpdatedBy: SystemOfOriginEnum;
  totalDoses?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  vaccineId: Scalars['Int'];
  vaccineLookupId: Scalars['Int'];
  visEdition?: Maybe<Scalars['Date']>;
  visReceived?: Maybe<Scalars['Boolean']>;
};

export enum VaccineAdverseReactionEnum {
  AlteredLevelOfConsciousness = 'ALTERED_LEVEL_OF_CONSCIOUSNESS',
  FacialSwelling = 'FACIAL_SWELLING',
  Fever = 'FEVER',
  Irritability = 'IRRITABILITY',
  Other = 'OTHER',
  PainAtInjectionSite = 'PAIN_AT_INJECTION_SITE',
  Rash = 'RASH',
  RednessAtInjectionSite = 'REDNESS_AT_INJECTION_SITE',
  ShortnessOfBreath = 'SHORTNESS_OF_BREATH',
  SwellingAtInjectionSite = 'SWELLING_AT_INJECTION_SITE',
  Syncope = 'SYNCOPE'
}

export enum VaccineCategoryEnum {
  Covid = 'COVID',
  Flu = 'FLU'
}

/** A condition to be used against `Vaccine` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type VaccineCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `vaccineId` field. */
  vaccineId?: Maybe<Scalars['Int']>;
};

export enum VaccineLocationEnum {
  LeftAnterolateralThighMuscle = 'LEFT_ANTEROLATERAL_THIGH_MUSCLE',
  LeftDeltoidMuscle = 'LEFT_DELTOID_MUSCLE',
  RightAnterolateralThighMuscle = 'RIGHT_ANTEROLATERAL_THIGH_MUSCLE',
  RightDeltoidMuscle = 'RIGHT_DELTOID_MUSCLE'
}

/** Contains lookup information about vaccines and their related drug.. */
export type VaccineLookup = Node & {
  createdAt: Scalars['Datetime'];
  doseQuantity: Scalars['BigFloat'];
  doseUnits: Scalars['String'];
  drug?: Maybe<Drug>;
  drugId: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  standingOrders?: Maybe<Array<Maybe<StandingOrder>>>;
  vaccineCategory: VaccineCategoryEnum;
  vaccineCode: Scalars['String'];
  vaccineCodeSystem: Scalars['String'];
  vaccineLookupId: Scalars['Int'];
  vaccineName: Scalars['String'];
};

/**
 * A condition to be used against `VaccineLookup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VaccineLookupCondition = {
  /** Checks for equality with the object’s `vaccineCode` field. */
  vaccineCode?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `vaccineLookupId` field. */
  vaccineLookupId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `VaccineLookup` values. */
export type VaccineLookupsConnection = {
  /** A list of edges which contains the `VaccineLookup` and cursor to aid in pagination. */
  edges: Array<VaccineLookupsEdge>;
  /** A list of `VaccineLookup` objects. */
  nodes: Array<VaccineLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VaccineLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VaccineLookup` edge in the connection. */
export type VaccineLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VaccineLookup` at the end of the edge. */
  node: VaccineLookup;
};

/** Methods to use when ordering `VaccineLookup`. */
export enum VaccineLookupsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VaccineCodeAsc = 'VACCINE_CODE_ASC',
  VaccineCodeDesc = 'VACCINE_CODE_DESC',
  VaccineLookupIdAsc = 'VACCINE_LOOKUP_ID_ASC',
  VaccineLookupIdDesc = 'VACCINE_LOOKUP_ID_DESC'
}

/** A connection to a list of `Vaccine` values. */
export type VaccinesConnection = {
  /** A list of edges which contains the `Vaccine` and cursor to aid in pagination. */
  edges: Array<VaccinesEdge>;
  /** A list of `Vaccine` objects. */
  nodes: Array<Vaccine>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Vaccine` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Vaccine` edge in the connection. */
export type VaccinesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Vaccine` at the end of the edge. */
  node: Vaccine;
};

/** Methods to use when ordering `Vaccine`. */
export enum VaccinesOrderBy {
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VaccineIdAsc = 'VACCINE_ID_ASC',
  VaccineIdDesc = 'VACCINE_ID_DESC'
}

/** Contains data related to Video Conference */
export type VideoConference = Node & {
  createdAt: Scalars['Datetime'];
  deletedAt?: Maybe<Scalars['Datetime']>;
  hostUrl: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  meetingEndTime?: Maybe<Scalars['Datetime']>;
  meetingId: Scalars['BigInt'];
  meetingStartTime?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  participantUrl: Scalars['String'];
  /** calculates the video_conference status based off the set timestamp fields */
  status?: Maybe<VideoConferenceStatusEnum>;
  updatedAt: Scalars['Datetime'];
  videoConferenceId: Scalars['Int'];
};

/**
 * A condition to be used against `VideoConference` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VideoConferenceCondition = {
  /** Checks for equality with the object’s `meetingId` field. */
  meetingId?: Maybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `videoConferenceId` field. */
  videoConferenceId?: Maybe<Scalars['Int']>;
};

export enum VideoConferenceStatusEnum {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** A connection to a list of `VideoConference` values. */
export type VideoConferencesConnection = {
  /** A list of edges which contains the `VideoConference` and cursor to aid in pagination. */
  edges: Array<VideoConferencesEdge>;
  /** A list of `VideoConference` objects. */
  nodes: Array<VideoConference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VideoConference` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VideoConference` edge in the connection. */
export type VideoConferencesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VideoConference` at the end of the edge. */
  node: VideoConference;
};

/** Methods to use when ordering `VideoConference`. */
export enum VideoConferencesOrderBy {
  MeetingIdAsc = 'MEETING_ID_ASC',
  MeetingIdDesc = 'MEETING_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VideoConferenceIdAsc = 'VIDEO_CONFERENCE_ID_ASC',
  VideoConferenceIdDesc = 'VIDEO_CONFERENCE_ID_DESC'
}

/** Contains information about the ReadyCore vital table */
export type Vital = Node & {
  createdAt: Scalars['Datetime'];
  encounterId?: Maybe<Scalars['Int']>;
  /** Reads a single `EncounterTask` that is related to this `Vital`. */
  encounterTask?: Maybe<EncounterTask>;
  encounterTaskId: Scalars['Int'];
  migrationSource?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  patientId?: Maybe<Scalars['Int']>;
  result: Scalars['String'];
  systemLastUpdatedBy: SystemOfOriginEnum;
  updatedAt: Scalars['Datetime'];
  vitalId: Scalars['Int'];
  /** Reads a single `VitalLookup` that is related to this `Vital`. */
  vitalLookup?: Maybe<VitalLookup>;
  vitalLookupId: Scalars['Int'];
};

export enum VitalCategoryEnum {
  AdditionalSet = 'ADDITIONAL_SET',
  FirstSet = 'FIRST_SET'
}

/** A condition to be used against `Vital` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type VitalCondition = {
  /** Checks for equality with the object’s `encounterTaskId` field. */
  encounterTaskId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `migrationSource` field. */
  migrationSource?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `vitalId` field. */
  vitalId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `vitalLookupId` field. */
  vitalLookupId?: Maybe<Scalars['Int']>;
};

/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookup = Node & {
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByVitalVitalLookupIdAndEncounterTaskId: VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyConnection;
  /** Reads and enables pagination through a set of `EncounterTask`. */
  encounterTasksByVitalVitalLookupIdAndEncounterTaskIdList: Array<EncounterTask>;
  isDeleted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  system?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  vitalCategory: VitalCategoryEnum;
  vitalLookupId: Scalars['Int'];
  vitalType: VitalLookupTypeEnum;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdListArgs = {
  condition?: Maybe<EncounterTaskCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<EncounterTasksOrderBy>>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupVitalsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};


/** Contains information about the ReadyCore vital_lookup table */
export type VitalLookupVitalsListArgs = {
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};

/**
 * A condition to be used against `VitalLookup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type VitalLookupCondition = {
  /** Checks for equality with the object’s `vitalCategory` field. */
  vitalCategory?: Maybe<VitalCategoryEnum>;
  /** Checks for equality with the object’s `vitalLookupId` field. */
  vitalLookupId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `EncounterTask` values, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyConnection = {
  /** A list of edges which contains the `EncounterTask`, info from the `Vital`, and the cursor to aid in pagination. */
  edges: Array<VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdge>;
  /** A list of `EncounterTask` objects. */
  nodes: Array<EncounterTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EncounterTask` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `EncounterTask` edge in the connection, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EncounterTask` at the end of the edge. */
  node: EncounterTask;
  /** Reads and enables pagination through a set of `Vital`. */
  vitals: VitalsConnection;
  /** Reads and enables pagination through a set of `Vital`. */
  vitalsList: Array<Vital>;
};


/** A `EncounterTask` edge in the connection, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdgeVitalsArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};


/** A `EncounterTask` edge in the connection, with data from `Vital`. */
export type VitalLookupEncounterTasksByVitalVitalLookupIdAndEncounterTaskIdManyToManyEdgeVitalsListArgs = {
  condition?: Maybe<VitalCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<VitalsOrderBy>>;
};

export enum VitalLookupTypeEnum {
  BloodPressureLocation = 'BLOOD_PRESSURE_LOCATION',
  BodyHeight = 'BODY_HEIGHT',
  BodyHeightMeasured = 'BODY_HEIGHT_MEASURED',
  BodyHeightStated = 'BODY_HEIGHT_STATED',
  BodyPosition = 'BODY_POSITION',
  BodyTemperature = 'BODY_TEMPERATURE',
  BodyWeight = 'BODY_WEIGHT',
  BodyWeightMeasured = 'BODY_WEIGHT_MEASURED',
  BodyWeightStated = 'BODY_WEIGHT_STATED',
  DiastolicBloodPressure = 'DIASTOLIC_BLOOD_PRESSURE',
  HeartRate = 'HEART_RATE',
  LungSounds = 'LUNG_SOUNDS',
  MeasuredAt = 'MEASURED_AT',
  Note = 'NOTE',
  OxygenSaturation = 'OXYGEN_SATURATION',
  RespiratoryRate = 'RESPIRATORY_RATE',
  SystolicBloodPressure = 'SYSTOLIC_BLOOD_PRESSURE'
}

/** A connection to a list of `VitalLookup` values. */
export type VitalLookupsConnection = {
  /** A list of edges which contains the `VitalLookup` and cursor to aid in pagination. */
  edges: Array<VitalLookupsEdge>;
  /** A list of `VitalLookup` objects. */
  nodes: Array<VitalLookup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VitalLookup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VitalLookup` edge in the connection. */
export type VitalLookupsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `VitalLookup` at the end of the edge. */
  node: VitalLookup;
};

/** Methods to use when ordering `VitalLookup`. */
export enum VitalLookupsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VitalCategoryAsc = 'VITAL_CATEGORY_ASC',
  VitalCategoryDesc = 'VITAL_CATEGORY_DESC',
  VitalLookupIdAsc = 'VITAL_LOOKUP_ID_ASC',
  VitalLookupIdDesc = 'VITAL_LOOKUP_ID_DESC'
}

/** A connection to a list of `Vital` values. */
export type VitalsConnection = {
  /** A list of edges which contains the `Vital` and cursor to aid in pagination. */
  edges: Array<VitalsEdge>;
  /** A list of `Vital` objects. */
  nodes: Array<Vital>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Vital` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Vital` edge in the connection. */
export type VitalsEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Vital` at the end of the edge. */
  node: Vital;
};

/** Methods to use when ordering `Vital`. */
export enum VitalsOrderBy {
  EncounterTaskIdAsc = 'ENCOUNTER_TASK_ID_ASC',
  EncounterTaskIdDesc = 'ENCOUNTER_TASK_ID_DESC',
  MigrationSourceAsc = 'MIGRATION_SOURCE_ASC',
  MigrationSourceDesc = 'MIGRATION_SOURCE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  VitalIdAsc = 'VITAL_ID_ASC',
  VitalIdDesc = 'VITAL_ID_DESC',
  VitalLookupIdAsc = 'VITAL_LOOKUP_ID_ASC',
  VitalLookupIdDesc = 'VITAL_LOOKUP_ID_DESC'
}

/** Contains information about the ReadyCore zipcode table */
export type Zipcode = Node & {
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  scheduledFreezeById?: Maybe<Scalars['Int']>;
  scheduledFreezeByUser?: Maybe<User>;
  scheduledFreezeEndTime?: Maybe<Scalars['Datetime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['Datetime']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  zipCode: Scalars['String'];
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodesByZipCode: ZoneZipcodesConnection;
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodesByZipCodeList: Array<ZoneZipcode>;
  /** Reads and enables pagination through a set of `Zone`. */
  zones: ZipcodeZonesManyToManyConnection;
  /** Reads and enables pagination through a set of `Zone`. */
  zonesByZoneZipcodeZipCodeAndZoneIdList: Array<Zone>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodeZoneZipcodesByZipCodeArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZoneZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZoneZipcodesOrderBy>>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodeZoneZipcodesByZipCodeListArgs = {
  condition?: Maybe<ZoneZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZoneZipcodesOrderBy>>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodeZonesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZoneCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZonesOrderBy>>;
};


/** Contains information about the ReadyCore zipcode table */
export type ZipcodeZonesByZoneZipcodeZipCodeAndZoneIdListArgs = {
  condition?: Maybe<ZoneCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZonesOrderBy>>;
};

/** A condition to be used against `Zipcode` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ZipcodeCondition = {
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: Maybe<Scalars['String']>;
};

/** A connection to a list of `Zone` values, with data from `ZoneZipcode`. */
export type ZipcodeZonesManyToManyConnection = {
  /** A list of edges which contains the `Zone`, info from the `ZoneZipcode`, and the cursor to aid in pagination. */
  edges: Array<ZipcodeZonesManyToManyEdge>;
  /** A list of `Zone` objects. */
  nodes: Array<Zone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zone` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zone` edge in the connection, with data from `ZoneZipcode`. */
export type ZipcodeZonesManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zone` at the end of the edge. */
  node: Zone;
};

/** A connection to a list of `Zipcode` values. */
export type ZipcodesConnection = {
  /** A list of edges which contains the `Zipcode` and cursor to aid in pagination. */
  edges: Array<ZipcodesEdge>;
  /** A list of `Zipcode` objects. */
  nodes: Array<Zipcode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zipcode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zipcode` edge in the connection. */
export type ZipcodesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zipcode` at the end of the edge. */
  node: Zipcode;
};

/** Methods to use when ordering `Zipcode`. */
export enum ZipcodesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

/** Contains a list of zip codes */
export type Zone = Node & {
  appointmentDurationAdjustment?: Maybe<Interval>;
  createdAt: Scalars['Datetime'];
  frozenById?: Maybe<Scalars['Int']>;
  frozenByUser?: Maybe<User>;
  frozenReason?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isFrozen: Scalars['Boolean'];
  launchTimestamp?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Market` that is related to this `Zone`. */
  market?: Maybe<Market>;
  marketId: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  scheduledFreezeById?: Maybe<Scalars['Int']>;
  scheduledFreezeByUser?: Maybe<User>;
  scheduledFreezeEndTime?: Maybe<Scalars['Datetime']>;
  scheduledFreezeReason?: Maybe<Scalars['String']>;
  scheduledFreezeStartTime?: Maybe<Scalars['Datetime']>;
  skeduloRegionAreaId?: Maybe<Scalars['String']>;
  skeduloRegionId?: Maybe<Scalars['String']>;
  stringifiedZoneZipcodeList?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  /** Reads and enables pagination through a set of `Zipcode`. */
  zipcodes: ZoneZipcodesManyToManyConnection;
  /** Reads and enables pagination through a set of `Zipcode`. */
  zipcodesByZoneZipcodeZoneIdAndZipCodeList: Array<Zipcode>;
  zoneId: Scalars['Int'];
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodes: ZoneZipcodesConnection;
  /** Reads and enables pagination through a set of `ZoneZipcode`. */
  zoneZipcodesList: Array<ZoneZipcode>;
};


/** Contains a list of zip codes */
export type ZoneZipcodesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZipcodesOrderBy>>;
};


/** Contains a list of zip codes */
export type ZoneZipcodesByZoneZipcodeZoneIdAndZipCodeListArgs = {
  condition?: Maybe<ZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZipcodesOrderBy>>;
};


/** Contains a list of zip codes */
export type ZoneZoneZipcodesArgs = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  condition?: Maybe<ZoneZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZoneZipcodesOrderBy>>;
};


/** Contains a list of zip codes */
export type ZoneZoneZipcodesListArgs = {
  condition?: Maybe<ZoneZipcodeCondition>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<ZoneZipcodesOrderBy>>;
};

/** A condition to be used against `Zone` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ZoneCondition = {
  /** Checks for equality with the object’s `marketId` field. */
  marketId?: Maybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: Maybe<Scalars['String']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: Maybe<Scalars['Int']>;
};

/** Contains information about the mapping between the ReadyCore zone table and zipcode table */
export type ZoneZipcode = Node & {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  zipCode: Scalars['UsPostalCode'];
  /** Reads a single `Zipcode` that is related to this `ZoneZipcode`. */
  zipcodeByZipCode?: Maybe<Zipcode>;
  /** Reads a single `Zone` that is related to this `ZoneZipcode`. */
  zone?: Maybe<Zone>;
  zoneId: Scalars['Int'];
};

/**
 * A condition to be used against `ZoneZipcode` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ZoneZipcodeCondition = {
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: Maybe<Scalars['UsPostalCode']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: Maybe<Scalars['Int']>;
};

/** A connection to a list of `ZoneZipcode` values. */
export type ZoneZipcodesConnection = {
  /** A list of edges which contains the `ZoneZipcode` and cursor to aid in pagination. */
  edges: Array<ZoneZipcodesEdge>;
  /** A list of `ZoneZipcode` objects. */
  nodes: Array<ZoneZipcode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneZipcode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ZoneZipcode` edge in the connection. */
export type ZoneZipcodesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ZoneZipcode` at the end of the edge. */
  node: ZoneZipcode;
};

/** A connection to a list of `Zipcode` values, with data from `ZoneZipcode`. */
export type ZoneZipcodesManyToManyConnection = {
  /** A list of edges which contains the `Zipcode`, info from the `ZoneZipcode`, and the cursor to aid in pagination. */
  edges: Array<ZoneZipcodesManyToManyEdge>;
  /** A list of `Zipcode` objects. */
  nodes: Array<Zipcode>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zipcode` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zipcode` edge in the connection, with data from `ZoneZipcode`. */
export type ZoneZipcodesManyToManyEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zipcode` at the end of the edge. */
  node: Zipcode;
};

/** Methods to use when ordering `ZoneZipcode`. */
export enum ZoneZipcodesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

/** A connection to a list of `Zone` values. */
export type ZonesConnection = {
  /** A list of edges which contains the `Zone` and cursor to aid in pagination. */
  edges: Array<ZonesEdge>;
  /** A list of `Zone` objects. */
  nodes: Array<Zone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zone` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Zone` edge in the connection. */
export type ZonesEdge = {
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Zone` at the end of the edge. */
  node: Zone;
};

/** Methods to use when ordering `Zone`. */
export enum ZonesOrderBy {
  MarketIdAsc = 'MARKET_ID_ASC',
  MarketIdDesc = 'MARKET_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ZoneIdAsc = 'ZONE_ID_ASC',
  ZoneIdDesc = 'ZONE_ID_DESC'
}

export type AddressFieldsFragment = { address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, unit?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number> };

export type AppointmentFragment = { appointmentId: number, skeduloJobId?: Maybe<any>, createdAt: any, createdBy?: Maybe<number>, scheduledFor: any, status?: Maybe<AppointmentStatusEnum>, systemOfOrigin: SystemOfOriginEnum, zoneId: number, marketId: number, cancelledReason?: Maybe<CancellationReasonEnum>, cancelledReasonOther?: Maybe<string>, rescheduledReason?: Maybe<RescheduleReasonEnum>, contactName?: Maybe<string>, primaryPhone?: Maybe<string>, specialInstructions?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, marketOverride?: Maybe<boolean>, availabilityOverride?: Maybe<boolean>, rescheduledFrom: Array<Maybe<number>>, rescheduledAt?: Maybe<any>, cancelledBy?: Maybe<{ name?: Maybe<string> }> };

export type AppointmentDispatchesFragment = { appointmentDispatches: { nodes: Array<{ appointmentDispatchId: number, appointmentId: number, skeduloJobAllocationId?: Maybe<any>, responderId: number, status?: Maybe<AppointmentDispatchStatusEnum>, dispatchedAt?: Maybe<any>, enRouteAt?: Maybe<any>, onSceneAt?: Maybe<any>, atPatientAt?: Maybe<any>, completedAt?: Maybe<any>, createdAt: any, updatedAt?: Maybe<any>, cancelledAt?: Maybe<any>, removedAt?: Maybe<any>, responder?: Maybe<{ userId: number, user?: Maybe<{ userId: number, employeeId?: Maybe<string>, lastName?: Maybe<string>, firstName?: Maybe<string>, fullName?: Maybe<string>, profilePictureUrl?: Maybe<string> }> }> }> } };

export type AppointmentPreviewEncountersFragment = { encounterId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, serviceLine?: Maybe<{ name: string, serviceLineId: number, subType: string, segment?: Maybe<string> }>, patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, age?: Maybe<number>, patientNotesList: Array<{ patientNoteId: number, patientId: number, note: string, label?: Maybe<PatientNoteLabel>, createdAt: any, isHighPriority?: Maybe<boolean>, isDeleted?: Maybe<boolean>, author?: Maybe<string>, friendlyLabel?: Maybe<string>, userByCreatedBy?: Maybe<{ nodeId: string, userId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, fullName?: Maybe<string>, friendlyRoles?: Maybe<string> }> }> }> };

export type ChannelAttributionFragment = { channel: string, channelAttributionId: number, createdAt: any, globalId: any, institutionType: ChannelAttributionInstitutionTypeEnum, referralType?: Maybe<ChannelAttributionReferralTypeEnum>, markets?: Maybe<Array<Maybe<{ name: string, marketId: number }>>> };

export type EncounterFieldsFragment = { encounterId: number, genderRequirement?: Maybe<SexEnum>, patientId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, modules?: Maybe<Array<Maybe<ModuleNameEnum>>>, channelAttributionId: number, cancellationReason?: Maybe<CancellationReasonEnum>, cancellationReasonOther?: Maybe<string>, cancelledAt?: Maybe<any>, modulesFriendly: string, serviceLine?: Maybe<{ name: string, friendlyName: string, serviceLineId: number, subType: string, segment?: Maybe<string> }> };

export type InsuranceRecordFragment = { patientId: number, company?: Maybe<string>, packageId?: Maybe<string>, memberId?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, groupNumber?: Maybe<string>, insuranceRecordId: number, policyHolderFirstName?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, isDeleted?: Maybe<boolean> };

export type MarketFragment = { marketId: number, name: string, isDeleted?: Maybe<boolean>, isFrozen: boolean, isActive: boolean, timezone?: Maybe<string>, startTimes: Array<Maybe<any>>, endTimes: Array<Maybe<any>> };

export type MarketNameFragment = { market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }> };

export type PatientFragment = { firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, unit?: Maybe<string>, specialInstructions?: Maybe<string> };

export type PatientNameFragment = { encounters: { nodes: Array<{ patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, patientId: number }> }> } };

export type PatientNoteFragment = { patientNoteId: number, patientId: number, note: string, label?: Maybe<PatientNoteLabel>, createdAt: any, isHighPriority?: Maybe<boolean>, isDeleted?: Maybe<boolean>, author?: Maybe<string>, friendlyLabel?: Maybe<string>, userByCreatedBy?: Maybe<{ nodeId: string, userId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, fullName?: Maybe<string>, friendlyRoles?: Maybe<string> }> };

export type ResponderNameFragment = { firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number };

export type ServiceLineFieldsFragment = { name: string, friendlyName: string, serviceLineId: number, subType: string, segment?: Maybe<string> };

export type UserFieldsFragment = { email?: Maybe<string>, employeeId?: Maybe<string>, firstName?: Maybe<string>, isClinician?: Maybe<boolean>, isDeleted?: Maybe<boolean>, isIt?: Maybe<boolean>, isResponder?: Maybe<boolean>, isOps?: Maybe<boolean>, lastLoginAt?: Maybe<any>, lastName?: Maybe<string>, userId: number, profilePictureUrl?: Maybe<string>, opsRole?: Maybe<{ opsAdmin: boolean }> };

export type PatientsByEncounterAppointmentIdAndPatientIdListFragment = { patientsByEncounterAppointmentIdAndPatientIdList: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, unit?: Maybe<string>, specialInstructions?: Maybe<string>, patientNotesList: Array<{ patientNoteId: number, note: string, nodeId: string, isHighPriority?: Maybe<boolean>, createdBy?: Maybe<number>, createdAt: any, userByCreatedBy?: Maybe<{ nodeId: string, firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number }> }> }> };

export type AddEncounterMutationVariables = Exact<{
  appointmentId: Scalars['Int'];
  patientId: Scalars['Int'];
  reasonForEncounter: Scalars['NonNullableText'];
  serviceLineId: Scalars['Int'];
  modules?: Maybe<Array<Maybe<ModuleNameEnum>> | Maybe<ModuleNameEnum>>;
  genderRequirement?: Maybe<SexEnum>;
  systemLastUpdatedBy?: Maybe<SystemOfOriginEnum>;
  channelAttributionId: Scalars['Int'];
}>;


export type AddEncounterMutation = { addEncounter?: Maybe<{ encounter?: Maybe<{ encounterId: number, appointmentId: number, patientId: number, createdAt: any, serviceLineId?: Maybe<number>, channelAttributionId: number, reasonForEncounter?: Maybe<string>, genderRequirement?: Maybe<SexEnum>, modules?: Maybe<Array<Maybe<ModuleNameEnum>>> }> }> };

export type CancelAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['Int'];
  cancellationReason: CancellationReasonEnum;
  cancellationReasonOther?: Maybe<Scalars['String']>;
}>;


export type CancelAppointmentMutation = { cancelAppointment?: Maybe<{ appointment?: Maybe<{ appointmentId: number, cancelledAt?: Maybe<any>, cancelledReason?: Maybe<CancellationReasonEnum>, cancelledReasonOther?: Maybe<string>, status?: Maybe<AppointmentStatusEnum> }> }> };

export type CancelEncountersMutationVariables = Exact<{
  encounterIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  cancellationReason: CancellationReasonEnum;
  cancellationReasonOther?: Maybe<Scalars['String']>;
}>;


export type CancelEncountersMutation = { cancelEncounters?: Maybe<Array<Maybe<{ encounterId: number }>>> };

export type CreateInsuranceRecordMutationVariables = Exact<{
  input: CreateInsuranceRecordInput;
}>;


export type CreateInsuranceRecordMutation = { createInsuranceRecord?: Maybe<{ insuranceRecord?: Maybe<{ insuranceRecordId: number, patientId: number, company?: Maybe<string>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, memberId?: Maybe<string>, groupNumber?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderFirstName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, packageId?: Maybe<string>, systemLastUpdatedBy: SystemOfOriginEnum }> }> };

export type CreatePatientNoteMutationVariables = Exact<{
  patientNote: PatientNoteInputRecordInput;
}>;


export type CreatePatientNoteMutation = { createPatientNote?: Maybe<{ patientNote?: Maybe<{ patientNoteId: number, patientId: number, note: string, label?: Maybe<PatientNoteLabel>, createdAt: any, isHighPriority?: Maybe<boolean>, isDeleted?: Maybe<boolean>, author?: Maybe<string>, friendlyLabel?: Maybe<string>, userByCreatedBy?: Maybe<{ nodeId: string, userId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, fullName?: Maybe<string>, friendlyRoles?: Maybe<string> }> }> }> };

export type CreateSkeduloAppointmentMutationVariables = Exact<{
  appointment?: Maybe<CreateSkeduloAppointmentInput>;
  patients?: Maybe<Array<Maybe<CreateSkeduloPatientInput>> | Maybe<CreateSkeduloPatientInput>>;
}>;


export type CreateSkeduloAppointmentMutation = { createSkeduloAppointment?: Maybe<{ error?: Maybe<string>, appointmentId?: Maybe<number> }> };

export type CreatePatientMutationVariables = Exact<{
  patient: PatientInputRecordInput;
}>;


export type CreatePatientMutation = { createPatient?: Maybe<{ clientMutationId?: Maybe<string>, code?: Maybe<ReadyCoreStatusCodeEnum>, patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, sex?: Maybe<SexEnum>, dob?: Maybe<any>, patientId: number, address1?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string> }> }> };

export type RescheduleSkeduloAppointmentMutationVariables = Exact<{
  appointment: CreateSkeduloAppointmentInput;
  appointmentId: Scalars['Int'];
  rescheduleReason: RescheduleReasonEnum;
  patients: Array<CreateSkeduloPatientInput> | CreateSkeduloPatientInput;
}>;


export type RescheduleSkeduloAppointmentMutation = { rescheduleSkeduloAppointment?: Maybe<{ error?: Maybe<string>, appointmentId?: Maybe<number> }> };

export type UpdateAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['Int'];
  appointmentPatch: AppointmentPatch;
}>;


export type UpdateAppointmentMutation = { updateAppointment?: Maybe<{ clientMutationId?: Maybe<string>, appointment?: Maybe<{ appointmentId: number, skeduloJobId?: Maybe<any>, createdAt: any, createdBy?: Maybe<number>, scheduledFor: any, status?: Maybe<AppointmentStatusEnum>, systemOfOrigin: SystemOfOriginEnum, zoneId: number, marketId: number, cancelledReason?: Maybe<CancellationReasonEnum>, cancelledReasonOther?: Maybe<string>, rescheduledReason?: Maybe<RescheduleReasonEnum>, contactName?: Maybe<string>, primaryPhone?: Maybe<string>, specialInstructions?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, marketOverride?: Maybe<boolean>, availabilityOverride?: Maybe<boolean>, rescheduledFrom: Array<Maybe<number>>, rescheduledAt?: Maybe<any>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, unit?: Maybe<string>, zip?: Maybe<string>, encountersList: Array<{ encounterId: number, genderRequirement?: Maybe<SexEnum>, patientId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, modules?: Maybe<Array<Maybe<ModuleNameEnum>>>, channelAttributionId: number, cancellationReason?: Maybe<CancellationReasonEnum>, cancellationReasonOther?: Maybe<string>, cancelledAt?: Maybe<any>, modulesFriendly: string, serviceLine?: Maybe<{ name: string, friendlyName: string, serviceLineId: number, subType: string, segment?: Maybe<string> }> }>, cancelledBy?: Maybe<{ name?: Maybe<string> }>, appointmentDispatches: { nodes: Array<{ appointmentDispatchId: number, appointmentId: number, skeduloJobAllocationId?: Maybe<any>, responderId: number, status?: Maybe<AppointmentDispatchStatusEnum>, dispatchedAt?: Maybe<any>, enRouteAt?: Maybe<any>, onSceneAt?: Maybe<any>, atPatientAt?: Maybe<any>, completedAt?: Maybe<any>, createdAt: any, updatedAt?: Maybe<any>, cancelledAt?: Maybe<any>, removedAt?: Maybe<any>, responder?: Maybe<{ userId: number, user?: Maybe<{ userId: number, employeeId?: Maybe<string>, lastName?: Maybe<string>, firstName?: Maybe<string>, fullName?: Maybe<string>, profilePictureUrl?: Maybe<string> }> }> }> }, market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }>, patientsByEncounterAppointmentIdAndPatientIdList: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, unit?: Maybe<string>, specialInstructions?: Maybe<string>, patientNotesList: Array<{ patientNoteId: number, note: string, nodeId: string, isHighPriority?: Maybe<boolean>, createdBy?: Maybe<number>, createdAt: any, userByCreatedBy?: Maybe<{ nodeId: string, firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number }> }> }> }> }> };

export type UpdateChannelAttributionMutationVariables = Exact<{
  input: UpdateChannelAttributionInput;
}>;


export type UpdateChannelAttributionMutation = { updateChannelAttribution?: Maybe<{ channelAttribution?: Maybe<{ channelAttributionId: number }> }> };

export type UpdateEncounterMutationVariables = Exact<{
  encounterId: Scalars['Int'];
  encounter: EncounterPatch;
}>;


export type UpdateEncounterMutation = { updateEncounter?: Maybe<{ clientMutationId?: Maybe<string>, encounter?: Maybe<{ encounterId: number, genderRequirement?: Maybe<SexEnum>, patientId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, modules?: Maybe<Array<Maybe<ModuleNameEnum>>>, channelAttributionId: number, cancellationReason?: Maybe<CancellationReasonEnum>, cancellationReasonOther?: Maybe<string>, cancelledAt?: Maybe<any>, modulesFriendly: string, serviceLine?: Maybe<{ name: string, friendlyName: string, serviceLineId: number, subType: string, segment?: Maybe<string> }> }> }> };

export type UpdatePatientMutationVariables = Exact<{
  patientId: Scalars['Int'];
  patientPatch: PatientPatchRecordInput;
}>;


export type UpdatePatientMutation = { updatePatient?: Maybe<{ clientMutationId?: Maybe<string>, patient?: Maybe<{ specialInstructions?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, age?: Maybe<number>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, unit?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number> }> }> };

export type UpdatePatientNoteMutationVariables = Exact<{
  patientNoteId: Scalars['Int'];
  patientNotePatch: PatientNotePatchRecordInput;
}>;


export type UpdatePatientNoteMutation = { updatePatientNote?: Maybe<{ patientNote?: Maybe<{ patientNoteId: number, patientId: number, note: string, label?: Maybe<PatientNoteLabel>, createdAt: any, isHighPriority?: Maybe<boolean>, isDeleted?: Maybe<boolean>, author?: Maybe<string>, friendlyLabel?: Maybe<string>, userByCreatedBy?: Maybe<{ nodeId: string, userId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, fullName?: Maybe<string>, friendlyRoles?: Maybe<string> }> }> }> };

export type UpsertMarketsMutationVariables = Exact<{
  endTimes?: Maybe<Array<Maybe<Scalars['Time']>> | Maybe<Scalars['Time']>>;
  isFrozen?: Maybe<Scalars['Boolean']>;
  marketId: Scalars['Int'];
  startTimes?: Maybe<Array<Maybe<Scalars['Time']>> | Maybe<Scalars['Time']>>;
  timezone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}>;


export type UpsertMarketsMutation = { upsertMarkets?: Maybe<{ query?: Maybe<{ market?: Maybe<{ marketId: number, name: string, isDeleted?: Maybe<boolean>, isFrozen: boolean, isActive: boolean, timezone?: Maybe<string>, startTimes: Array<Maybe<any>>, endTimes: Array<Maybe<any>> }> }> }> };

export type UpsertZoneMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  zoneId: Scalars['Int'];
  marketId: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isFrozen: Scalars['Boolean'];
}>;


export type UpsertZoneMutation = { upsertZones?: Maybe<{ query?: Maybe<{ zone?: Maybe<{ zoneId: number, name: string, marketId: number }> }> }> };

export type UpsertZoneZipcodesMutationVariables = Exact<{
  zoneId: Scalars['Int'];
  zipCodes: Array<Maybe<Scalars['ZipCode']>> | Maybe<Scalars['ZipCode']>;
}>;


export type UpsertZoneZipcodesMutation = { upsertZoneZipcodes?: Maybe<{ code?: Maybe<string>, zoneZipcodes?: Maybe<Array<Maybe<{ nodeId: string, zipCode: any, zone?: Maybe<{ zoneId: number, zoneZipcodesList: Array<{ zipCode: any }> }> }>>> }> };

export type GetAppointmentQueryVariables = Exact<{
  appointmentId: Scalars['Int'];
}>;


export type GetAppointmentQuery = { appointment?: Maybe<{ appointmentId: number, skeduloJobId?: Maybe<any>, createdAt: any, createdBy?: Maybe<number>, scheduledFor: any, status?: Maybe<AppointmentStatusEnum>, systemOfOrigin: SystemOfOriginEnum, zoneId: number, marketId: number, cancelledReason?: Maybe<CancellationReasonEnum>, cancelledReasonOther?: Maybe<string>, rescheduledReason?: Maybe<RescheduleReasonEnum>, contactName?: Maybe<string>, primaryPhone?: Maybe<string>, specialInstructions?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, marketOverride?: Maybe<boolean>, availabilityOverride?: Maybe<boolean>, rescheduledFrom: Array<Maybe<number>>, rescheduledAt?: Maybe<any>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, unit?: Maybe<string>, zip?: Maybe<string>, rescheduledTo?: Maybe<{ appointmentId: number }>, userByCreatedBy?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number }>, encountersList: Array<{ channelAttributionId: number, encounterId: number, genderRequirement?: Maybe<SexEnum>, patientId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, modules?: Maybe<Array<Maybe<ModuleNameEnum>>>, cancellationReason?: Maybe<CancellationReasonEnum>, cancellationReasonOther?: Maybe<string>, cancelledAt?: Maybe<any>, modulesFriendly: string, serviceLine?: Maybe<{ name: string, friendlyName: string, serviceLineId: number, subType: string, segment?: Maybe<string> }> }>, cancelledBy?: Maybe<{ name?: Maybe<string> }>, appointmentDispatches: { nodes: Array<{ appointmentDispatchId: number, appointmentId: number, skeduloJobAllocationId?: Maybe<any>, responderId: number, status?: Maybe<AppointmentDispatchStatusEnum>, dispatchedAt?: Maybe<any>, enRouteAt?: Maybe<any>, onSceneAt?: Maybe<any>, atPatientAt?: Maybe<any>, completedAt?: Maybe<any>, createdAt: any, updatedAt?: Maybe<any>, cancelledAt?: Maybe<any>, removedAt?: Maybe<any>, responder?: Maybe<{ userId: number, user?: Maybe<{ userId: number, employeeId?: Maybe<string>, lastName?: Maybe<string>, firstName?: Maybe<string>, fullName?: Maybe<string>, profilePictureUrl?: Maybe<string> }> }> }> }, market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }>, patientsByEncounterAppointmentIdAndPatientIdList: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, unit?: Maybe<string>, specialInstructions?: Maybe<string>, patientNotesList: Array<{ patientNoteId: number, note: string, nodeId: string, isHighPriority?: Maybe<boolean>, createdBy?: Maybe<number>, createdAt: any, userByCreatedBy?: Maybe<{ nodeId: string, firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number }> }> }> }> };

export type GetAppointmentAvailabilitiesQueryVariables = Exact<{
  appointment: AppointmentAddress;
  end: Scalars['String'];
  patients: Array<Maybe<PatientEncounterRequest>> | Maybe<PatientEncounterRequest>;
  start: Scalars['String'];
}>;


export type GetAppointmentAvailabilitiesQuery = { getAppointmentAvailabilities: { jobDuration?: Maybe<number>, jobType: string, requiredResponders?: Maybe<number>, appointmentSlots: Array<Maybe<{ end: string, respondersAvailable: number, start: string }>>, jobTags?: Maybe<Array<Maybe<{ id: any }>>> } };

export type GetAppointmentPreviewQueryVariables = Exact<{
  appointmentId: Scalars['Int'];
}>;


export type GetAppointmentPreviewQuery = { appointment?: Maybe<{ appointmentId: number, skeduloJobId?: Maybe<any>, createdAt: any, createdBy?: Maybe<number>, scheduledFor: any, status?: Maybe<AppointmentStatusEnum>, systemOfOrigin: SystemOfOriginEnum, zoneId: number, marketId: number, cancelledReason?: Maybe<CancellationReasonEnum>, cancelledReasonOther?: Maybe<string>, rescheduledReason?: Maybe<RescheduleReasonEnum>, contactName?: Maybe<string>, primaryPhone?: Maybe<string>, specialInstructions?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, marketOverride?: Maybe<boolean>, availabilityOverride?: Maybe<boolean>, rescheduledFrom: Array<Maybe<number>>, rescheduledAt?: Maybe<any>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, unit?: Maybe<string>, zip?: Maybe<string>, rescheduledTo?: Maybe<{ appointmentId: number }>, userByCreatedBy?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number }>, encountersList: Array<{ encounterId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, serviceLine?: Maybe<{ name: string, serviceLineId: number, subType: string, segment?: Maybe<string> }>, patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, age?: Maybe<number>, patientNotesList: Array<{ patientNoteId: number, patientId: number, note: string, label?: Maybe<PatientNoteLabel>, createdAt: any, isHighPriority?: Maybe<boolean>, isDeleted?: Maybe<boolean>, author?: Maybe<string>, friendlyLabel?: Maybe<string>, userByCreatedBy?: Maybe<{ nodeId: string, userId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, fullName?: Maybe<string>, friendlyRoles?: Maybe<string> }> }> }> }>, cancelledBy?: Maybe<{ name?: Maybe<string> }>, appointmentDispatches: { nodes: Array<{ appointmentDispatchId: number, appointmentId: number, skeduloJobAllocationId?: Maybe<any>, responderId: number, status?: Maybe<AppointmentDispatchStatusEnum>, dispatchedAt?: Maybe<any>, enRouteAt?: Maybe<any>, onSceneAt?: Maybe<any>, atPatientAt?: Maybe<any>, completedAt?: Maybe<any>, createdAt: any, updatedAt?: Maybe<any>, cancelledAt?: Maybe<any>, removedAt?: Maybe<any>, responder?: Maybe<{ userId: number, user?: Maybe<{ userId: number, employeeId?: Maybe<string>, lastName?: Maybe<string>, firstName?: Maybe<string>, fullName?: Maybe<string>, profilePictureUrl?: Maybe<string> }> }> }> }, market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }> }> };

export type GetAppointmentsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  marketId?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Array<AppointmentsOrderBy> | AppointmentsOrderBy>;
}>;


export type GetAppointmentsQuery = { appointmentsList?: Maybe<Array<{ appointmentId: number, scheduledFor: any, status?: Maybe<AppointmentStatusEnum>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, encounters: { nodes: Array<{ encounterId: number, patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, patientId: number, patientNotes: { totalCount: number } }> }> }, appointmentDispatches: { nodes: Array<{ appointmentDispatchId: number, appointmentId: number, skeduloJobAllocationId?: Maybe<any>, responderId: number, status?: Maybe<AppointmentDispatchStatusEnum>, dispatchedAt?: Maybe<any>, enRouteAt?: Maybe<any>, onSceneAt?: Maybe<any>, atPatientAt?: Maybe<any>, completedAt?: Maybe<any>, createdAt: any, updatedAt?: Maybe<any>, cancelledAt?: Maybe<any>, removedAt?: Maybe<any>, responder?: Maybe<{ userId: number, user?: Maybe<{ userId: number, employeeId?: Maybe<string>, lastName?: Maybe<string>, firstName?: Maybe<string>, fullName?: Maybe<string>, profilePictureUrl?: Maybe<string> }> }> }> }, market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }> }>> };

export type GetChannelAttributionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChannelAttributionsQuery = { channelAttributionsList?: Maybe<Array<{ channelAttributionId: number, channel: string }>> };

export type GetChannelAttributionsByMarketQueryVariables = Exact<{
  marketId?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  tagSystem?: Maybe<ChannelAttributionTagSystemConditionEnum>;
}>;


export type GetChannelAttributionsByMarketQuery = { channelAttributionsList?: Maybe<Array<{ channelAttributionId: number, channel: string }>> };

export type GetChannelAttributionsWithMarketsQueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  marketId?: Maybe<Array<Maybe<Scalars['Int']>> | Maybe<Scalars['Int']>>;
}>;


export type GetChannelAttributionsWithMarketsQuery = { channelAttributions?: Maybe<{ totalCount: number, nodes: Array<{ channel: string, channelAttributionId: number, createdAt: any, globalId: any, institutionType: ChannelAttributionInstitutionTypeEnum, referralType?: Maybe<ChannelAttributionReferralTypeEnum>, markets?: Maybe<Array<Maybe<{ name: string, marketId: number }>>> }> }> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { getCurrentUser?: Maybe<{ email?: Maybe<string>, employeeId?: Maybe<string>, firstName?: Maybe<string>, isClinician?: Maybe<boolean>, isDeleted?: Maybe<boolean>, isIt?: Maybe<boolean>, isResponder?: Maybe<boolean>, isOps?: Maybe<boolean>, lastLoginAt?: Maybe<any>, lastName?: Maybe<string>, userId: number, profilePictureUrl?: Maybe<string>, opsRole?: Maybe<{ opsAdmin: boolean }> }> };

export type GetEncounterInsuranceRecordsQueryVariables = Exact<{
  appointmentId: Scalars['Int'];
  patientId: Scalars['Int'];
}>;


export type GetEncounterInsuranceRecordsQuery = { appointment?: Maybe<{ appointmentId: number, insuranceRecordsByEncounterAppointmentIdAndPrimaryInsurance: { nodes: Array<{ patientId: number, company?: Maybe<string>, packageId?: Maybe<string>, memberId?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, groupNumber?: Maybe<string>, insuranceRecordId: number, policyHolderFirstName?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, isDeleted?: Maybe<boolean> }> }, insuranceRecordsByEncounterAppointmentIdAndSecondaryInsurance: { nodes: Array<{ patientId: number, company?: Maybe<string>, packageId?: Maybe<string>, memberId?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, groupNumber?: Maybe<string>, insuranceRecordId: number, policyHolderFirstName?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, isDeleted?: Maybe<boolean> }> } }> };

export type GetExportAppointmentsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  status?: Maybe<Array<AppointmentStatusEnum> | AppointmentStatusEnum>;
  orderBy?: Maybe<SearchAppointmentsOrderByEnum>;
  scheduledBefore?: Maybe<Scalars['String']>;
  scheduledAfter?: Maybe<Scalars['String']>;
  serviceLines?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetExportAppointmentsQuery = { searchAppointments?: Maybe<Array<{ partnership?: Maybe<string>, completedAt?: Maybe<any>, appointmentId: number, skeduloJobId?: Maybe<any>, createdAt: any, createdBy?: Maybe<number>, scheduledFor: any, status?: Maybe<AppointmentStatusEnum>, systemOfOrigin: SystemOfOriginEnum, zoneId: number, marketId: number, cancelledReason?: Maybe<CancellationReasonEnum>, cancelledReasonOther?: Maybe<string>, rescheduledReason?: Maybe<RescheduleReasonEnum>, contactName?: Maybe<string>, primaryPhone?: Maybe<string>, specialInstructions?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, marketOverride?: Maybe<boolean>, availabilityOverride?: Maybe<boolean>, rescheduledFrom: Array<Maybe<number>>, rescheduledAt?: Maybe<any>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, unit?: Maybe<string>, zip?: Maybe<string>, rescheduledTo?: Maybe<{ appointmentId: number }>, userByCreatedBy?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number }>, encountersList: Array<{ inProgressAt?: Maybe<any>, encounterId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, channelAttribution?: Maybe<{ channel: string }>, encounterSignaturesList: Array<{ createdAt: any }>, serviceLine?: Maybe<{ name: string, serviceLineId: number, subType: string, segment?: Maybe<string> }>, patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, age?: Maybe<number>, patientNotesList: Array<{ patientNoteId: number, patientId: number, note: string, label?: Maybe<PatientNoteLabel>, createdAt: any, isHighPriority?: Maybe<boolean>, isDeleted?: Maybe<boolean>, author?: Maybe<string>, friendlyLabel?: Maybe<string>, userByCreatedBy?: Maybe<{ nodeId: string, userId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, fullName?: Maybe<string>, friendlyRoles?: Maybe<string> }> }> }> }>, cancelledBy?: Maybe<{ name?: Maybe<string> }>, appointmentDispatches: { nodes: Array<{ appointmentDispatchId: number, appointmentId: number, skeduloJobAllocationId?: Maybe<any>, responderId: number, status?: Maybe<AppointmentDispatchStatusEnum>, dispatchedAt?: Maybe<any>, enRouteAt?: Maybe<any>, onSceneAt?: Maybe<any>, atPatientAt?: Maybe<any>, completedAt?: Maybe<any>, createdAt: any, updatedAt?: Maybe<any>, cancelledAt?: Maybe<any>, removedAt?: Maybe<any>, responder?: Maybe<{ userId: number, user?: Maybe<{ userId: number, employeeId?: Maybe<string>, lastName?: Maybe<string>, firstName?: Maybe<string>, fullName?: Maybe<string>, profilePictureUrl?: Maybe<string> }> }> }> }, market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }> }>> };

export type GetFullAppointmentPreviewQueryVariables = Exact<{
  appointmentId: Scalars['Int'];
}>;


export type GetFullAppointmentPreviewQuery = { appointment?: Maybe<{ appointmentId: number, createdAt: any, createdBy?: Maybe<number>, scheduledFor: any, zoneId: number, marketId: number, contactName?: Maybe<string>, primaryPhone?: Maybe<string>, skeduloJobId?: Maybe<any>, specialInstructions?: Maybe<string>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, unit?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, encountersList: Array<{ channelAttributionId: number, encounterId: number, genderRequirement?: Maybe<SexEnum>, patientId: number, responderStatus?: Maybe<EncounterResponderStatusEnum>, reasonForEncounter?: Maybe<string>, modules?: Maybe<Array<Maybe<ModuleNameEnum>>>, cancellationReason?: Maybe<CancellationReasonEnum>, cancellationReasonOther?: Maybe<string>, cancelledAt?: Maybe<any>, modulesFriendly: string, primaryInsuranceRecord?: Maybe<{ patientId: number, company?: Maybe<string>, packageId?: Maybe<string>, memberId?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, groupNumber?: Maybe<string>, insuranceRecordId: number, policyHolderFirstName?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, isDeleted?: Maybe<boolean> }>, secondaryInsuranceRecord?: Maybe<{ patientId: number, company?: Maybe<string>, packageId?: Maybe<string>, memberId?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, groupNumber?: Maybe<string>, insuranceRecordId: number, policyHolderFirstName?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, isDeleted?: Maybe<boolean> }>, serviceLine?: Maybe<{ name: string, friendlyName: string, serviceLineId: number, subType: string, segment?: Maybe<string> }> }>, market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }>, patientsByEncounterAppointmentIdAndPatientIdList: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, unit?: Maybe<string>, specialInstructions?: Maybe<string>, patientNotesList: Array<{ patientNoteId: number, note: string, nodeId: string, isHighPriority?: Maybe<boolean>, createdBy?: Maybe<number>, createdAt: any, userByCreatedBy?: Maybe<{ nodeId: string, firstName?: Maybe<string>, lastName?: Maybe<string>, userId: number }> }> }> }> };

export type GetInsuranceRecordQueryVariables = Exact<{
  insuranceRecordId: Scalars['Int'];
}>;


export type GetInsuranceRecordQuery = { insuranceRecord?: Maybe<{ patientId: number, company?: Maybe<string>, packageId?: Maybe<string>, memberId?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, groupNumber?: Maybe<string>, insuranceRecordId: number, policyHolderFirstName?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, isDeleted?: Maybe<boolean> }> };

export type GetInsuranceRecordListQueryVariables = Exact<{
  insuranceRecordsListCondition: InsuranceRecordCondition;
}>;


export type GetInsuranceRecordListQuery = { insuranceRecordsList?: Maybe<Array<{ patientId: number, company?: Maybe<string>, packageId?: Maybe<string>, memberId?: Maybe<string>, relationshipToPolicyHolder?: Maybe<string>, groupNumber?: Maybe<string>, insuranceRecordId: number, policyHolderFirstName?: Maybe<string>, policyHolderLastName?: Maybe<string>, policyHolderGender?: Maybe<SexEnum>, policyHolderDob?: Maybe<any>, isDeleted?: Maybe<boolean> }>> };

export type GetMarketQueryVariables = Exact<{
  marketId: Scalars['Int'];
}>;


export type GetMarketQuery = { market?: Maybe<{ marketId: number, name: string, isDeleted?: Maybe<boolean>, isFrozen: boolean, isActive: boolean, timezone?: Maybe<string>, startTimes: Array<Maybe<any>>, endTimes: Array<Maybe<any>> }> };

export type GetMarketByZipQueryVariables = Exact<{
  zipCode: Scalars['String'];
}>;


export type GetMarketByZipQuery = { zipcode?: Maybe<{ zipCode: string, zones: { nodes: Array<{ zoneId: number, market?: Maybe<{ marketId: number, name: string, isDeleted?: Maybe<boolean>, isFrozen: boolean, isActive: boolean, timezone?: Maybe<string>, startTimes: Array<Maybe<any>>, endTimes: Array<Maybe<any>> }> }> } }> };

export type GetMarketWithZonesQueryVariables = Exact<{
  marketId: Scalars['Int'];
}>;


export type GetMarketWithZonesQuery = { market?: Maybe<{ marketId: number, name: string, isDeleted?: Maybe<boolean>, isFrozen: boolean, isActive: boolean, timezone?: Maybe<string>, startTimes: Array<Maybe<any>>, endTimes: Array<Maybe<any>>, zonesList: Array<{ name: string, zoneId: number, isDeleted?: Maybe<boolean>, stringifiedZoneZipcodeList?: Maybe<string>, zoneZipcodesList: Array<{ zipCode: any }> }> }> };

export type GetMarketsQueryVariables = Exact<{
  condition?: Maybe<MarketCondition>;
}>;


export type GetMarketsQuery = { marketsList?: Maybe<Array<{ marketId: number, name: string, isDeleted?: Maybe<boolean>, isFrozen: boolean, isActive: boolean, timezone?: Maybe<string>, startTimes: Array<Maybe<any>>, endTimes: Array<Maybe<any>> }>> };

export type GetPatientQueryVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type GetPatientQuery = { patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, unit?: Maybe<string>, specialInstructions?: Maybe<string> }> };

export type GetPatientNotesQueryVariables = Exact<{
  patientId: Scalars['Int'];
}>;


export type GetPatientNotesQuery = { patient?: Maybe<{ patientId: number, patientNotesList: Array<{ patientNoteId: number, patientId: number, note: string, label?: Maybe<PatientNoteLabel>, createdAt: any, isHighPriority?: Maybe<boolean>, isDeleted?: Maybe<boolean>, author?: Maybe<string>, friendlyLabel?: Maybe<string>, userByCreatedBy?: Maybe<{ nodeId: string, userId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, fullName?: Maybe<string>, friendlyRoles?: Maybe<string> }> }> }> };

export type GetPatientsQueryVariables = Exact<{
  patientIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetPatientsQuery = { patients?: Maybe<{ nodes: Array<{ firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, patientId: number, dob?: Maybe<any>, sex?: Maybe<SexEnum>, email?: Maybe<string>, languages?: Maybe<Array<Maybe<LanguagesEnum>>>, communicationNeed?: Maybe<Array<Maybe<CommunicationNeedEnum>>>, genderIdentity?: Maybe<GenderIdentityEnum>, globalHumanId?: Maybe<string>, genderPronoun?: Maybe<GenderPronounEnum>, races?: Maybe<Array<Maybe<RaceEnum>>>, address1?: Maybe<string>, address2?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string>, zip?: Maybe<string>, addressLat?: Maybe<number>, addressLng?: Maybe<number>, unit?: Maybe<string>, specialInstructions?: Maybe<string> }> }> };

export type GetSearchAppointmentsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  status?: Maybe<Array<AppointmentStatusEnum> | AppointmentStatusEnum>;
  orderBy?: Maybe<SearchAppointmentsOrderByEnum>;
  scheduledBefore?: Maybe<Scalars['String']>;
  scheduledAfter?: Maybe<Scalars['String']>;
  serviceLines?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetSearchAppointmentsQuery = { searchAppointments?: Maybe<Array<{ appointmentId: number, scheduledFor: any, status?: Maybe<AppointmentStatusEnum>, availabilityOverride?: Maybe<boolean>, encounters: { nodes: Array<{ encounterId: number, patient?: Maybe<{ firstName?: Maybe<string>, lastName?: Maybe<string>, patientId: number, patientNotes: { totalCount: number } }>, channelAttribution?: Maybe<{ channelAttributionId: number, channel: string }> }> }, appointmentDispatches: { nodes: Array<{ appointmentDispatchId: number, appointmentId: number, skeduloJobAllocationId?: Maybe<any>, responderId: number, status?: Maybe<AppointmentDispatchStatusEnum>, dispatchedAt?: Maybe<any>, enRouteAt?: Maybe<any>, onSceneAt?: Maybe<any>, atPatientAt?: Maybe<any>, completedAt?: Maybe<any>, createdAt: any, updatedAt?: Maybe<any>, cancelledAt?: Maybe<any>, removedAt?: Maybe<any>, responder?: Maybe<{ userId: number, user?: Maybe<{ userId: number, employeeId?: Maybe<string>, lastName?: Maybe<string>, firstName?: Maybe<string>, fullName?: Maybe<string>, profilePictureUrl?: Maybe<string> }> }> }> }, market?: Maybe<{ marketId: number, name: string, timezone?: Maybe<string> }> }>> };

export type SearchPatientsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SearchPatientsQuery = { searchPatients?: Maybe<Array<{ patientId: number, firstName?: Maybe<string>, lastName?: Maybe<string>, preferredName?: Maybe<string>, preferredPhoneNumber?: Maybe<string>, sex?: Maybe<SexEnum>, dob?: Maybe<any>, genderPronoun?: Maybe<GenderPronounEnum>, address1?: Maybe<string>, city?: Maybe<string>, state?: Maybe<string> }>> };

export type GetServiceLinesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceLinesQuery = { serviceLines?: Maybe<{ nodes: Array<{ serviceLineId: number, name: string, friendlyName: string, subType: string, segment?: Maybe<string>, priority: number, isDeleted: boolean }> }> };

export type GetUsersQueryVariables = Exact<{
  orderBy?: Maybe<Array<UsersOrderBy> | UsersOrderBy>;
}>;


export type GetUsersQuery = { users?: Maybe<{ edges: Array<{ cursor?: Maybe<any>, node: { email?: Maybe<string>, employeeId?: Maybe<string>, firstName?: Maybe<string>, isClinician?: Maybe<boolean>, isDeleted?: Maybe<boolean>, isIt?: Maybe<boolean>, isResponder?: Maybe<boolean>, isOps?: Maybe<boolean>, lastLoginAt?: Maybe<any>, lastName?: Maybe<string>, userId: number, profilePictureUrl?: Maybe<string>, opsRole?: Maybe<{ opsAdmin: boolean }> } }> }> };

export type GetZoneQueryVariables = Exact<{
  zoneId: Scalars['Int'];
}>;


export type GetZoneQuery = { zone?: Maybe<{ name: string, zoneId: number }> };

export type GetZoneAndMarketByZipCodeQueryVariables = Exact<{
  zipCode: Scalars['String'];
}>;


export type GetZoneAndMarketByZipCodeQuery = { zipcode?: Maybe<{ zones: { nodes: Array<{ isActive: boolean, zoneId: number, marketId: number }> } }> };

export type GetZonesQueryVariables = Exact<{
  condition?: Maybe<ZoneCondition>;
}>;


export type GetZonesQuery = { zonesList?: Maybe<Array<{ name: string, zoneId: number, isActive: boolean }>> };

export const AddressFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment AddressFields on Appointment {
  address1
  address2
  city
  state
  unit
  zip
  addressLat
  addressLng
}
    `;
export const AppointmentFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentFragment on Appointment {
  appointmentId
  skeduloJobId
  createdAt
  createdBy
  scheduledFor
  status
  systemOfOrigin
  zoneId
  marketId
  cancelledBy {
    name
  }
  cancelledReason
  cancelledReasonOther
  rescheduledReason
  contactName
  primaryPhone
  specialInstructions
  addressLat
  addressLng
  marketOverride
  availabilityOverride
  rescheduledFrom
  rescheduledAt
}
    `;
export const AppointmentDispatchesFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentDispatches on Appointment {
  appointmentDispatches {
    nodes {
      appointmentDispatchId
      appointmentId
      skeduloJobAllocationId
      responderId
      status
      dispatchedAt
      enRouteAt
      onSceneAt
      atPatientAt
      completedAt
      createdAt
      updatedAt
      cancelledAt
      removedAt
      responder {
        userId
        user {
          userId
          employeeId
          lastName
          firstName
          fullName @client
          profilePictureUrl
        }
      }
    }
  }
}
    `;
export const PatientNoteFragmentDoc = /*#__PURE__*/ gql`
    fragment PatientNote on PatientNote {
  userByCreatedBy {
    nodeId
    userId
    firstName
    lastName
    fullName @client
    friendlyRoles @client
  }
  patientNoteId
  patientId
  note
  label
  createdAt
  isHighPriority
  isDeleted
  author @client
  friendlyLabel @client
}
    `;
export const AppointmentPreviewEncountersFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentPreviewEncounters on Encounter {
  encounterId
  responderStatus
  reasonForEncounter
  serviceLine {
    name
    serviceLineId
    subType
    segment
  }
  patient {
    firstName
    lastName
    patientId
    dob
    sex
    age @client
    patientNotesList(condition: {isHighPriority: true, isDeleted: false}) {
      ...PatientNote
    }
  }
}
    ${PatientNoteFragmentDoc}`;
export const ChannelAttributionFragmentDoc = /*#__PURE__*/ gql`
    fragment ChannelAttributionFragment on ChannelAttribution {
  channel
  channelAttributionId
  createdAt
  globalId
  institutionType
  referralType
  markets {
    name
    marketId
  }
}
    `;
export const ServiceLineFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment ServiceLineFields on ServiceLine {
  name
  friendlyName @client
  serviceLineId
  subType
  segment
}
    `;
export const EncounterFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment EncounterFields on Encounter {
  encounterId
  genderRequirement
  patientId
  responderStatus
  reasonForEncounter
  modules
  channelAttributionId
  cancellationReason
  cancellationReasonOther
  cancelledAt
  modulesFriendly @client
  serviceLine {
    ...ServiceLineFields
  }
}
    ${ServiceLineFieldsFragmentDoc}`;
export const InsuranceRecordFragmentDoc = /*#__PURE__*/ gql`
    fragment InsuranceRecord on InsuranceRecord {
  patientId
  company
  packageId
  memberId
  relationshipToPolicyHolder
  groupNumber
  insuranceRecordId
  policyHolderFirstName
  policyHolderLastName
  policyHolderGender
  policyHolderDob
  isDeleted
}
    `;
export const MarketFragmentDoc = /*#__PURE__*/ gql`
    fragment Market on Market {
  marketId
  name
  isDeleted
  isFrozen
  isActive
  timezone
  startTimes
  endTimes
}
    `;
export const MarketNameFragmentDoc = /*#__PURE__*/ gql`
    fragment MarketName on Appointment {
  market {
    marketId
    name
    timezone
  }
}
    `;
export const PatientNameFragmentDoc = /*#__PURE__*/ gql`
    fragment PatientName on Appointment {
  encounters {
    nodes {
      patient {
        firstName
        lastName
        patientId
      }
    }
  }
}
    `;
export const ResponderNameFragmentDoc = /*#__PURE__*/ gql`
    fragment ResponderName on User {
  firstName
  lastName
  userId
}
    `;
export const UserFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment UserFields on User {
  email
  employeeId
  firstName
  isClinician
  isDeleted
  isIt
  isResponder
  isOps
  lastLoginAt
  lastName
  userId
  profilePictureUrl
  opsRole {
    opsAdmin
  }
}
    `;
export const PatientFragmentDoc = /*#__PURE__*/ gql`
    fragment Patient on Patient {
  firstName
  lastName
  preferredName
  preferredPhoneNumber
  patientId
  dob
  sex
  email
  languages
  communicationNeed
  genderIdentity
  globalHumanId
  genderPronoun
  races
  address1
  address2
  city
  state
  zip
  addressLat
  addressLng
  unit
  specialInstructions
}
    `;
export const PatientsByEncounterAppointmentIdAndPatientIdListFragmentDoc = /*#__PURE__*/ gql`
    fragment patientsByEncounterAppointmentIdAndPatientIdList on Appointment {
  patientsByEncounterAppointmentIdAndPatientIdList {
    ...Patient
    patientNotesList {
      userByCreatedBy {
        nodeId
        firstName
        lastName
        userId
      }
      patientNoteId
      note
      nodeId
      isHighPriority
      createdBy
      createdAt
    }
  }
}
    ${PatientFragmentDoc}`;
export const AddEncounterDocument = /*#__PURE__*/ gql`
    mutation AddEncounter($appointmentId: Int!, $patientId: Int!, $reasonForEncounter: NonNullableText!, $serviceLineId: Int!, $modules: [ModuleNameEnum], $genderRequirement: SexEnum, $systemLastUpdatedBy: SystemOfOriginEnum = READY_OPS, $channelAttributionId: Int!) {
  addEncounter(
    input: {appointmentId: $appointmentId, patientId: $patientId, reasonForEncounter: $reasonForEncounter, serviceLineId: $serviceLineId, modules: $modules, genderRequirement: $genderRequirement, systemLastUpdatedBy: $systemLastUpdatedBy, channelAttributionId: $channelAttributionId}
  ) {
    encounter {
      encounterId
      appointmentId
      patientId
      createdAt
      serviceLineId
      channelAttributionId
      reasonForEncounter
      genderRequirement
      modules
    }
  }
}
    `;
export type AddEncounterMutationFn = Apollo.MutationFunction<AddEncounterMutation, AddEncounterMutationVariables>;

/**
 * __useAddEncounterMutation__
 *
 * To run a mutation, you first call `useAddEncounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEncounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEncounterMutation, { data, loading, error }] = useAddEncounterMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      patientId: // value for 'patientId'
 *      reasonForEncounter: // value for 'reasonForEncounter'
 *      serviceLineId: // value for 'serviceLineId'
 *      modules: // value for 'modules'
 *      genderRequirement: // value for 'genderRequirement'
 *      systemLastUpdatedBy: // value for 'systemLastUpdatedBy'
 *      channelAttributionId: // value for 'channelAttributionId'
 *   },
 * });
 */
export function useAddEncounterMutation(baseOptions?: Apollo.MutationHookOptions<AddEncounterMutation, AddEncounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEncounterMutation, AddEncounterMutationVariables>(AddEncounterDocument, options);
      }
export type AddEncounterMutationHookResult = ReturnType<typeof useAddEncounterMutation>;
export type AddEncounterMutationResult = Apollo.MutationResult<AddEncounterMutation>;
export type AddEncounterMutationOptions = Apollo.BaseMutationOptions<AddEncounterMutation, AddEncounterMutationVariables>;
export const CancelAppointmentDocument = /*#__PURE__*/ gql`
    mutation CancelAppointment($appointmentId: Int!, $cancellationReason: CancellationReasonEnum!, $cancellationReasonOther: String) {
  cancelAppointment(
    input: {appointmentId: $appointmentId, cancelledReason: $cancellationReason, cancelledReasonOther: $cancellationReasonOther}
  ) {
    appointment {
      appointmentId
      cancelledAt
      cancelledReason
      cancelledReasonOther
      status
    }
  }
}
    `;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      cancellationReason: // value for 'cancellationReason'
 *      cancellationReasonOther: // value for 'cancellationReasonOther'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const CancelEncountersDocument = /*#__PURE__*/ gql`
    mutation CancelEncounters($encounterIds: [Int!], $cancellationReason: CancellationReasonEnum!, $cancellationReasonOther: String) {
  cancelEncounters(
    input: {encounterIds: $encounterIds, cancellationReason: $cancellationReason, cancellationReasonOther: $cancellationReasonOther}
  ) {
    encounterId
  }
}
    `;
export type CancelEncountersMutationFn = Apollo.MutationFunction<CancelEncountersMutation, CancelEncountersMutationVariables>;

/**
 * __useCancelEncountersMutation__
 *
 * To run a mutation, you first call `useCancelEncountersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEncountersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEncountersMutation, { data, loading, error }] = useCancelEncountersMutation({
 *   variables: {
 *      encounterIds: // value for 'encounterIds'
 *      cancellationReason: // value for 'cancellationReason'
 *      cancellationReasonOther: // value for 'cancellationReasonOther'
 *   },
 * });
 */
export function useCancelEncountersMutation(baseOptions?: Apollo.MutationHookOptions<CancelEncountersMutation, CancelEncountersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEncountersMutation, CancelEncountersMutationVariables>(CancelEncountersDocument, options);
      }
export type CancelEncountersMutationHookResult = ReturnType<typeof useCancelEncountersMutation>;
export type CancelEncountersMutationResult = Apollo.MutationResult<CancelEncountersMutation>;
export type CancelEncountersMutationOptions = Apollo.BaseMutationOptions<CancelEncountersMutation, CancelEncountersMutationVariables>;
export const CreateInsuranceRecordDocument = /*#__PURE__*/ gql`
    mutation CreateInsuranceRecord($input: CreateInsuranceRecordInput!) {
  createInsuranceRecord(input: $input) {
    insuranceRecord {
      insuranceRecordId
      patientId
      company
      address1
      address2
      city
      state
      zip
      memberId
      groupNumber
      relationshipToPolicyHolder
      policyHolderLastName
      policyHolderFirstName
      policyHolderGender
      policyHolderDob
      packageId
      systemLastUpdatedBy
    }
  }
}
    `;
export type CreateInsuranceRecordMutationFn = Apollo.MutationFunction<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>;

/**
 * __useCreateInsuranceRecordMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceRecordMutation, { data, loading, error }] = useCreateInsuranceRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInsuranceRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>(CreateInsuranceRecordDocument, options);
      }
export type CreateInsuranceRecordMutationHookResult = ReturnType<typeof useCreateInsuranceRecordMutation>;
export type CreateInsuranceRecordMutationResult = Apollo.MutationResult<CreateInsuranceRecordMutation>;
export type CreateInsuranceRecordMutationOptions = Apollo.BaseMutationOptions<CreateInsuranceRecordMutation, CreateInsuranceRecordMutationVariables>;
export const CreatePatientNoteDocument = /*#__PURE__*/ gql`
    mutation CreatePatientNote($patientNote: PatientNoteInputRecordInput!) {
  createPatientNote(input: {patientNote: $patientNote}) {
    patientNote {
      ...PatientNote
    }
  }
}
    ${PatientNoteFragmentDoc}`;
export type CreatePatientNoteMutationFn = Apollo.MutationFunction<CreatePatientNoteMutation, CreatePatientNoteMutationVariables>;

/**
 * __useCreatePatientNoteMutation__
 *
 * To run a mutation, you first call `useCreatePatientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientNoteMutation, { data, loading, error }] = useCreatePatientNoteMutation({
 *   variables: {
 *      patientNote: // value for 'patientNote'
 *   },
 * });
 */
export function useCreatePatientNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientNoteMutation, CreatePatientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientNoteMutation, CreatePatientNoteMutationVariables>(CreatePatientNoteDocument, options);
      }
export type CreatePatientNoteMutationHookResult = ReturnType<typeof useCreatePatientNoteMutation>;
export type CreatePatientNoteMutationResult = Apollo.MutationResult<CreatePatientNoteMutation>;
export type CreatePatientNoteMutationOptions = Apollo.BaseMutationOptions<CreatePatientNoteMutation, CreatePatientNoteMutationVariables>;
export const CreateSkeduloAppointmentDocument = /*#__PURE__*/ gql`
    mutation CreateSkeduloAppointment($appointment: CreateSkeduloAppointmentInput, $patients: [CreateSkeduloPatientInput]) {
  createSkeduloAppointment(
    input: {patients: $patients, appointment: $appointment}
  ) {
    error
    appointmentId
  }
}
    `;
export type CreateSkeduloAppointmentMutationFn = Apollo.MutationFunction<CreateSkeduloAppointmentMutation, CreateSkeduloAppointmentMutationVariables>;

/**
 * __useCreateSkeduloAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateSkeduloAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkeduloAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkeduloAppointmentMutation, { data, loading, error }] = useCreateSkeduloAppointmentMutation({
 *   variables: {
 *      appointment: // value for 'appointment'
 *      patients: // value for 'patients'
 *   },
 * });
 */
export function useCreateSkeduloAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSkeduloAppointmentMutation, CreateSkeduloAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSkeduloAppointmentMutation, CreateSkeduloAppointmentMutationVariables>(CreateSkeduloAppointmentDocument, options);
      }
export type CreateSkeduloAppointmentMutationHookResult = ReturnType<typeof useCreateSkeduloAppointmentMutation>;
export type CreateSkeduloAppointmentMutationResult = Apollo.MutationResult<CreateSkeduloAppointmentMutation>;
export type CreateSkeduloAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateSkeduloAppointmentMutation, CreateSkeduloAppointmentMutationVariables>;
export const CreatePatientDocument = /*#__PURE__*/ gql`
    mutation CreatePatient($patient: PatientInputRecordInput!) {
  createPatient(input: {patient: $patient}) {
    clientMutationId
    code
    patient {
      firstName
      lastName
      preferredName
      preferredPhoneNumber
      sex
      dob
      patientId
      address1
      city
      state
    }
  }
}
    `;
export type CreatePatientMutationFn = Apollo.MutationFunction<CreatePatientMutation, CreatePatientMutationVariables>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      patient: // value for 'patient'
 *   },
 * });
 */
export function useCreatePatientMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientMutation, CreatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(CreatePatientDocument, options);
      }
export type CreatePatientMutationHookResult = ReturnType<typeof useCreatePatientMutation>;
export type CreatePatientMutationResult = Apollo.MutationResult<CreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>;
export const RescheduleSkeduloAppointmentDocument = /*#__PURE__*/ gql`
    mutation RescheduleSkeduloAppointment($appointment: CreateSkeduloAppointmentInput!, $appointmentId: Int!, $rescheduleReason: RescheduleReasonEnum!, $patients: [CreateSkeduloPatientInput!]!) {
  rescheduleSkeduloAppointment(
    input: {patients: $patients, appointment: $appointment, appointmentId: $appointmentId, rescheduleReason: $rescheduleReason}
  ) {
    error
    appointmentId
  }
}
    `;
export type RescheduleSkeduloAppointmentMutationFn = Apollo.MutationFunction<RescheduleSkeduloAppointmentMutation, RescheduleSkeduloAppointmentMutationVariables>;

/**
 * __useRescheduleSkeduloAppointmentMutation__
 *
 * To run a mutation, you first call `useRescheduleSkeduloAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleSkeduloAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleSkeduloAppointmentMutation, { data, loading, error }] = useRescheduleSkeduloAppointmentMutation({
 *   variables: {
 *      appointment: // value for 'appointment'
 *      appointmentId: // value for 'appointmentId'
 *      rescheduleReason: // value for 'rescheduleReason'
 *      patients: // value for 'patients'
 *   },
 * });
 */
export function useRescheduleSkeduloAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleSkeduloAppointmentMutation, RescheduleSkeduloAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleSkeduloAppointmentMutation, RescheduleSkeduloAppointmentMutationVariables>(RescheduleSkeduloAppointmentDocument, options);
      }
export type RescheduleSkeduloAppointmentMutationHookResult = ReturnType<typeof useRescheduleSkeduloAppointmentMutation>;
export type RescheduleSkeduloAppointmentMutationResult = Apollo.MutationResult<RescheduleSkeduloAppointmentMutation>;
export type RescheduleSkeduloAppointmentMutationOptions = Apollo.BaseMutationOptions<RescheduleSkeduloAppointmentMutation, RescheduleSkeduloAppointmentMutationVariables>;
export const UpdateAppointmentDocument = /*#__PURE__*/ gql`
    mutation UpdateAppointment($appointmentId: Int!, $appointmentPatch: AppointmentPatch!) {
  updateAppointment(
    input: {patch: $appointmentPatch, appointmentId: $appointmentId}
  ) {
    clientMutationId
    appointment {
      ...AppointmentFragment
      encountersList {
        ...EncounterFields
      }
      ...AppointmentDispatches
      ...MarketName
      ...AddressFields
      ...patientsByEncounterAppointmentIdAndPatientIdList
    }
  }
}
    ${AppointmentFragmentDoc}
${EncounterFieldsFragmentDoc}
${AppointmentDispatchesFragmentDoc}
${MarketNameFragmentDoc}
${AddressFieldsFragmentDoc}
${PatientsByEncounterAppointmentIdAndPatientIdListFragmentDoc}`;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      appointmentPatch: // value for 'appointmentPatch'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const UpdateChannelAttributionDocument = /*#__PURE__*/ gql`
    mutation UpdateChannelAttribution($input: UpdateChannelAttributionInput!) {
  updateChannelAttribution(input: $input) {
    channelAttribution {
      channelAttributionId
    }
  }
}
    `;
export type UpdateChannelAttributionMutationFn = Apollo.MutationFunction<UpdateChannelAttributionMutation, UpdateChannelAttributionMutationVariables>;

/**
 * __useUpdateChannelAttributionMutation__
 *
 * To run a mutation, you first call `useUpdateChannelAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelAttributionMutation, { data, loading, error }] = useUpdateChannelAttributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelAttributionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelAttributionMutation, UpdateChannelAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelAttributionMutation, UpdateChannelAttributionMutationVariables>(UpdateChannelAttributionDocument, options);
      }
export type UpdateChannelAttributionMutationHookResult = ReturnType<typeof useUpdateChannelAttributionMutation>;
export type UpdateChannelAttributionMutationResult = Apollo.MutationResult<UpdateChannelAttributionMutation>;
export type UpdateChannelAttributionMutationOptions = Apollo.BaseMutationOptions<UpdateChannelAttributionMutation, UpdateChannelAttributionMutationVariables>;
export const UpdateEncounterDocument = /*#__PURE__*/ gql`
    mutation UpdateEncounter($encounterId: Int!, $encounter: EncounterPatch!) {
  updateEncounter(input: {patch: $encounter, encounterId: $encounterId}) {
    clientMutationId
    encounter {
      ...EncounterFields
    }
  }
}
    ${EncounterFieldsFragmentDoc}`;
export type UpdateEncounterMutationFn = Apollo.MutationFunction<UpdateEncounterMutation, UpdateEncounterMutationVariables>;

/**
 * __useUpdateEncounterMutation__
 *
 * To run a mutation, you first call `useUpdateEncounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEncounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEncounterMutation, { data, loading, error }] = useUpdateEncounterMutation({
 *   variables: {
 *      encounterId: // value for 'encounterId'
 *      encounter: // value for 'encounter'
 *   },
 * });
 */
export function useUpdateEncounterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEncounterMutation, UpdateEncounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEncounterMutation, UpdateEncounterMutationVariables>(UpdateEncounterDocument, options);
      }
export type UpdateEncounterMutationHookResult = ReturnType<typeof useUpdateEncounterMutation>;
export type UpdateEncounterMutationResult = Apollo.MutationResult<UpdateEncounterMutation>;
export type UpdateEncounterMutationOptions = Apollo.BaseMutationOptions<UpdateEncounterMutation, UpdateEncounterMutationVariables>;
export const UpdatePatientDocument = /*#__PURE__*/ gql`
    mutation UpdatePatient($patientId: Int!, $patientPatch: PatientPatchRecordInput!) {
  updatePatient(input: {patch: $patientPatch, patientId: $patientId}) {
    clientMutationId
    patient {
      specialInstructions
      firstName
      lastName
      preferredName
      preferredPhoneNumber
      patientId
      dob
      sex
      email
      languages
      communicationNeed
      genderIdentity
      globalHumanId
      genderPronoun
      races
      age @client
      address1
      address2
      city
      state
      unit
      zip
      addressLat
      addressLng
    }
  }
}
    `;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      patientPatch: // value for 'patientPatch'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const UpdatePatientNoteDocument = /*#__PURE__*/ gql`
    mutation UpdatePatientNote($patientNoteId: Int!, $patientNotePatch: PatientNotePatchRecordInput!) {
  updatePatientNote(
    input: {patch: $patientNotePatch, patientNoteId: $patientNoteId}
  ) {
    patientNote {
      ...PatientNote
    }
  }
}
    ${PatientNoteFragmentDoc}`;
export type UpdatePatientNoteMutationFn = Apollo.MutationFunction<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>;

/**
 * __useUpdatePatientNoteMutation__
 *
 * To run a mutation, you first call `useUpdatePatientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientNoteMutation, { data, loading, error }] = useUpdatePatientNoteMutation({
 *   variables: {
 *      patientNoteId: // value for 'patientNoteId'
 *      patientNotePatch: // value for 'patientNotePatch'
 *   },
 * });
 */
export function useUpdatePatientNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>(UpdatePatientNoteDocument, options);
      }
export type UpdatePatientNoteMutationHookResult = ReturnType<typeof useUpdatePatientNoteMutation>;
export type UpdatePatientNoteMutationResult = Apollo.MutationResult<UpdatePatientNoteMutation>;
export type UpdatePatientNoteMutationOptions = Apollo.BaseMutationOptions<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>;
export const UpsertMarketsDocument = /*#__PURE__*/ gql`
    mutation UpsertMarkets($endTimes: [Time], $isFrozen: Boolean, $marketId: Int!, $startTimes: [Time], $timezone: String, $name: String) {
  upsertMarkets(
    input: {markets: {timezone: $timezone, startTimes: $startTimes, marketId: $marketId, isFrozen: $isFrozen, endTimes: $endTimes, name: $name}}
  ) {
    query {
      market(marketId: $marketId) {
        ...Market
      }
    }
  }
}
    ${MarketFragmentDoc}`;
export type UpsertMarketsMutationFn = Apollo.MutationFunction<UpsertMarketsMutation, UpsertMarketsMutationVariables>;

/**
 * __useUpsertMarketsMutation__
 *
 * To run a mutation, you first call `useUpsertMarketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMarketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMarketsMutation, { data, loading, error }] = useUpsertMarketsMutation({
 *   variables: {
 *      endTimes: // value for 'endTimes'
 *      isFrozen: // value for 'isFrozen'
 *      marketId: // value for 'marketId'
 *      startTimes: // value for 'startTimes'
 *      timezone: // value for 'timezone'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpsertMarketsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMarketsMutation, UpsertMarketsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMarketsMutation, UpsertMarketsMutationVariables>(UpsertMarketsDocument, options);
      }
export type UpsertMarketsMutationHookResult = ReturnType<typeof useUpsertMarketsMutation>;
export type UpsertMarketsMutationResult = Apollo.MutationResult<UpsertMarketsMutation>;
export type UpsertMarketsMutationOptions = Apollo.BaseMutationOptions<UpsertMarketsMutation, UpsertMarketsMutationVariables>;
export const UpsertZoneDocument = /*#__PURE__*/ gql`
    mutation UpsertZone($name: String, $zoneId: Int!, $marketId: Int!, $isActive: Boolean!, $isFrozen: Boolean!) {
  upsertZones(
    input: {zones: {name: $name, zoneId: $zoneId, marketId: $marketId, isActive: $isActive, isFrozen: $isFrozen}}
  ) {
    query {
      zone(zoneId: $zoneId) {
        zoneId
        name
        marketId
      }
    }
  }
}
    `;
export type UpsertZoneMutationFn = Apollo.MutationFunction<UpsertZoneMutation, UpsertZoneMutationVariables>;

/**
 * __useUpsertZoneMutation__
 *
 * To run a mutation, you first call `useUpsertZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertZoneMutation, { data, loading, error }] = useUpsertZoneMutation({
 *   variables: {
 *      name: // value for 'name'
 *      zoneId: // value for 'zoneId'
 *      marketId: // value for 'marketId'
 *      isActive: // value for 'isActive'
 *      isFrozen: // value for 'isFrozen'
 *   },
 * });
 */
export function useUpsertZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpsertZoneMutation, UpsertZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertZoneMutation, UpsertZoneMutationVariables>(UpsertZoneDocument, options);
      }
export type UpsertZoneMutationHookResult = ReturnType<typeof useUpsertZoneMutation>;
export type UpsertZoneMutationResult = Apollo.MutationResult<UpsertZoneMutation>;
export type UpsertZoneMutationOptions = Apollo.BaseMutationOptions<UpsertZoneMutation, UpsertZoneMutationVariables>;
export const UpsertZoneZipcodesDocument = /*#__PURE__*/ gql`
    mutation UpsertZoneZipcodes($zoneId: Int!, $zipCodes: [ZipCode]!) {
  upsertZoneZipcodes(input: {zoneId: $zoneId, zipCodes: $zipCodes}) {
    code
    zoneZipcodes {
      nodeId
      zipCode
      zone {
        zoneId
        zoneZipcodesList {
          zipCode
        }
      }
    }
  }
}
    `;
export type UpsertZoneZipcodesMutationFn = Apollo.MutationFunction<UpsertZoneZipcodesMutation, UpsertZoneZipcodesMutationVariables>;

/**
 * __useUpsertZoneZipcodesMutation__
 *
 * To run a mutation, you first call `useUpsertZoneZipcodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertZoneZipcodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertZoneZipcodesMutation, { data, loading, error }] = useUpsertZoneZipcodesMutation({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *      zipCodes: // value for 'zipCodes'
 *   },
 * });
 */
export function useUpsertZoneZipcodesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertZoneZipcodesMutation, UpsertZoneZipcodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertZoneZipcodesMutation, UpsertZoneZipcodesMutationVariables>(UpsertZoneZipcodesDocument, options);
      }
export type UpsertZoneZipcodesMutationHookResult = ReturnType<typeof useUpsertZoneZipcodesMutation>;
export type UpsertZoneZipcodesMutationResult = Apollo.MutationResult<UpsertZoneZipcodesMutation>;
export type UpsertZoneZipcodesMutationOptions = Apollo.BaseMutationOptions<UpsertZoneZipcodesMutation, UpsertZoneZipcodesMutationVariables>;
export const GetAppointmentDocument = /*#__PURE__*/ gql`
    query GetAppointment($appointmentId: Int!) {
  appointment(appointmentId: $appointmentId) {
    ...AppointmentFragment
    rescheduledTo {
      appointmentId
    }
    userByCreatedBy {
      firstName
      lastName
      userId
    }
    encountersList {
      channelAttributionId
      ...EncounterFields
    }
    ...AppointmentDispatches
    ...MarketName
    ...AddressFields
    ...patientsByEncounterAppointmentIdAndPatientIdList
  }
}
    ${AppointmentFragmentDoc}
${EncounterFieldsFragmentDoc}
${AppointmentDispatchesFragmentDoc}
${MarketNameFragmentDoc}
${AddressFieldsFragmentDoc}
${PatientsByEncounterAppointmentIdAndPatientIdListFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export function refetchGetAppointmentQuery(variables?: GetAppointmentQueryVariables) {
      return { query: GetAppointmentDocument, variables: variables }
    }
export const GetAppointmentAvailabilitiesDocument = /*#__PURE__*/ gql`
    query GetAppointmentAvailabilities($appointment: AppointmentAddress!, $end: String!, $patients: [PatientEncounterRequest]!, $start: String!) {
  getAppointmentAvailabilities(
    appointment: $appointment
    end: $end
    patients: $patients
    start: $start
  ) {
    appointmentSlots {
      end
      respondersAvailable
      start
    }
    jobDuration
    jobTags {
      id
    }
    jobType
    requiredResponders
  }
}
    `;

/**
 * __useGetAppointmentAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentAvailabilitiesQuery({
 *   variables: {
 *      appointment: // value for 'appointment'
 *      end: // value for 'end'
 *      patients: // value for 'patients'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetAppointmentAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentAvailabilitiesQuery, GetAppointmentAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentAvailabilitiesQuery, GetAppointmentAvailabilitiesQueryVariables>(GetAppointmentAvailabilitiesDocument, options);
      }
export function useGetAppointmentAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentAvailabilitiesQuery, GetAppointmentAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentAvailabilitiesQuery, GetAppointmentAvailabilitiesQueryVariables>(GetAppointmentAvailabilitiesDocument, options);
        }
export type GetAppointmentAvailabilitiesQueryHookResult = ReturnType<typeof useGetAppointmentAvailabilitiesQuery>;
export type GetAppointmentAvailabilitiesLazyQueryHookResult = ReturnType<typeof useGetAppointmentAvailabilitiesLazyQuery>;
export type GetAppointmentAvailabilitiesQueryResult = Apollo.QueryResult<GetAppointmentAvailabilitiesQuery, GetAppointmentAvailabilitiesQueryVariables>;
export function refetchGetAppointmentAvailabilitiesQuery(variables?: GetAppointmentAvailabilitiesQueryVariables) {
      return { query: GetAppointmentAvailabilitiesDocument, variables: variables }
    }
export const GetAppointmentPreviewDocument = /*#__PURE__*/ gql`
    query GetAppointmentPreview($appointmentId: Int!) {
  appointment(appointmentId: $appointmentId) {
    ...AppointmentFragment
    rescheduledTo {
      appointmentId
    }
    userByCreatedBy {
      firstName
      lastName
      userId
    }
    encountersList {
      ...AppointmentPreviewEncounters
    }
    ...AppointmentDispatches
    ...MarketName
    ...AddressFields
  }
}
    ${AppointmentFragmentDoc}
${AppointmentPreviewEncountersFragmentDoc}
${AppointmentDispatchesFragmentDoc}
${MarketNameFragmentDoc}
${AddressFieldsFragmentDoc}`;

/**
 * __useGetAppointmentPreviewQuery__
 *
 * To run a query within a React component, call `useGetAppointmentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentPreviewQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentPreviewQuery, GetAppointmentPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentPreviewQuery, GetAppointmentPreviewQueryVariables>(GetAppointmentPreviewDocument, options);
      }
export function useGetAppointmentPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentPreviewQuery, GetAppointmentPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentPreviewQuery, GetAppointmentPreviewQueryVariables>(GetAppointmentPreviewDocument, options);
        }
export type GetAppointmentPreviewQueryHookResult = ReturnType<typeof useGetAppointmentPreviewQuery>;
export type GetAppointmentPreviewLazyQueryHookResult = ReturnType<typeof useGetAppointmentPreviewLazyQuery>;
export type GetAppointmentPreviewQueryResult = Apollo.QueryResult<GetAppointmentPreviewQuery, GetAppointmentPreviewQueryVariables>;
export function refetchGetAppointmentPreviewQuery(variables?: GetAppointmentPreviewQueryVariables) {
      return { query: GetAppointmentPreviewDocument, variables: variables }
    }
export const GetAppointmentsDocument = /*#__PURE__*/ gql`
    query GetAppointments($first: Int = 10, $offset: Int = 0, $marketId: Int, $orderBy: [AppointmentsOrderBy!]) {
  appointmentsList(
    offset: $offset
    condition: {marketId: $marketId}
    first: $first
    orderBy: $orderBy
  ) {
    appointmentId
    scheduledFor
    status
    addressLat
    addressLng
    encounters {
      nodes {
        encounterId
        patient {
          firstName
          lastName
          patientId
          patientNotes(condition: {isHighPriority: true, isDeleted: false}) {
            totalCount
          }
        }
      }
    }
    ...AppointmentDispatches
    ...MarketName
  }
}
    ${AppointmentDispatchesFragmentDoc}
${MarketNameFragmentDoc}`;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      marketId: // value for 'marketId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export function refetchGetAppointmentsQuery(variables?: GetAppointmentsQueryVariables) {
      return { query: GetAppointmentsDocument, variables: variables }
    }
export const GetChannelAttributionsDocument = /*#__PURE__*/ gql`
    query GetChannelAttributions {
  channelAttributionsList {
    channelAttributionId
    channel
  }
}
    `;

/**
 * __useGetChannelAttributionsQuery__
 *
 * To run a query within a React component, call `useGetChannelAttributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelAttributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelAttributionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChannelAttributionsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelAttributionsQuery, GetChannelAttributionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelAttributionsQuery, GetChannelAttributionsQueryVariables>(GetChannelAttributionsDocument, options);
      }
export function useGetChannelAttributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelAttributionsQuery, GetChannelAttributionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelAttributionsQuery, GetChannelAttributionsQueryVariables>(GetChannelAttributionsDocument, options);
        }
export type GetChannelAttributionsQueryHookResult = ReturnType<typeof useGetChannelAttributionsQuery>;
export type GetChannelAttributionsLazyQueryHookResult = ReturnType<typeof useGetChannelAttributionsLazyQuery>;
export type GetChannelAttributionsQueryResult = Apollo.QueryResult<GetChannelAttributionsQuery, GetChannelAttributionsQueryVariables>;
export function refetchGetChannelAttributionsQuery(variables?: GetChannelAttributionsQueryVariables) {
      return { query: GetChannelAttributionsDocument, variables: variables }
    }
export const GetChannelAttributionsByMarketDocument = /*#__PURE__*/ gql`
    query GetChannelAttributionsByMarket($marketId: [Int!], $tagSystem: ChannelAttributionTagSystemConditionEnum = MANUAL) {
  channelAttributionsList(
    condition: {marketId: $marketId, isDeleted: false, tagSystem: $tagSystem}
  ) {
    channelAttributionId
    channel
  }
}
    `;

/**
 * __useGetChannelAttributionsByMarketQuery__
 *
 * To run a query within a React component, call `useGetChannelAttributionsByMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelAttributionsByMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelAttributionsByMarketQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *      tagSystem: // value for 'tagSystem'
 *   },
 * });
 */
export function useGetChannelAttributionsByMarketQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelAttributionsByMarketQuery, GetChannelAttributionsByMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelAttributionsByMarketQuery, GetChannelAttributionsByMarketQueryVariables>(GetChannelAttributionsByMarketDocument, options);
      }
export function useGetChannelAttributionsByMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelAttributionsByMarketQuery, GetChannelAttributionsByMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelAttributionsByMarketQuery, GetChannelAttributionsByMarketQueryVariables>(GetChannelAttributionsByMarketDocument, options);
        }
export type GetChannelAttributionsByMarketQueryHookResult = ReturnType<typeof useGetChannelAttributionsByMarketQuery>;
export type GetChannelAttributionsByMarketLazyQueryHookResult = ReturnType<typeof useGetChannelAttributionsByMarketLazyQuery>;
export type GetChannelAttributionsByMarketQueryResult = Apollo.QueryResult<GetChannelAttributionsByMarketQuery, GetChannelAttributionsByMarketQueryVariables>;
export function refetchGetChannelAttributionsByMarketQuery(variables?: GetChannelAttributionsByMarketQueryVariables) {
      return { query: GetChannelAttributionsByMarketDocument, variables: variables }
    }
export const GetChannelAttributionsWithMarketsDocument = /*#__PURE__*/ gql`
    query GetChannelAttributionsWithMarkets($offset: Int = 0, $first: Int, $marketId: [Int]) {
  channelAttributions(
    first: $first
    offset: $offset
    orderBy: CHANNEL_ATTRIBUTION_ID_DESC
    condition: {isDeleted: false, tagSystem: MANUAL, marketId: $marketId}
  ) {
    nodes {
      ...ChannelAttributionFragment
    }
    totalCount
  }
}
    ${ChannelAttributionFragmentDoc}`;

/**
 * __useGetChannelAttributionsWithMarketsQuery__
 *
 * To run a query within a React component, call `useGetChannelAttributionsWithMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelAttributionsWithMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelAttributionsWithMarketsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useGetChannelAttributionsWithMarketsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelAttributionsWithMarketsQuery, GetChannelAttributionsWithMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelAttributionsWithMarketsQuery, GetChannelAttributionsWithMarketsQueryVariables>(GetChannelAttributionsWithMarketsDocument, options);
      }
export function useGetChannelAttributionsWithMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelAttributionsWithMarketsQuery, GetChannelAttributionsWithMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelAttributionsWithMarketsQuery, GetChannelAttributionsWithMarketsQueryVariables>(GetChannelAttributionsWithMarketsDocument, options);
        }
export type GetChannelAttributionsWithMarketsQueryHookResult = ReturnType<typeof useGetChannelAttributionsWithMarketsQuery>;
export type GetChannelAttributionsWithMarketsLazyQueryHookResult = ReturnType<typeof useGetChannelAttributionsWithMarketsLazyQuery>;
export type GetChannelAttributionsWithMarketsQueryResult = Apollo.QueryResult<GetChannelAttributionsWithMarketsQuery, GetChannelAttributionsWithMarketsQueryVariables>;
export function refetchGetChannelAttributionsWithMarketsQuery(variables?: GetChannelAttributionsWithMarketsQueryVariables) {
      return { query: GetChannelAttributionsWithMarketsDocument, variables: variables }
    }
export const GetCurrentUserDocument = /*#__PURE__*/ gql`
    query GetCurrentUser {
  getCurrentUser {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function refetchGetCurrentUserQuery(variables?: GetCurrentUserQueryVariables) {
      return { query: GetCurrentUserDocument, variables: variables }
    }
export const GetEncounterInsuranceRecordsDocument = /*#__PURE__*/ gql`
    query GetEncounterInsuranceRecords($appointmentId: Int!, $patientId: Int!) {
  appointment(appointmentId: $appointmentId) {
    appointmentId
    insuranceRecordsByEncounterAppointmentIdAndPrimaryInsurance(
      condition: {patientId: $patientId}
    ) {
      nodes {
        ...InsuranceRecord
      }
    }
    insuranceRecordsByEncounterAppointmentIdAndSecondaryInsurance(
      condition: {patientId: $patientId}
    ) {
      nodes {
        ...InsuranceRecord
      }
    }
  }
}
    ${InsuranceRecordFragmentDoc}`;

/**
 * __useGetEncounterInsuranceRecordsQuery__
 *
 * To run a query within a React component, call `useGetEncounterInsuranceRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterInsuranceRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEncounterInsuranceRecordsQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetEncounterInsuranceRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetEncounterInsuranceRecordsQuery, GetEncounterInsuranceRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEncounterInsuranceRecordsQuery, GetEncounterInsuranceRecordsQueryVariables>(GetEncounterInsuranceRecordsDocument, options);
      }
export function useGetEncounterInsuranceRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEncounterInsuranceRecordsQuery, GetEncounterInsuranceRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEncounterInsuranceRecordsQuery, GetEncounterInsuranceRecordsQueryVariables>(GetEncounterInsuranceRecordsDocument, options);
        }
export type GetEncounterInsuranceRecordsQueryHookResult = ReturnType<typeof useGetEncounterInsuranceRecordsQuery>;
export type GetEncounterInsuranceRecordsLazyQueryHookResult = ReturnType<typeof useGetEncounterInsuranceRecordsLazyQuery>;
export type GetEncounterInsuranceRecordsQueryResult = Apollo.QueryResult<GetEncounterInsuranceRecordsQuery, GetEncounterInsuranceRecordsQueryVariables>;
export function refetchGetEncounterInsuranceRecordsQuery(variables?: GetEncounterInsuranceRecordsQueryVariables) {
      return { query: GetEncounterInsuranceRecordsDocument, variables: variables }
    }
export const GetExportAppointmentsDocument = /*#__PURE__*/ gql`
    query GetExportAppointments($limit: Int = 10000, $offset: Int = 0, $query: String, $markets: [Int!], $status: [AppointmentStatusEnum!], $orderBy: SearchAppointmentsOrderByEnum, $scheduledBefore: String, $scheduledAfter: String, $serviceLines: [Int!]) {
  searchAppointments(
    limit: $limit
    offset: $offset
    nameQuery: $query
    condition: {markets: $markets, status: $status, scheduledBefore: $scheduledBefore, scheduledAfter: $scheduledAfter, serviceLines: $serviceLines}
    orderBy: $orderBy
  ) {
    ...AppointmentFragment
    rescheduledTo {
      appointmentId
    }
    partnership
    completedAt
    userByCreatedBy {
      firstName
      lastName
      userId
    }
    encountersList {
      ...AppointmentPreviewEncounters
      inProgressAt
      channelAttribution {
        channel
      }
      encounterSignaturesList {
        createdAt
      }
    }
    ...AppointmentDispatches
    ...MarketName
    ...AddressFields
  }
}
    ${AppointmentFragmentDoc}
${AppointmentPreviewEncountersFragmentDoc}
${AppointmentDispatchesFragmentDoc}
${MarketNameFragmentDoc}
${AddressFieldsFragmentDoc}`;

/**
 * __useGetExportAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetExportAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportAppointmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      markets: // value for 'markets'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *      scheduledBefore: // value for 'scheduledBefore'
 *      scheduledAfter: // value for 'scheduledAfter'
 *      serviceLines: // value for 'serviceLines'
 *   },
 * });
 */
export function useGetExportAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetExportAppointmentsQuery, GetExportAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExportAppointmentsQuery, GetExportAppointmentsQueryVariables>(GetExportAppointmentsDocument, options);
      }
export function useGetExportAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExportAppointmentsQuery, GetExportAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExportAppointmentsQuery, GetExportAppointmentsQueryVariables>(GetExportAppointmentsDocument, options);
        }
export type GetExportAppointmentsQueryHookResult = ReturnType<typeof useGetExportAppointmentsQuery>;
export type GetExportAppointmentsLazyQueryHookResult = ReturnType<typeof useGetExportAppointmentsLazyQuery>;
export type GetExportAppointmentsQueryResult = Apollo.QueryResult<GetExportAppointmentsQuery, GetExportAppointmentsQueryVariables>;
export function refetchGetExportAppointmentsQuery(variables?: GetExportAppointmentsQueryVariables) {
      return { query: GetExportAppointmentsDocument, variables: variables }
    }
export const GetFullAppointmentPreviewDocument = /*#__PURE__*/ gql`
    query GetFullAppointmentPreview($appointmentId: Int!) {
  appointment(appointmentId: $appointmentId) {
    appointmentId
    createdAt
    createdBy
    scheduledFor
    zoneId
    marketId
    contactName
    primaryPhone
    skeduloJobId
    specialInstructions
    encountersList {
      channelAttributionId
      ...EncounterFields
      primaryInsuranceRecord {
        ...InsuranceRecord
      }
      secondaryInsuranceRecord {
        ...InsuranceRecord
      }
    }
    ...MarketName
    ...AddressFields
    ...patientsByEncounterAppointmentIdAndPatientIdList
  }
}
    ${EncounterFieldsFragmentDoc}
${InsuranceRecordFragmentDoc}
${MarketNameFragmentDoc}
${AddressFieldsFragmentDoc}
${PatientsByEncounterAppointmentIdAndPatientIdListFragmentDoc}`;

/**
 * __useGetFullAppointmentPreviewQuery__
 *
 * To run a query within a React component, call `useGetFullAppointmentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullAppointmentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullAppointmentPreviewQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetFullAppointmentPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetFullAppointmentPreviewQuery, GetFullAppointmentPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullAppointmentPreviewQuery, GetFullAppointmentPreviewQueryVariables>(GetFullAppointmentPreviewDocument, options);
      }
export function useGetFullAppointmentPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullAppointmentPreviewQuery, GetFullAppointmentPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullAppointmentPreviewQuery, GetFullAppointmentPreviewQueryVariables>(GetFullAppointmentPreviewDocument, options);
        }
export type GetFullAppointmentPreviewQueryHookResult = ReturnType<typeof useGetFullAppointmentPreviewQuery>;
export type GetFullAppointmentPreviewLazyQueryHookResult = ReturnType<typeof useGetFullAppointmentPreviewLazyQuery>;
export type GetFullAppointmentPreviewQueryResult = Apollo.QueryResult<GetFullAppointmentPreviewQuery, GetFullAppointmentPreviewQueryVariables>;
export function refetchGetFullAppointmentPreviewQuery(variables?: GetFullAppointmentPreviewQueryVariables) {
      return { query: GetFullAppointmentPreviewDocument, variables: variables }
    }
export const GetInsuranceRecordDocument = /*#__PURE__*/ gql`
    query GetInsuranceRecord($insuranceRecordId: Int!) {
  insuranceRecord(insuranceRecordId: $insuranceRecordId) {
    ...InsuranceRecord
  }
}
    ${InsuranceRecordFragmentDoc}`;

/**
 * __useGetInsuranceRecordQuery__
 *
 * To run a query within a React component, call `useGetInsuranceRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceRecordQuery({
 *   variables: {
 *      insuranceRecordId: // value for 'insuranceRecordId'
 *   },
 * });
 */
export function useGetInsuranceRecordQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceRecordQuery, GetInsuranceRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceRecordQuery, GetInsuranceRecordQueryVariables>(GetInsuranceRecordDocument, options);
      }
export function useGetInsuranceRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceRecordQuery, GetInsuranceRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceRecordQuery, GetInsuranceRecordQueryVariables>(GetInsuranceRecordDocument, options);
        }
export type GetInsuranceRecordQueryHookResult = ReturnType<typeof useGetInsuranceRecordQuery>;
export type GetInsuranceRecordLazyQueryHookResult = ReturnType<typeof useGetInsuranceRecordLazyQuery>;
export type GetInsuranceRecordQueryResult = Apollo.QueryResult<GetInsuranceRecordQuery, GetInsuranceRecordQueryVariables>;
export function refetchGetInsuranceRecordQuery(variables?: GetInsuranceRecordQueryVariables) {
      return { query: GetInsuranceRecordDocument, variables: variables }
    }
export const GetInsuranceRecordListDocument = /*#__PURE__*/ gql`
    query GetInsuranceRecordList($insuranceRecordsListCondition: InsuranceRecordCondition!) {
  insuranceRecordsList(condition: $insuranceRecordsListCondition) {
    ...InsuranceRecord
  }
}
    ${InsuranceRecordFragmentDoc}`;

/**
 * __useGetInsuranceRecordListQuery__
 *
 * To run a query within a React component, call `useGetInsuranceRecordListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceRecordListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceRecordListQuery({
 *   variables: {
 *      insuranceRecordsListCondition: // value for 'insuranceRecordsListCondition'
 *   },
 * });
 */
export function useGetInsuranceRecordListQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceRecordListQuery, GetInsuranceRecordListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceRecordListQuery, GetInsuranceRecordListQueryVariables>(GetInsuranceRecordListDocument, options);
      }
export function useGetInsuranceRecordListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceRecordListQuery, GetInsuranceRecordListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceRecordListQuery, GetInsuranceRecordListQueryVariables>(GetInsuranceRecordListDocument, options);
        }
export type GetInsuranceRecordListQueryHookResult = ReturnType<typeof useGetInsuranceRecordListQuery>;
export type GetInsuranceRecordListLazyQueryHookResult = ReturnType<typeof useGetInsuranceRecordListLazyQuery>;
export type GetInsuranceRecordListQueryResult = Apollo.QueryResult<GetInsuranceRecordListQuery, GetInsuranceRecordListQueryVariables>;
export function refetchGetInsuranceRecordListQuery(variables?: GetInsuranceRecordListQueryVariables) {
      return { query: GetInsuranceRecordListDocument, variables: variables }
    }
export const GetMarketDocument = /*#__PURE__*/ gql`
    query GetMarket($marketId: Int!) {
  market(marketId: $marketId) {
    ...Market
  }
}
    ${MarketFragmentDoc}`;

/**
 * __useGetMarketQuery__
 *
 * To run a query within a React component, call `useGetMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useGetMarketQuery(baseOptions: Apollo.QueryHookOptions<GetMarketQuery, GetMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketQuery, GetMarketQueryVariables>(GetMarketDocument, options);
      }
export function useGetMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketQuery, GetMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketQuery, GetMarketQueryVariables>(GetMarketDocument, options);
        }
export type GetMarketQueryHookResult = ReturnType<typeof useGetMarketQuery>;
export type GetMarketLazyQueryHookResult = ReturnType<typeof useGetMarketLazyQuery>;
export type GetMarketQueryResult = Apollo.QueryResult<GetMarketQuery, GetMarketQueryVariables>;
export function refetchGetMarketQuery(variables?: GetMarketQueryVariables) {
      return { query: GetMarketDocument, variables: variables }
    }
export const GetMarketByZipDocument = /*#__PURE__*/ gql`
    query GetMarketByZip($zipCode: String!) {
  zipcode(zipCode: $zipCode) {
    zipCode
    zones {
      nodes {
        zoneId
        market {
          ...Market
        }
      }
    }
  }
}
    ${MarketFragmentDoc}`;

/**
 * __useGetMarketByZipQuery__
 *
 * To run a query within a React component, call `useGetMarketByZipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketByZipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketByZipQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useGetMarketByZipQuery(baseOptions: Apollo.QueryHookOptions<GetMarketByZipQuery, GetMarketByZipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketByZipQuery, GetMarketByZipQueryVariables>(GetMarketByZipDocument, options);
      }
export function useGetMarketByZipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketByZipQuery, GetMarketByZipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketByZipQuery, GetMarketByZipQueryVariables>(GetMarketByZipDocument, options);
        }
export type GetMarketByZipQueryHookResult = ReturnType<typeof useGetMarketByZipQuery>;
export type GetMarketByZipLazyQueryHookResult = ReturnType<typeof useGetMarketByZipLazyQuery>;
export type GetMarketByZipQueryResult = Apollo.QueryResult<GetMarketByZipQuery, GetMarketByZipQueryVariables>;
export function refetchGetMarketByZipQuery(variables?: GetMarketByZipQueryVariables) {
      return { query: GetMarketByZipDocument, variables: variables }
    }
export const GetMarketWithZonesDocument = /*#__PURE__*/ gql`
    query GetMarketWithZones($marketId: Int!) {
  market(marketId: $marketId) {
    ...Market
    zonesList {
      name
      zoneId
      isDeleted
      stringifiedZoneZipcodeList @client
      zoneZipcodesList {
        zipCode
      }
    }
  }
}
    ${MarketFragmentDoc}`;

/**
 * __useGetMarketWithZonesQuery__
 *
 * To run a query within a React component, call `useGetMarketWithZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketWithZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketWithZonesQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useGetMarketWithZonesQuery(baseOptions: Apollo.QueryHookOptions<GetMarketWithZonesQuery, GetMarketWithZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketWithZonesQuery, GetMarketWithZonesQueryVariables>(GetMarketWithZonesDocument, options);
      }
export function useGetMarketWithZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketWithZonesQuery, GetMarketWithZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketWithZonesQuery, GetMarketWithZonesQueryVariables>(GetMarketWithZonesDocument, options);
        }
export type GetMarketWithZonesQueryHookResult = ReturnType<typeof useGetMarketWithZonesQuery>;
export type GetMarketWithZonesLazyQueryHookResult = ReturnType<typeof useGetMarketWithZonesLazyQuery>;
export type GetMarketWithZonesQueryResult = Apollo.QueryResult<GetMarketWithZonesQuery, GetMarketWithZonesQueryVariables>;
export function refetchGetMarketWithZonesQuery(variables?: GetMarketWithZonesQueryVariables) {
      return { query: GetMarketWithZonesDocument, variables: variables }
    }
export const GetMarketsDocument = /*#__PURE__*/ gql`
    query GetMarkets($condition: MarketCondition = {isDeleted: false}) {
  marketsList(condition: $condition) {
    ...Market
  }
}
    ${MarketFragmentDoc}`;

/**
 * __useGetMarketsQuery__
 *
 * To run a query within a React component, call `useGetMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *   },
 * });
 */
export function useGetMarketsQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketsQuery, GetMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketsQuery, GetMarketsQueryVariables>(GetMarketsDocument, options);
      }
export function useGetMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketsQuery, GetMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketsQuery, GetMarketsQueryVariables>(GetMarketsDocument, options);
        }
export type GetMarketsQueryHookResult = ReturnType<typeof useGetMarketsQuery>;
export type GetMarketsLazyQueryHookResult = ReturnType<typeof useGetMarketsLazyQuery>;
export type GetMarketsQueryResult = Apollo.QueryResult<GetMarketsQuery, GetMarketsQueryVariables>;
export function refetchGetMarketsQuery(variables?: GetMarketsQueryVariables) {
      return { query: GetMarketsDocument, variables: variables }
    }
export const GetPatientDocument = /*#__PURE__*/ gql`
    query GetPatient($patientId: Int!) {
  patient(patientId: $patientId) {
    ...Patient
  }
}
    ${PatientFragmentDoc}`;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export function refetchGetPatientQuery(variables?: GetPatientQueryVariables) {
      return { query: GetPatientDocument, variables: variables }
    }
export const GetPatientNotesDocument = /*#__PURE__*/ gql`
    query GetPatientNotes($patientId: Int!) {
  patient(patientId: $patientId) {
    patientId
    patientNotesList {
      ...PatientNote
    }
  }
}
    ${PatientNoteFragmentDoc}`;

/**
 * __useGetPatientNotesQuery__
 *
 * To run a query within a React component, call `useGetPatientNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientNotesQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetPatientNotesQuery(baseOptions: Apollo.QueryHookOptions<GetPatientNotesQuery, GetPatientNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientNotesQuery, GetPatientNotesQueryVariables>(GetPatientNotesDocument, options);
      }
export function useGetPatientNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientNotesQuery, GetPatientNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientNotesQuery, GetPatientNotesQueryVariables>(GetPatientNotesDocument, options);
        }
export type GetPatientNotesQueryHookResult = ReturnType<typeof useGetPatientNotesQuery>;
export type GetPatientNotesLazyQueryHookResult = ReturnType<typeof useGetPatientNotesLazyQuery>;
export type GetPatientNotesQueryResult = Apollo.QueryResult<GetPatientNotesQuery, GetPatientNotesQueryVariables>;
export function refetchGetPatientNotesQuery(variables?: GetPatientNotesQueryVariables) {
      return { query: GetPatientNotesDocument, variables: variables }
    }
export const GetPatientsDocument = /*#__PURE__*/ gql`
    query GetPatients($patientIds: [Int!]) {
  patients(condition: {patientIds: $patientIds}) {
    nodes {
      ...Patient
    }
  }
}
    ${PatientFragmentDoc}`;

/**
 * __useGetPatientsQuery__
 *
 * To run a query within a React component, call `useGetPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsQuery({
 *   variables: {
 *      patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useGetPatientsQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientsQuery, GetPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsQuery, GetPatientsQueryVariables>(GetPatientsDocument, options);
      }
export function useGetPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsQuery, GetPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsQuery, GetPatientsQueryVariables>(GetPatientsDocument, options);
        }
export type GetPatientsQueryHookResult = ReturnType<typeof useGetPatientsQuery>;
export type GetPatientsLazyQueryHookResult = ReturnType<typeof useGetPatientsLazyQuery>;
export type GetPatientsQueryResult = Apollo.QueryResult<GetPatientsQuery, GetPatientsQueryVariables>;
export function refetchGetPatientsQuery(variables?: GetPatientsQueryVariables) {
      return { query: GetPatientsDocument, variables: variables }
    }
export const GetSearchAppointmentsDocument = /*#__PURE__*/ gql`
    query GetSearchAppointments($first: Int = 10, $offset: Int = 0, $query: String, $markets: [Int!], $status: [AppointmentStatusEnum!], $orderBy: SearchAppointmentsOrderByEnum, $scheduledBefore: String, $scheduledAfter: String, $serviceLines: [Int!]) {
  searchAppointments(
    limit: $first
    offset: $offset
    nameQuery: $query
    condition: {markets: $markets, status: $status, scheduledBefore: $scheduledBefore, scheduledAfter: $scheduledAfter, serviceLines: $serviceLines}
    orderBy: $orderBy
  ) {
    appointmentId
    scheduledFor
    status
    availabilityOverride
    encounters {
      nodes {
        encounterId
        patient {
          firstName
          lastName
          patientId
          patientNotes(condition: {isHighPriority: true, isDeleted: false}) {
            totalCount
          }
        }
        channelAttribution {
          channelAttributionId
          channel
        }
      }
    }
    ...AppointmentDispatches
    ...MarketName
  }
}
    ${AppointmentDispatchesFragmentDoc}
${MarketNameFragmentDoc}`;

/**
 * __useGetSearchAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetSearchAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchAppointmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      markets: // value for 'markets'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *      scheduledBefore: // value for 'scheduledBefore'
 *      scheduledAfter: // value for 'scheduledAfter'
 *      serviceLines: // value for 'serviceLines'
 *   },
 * });
 */
export function useGetSearchAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchAppointmentsQuery, GetSearchAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchAppointmentsQuery, GetSearchAppointmentsQueryVariables>(GetSearchAppointmentsDocument, options);
      }
export function useGetSearchAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchAppointmentsQuery, GetSearchAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchAppointmentsQuery, GetSearchAppointmentsQueryVariables>(GetSearchAppointmentsDocument, options);
        }
export type GetSearchAppointmentsQueryHookResult = ReturnType<typeof useGetSearchAppointmentsQuery>;
export type GetSearchAppointmentsLazyQueryHookResult = ReturnType<typeof useGetSearchAppointmentsLazyQuery>;
export type GetSearchAppointmentsQueryResult = Apollo.QueryResult<GetSearchAppointmentsQuery, GetSearchAppointmentsQueryVariables>;
export function refetchGetSearchAppointmentsQuery(variables?: GetSearchAppointmentsQueryVariables) {
      return { query: GetSearchAppointmentsDocument, variables: variables }
    }
export const SearchPatientsDocument = /*#__PURE__*/ gql`
    query SearchPatients($name: String!) {
  searchPatients(nameQuery: $name) {
    patientId
    firstName
    lastName
    preferredName
    preferredPhoneNumber
    sex
    dob
    genderPronoun
    address1
    city
    state
  }
}
    `;

/**
 * __useSearchPatientsQuery__
 *
 * To run a query within a React component, call `useSearchPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPatientsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSearchPatientsQuery(baseOptions: Apollo.QueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPatientsQuery, SearchPatientsQueryVariables>(SearchPatientsDocument, options);
      }
export function useSearchPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPatientsQuery, SearchPatientsQueryVariables>(SearchPatientsDocument, options);
        }
export type SearchPatientsQueryHookResult = ReturnType<typeof useSearchPatientsQuery>;
export type SearchPatientsLazyQueryHookResult = ReturnType<typeof useSearchPatientsLazyQuery>;
export type SearchPatientsQueryResult = Apollo.QueryResult<SearchPatientsQuery, SearchPatientsQueryVariables>;
export function refetchSearchPatientsQuery(variables?: SearchPatientsQueryVariables) {
      return { query: SearchPatientsDocument, variables: variables }
    }
export const GetServiceLinesDocument = /*#__PURE__*/ gql`
    query GetServiceLines {
  serviceLines {
    nodes {
      serviceLineId
      name
      friendlyName @client
      subType
      segment
      priority
      isDeleted
    }
  }
}
    `;

/**
 * __useGetServiceLinesQuery__
 *
 * To run a query within a React component, call `useGetServiceLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceLinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceLinesQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceLinesQuery, GetServiceLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceLinesQuery, GetServiceLinesQueryVariables>(GetServiceLinesDocument, options);
      }
export function useGetServiceLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceLinesQuery, GetServiceLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceLinesQuery, GetServiceLinesQueryVariables>(GetServiceLinesDocument, options);
        }
export type GetServiceLinesQueryHookResult = ReturnType<typeof useGetServiceLinesQuery>;
export type GetServiceLinesLazyQueryHookResult = ReturnType<typeof useGetServiceLinesLazyQuery>;
export type GetServiceLinesQueryResult = Apollo.QueryResult<GetServiceLinesQuery, GetServiceLinesQueryVariables>;
export function refetchGetServiceLinesQuery(variables?: GetServiceLinesQueryVariables) {
      return { query: GetServiceLinesDocument, variables: variables }
    }
export const GetUsersDocument = /*#__PURE__*/ gql`
    query GetUsers($orderBy: [UsersOrderBy!]) {
  users(condition: {isDeleted: false}, orderBy: $orderBy) {
    edges {
      node {
        ...UserFields
      }
      cursor
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: GetUsersDocument, variables: variables }
    }
export const GetZoneDocument = /*#__PURE__*/ gql`
    query GetZone($zoneId: Int!) {
  zone(zoneId: $zoneId) {
    name
    zoneId
  }
}
    `;

/**
 * __useGetZoneQuery__
 *
 * To run a query within a React component, call `useGetZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useGetZoneQuery(baseOptions: Apollo.QueryHookOptions<GetZoneQuery, GetZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
      }
export function useGetZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZoneQuery, GetZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
        }
export type GetZoneQueryHookResult = ReturnType<typeof useGetZoneQuery>;
export type GetZoneLazyQueryHookResult = ReturnType<typeof useGetZoneLazyQuery>;
export type GetZoneQueryResult = Apollo.QueryResult<GetZoneQuery, GetZoneQueryVariables>;
export function refetchGetZoneQuery(variables?: GetZoneQueryVariables) {
      return { query: GetZoneDocument, variables: variables }
    }
export const GetZoneAndMarketByZipCodeDocument = /*#__PURE__*/ gql`
    query GetZoneAndMarketByZipCode($zipCode: String!) {
  zipcode(zipCode: $zipCode) {
    zones {
      nodes {
        isActive
        zoneId
        marketId
      }
    }
  }
}
    `;

/**
 * __useGetZoneAndMarketByZipCodeQuery__
 *
 * To run a query within a React component, call `useGetZoneAndMarketByZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneAndMarketByZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneAndMarketByZipCodeQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useGetZoneAndMarketByZipCodeQuery(baseOptions: Apollo.QueryHookOptions<GetZoneAndMarketByZipCodeQuery, GetZoneAndMarketByZipCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZoneAndMarketByZipCodeQuery, GetZoneAndMarketByZipCodeQueryVariables>(GetZoneAndMarketByZipCodeDocument, options);
      }
export function useGetZoneAndMarketByZipCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZoneAndMarketByZipCodeQuery, GetZoneAndMarketByZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZoneAndMarketByZipCodeQuery, GetZoneAndMarketByZipCodeQueryVariables>(GetZoneAndMarketByZipCodeDocument, options);
        }
export type GetZoneAndMarketByZipCodeQueryHookResult = ReturnType<typeof useGetZoneAndMarketByZipCodeQuery>;
export type GetZoneAndMarketByZipCodeLazyQueryHookResult = ReturnType<typeof useGetZoneAndMarketByZipCodeLazyQuery>;
export type GetZoneAndMarketByZipCodeQueryResult = Apollo.QueryResult<GetZoneAndMarketByZipCodeQuery, GetZoneAndMarketByZipCodeQueryVariables>;
export function refetchGetZoneAndMarketByZipCodeQuery(variables?: GetZoneAndMarketByZipCodeQueryVariables) {
      return { query: GetZoneAndMarketByZipCodeDocument, variables: variables }
    }
export const GetZonesDocument = /*#__PURE__*/ gql`
    query GetZones($condition: ZoneCondition) {
  zonesList(condition: $condition) {
    name
    zoneId
    isActive
  }
}
    `;

/**
 * __useGetZonesQuery__
 *
 * To run a query within a React component, call `useGetZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZonesQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *   },
 * });
 */
export function useGetZonesQuery(baseOptions?: Apollo.QueryHookOptions<GetZonesQuery, GetZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZonesQuery, GetZonesQueryVariables>(GetZonesDocument, options);
      }
export function useGetZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZonesQuery, GetZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZonesQuery, GetZonesQueryVariables>(GetZonesDocument, options);
        }
export type GetZonesQueryHookResult = ReturnType<typeof useGetZonesQuery>;
export type GetZonesLazyQueryHookResult = ReturnType<typeof useGetZonesLazyQuery>;
export type GetZonesQueryResult = Apollo.QueryResult<GetZonesQuery, GetZonesQueryVariables>;
export function refetchGetZonesQuery(variables?: GetZonesQueryVariables) {
      return { query: GetZonesDocument, variables: variables }
    }